import engagementEN from 'features/engagement/locales/engagement.en';
import { wizardEN } from 'features/co-pilot/campaign-wizard/locales';

const localeEN = {
  awdefaultmessage: 'Augmented Writing is built here',
  cidefaultmessage: 'Customer Intelligence is built here',
  jointPosAchieve: 'Achievement motive',
  jointPosAffil: 'Affiliation motive',
  jointPosPower: 'Power motive',
  authenticity: 'Authenticity',
  emotionality: 'Emotionality',
  regFocus: 'Reward Focus',
  abstractness: 'Abstractness',
  gender: 'Femininity',
  chartHoverTooltipTitle: 'Expression of',
  chartLabelPower: 'Influence',
  chartLabelAffil: 'Affiliation',
  chartLabelAchieve: 'Achieve\n-ment',
  chartLabelAuthenticity: 'Authentic Speech',
  chartLabelAbstractness: 'Abstract Speech',
  chartLabelOrientation: 'Risk',
  chartLabelEmotion: 'Emotional Speech',
  chartLabelGender: 'Feminine Speech',
  yellow: 'Excitement',
  red: 'Relatedness',
  green: 'Certainity',
  blue: 'Autonomy',
  male: 'Masculine language',
  female: 'Feminine language',
  profileRemoveConfirmation: 'Are you sure you want to remove this profile?',
  profileWillNoLongerBeAvailable: 'This action is irreversible. The profile will no longer be available.',
  proceed: 'Proceed',
  profileName: 'Profile Name',
  vlow: 'Very Low',
  low: 'Low',
  medium: 'Balanced',
  high: 'High',
  vhigh: 'Very High',
  vformal: 'Very formal',
  formal: 'formal',
  informal: 'informal',
  free: 'Free',
  vfree: 'Very free',
  vrisk: 'Very risk-oriented',
  risk: 'Risk-oriented',
  reward: 'Benefit-oriented',
  vreward: 'Very benefit-oriented',
  vabstract: 'Very abstract',
  vconcrete: 'Very concrete',
  vfem: 'Very feminine',
  fem: 'Slightly feminine',
  masc: 'Masculine',
  vmasc: 'Very masculine',
  das: 'The',
  profileCreation: 'Profile create',
  profileUpdate: 'Profile update',
  whatMeans: 'What does that mean?',
  manageRights: 'Manage Rights',
  visibleToMe: 'Visible to me',
  visibleToCompany: 'Visible to the company',
  moreInfo: 'Further information',
  profileWizard: 'Use profile wizard',
  update: 'Update',
  neutral: 'Neutral',
  selectProfile: 'Select a Profile',
  genderNeutral: 'The text is gender-neutral',
  directedToWomen: 'The text is more directed to women',
  directedToMen: 'The text is more directed to men',
  manual: 'Manual',
  contact: 'Contact',
  userProfile: 'User Profile',
  contactDetails: 'Contact Details',
  firstName: 'First name',
  lastName: 'Last name',
  telephoneNumber: 'Telephone number',
  changePassword: 'Change Password',
  confirmPassword: 'Confirm your new Password',
  activatesuccess1: 'Thanks for your interest in our services.',
  activatesuccess2: 'You will receive a confirmation email shortly, with a link to authenticate your account.',
  activatesuccess3: 'You can now test the products.',
  forgetpass: 'You will shortly receive an email, with a link to reset your password.',
  withRegards: 'Best regards,',
  yourTeam: 'Your SAIA team!',
  registration: 'Registration',
  resendActivation: 'Resend activation',
  register: 'Register',
  repeatEmail: 'Repeat email',
  repeatPassword: 'Repeat Password',
  pleaseEnterEmail: 'Please enter your email',
  invalidEmail: 'This email address is invalid',
  emailLooksGood: 'This email address looks good',
  pleaseEnterPassword: 'Please enter your password',
  pleaseRepeatPassword: 'Please repeat your password',
  passwordLength: 'Password length must be between 6 & 50 characters',
  passwordNoEdgeWhitespace: 'Password must not start or end with spaces',
  firstNameLength: 'The first name must not be longer than 128 characters',
  lastNameLength: 'The last name must not be longer than 128 characters',
  cityNameLength: 'The city must not be longer than 128 characters',
  invitingUserLength: 'The user (first and last name) must not be longer than 128 characters',
  passwordLooksGood: 'This password looks good',
  changesInNewVersion: 'Changes in the new version',
  requests: 'Requests',
  lastRequest: 'Last Request',
  blocked: 'Blocked',
  copied: 'copied',
  apiRemoveConfirmation: 'Are you sure you want to remove this API Key?',
  apiWillNoLongerBeAvailable: 'This action is irreversible. The API Key will no longer be available.',
  changeActiveConfirmationTitle: 'Are you sure you want to remove this user?',
  changeActiveConfirmationText: 'This action is irreversible. The user will no longer be able to log in or use the application.',
  deleteUserDataTitle: 'Delete user data?',
  deleteUserData: 'Would you like to delete all data of this user as well?',
  changesWillTakeEffect: 'Changes will take effect immediately.',
  blockToggle: 'Are you sure you want to change block state?',
  updateRequestsLimit: 'Update requests limit',
  users: 'Users',
  price: 'Price',
  createAPIKey: 'Create API Key',
  manageAPIKeys: 'Manage Keys',
  jobProfiles: 'Job Profiles',
  brandProfiles: 'Brand Profiles',
  country: 'Country',
  paymentData: 'Payment Data',
  generalData: 'General Data',
  accountNumber: 'Account Number',
  accountOwner: 'Account Owner',
  createCompany: 'Create New Company',
  companyRemoveConfirmation: 'Are you sure you want to remove this company?',
  companyWillNoLongerBeAvailable: 'This action is irreversible. The company will no longer be available.',
  wizardExplanation:
    'For each of the following statements, select the suitable level of importance with 1 being unimportant and 5 being very important',
  wizardExplanationYesNo: 'For each of the following statements, select whether the statement is of great importance or not',
  profileTitle: 'Profiles',
  cantRemove: 'Can\'t remove a profile that is attached to an analysis',
  creationDate: 'CreationView Date',
  creator: 'Creator',
  numberOfanalyzes: 'No. of Analyses',
  numberOfUsers: 'No. of Users',
  general: 'General',
  packageRemoveConfirmation: 'Are you sure you want to remove this package?',
  packageWillNoLongerBeAvailable: 'This action is irreversible. The package will no longer be available.',
  packageDetails: 'Package Details',
  package: 'Package',
  startDate: 'Start Date',
  endDate: 'End Date',
  statusChangeConfirmationTitle: 'Are you sure you want to change the current status?',
  bookings: 'Bookings',
  newBooking: 'New Booking',
  bookPackage: 'Book Package',
  bookPackageNow: 'Book Package now',
  packageName: 'Package Name',
  statistics: 'Statistics',
  analyzesUsed: 'Analyzes used up till now',
  analysisLeft: 'Remaining analyzes',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  bookingMade: 'The booking is made',
  userManagment: 'User Management',
  lastLogin: 'Last Login',
  userLanguage: 'User language',
  choosePrimaryLanguage: 'Choose your primary language',
  updateAccount: 'Update Account',
  total: 'Total',
  admin: 'Admin',
  agencyadmin: 'Agency Admin',
  agency: 'Agency',
  bindToAgency: 'Bind to agency',
  noAgencyAssigned: 'No agency assigned',
  selectAgency: 'Select agency',
  notGettingData: 'Could not retrieve data. Try again later.',
  notSubmittingData: 'Could not submit data. Try again later.',
  changesSaved: 'Changes Saved',
  requestError: 'Unfortunately, your request can not be executed',
  optOutSuccess: 'Your email was opted out successfully',
  optOutRequestError: 'Could not opt out requested email',
  loginToOptOut: 'Please sign in to opt out your email',
  tagCreated: 'You have successfully added your folder',
  analysesUploadedSuccess: 'All analyses uploaded successfully',
  addToTagSuccess: 'You have successfully analyzed and added {{ name }} to the tag',
  tagDeleteSuccess: 'You have deleted {{ count }} analysis successfully',
  tagDeleteSuccess_plural: 'You have deleted {{ count }} analyses successfully',
  tagEdited: 'You have successfully updated your folder',
  newTag: 'Add new folder',
  deleteTagDialogTitle: 'Delete job offer',
  deleteTagDialogText: 'Are you sure you want to delete the job offer "{{name}}"?\r You will lose the analysis calculated for this.',
  deleteTagDialogText_plural:
    'Are you sure you want to delete the job offer "{{name}}"?\r You will lose all of {{count}} analyses calculated for this.',
  tagDeleted: 'You have deleted the folder successfully',
  analysesMoved: 'Analysis moved successfully',
  method: 'Method',
  products: 'Products',
  changelogHeadline1: 'Improvement of our formula',
  changelogContent1: 'More accurate personality measurement, especially for short texts',
  changelogHeadline2: 'New category',
  changelogContent2: 'Measure the "abstractness" of texts',
  changelogHeadline3: 'Deletion suggestions',
  changelogContent3: 'Improve the effect of German texts',
  changelogHeadline4: 'Abbreviations',
  changelogContent4: 'Recognition of undefined abbreviations',
  changelogHeadline5: 'Improved language model',
  changelogContent5: 'More and better word suggestions make writing texts easier',
  changelogHeadline6: 'Italian',
  changelogContent6: 'Support of Italian for text analysis and as the language of the user interface',
  analyzeText: 'Analyze Text',
  analyze: 'Analyze',
  entireSampleCompare: 'Comparison with entire sample',
  currentSampleCompare: 'Comparison with current sample',
  results: 'Results',
  pending: 'pending',
  newSurvey: 'New Survey',
  professionalMotivation: 'Professional Motivation',
  professionalMotivationIntro:
    'Motives and needs are an important aspect in the human Behavior and thinking. They drive us and give our actions direction. The Competence Monitor measures these motives. They are going back to the Need Theory by D. McClelland (1987). He postulated that Needs for power and status, professional success and Development as well as good relationships with other people as basic motives in all of us.',
  leadershipIntro:
    'Power motive comes with the desire to lead others and guide them. The power motive goes back to the Need Theory by McClelland and together with the other two motives „Achievement" and „Affiliation" form the three basic tendencies of human endeavor.',
  achievementIntro:
    'Achievement motive goes hand in hand with the desire to achieve new career successes in particular and to constantly develop. The motive for success goes back to the Need Theory of McClelland and forms with the other two motives „Power" and „Affiliation" the three basic tendencies of human endeavor.',
  affiliationIntro:
    'Affiliation motive goes hand in hand with the desire to cultivate good contact with other people and to experience fellowship. The relationship motive goes back to the Need Theory of McClelland and forms with the other two motives „Power" and „Achieve" the three basic tendencies of human endeavor.',
  characterTraits: 'Character Traits',
  characterTraitsIntro:
    'The following characteristics describe enduring characteristics of the candidate, as expressed in the letter of application.',
  thinkingStyle: 'Thinking Style',
  spontaneous: 'Spontaneous',
  concrete: 'Concrete',
  deliberate: 'Deliberate',
  abstract: 'Abstract',
  thinkingStyleIntro:
    'People also differ in their way of thinking. Intuitively thinking people often decide on feeling. They often do not worry so much in advance, but trust in a good result. Accuracy is not so important to them. Analytically minded people attach great importance to accuracy and are not satisfied with the approximate. For decisions, they need facts that they weigh carefully.',
  authenticityIntro:
    'Authenticity captures how personally and directly applicants work in the cover letter. Two types are measured: formality (when the language is rather impersonal and formal) and free-out (when the language is personal and free).',
  socialCompetence: 'Social Competence',
  socialCompetenceIntro:
    'Here you can see how dominant applicants are in their writing. The use of different function and content words (especially personal pronouns) provide information about the dominance of a person',
  domination: 'Domination',
  dominationIntro:
    'Domination describes how people fit into a group. The characteristic dominance has the two characteristics „yielding" and „assertive".',
  yielding: 'Yielding',
  assertive: 'Assertive',
  clickToUploadEML: 'Drag and drop an EML-file here\n or click\n to upload emails to analyze',
  clickToUploadPDF: 'Drag and drop a PDF-file here or click to analyze the application',
  explanationJointPosPower:
    '<b>Striving for prestige and recognition and assuming responsibility</b><br><br/>People with a power motive:<ul><li> take <b>influence</b></li><li>like to <b>lead</b></li><li>are <b>competitive</b></li><li>like to have the <b>control</b></li><li>pursue <b>high standards</b></li></ul>',
  explanationJointPosAffil:
    '<b>Strong need for conviviality, social contact and harmonious relationships.</b><br><br/>People with an affiliation motive:<ul><li>cultivate <b>relationships</b></li><li><b>like</b> to work <b>in a team</b></li><li>value <b>feedback and recognition</b></li><li>try to <b>avoid conflict</b></li><li><b>avoid isolation</b></li></ul>',
  explanationJointPosAchieve:
    '<b>Dealing with or achieving self-set achievement goals.</b><br><br/>People with an achievement motive:<ul><li>are <b>ambitious</b></li><li>are <b>competitive</b></li><li>are <b>independent</b></li><li>strive for <b>further development</b></li><li>face <b>challenges</b></li></ul>',
  explanationAuthenticity:
    '<b>Expresses how open, direct and personal the writing style is.</b><br><br/>Authentic texts:<ul><li>seem <b>honest</b></li><li>seem <b>plainspoken</b></li><li><b>loosen up</b> the language</li><li>create a <b>personal connection</b></li></ul>',
  explanationOrientation:
    '<b>Different focus on a goal. Either paying attention to making profits or avoiding losses.</b><br/><br/>People with promotion focus:<ul><li>sometimes take a <b>risk</b></li><li>appreciate <b>progress and performance</b></li><li>solve tasks in a <b>creative way</b></li><li>go <b>new ways</b></li></ul><br/>People with prevention focus:<ul><li>avoid <b>failures</b></li><li>appreciate <b>responsibility and security</b></li><li>solve tasks in a <b>proven way</b></li><li>prefer <b>stable conditions</b></li></ul>',
  explanationAbstractness:
    'The degree of abstraction in language reveals something about how people construct the world around them: in a more abstract or concrete way. Adjectives can be used to describe things that cannot be measured objectively (e.g. characteristics of people). Or they can be used to describe characteristics that go beyond what can be observed in concrete terms. Verbs, on the other hand, can be used to explain concrete facts (e.g. procedures, e.g. how to bake a cake). The concept of linguistic abstraction is related to the perception of opportunities and risks. Depending on what people expect, they use a different linguistic abstractness. An abstract language is more often used when people pursue goals and express hopes. On the other hand, language becomes more concrete when it comes to duties and risks.',
  explanationGender:
    '<b>Language can be differentiated according to whether it emphasizes feminine or masculine characteristics.</b><br/><br/>Feminine language is associated with:<ul><li><b>emotional warmth</b></li><li><b>communality</b></li><li>expression of <b>social relationships</b></li><li><b>balance</b></li></ul><br/>Masculine language is associated with:<ul><li><b>sobriety</b></li><li><b>individuality</b></li><li>expression of <b>competition</b></li><li><b>pragmatics</b></li></ul>',
  explanationEmotionality:
    'Emotionality summarizes the all positive and negative formulations in the text. Positive words like \'friendly\', \'happy\', \'optimistic\' usually express a positive point of view, good mood and friendliness. Negative words like \'anger\', \'disappointment\', \'sadness\' can express regret, anger or generally a bad mood. The aim should be for you to take up the emotional condition of your customers. This can also mean that you name negative emotions when your customer expresses them. This creates a feeling of being understood.',
  explanationBlue: 'Autonomy: rational, analytical, number-oriented, assertive, factual.',
  explanationYellow: 'Excitement: Creative, surprising, open to new ideas, keen to experiment, individual.',
  explanationGreen: 'Certainty: discipline, reliable, pragmatic, traditional, planning.',
  explanationRed: 'Relatedness: Sensitive, communicative, cooperative, interpersonal, familiar.',
  explanationBrandsync:
    'Only if all those involved in the branding process and the target group have a uniform understanding of the brand will the brand message hit the decisive mark: right into the heart. The important prerequisite for this is: a clear understanding of the brand, a targeted synchronisation of all levels of your marketing. This will make you much more efficient and effective. With the dimensions autonomy, excitement, certainty and relatedness, you have the essential characteristics in your hand to strike exactly the right tone for your target group.',
  explanationTalentIntelligence:
    'People are guided by motives. Knowing what drives applicants is especially important in the professional context, because it provides information about which career path is the right one. But first, what are motives? Motives are internal guides to action. They cause a person to think and act in a certain direction. They express a striving: "I would like to be". Three basic motives are distinguished. The motive is (1) responsibility and leadership, (2) performance and development, and (3) harmonious relationships with other people. These motives were formulated and researched by the social psychologist D. McClelland. Talk like your applicant! If you want to address motivated applicants particularly in your advertisement, use performance-related words and a high level of expression on this characteristic when creating the professional profile. This applies accordingly to the other motives.',
  explanationBrand:
    '"If you want to have an effect on other people, you first have to talk to them in their language." This sentence by Kurt Tucholsky already expresses everything that is important in the communication of companies. As the quote suggests, it\'s about imitation. In psychology, this is also known as social mimicry. Imitation takes place on various levels, including linguistic ones. Numerous studies have investigated the influence of imitation and found, for example, a change in accent, speech rhythm or speech speed. Imitation is particularly relevant in the marketing context, as it has an influence on people\'s consumer behaviour. For example, the persuasiveness of messages is higher if they match the language of the target group. Use the following categories to adapt your language to your target group.',
  explanationCustomer:
    'In Customer Intelligence Augmented Writer everything revolves around your customer. To be more precise, it is about how customer loyalty and satisfaction can be maintained or improved. Language is an important tool, as psychological research has shown. Central is the theory of regulatory focus. According to this theory, people can achieve goals via two different self-regulatory systems by taking two different foci. Either the Promotion Focus (need for self-realization and maximization of positive results) or the Prevention Focus (need for protection and security and avoidance of loss). Closely related to this is the concept of Regulatory Fit, which is achieved by fitting regulatory focus and other variables. If there is a regulatory fit, this frequently leads to the implementation of an intention - in the context of customer communication to a better evaluation of the company / product / brand. In the following, you will find the most important linguistic means to achieve a regulatory fit.',
  writeAnswer: 'Write Answer',
  analyzedCustomerProfile: 'Analysed Customer Profile',
  analyzedJobProfile: 'Analysiertes Job Profile',
  affiliation0:
    'Persons with a very low expression do not matter if they are not part of a group. Other things are more important to them than close relationships with other people. They like to work <b>for themselves alone</b>.',
  affiliation1:
    'Persons with a low expression can endure it if they are <b>not part of a group</b>. Other things are more important to them than close relationships with other people. If they don\'t work in a team, but alone, that doesn\'t matter much to them.',
  affiliation2:
    'For people with a high level of development, the focus is on good relationships with other people. They like to feel part of a group. They support others and enjoy working in a team. It is important for them to receive <b>feedback and recognition</b> from their group and from individuals who are important to them.',
  affiliation3:
    'People with a very high level of development are important to have good relationships with others and they need regular contact with them. They feel particularly good when they are <b>part of a group</b>. They support others and enjoy working in a team. It is particularly important for them to receive feedback and recognition from their group and from individuals who are important to them.',
  leadership0:
    'Persons with a very low expression have no problem with being in second place. They do not define themselves by status symbols and they do not seek power over others and do not seek approval from others. They are <b>compromising </b> and prefer others.',
  leadership1:
    'Persons with a low expression also feel comfortable in a subordinate position. They define themselves less by status symbols and it is less important to them to have power over others. They are <b>more willing to compromise</b> than persons with a high characteristic.',
  leadership2:
    'Persons with a high level of development tend to exercise power over others. They succeed in <b>taking influence on others</b> and they do not find it difficult to compete with others. In positions where they lead others, they feel more comfortable than in positions where they are led.',
  leadership3:
    'Persons with a very high expression it is important to get <b>power</b> over and <b>loyalty</b> from others. They have the ability to influence others and no problem competing with others. In positions where they lead others, they feel more comfortable than in positions where they are led.',
  achievement0:
    'People with a very low level of proficiency like to work <b>by the book </b> and they don\'t mind having to work on the same tasks over and over again. Further development in life does not stand in the first place. They rarely set themselves ambitious goals. If nevertheless, they must be motivated often from the outside to it.',
  achievement1:
    'Persons with a low level of expression <b>work more by the book </b> and they don\'t mind doing similar tasks repeatedly. Further development in life is rather a secondary goal. They rarely set themselves ambitious goals. If nevertheless, they must be motivated often from the outside to it.',
  achievement2:
    'Persons with a high degree of <b>like to commit themselves </b> to self-imposed goals and they strive to develop themselves further. Independence is important to them and they attribute successes to themselves. The motivation for success comes from themselves; praise and recognition of others is less important.',
  achievement3:
    'Persons with a very high level of development are prepared to commit themselves strongly to pursuing their goals <b>strongly</b> and strive to continuously improve their own performance. Independence is important to them and they attribute successes achieved to themselves. The motivation for success comes from themselves; praise and recognition of others is not important to them.',
  abstractness0:
    'People with a high degree of expression towards a spontaneous and intuitive way of thinking often decide <b>by feeling</b>. They often do not think much in advance, but trust in a good result. Accuracy is often not important to them. Tasks that require accuracy and conscientiousness make these people reluctant. They are more interested in creative, only roughly outlined tasks.',
  abstractness1:
    'People with a marked tendency towards spontaneous and intuitive thinking often decide by feeling. They often do not think so much in advance, but rather trust in a good result. When solving problems, there are <b>more important aspects for them than accuracy</b>.',
  abstractness2:
    'People with an analytical way of thinking attach importance to accuracy and precision. They make their <b> decisions with caution</b>. They are not satisfied with the approximate. For decisions they need facts that they weigh up several times.',
  abstractness3:
    'Persons with a high degree of analytical thinking style approach their work very <b>exactly and precisely</b>. They are not satisfied with the approximation. Only when all details are correct is a task considered to have been completed for them.',
  selfConfidence0:
    'People with high levels of formal language do not say directly what they think and feel. They are reluctant in their formulations and <b> pay close attention</b> to what they say. This makes the applicant\'s language appear formal.',
  selfConfidence1:
    'Persons with expression towards formal language express themselves more selectively. They are <b>more reserved in their formulations</b> and pay attention to what they say. This can make the applicant\'s language appear less lively.',
  selfConfidence2:
    'It is not difficult for persons with a pronounced tendency towards free out to speak <b>openly about themselves</b>. They are perceived as more direct and personal. They worry less about the impression they leave on others.',
  selfConfidence3:
    'People with a high degree of expression in the free out direction say what they think and feel. They are often perceived as <b>direct and personal</b>. They do not worry about the impression they leave on others.',
  contact0:
    'Persons with a high degree of "indulgence" avoid dominating others and asserting themselves against others. In disputes <b> they give up more quickly </b> and adapt to the majority opinion, even if they do not share it.',
  contact1:
    'Persons with a tendency towards "yielding" do not tend to dominate others and assert themselves unconditionally. In arguments they give up rather than others and <b>do not insist </b> on their point of view.',
  contact2:
    'Persons with an emphasis on \'assertiveness\' are <b>more dominant</b> and stand up for their goals. In disputes they can always assert their point of view. They see themselves more as representatives of a group and therefore often use the pronoun "we", but fewer words that express uncertainty (such as "a little", "perhaps").',
  contact3:
    'People with a high degree of assertiveness are dominant and are committed to their goals in the long term. In disputes they can often assert their <b>point of view </b>. They often see themselves as representatives of a group and therefore often use the pronoun "we", but fewer words that express uncertainty (such as "a little", "perhaps").',
  noProfilesFound: 'No Profiles Found',
  createProfileFirst: 'Please create a profile first.',
  createProfile: 'Create Profile',
  whatAreProfiles: 'What are profiles?',
  switchTag: 'Switch analyses between Tags',
  comparedWith: 'compared with {{profile}}',
  confirmSwitchTag: 'Are you sure you want to move {{ count }} analysis from  "{{ source }}" to "{{ dest }}"?',
  confirmSwitchTag_plural: 'Are you sure you want to move {{ count }} analyses from "{{ source }}" to "{{ dest }}"?',
  moreDetails: 'More details',
  lessDetails: 'Less details',
  more: 'more',
  less: 'less',
  how: 'How?',
  fileName: 'File name',
  fit: 'Fit',
  analysisOf: 'Analysis of {{ analysisName }}',
  saveProfile: 'Save Profile',
  dismissProfile: 'Dismiss Profile',
  downloadAsPdf: 'Download as PDF',
  savePdfFileAs: 'Save PDF File as:',
  print: 'Print',
  fileUploadFolder: 'choose a folder you want to upload the files to.',
  textToAnalyse: 'Text to be analysed',
  analysisName: 'Analysis name',
  directEnterText: 'Enter text',
  folderRename: 'Rename the folder',
  chooseName: 'Enter a name',
  chooseJobProfile: 'Please choose a job profile',
  saveTextProfile: 'Type a name for your text to save',
  loadTextProfile: 'Load text and profile',
  chooseLoadTextProfile: 'Choose a text to load',
  name: 'Name',
  loadTextConfirm: 'Are you sure of loading this text? you\'ll lose the current text inside the editor',
  customValue: 'Custom Value',
  passResetSuccessfully: 'Password reset successfully',
  clearAWButton: 'Remove highlights',
  updateAWButton: 'Analyze the text',
  saveAWButton: 'Save current text',
  loadAWButton: 'Load a saved text',
  videos: 'Videos',
  videoCmId: 'rQsJ8zgLLfU',
  videoProfileId: 'b7Uf4ITNFH0',
  videoTiAwId: '0MtV1j2z9RE',
  videoCiId: 'C8vDM_FFV2o',
  videoCiAwId: 'TGIvR2l2PLo',
  videoBiAwId: 'Kzrf8bkMgX8',
  videoMotivesId: 'M2MONEmaHoc',
  profileVideoName: 'Create profiles',
  motivesVideoName: 'Motives explained',
  welcome: 'Welcome to the SAIA dashboard!',
  search: 'Search...',
  noLogin: 'No Login',
  chooseMore: 'Please choose more of the following words',
  createNew: 'Create new',
  updateExisting: 'Update existing',
  chooseTextOverride: 'Please choose a saved text to override its content',
  manageAWButton: 'Manage texts',
  savedTextProfile: 'Saved profile',
  savedTextName: 'Saved text name',
  chooseEditTextProfile: 'Choose a saved text to edit or delete',
  awManual: 'Augmented Writing Manual',
  teamManual: 'Team Match for Talent Manual',
  ciManual: 'Customer Intelligence Manual',
  talenAWManual: 'Augmented Writing Talent Manual',
  brandAWManual: 'Augmented Writing Brand Manual',
  notEnoughContent: 'In order to obtain a reliable result, the individual text samples should contain at least {{number}} words!',
  scientificBackground: 'Scientific Background',
  helpCenter: 'Help Center',
  connectionFailure:
    'There is a problem with your internet connection or the communication to our server. You can continue your work as soon as the connection is reestablished',
  connectionFailureTitle: 'Internet Connection problem',
  checkConnection: 'Please check your internet connection to be able to perform an analysis',
  EnterTextHere: 'Please enter your text here...',
  contactSales:
    'Thank you for your registration. You currently have no activated products please contact our sales team to receive a free test version.',
  viewTour: 'View Tour',
  sureLeaving: 'Leave Site? Changes that you made may not be saved.',
  closeDialog: 'Close',
  change: 'Change',
  load: 'Load',
  switch: 'Switch',
  cmUploadTitle: 'Upload & analyze\na new application',
  cmViewTitle: 'View uploaded\napplications & results',
  soHints:
    '- Create a new survey folder.\n- Send a survey key to one or multiple email addresses.\n- You can see directly if a survey has already been answered. If answered, you can look at the analysis result.\n- You can copy the survey key with a link to the survey to clipboard\n- You can edit and delete surveys.\n- You can move analyses by drag & drop and you can delete them.',
  hints: 'Hints',
  showHints: 'Show Hints',
  hideHints: 'Hide Hints',
  comparisonWith: 'Comparison with profile: ',
  newProfile: 'New Profile',
  viewResultsCM: 'View results',
  surveyStartPageTitle: 'Information for the upcoming potential analysis',
  startSurvey: 'Start',
  sendSurvey: 'Send',
  contactMotif: 'Contact motive',
  powerMotif: 'Power motive',
  achievementMotif: 'Achievement motive',
  surveyStartPageGreetingTitle: 'Welcome to the potential analysis',
  surveyStartPageGreeting:
    'Dear participant!\n\nThank you for participating in the potential analysis.\nTwo psychological tests follow. Please be completely yourself and do not pretend while you are working on the tests.\n',
  surveyStartPageInfo:
    'A series of pictures will follow. Please write for each picture a story about the people shown in the pictures. Try to imagine what is going on there. Then tell what happened before, what people think about, what they feel and what will happen next. Try to write a story about each picture with a beginning and an end.\n\nYou will find the following questions placed on the image page to help you write the story:\n\nWhat will happen? Who are the people?\nWhat did happen before? How does the story begin?\nWhat do people think about and how do they feel?\nWhat will happen? How does the story end?\n\nThese questions are just guidelines for your stories; You do not have to answer every single one.\n\nImportant: Please write whole stories. Few individual sentences are not sufficient.\n\nYou have about five minutes for each story.\n\nThe entire potential analysis will take about 30 minutes.\n\nThere are no right or wrong stories. Write whatever stories you can come up with.',
  pictureStoryTodo1:
    'Please look at this image as a stimulus for your story just a few seconds. As soon as you know what you want to write, click \'Continue\' below.',
  pictureStoryTodo2:
    'Below are some questions as guidelines. Instead of answering each one individually, please write whole stories in German with a beginning and an end.',
  pictureStoryQuestion1: 'What will happen?',
  pictureStoryQuestion2: 'Who are the people?',
  pictureStoryQuestion3: 'What did happen before?',
  pictureStoryQuestion4: 'How does the story begin?',
  pictureStoryQuestion5: 'What do people think about and how do they feel?',
  pictureStoryQuestion6: 'What will happen? How does the story end?',
  enterTextHere: 'Please write your story here.',
  surveyCompletedAlready: 'The potential analysis has already been answered.',
  surveyNotFound: 'The potential analysis was not found. Please check your URL and the Key in it.',
  questionnaireTitle: 'Questionnaire',
  questionnaireInfo1: 'There are several statements that you can more or less agree with.',
  questionnaireInfo2: 'To do this, please tick one of the options shown between "does not apply at all" (1) to "applies perfectly" (6).',
  questionnaireInfo3:
    'There are no "right" or "wrong" answers and the best way to serve the purpose of the survey is to answer the questions as truthfully as possible.',
  questionnaireInfo4: 'Now there are several statements about goals that you may find more or less important.',
  questionnaireInfo5: 'For each goal, please check how important this goal is in your life, from "not important" (1) to "extremely important" (6).',
  surveyQuestionnaireMissingAnswersError:
    'Please answer all questions before sending. {{count}} question(s) are still unanswered.',
  surveyQuestionnaireSubmitError:
    'Your answers could not be submitted. Please check your answers and try again.',
  beginQuestionnaire: 'Begin questionnaire',
  surveyQuestionnaireContactOne: 'I try to be in the company of friends as often as possible.',
  surveyQuestionnaireContactTwo: 'Meeting with other people makes me happy.',
  surveyQuestionnaireContactThree: 'I spend a lot of time visiting friends.',
  surveyQuestionnaireContactFour: 'I try to get to know other people.',
  surveyQuestionnaireContactFive: 'Often I would rather be with a group of friends than alone.',
  surveyQuestionnaireContactSix: 'Most of the time I choose activities in the leisure time that I can do together with other people.',
  surveyQuestionnaireContactSeven: 'I like to make friends as many as I can.',
  surveyQuestionnaireContactEight: 'When I get to know new people, I feel full of energy.',
  surveyQuestionnaireContactNine: 'To do a lot with other people.',
  surveyQuestionnaireContactTen: 'Have a large circle of acquaintances.',
  surveyQuestionnaireAchievementOne: 'I am drawn to work where I have the opportunity to test my skills.',
  surveyQuestionnaireAchievementTwo: 'I\'ve decided to do at least something more than anyone before me.',
  surveyQuestionnaireAchievementThree: 'To always keep my performance at a high level.',
  surveyQuestionnaireAchievementFour: 'Work of high quality.',
  surveyQuestionnaireAchievementFive: 'Projects that bring me to the limit of my ability.',
  surveyQuestionnaireAchievementSix: 'Improve me constantly.',
  surveyQuestionnaireAchievementSeven: 'Constantly new, interesting and challenging goals and projects.',
  surveyQuestionnaireAchievementEight: 'To take responsibility for difficult and challenging tasks and goals.',
  surveyQuestionnaireAchievementNine: 'Own responsibility to do something better than it was done before.',
  surveyQuestionnaireAchievementTen: 'To be able to create something new.',
  surveyQuestionnairePowerOne: 'I like to call the shots.',
  surveyQuestionnairePowerTwo: 'I strive for positions in which I have authority.',
  surveyQuestionnairePowerThree: 'I\'m interested in leading others.',
  surveyQuestionnairePowerFour: 'I feel in my element when it comes to leading others\' activities.',
  surveyQuestionnairePowerFive: 'I try to get others under my influence instead of letting them control me.',
  surveyQuestionnairePowerSix: 'To exercise control over a group or organization.',
  surveyQuestionnairePowerSeven: 'Can exercise influence.',
  surveyQuestionnairePowerEight: 'To be in a leadership position where others work for me and receive instructions from me.',
  surveyQuestionnairePowerNine: 'Being able to influence other people.',
  surveyQuestionnairePowerTen: 'A position of prestige.',
  surveyEndThanks: 'Thank you for participating in our potential analysis!',
  surveyEndSuccess: 'The potential analysis was successfully completed. The results will now be sent to the creator of this potential analysis.',
  surveyEndGreetings: 'We wish you a lot of success on your future career. Your SAIA team.',
  notImportant: 'not important',
  littleImportant: 'a little important',
  somethingImportant: 'something important',
  important: 'important',
  veryImportant: 'very important',
  extremelyImportant: 'extremely important',
  notApplyAtAll: 'does not apply at all',
  notApply: 'does not apply',
  ratherNotApply: 'does rather not apply',
  ratherApply: 'does rather apply',
  quiteApply: 'does quite apply',
  appliesPerfectly: 'applies perfectly',
  AWTalentQuestion1: 'to prevail against others?',
  AWTalentQuestion2: 'to take responsibility?',
  AWTalentQuestion3: 'to influence others (like convincing others)?',
  AWTalentQuestion4: 'to guide and lead others?',
  AWTalentQuestion5: 'to achieve better results than others?',
  AWTalentQuestion6: 'to go the extra mile?',
  AWTalentQuestion7: 'to avoid failures as much as possible?',
  AWTalentQuestion8: 'to compare themselves with others?',
  AWTalentQuestion9: 'to cultivate a friendly and harmonious relationship to colleagues?',
  AWTalentQuestion10: 'to work together with others?',
  AWTalentQuestion11: 'to spend time with others (and not work alone)?',
  AWTalentQuestion12: 'to help others?',
  AWTalentQuestion13: 'that you appear personally with your company, e.g. \'Me from ...\', \'With us...\', \'With us...\'?',
  AWTalentQuestion14: 'to name things without doubt and unreservedly and to commit oneself?',
  AWTalentExample1Left: 'We should let the others go ahead.',
  AWTalentExample3Right: 'I always manage to convince others of the right course.',
  AWTalentExample4Left: 'I like minding my own business.',
  AWTalentExample4Right: 'If you do that, then it works.',
  AWTalentExample5Left: 'He does not want to be in the spotlight.',
  AWTalentExample5Right: 'He made great efforts to achieve his goal.',
  AWTalentExample6Left: 'Work is important, but other things count too.',
  AWTalentExample6Right: 'She worked hard for her success.',
  AWTalentExample7Left: 'Errors can happen.',
  AWTalentExample7Right: 'It annoyed him that Internet problems delayed the completion of his tasks.',
  AWTalentExample8Left: 'It is not important for me to be better than my colleagues.',
  AWTalentExample8Right: 'Among all employees, she achieved the best result in the annual targets.',
  AWTalentExample9Left: 'It is not important for him to have strong friendships with his colleagues.',
  AWTalentExample9Right: 'She was very sad when her department was dissolved and her colleagues worked in other areas.',
  AWTalentExample10Left: 'I like working for myself.',
  AWTalentExample10Right: 'I am glad that we can finally work together again.',
  AWTalentExample11Left: 'Work is work. Personal things have no place there.',
  AWTalentExample11Right: 'Nice that we spend the lunch break together.',
  AWTalentExample12Left: 'I support my colleagues if they ask, but do not approach them myself.',
  AWTalentExample12Right: 'I am happy if I can help you.',
  AWTalentExample13Left: 'It\'s not about us, it\'s about the job.',
  AWTalentExample13Right: 'In order to address the counterpart, we should also appear in person.',
  AWTalentExample14Left: 'It\'s human if you don\'t know everything.',
  AWTalentExample14Right: 'Of course, the applicants need clarity, and that\'s why we should name things clearly and unreservedly.',
  AWBrandQuestionHeader1: 'How important should be for your future employee ',
  AWBrandQuestionHeader2: 'If you think about your company, how important is then',
  AWBrandQuestion1: 'to avoid failures?',
  AWBrandQuestion2: 'to live in stable conditions?',
  AWBrandQuestion3: 'to avoid risks?',
  AWBrandQuestion4: 'to solve problems in a proven way?',
  AWBrandQuestion5: 'to go your own way?',
  AWBrandQuestion6: 'to have no foreign instructions?',
  AWBrandQuestion7: 'to admit mistakes?',
  AWBrandQuestion8: 'to solve problems in a creative way?',
  AWBrandQuestion9: 'that you personally appear as a company / brand, eg. \'We from ...\', \'For us ...\', \'With us ...\'?',
  AWBrandQuestion10: 'to name and determine things without doubt and without reservation?',
  AWBrandQuestion11: 'to prevail against others?',
  AWBrandQuestion12: 'to have a high status?',
  AWBrandQuestion13: 'to show your Status to others?',
  AWBrandQuestion14: 'to always achieve a high performance?',
  AWBrandQuestion15: 'to demand high goals from oneself and others?',
  AWBrandQuestion16: 'to compare yourself with others in competition?',
  AWBrandQuestion17: 'to have harmonious relationships with others?',
  AWBrandQuestion18: 'to be together with others?',
  AWBrandQuestion19: 'to avoid conflict?',
  AWBrandQuestion20: 'to address them objectively and with few emotions?',
  AWCustomerQuestionHeader1: 'If you think about your customers how important is it then',
  AWCustomerQuestionHeader2: 'If you think about your function as an agent how important is it then',
  AWCustomerQuestion1: 'to avoid failures?',
  AWCustomerQuestion2: 'to live in stable conditions?',
  AWCustomerQuestion3: 'to avoid risks?',
  AWCustomerQuestion4: 'to solve problems in a proven way?',
  AWCustomerQuestion5: 'to go your own way?',
  AWCustomerQuestion6: 'to have no foreign instructions?',
  AWCustomerQuestion7: 'to admit mistakes?',
  AWCustomerQuestion8: 'to solve problems in a creative way?',
  AWCustomerQuestion9: 'that you personally appear as a company / brand, eg. \'We from ...\', \'For us ...\', \'With us ...\'?',
  AWCustomerQuestion10: 'to name and determine things without doubt and without reservation?',
  AWCustomerQuestion11: 'to prevail against others?',
  AWCustomerQuestion12: 'to have a high status?',
  AWCustomerQuestion13: 'to show your Status to others?',
  AWCustomerQuestion14: 'to always achieve a high performance?',
  AWCustomerQuestion15: 'to demand high goals from oneself and others?',
  AWCustomerQuestion16: 'to compare yourself with others in competition?',
  AWCustomerQuestion17: 'to have harmonious relationships with others?',
  AWCustomerQuestion18: 'to be together with others?',
  AWCustomerQuestion19: 'to avoid conflict?',
  AWCustomerQuestion20: 'to address them objectively and with few emotions?',
  AWBrandExample1Left: 'Who dares not, wont not win.',
  AWBrandExample1Right: 'Failures cause me a lot of trouble and make me doubt myself.',
  AWBrandExample2Left: 'Living in stable conditions means boredom.',
  AWBrandExample2Right: 'It gives me a sense of security when my life has a solid structure.',
  AWBrandExample3Left: 'If I never take any chances, I won\'t make any progress.',
  AWBrandExample3Right: 'Change is the danger of something developing for the worse.',
  AWBrandExample4Left: 'It\'s the new solutions that get us ahead.',
  AWBrandExample4Right: 'First of all, I am sceptical about new developments. Have they already proven themselves?',
  AWBrandExample5Left: 'I\'ll take a look at things first with the others.',
  AWBrandExample5Right: 'Being independent and free is worth a lot to me.',
  AWBrandExample6Left: 'I like it when others guide me',
  AWBrandExample6Right: 'I like to find my own way without others',
  AWBrandExample7Left: 'Making mistakes is embarrassing, and I try to avoid them.',
  AWBrandExample7Right: 'You can only learn by making mistakes.',
  AWBrandExample8Left: 'Creativity is for artists.',
  AWBrandExample8Right: 'Really new only comes from creative ideas.',
  AWBrandExample9Left: 'It\'s not about me as a person, it\'s about the thing.',
  AWBrandExample9Right: 'The customer is talking to me, that\'s why I want to appear.',
  AWBrandExample10Left: 'It\'s human to admit your doubts and be reserved.',
  AWBrandExample10Right: 'Of course, the customers need clarity, and that\'s why I should name things clearly and unreservedly.',
  AWBrandExample11Left: 'I don\'t have to stand in the first row.',
  AWBrandExample11Right: 'It\'s important to me that I get ahead of everyone else.',
  AWBrandExample12Left: 'Whether branded or not, the main thing is to make it work.',
  AWBrandExample12Right: 'I like it when the things I own express a certain prestige.',
  AWBrandExample13Left: 'Showing others what I have means nothing to me.',
  AWBrandExample13Right: 'Brands are there to be worn and shown.',
  AWBrandExample14Left: 'I don\'t care if my cell phone camera is the best on the market.',
  AWBrandExample14Right: 'Of course, the processor on my new smartphone should be in the top 3.',
  AWBrandExample15Left: 'Too ambitious technology is unstable and error-prone. That\'s why I don\'t like to buy the latest model.',
  AWBrandExample15Right: 'Because performance is important to me, I love products that are at the cutting edge of technology.',
  AWBrandExample16Left: 'I buy things for myself, so I don\'t compare myself to others.',
  AWBrandExample16Right: 'I enjoy comparing myself to my friends. Then there is often competition.',
  AWBrandExample17Left: 'If anybody\'s too friendly, I get skeptical.',
  AWBrandExample17Right: 'A friendly and personal atmosphere is very important to me.',
  AWBrandExample18Left: 'If the salesgirl comes up to me, it\'ll stress me out. I don\'t need anyone.',
  AWBrandExample18Right: 'Advice and good service are a must, that\'s just part of it.',
  AWBrandExample19Left: 'If I don\'t like the food, I\'ll tell the waiter.',
  AWBrandExample19Right: 'I\'m reserved and I don\'t want to jeopardize the good mood.',
  AWBrandExample20Left: 'The facts should be on the table. There\'s too much feeling just distracting.',
  AWBrandExample20Right: 'I need a positive speech to feel comfortable and accepted.',
  AWCustomerExample1Left: 'Who dares not, wont not win.',
  AWCustomerExample1Right: 'Failures cause me a lot of trouble and make me doubt myself.',
  AWCustomerExample2Left: 'Living in stable conditions means boredom.',
  AWCustomerExample2Right: 'It gives me a sense of security when my life has a solid structure.',
  AWCustomerExample3Left: 'If I never take any chances, I won\'t make any progress.',
  AWCustomerExample3Right: 'Change is the danger of something developing for the worse.',
  AWCustomerExample4Left: 'It\'s the new solutions that get us ahead.',
  AWCustomerExample4Right: 'First of all, I am sceptical about new developments. Have they already proven themselves?',
  AWCustomerExample5Left: 'I\'ll take a look at things first with the others.',
  AWCustomerExample5Right: 'Being independent and free is worth a lot to me.',
  AWCustomerExample6Left: 'I like it when others guide me',
  AWCustomerExample6Right: 'I like to find my own way without others',
  AWCustomerExample7Left: 'Making mistakes is embarrassing, and I try to avoid them.',
  AWCustomerExample7Right: 'You can only learn by making mistakes.',
  AWCustomerExample8Left: 'Creativity is for artists.',
  AWCustomerExample8Right: 'Really new only comes from creative ideas.',
  AWCustomerExample9Left: 'It\'s not about me as a person, it\'s about the thing.',
  AWCustomerExample9Right: 'The customer is talking to me, that\'s why I want to appear.',
  AWCustomerExample10Left: 'It\'s human to admit your doubts and be reserved.',
  AWCustomerExample10Right: 'Of course, the customers need clarity, and that\'s why I should name things clearly and unreservedly.',
  AWCustomerExample11Left: 'I don\'t have to stand in the first row.',
  AWCustomerExample11Right: 'It\'s important to me that I get ahead of everyone else.',
  AWCustomerExample12Left: 'Whether branded or not, the main thing is to make it work.',
  AWCustomerExample12Right: 'I like it when the things I own express a certain prestige.',
  AWCustomerExample13Left: 'Showing others what I have means nothing to me.',
  AWCustomerExample13Right: 'Brands are there to be worn and shown.',
  AWCustomerExample14Left: 'I don\'t care if my cell phone camera is the best on the market.',
  AWCustomerExample14Right: 'Of course, the processor on my new smartphone should be in the top 3.',
  AWCustomerExample15Left: 'Too ambitious technology is unstable and error-prone. That\'s why I don\'t like to buy the latest model.',
  AWCustomerExample15Right: 'Because performance is important to me, I love products that are at the cutting edge of technology.',
  AWCustomerExample16Left: 'I buy things for myself, so I don\'t compare myself to others.',
  AWCustomerExample16Right: 'I enjoy comparing myself to my friends. Then there is often competition.',
  AWCustomerExample17Left: 'If anybody\'s too friendly, I get skeptical.',
  AWCustomerExample17Right: 'A friendly and personal atmosphere is very important to me.',
  AWCustomerExample18Left: 'If the salesgirl comes up to me, it\'ll stress me out. I don\'t need anyone.',
  AWCustomerExample18Right: 'Advice and good service are a must, that\'s just part of it.',
  AWCustomerExample19Left: 'If I don\'t like the food, I\'ll tell the waiter.',
  AWCustomerExample19Right: 'I\'m reserved and I don\'t want to jeopardize the good mood.',
  AWCustomerExample20Left: 'The facts should be on the table. There\'s too much feeling just distracting.',
  AWCustomerExample20Right: 'I need a positive speech to feel comfortable and accepted.',
  sendInvitations: 'Send invitations',
  exportInviteLinks: 'Export invite links',
  exportSelectedInviteLinks: 'Export selected invite links ({{count}})',
  send: 'Send',
  sendInvitationsAt: 'Send invitations for personality test at:',
  classic: 'Classic (4 images)',
  modern: 'Modern (4 images)',
  extended: 'Extended (6 images)',
  expertSample: 'Expert sample',
  leadershipSample: 'Leadership sample',
  surveyType: 'Survey type: ',
  surveyTypeNotSupported: 'There were problems with the survey type',
  addAnother: 'Add another',
  allEmailsSent: 'Email has been sent',
  allEmailsSent_plural: 'All {{count}} emails have been sent',
  allSurveysCreated: 'Survey has been created',
  allSurveysCreated_plural: 'All {{count}} surveys have been created',
  keyCopied: 'Copied link incl. key {{key}} to clipboard.',
  copyKey: 'Copy key',
  infoAboutAI: 'Information about our AI can be found <1>here.</1>',
  soWordCount: '{{words}} / {{minWords}} words',
  soWordHint:
    'The amount of words is just for guidance. But keep in mind, that the results of the potential analysis will be more meaningful, the more text you offer.',
  consentForm: 'Consent form',
  surveyStartPageLegalInquiry:
    'The potential analysis uses the <1>SAIA Sprachanalyse GmbH</1> analysis technology to analyze your implicit and explicit motives.<3></3><4></4>If necessary, data is collected, processed and stored from which individual profiles are created. The collected data, which may also contain personal data, are transmitted to SAIA and processed on their servers.<6></6><7></7>You can prevent the collection of your data by SAIA by telling us <9>here</9>.',
  surveyAgree: 'I agree and would like to participate in the potential analysis.',
  yes: 'Yes',
  no: 'No',
  SEOButton: 'SEO Analysis',
  SEOExplanation: 'Please enter a keyword to analyze it regarding search engine optimization.',
  enterTextInEditorFirst: 'Please enter some text in the editor first',
  keyword: 'SEO Keyword',
  readTermsAndPrivacy: 'By continuing, you agree to the SAIA <1>Terms of Use for Customers</1> and <2></2><3>Privacy Policy</3>.',
  termsOfUse: 'General Terms and Conditions (GTC)',
  dataProcessingAgreement: 'Data Processing Agreement',
  acceptTermsAndPrivacy: 'I have read and agree to the Terms and Conditions and the Privacy Policy.',
  andThe: 'and the',
  privacyPolicy: 'Privacy Policy',
  readTerms: 'I have read and agree to the <1>Terms and Conditions</1>.',
  readPrivacy: 'I have read and agree to the <1>Privacy Policy</1>.',
  surveysMoved: 'Survey(s) moved successfully',
  switchTagSurvey: 'Switch survey(s) between Tags',
  confirmSwitchTagSurveys: 'Are you sure you want to move {{ count }} analysis from  "{{ source }}" to "{{ dest }}"?',
  confirmSwitchTagSurveys_plural: 'Are you sure you want to move {{ count }} analyses from "{{ source }}" to "{{ dest }}"?',
  uploadCSVFile: 'You can add multiple people by uploading a csv file with the following format',
  uploadCSVFileContacts: 'You can add multiple contacts by uploading a csv file with the following format',
  uploadCSVFileContactsManual: 'You can enter email addresses manually and add them to the profile.',
  upload: 'Upload',
  uploadExample: 'Format: Email, Last Name, First Name',
  uploadEmailsExample: 'Format: Emails',
  uploadHint:
    'Note: Please don\'t include a header for the data (i.e. start with the first recipient in the above mentioned format directly in the first row)',
  uploadHint2: 'Upload a csv file and click "Save" afterwards',
  csvUploadAction: 'Click to choose a CSV file',
  csvUploadLoading: 'Importing CSV...',
  csvUploadDownloadTemplate: 'Download template',
  csvUploadResetList: 'Reset list',
  csvUploadHintHeaderOptional: 'Header row is optional. Supported columns: Email, Last Name, First Name.',
  csvUploadImportedRows: 'Imported {{count}} rows from {{file}}.',
  csvUploadNoRows: 'No valid rows were found in {{file}}.',
  csvUploadHeaderDetected: 'Header row detected and skipped automatically.',
  csvUploadInvalidEmails: '{{count}} rows contain invalid email addresses. Please correct them before sending.',
  csvUploadDuplicatesIgnored: '{{count}} duplicate rows were ignored.',
  csvUploadRowsIgnored: '{{count}} empty or incomplete rows were ignored.',
  csvUploadLimitReached: '{{count}} additional rows were skipped due to upload limit (1000 rows max).',
  csvPreviewTitle: 'Import preview',
  csvPreviewRow: 'Row',
  csvPreviewLimitHint: 'Showing first 200 preview rows.',
  csvStatusValid: 'Valid',
  csvStatusInvalidEmail: 'Invalid email',
  csvStatusDuplicate: 'Duplicate',
  csvStatusIgnored: 'Ignored',
  csvStatusTruncated: 'Skipped (limit)',
  focus: 'Focus',
  emotion: 'Emotion',
  motive: 'Motive',
  contactInfo: 'Contact information',
  lastUpdate: 'Last update',
  wordsShared: 'Words analyzed',
  addNewContact: 'New contact',
  contactName: 'Contact name',
  sortBy: 'Sort by',
  searchForContact: 'Search for contact',
  contactsPerPage: 'Contacts per page',
  searchNameOrLinkedInUrl: 'Search by name or LinkedIn URL',
  profileId: 'LinkedIn profile',
  connectionDegree: 'Connected',
  dayMessagesTitle_one: '{{step}} on {{date}} · {{count}} message',
  dayMessagesTitle_other: '{{step}} on {{date}} · {{count}} messages',
  dayMessagesEmpty: 'No messages in the history for this day.',
  connectionRequestNoNote: 'Connection request (no note)',
  visitProfile: 'Visit profile',
  checkReply: 'Check reply',
  checkIfGeneratedEmailAddress: 'Check email address',
  footerNote: 'Tip: Click a name to see details and the interaction history.',
  footerNotePlaceholder: 'Tip: Click a name to see details and the interaction history.',
  deleteContact: 'Delete profile',
  contactDeleteDialog: 'You are about to delete the profile {{firstName}} {{lastName}}. This operation is not reversible, still delete?',
  makeVisible: 'Make visible',
  makeInvisible: 'Make invisible',
  editContactName: 'Edit contact name',
  newText: 'Extend profile',
  seeDetails: 'See details',
  notAnalyzed: 'No profile available',
  ascend: 'Ascending',
  descend: 'Descending',
  updateDate: 'Update date',
  notSet: 'not set',
  emailLong: 'Email (long)',
  textLang: 'Text language',
  inconsistentLang: 'Texts of different languages have been analyzed, which can negatively affect the accuracy of the analyzes.',
  tooFewWords: 'The profile contains too few analyzed words to provide meaningful analysis results.',
  de: 'German',
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  pageLoadError: 'An error occurred while loading the page',
  successNewContact: 'The new contact {{firstname}} {{lastname}} has been added',
  contactDeleted: 'The contact has been successfully deleted',
  successCustomerEdit: 'The contact has been successfully edited',
  successAddText: 'Added new text for contact analysis. Profile has been updated.',
  customerLoadingError: 'An error occurred while loading the contact data',
  analyzeNewText: 'Add new text for profile analysis',
  analyzeNewTextExplanation: 'Adding additional texts will refine the profile of the selected contact.',
  noAssessment2: 'Please add data or set profile manually.',
  noAssessment3: 'To view analysis results, you must first add text using the "{{button}}" button.',
  uploadEmail: 'Upload email',
  chooseEmailParticipant: 'Select the conversation participant to analyze',
  participants: 'Participants',
  choose: 'choose',
  noContactInfo1: 'Welcome to {{product}} by SAIA.',
  noContactInfo2: 'There are only two steps to your first customer analysis:',
  noContactInfo3: '1. Create a new contact with the button "{{button}}".',
  noContactInfo4: '2. Add one or more texts to this contact via the "{{button}}" button.',
  moreInfoCi: 'More information about {{info}}',
  title: 'Title',
  public: 'Visible for company',
  options: 'Options',
  enterEditingMode: 'Editing mode',
  exitEditingMode: 'Exit editing mode',
  moveToFolder: 'Move to folder',
  textMovedSuccess: 'Text moved to directory successfully',
  moveToRoot: 'Move to root directory',
  selectExistingFolder: 'Select existing folder',
  folderSelection: 'Select folder',
  saveEditorText: 'Save editor text',
  searchForText: 'Search for text',
  textTitle: 'Text title',
  folderTitle: 'Folder title',
  successDeleteText: 'The text "{{title}}" has successfully been deleted',
  successDeleteFolder: 'The folder "{{title}}" has successfully been deleted',
  confirmDeleteTitle: 'Deletion warning',
  warning: 'Warning',
  SettingForAutomaticDeletion: 'Setting to automatically remove analyzed data from contacts in years:',
  confirmDeleteText: 'Are you sure you want to delete the text "{{text}}"?',
  confirmDeleteFolder: 'Are you sure you want to delete the folder "{{text}}" and all it\'s texts?',
  confirmChangeNumberOfYears: 'are you sure that you would like to automatically delete information after {{numberOfYears}} years',
  confirmOverwriteTitle: 'Text is overwritten',
  confirmOverwriteText: 'Are you sure you want to overwrite the saved text with the current text from the editor?',
  confirmOverwriteTextNoText: 'The editor currently contains no text, but overwrite it?',
  successOverwriteText: 'The text has been successfully overwritten',
  successOverwriteFolder: 'The folder has been successfully overwritten',
  successPutNewText: 'The text {{name}} has successfully been saved',
  successPutNewFolder: 'The folder {{name}} has successfully been saved',
  successEditExistingText: 'The text {{name}} has successfully been edited',
  successEditExistingFolder: 'The folder {{name}} has successfully been edited',
  confirmCloseDialogTitle: 'Editing process not saved',
  confirmCloseDialogText: 'Do you really want to close the dialog without applying the changes?',
  confirmLeaveEditingModeText: 'Do you really want to leave the editing mode without applying the changes?',
  leave: 'leave',
  notOwnText: 'Not your own text',
  notOwnFolder: 'Not your own folder',
  profileNotCompanyWide: 'Not company wide',
  addNewText: 'Add new text',
  addFolder: 'Add folder',
  saveText: 'Save text',
  searchText: 'Search text',
  enterTextName: 'Please enter a name for the new text',
  removeAnalyzedProfile: 'Discard analyzed profile',
  searchVolume: 'Search Volume',
  searchCompetition: 'Competition',
  searchCPC: 'Cost-per-Click (cpc)',
  SEOResult: 'SEO Results',
  pdfCreate: 'generating PDF',
  noTextsAvailable: 'No texts available',
  notes: 'Notes',
  noKeywords: 'No related keywords found.',
  startPageWelcome: '<0>Welcome to</0> <1></1> <2>SAIA, {{firstName}} {{lastName}}</2>',
  startPageInfo: 'Here you can see all the products that are activated for the account "{{username}}".',
  selectAwProfile: 'Select a profile',
  startPageAWTI: 'Write job advertisements in the tone that your candidates find attractive. Check that you have chosen a relevant title.',
  startPageCM: 'Analyze your existing teams for diversity and homogeneity. Find out which potential candidates fit best into this team.',
  startPageBAR: 'Nothing yet.',
  startPageBS: 'Optimize your marketing texts according to the BrandSync-Categories.',
  startPageSegmentation: 'Analyze the distribution of your customers',
  startPageCI:
    'Analyze incoming messages from your customers and get an individual customer profile. Write answers that match the personal customer profile',
  startPageAWB: 'Write website texts, blog posts, brochures and sales folders based on a Buyer Persona.',
  startPageAWC:
    'Write newsletters, first addresses in the acquisition of new customers for the different direct messaging channels on the basis of a Buyer Persona',
  startPageSurvey:
    'Enter basic implicit and explicit motives. Get recommendations for action in dealing with your motive characteristics in your daily work.',
  startPageProfiles: 'Create and manage target profiles.',
  startPageAdmin: 'Management of user rights, bookings, etc.',
  questionnairePagination: 'Page {{page}} of {{pagesCount}}',
  infoTextCi:
    '- New contacts can be added using the + button.\n- Contacts can be searched and sorted.\n- Contacts can be edited or deleted.\n- Clicking on the contact card will take you to the individual analysis page for further details.\n- Clicking \'{{reply}}\' will take you to the augmented writer in which the current contact profile is loaded.\n- By clicking on \'{{extendProfile}}\' further texts can be added to the contact profile either directly or via an .eml file.',
  infoTextAw:
    '- New profiles can be created directly in the Augmented Writer.\n- Profiles that have already been created can be searched for via auto-completion and loaded into the AW.\n- If a profile is selected and text in the editor, the analysis can be started using the button.\n- Analyzed text from the editor can be freed from the highlights for copying.\n- Texts can be loaded, saved, overwritten or deleted.\n- The higher the score, the better the text from the editor fits the selected profile.\n- Diagram fields filter highlights when hovering.\n- More information on the characteristic by clicking on the respective diagram field.\n- Suggestions are sorted by importance.\n- Suggestions with more information are marked and therefore clickable.\n- Highlighting provides additional information when hovering.\n- A black border indicates a replacement proposal.',
  infoTextCm:
    '- Job offers can be created using the plus button.\n- A team, a profile, or neither can be added when creating a job offer.\n- Job offers can be deleted, searched and sorted alphabetically by name.\n- Teams can be created and managed in the team dialog.\n- Teams can be deleted, searched and sorted alphabetically.\n- The team name can also be changed afterwards.\n- Team members can be added to a team, you can also remove them from it.\n- The PDF survey report of an employee is available for download.\n- The details page of a job offer provides information about the currently added team and its applicants.\n- Teams and job profiles of a job offer can also be changed afterwards.\n- Applicants can be added to the application letter either via surveys or via free text and PDF uploads.\n- If applicants were added via survey, applicants can no longer be added via free text and PDF and vice versa.\n- You can view the survey status of applicants added through a survey, and if completed, the PDF survey report is available for download.\n- Applicants can be removed from the job offer.\n- Surveys can be sent to the recipient again.\n- The survey link can be copied to the clipboard.\n- The team diagram shows the line-up of the currently selected team and gives recommendations as to which motive type should best be addressed in the job offer.\n- The selected profile is integrated into the Augmented Writer Talent Intelligence by clicking the "{{button}}" button.',
  done: 'done',
  addProfile: 'Add profile',
  editProfile: 'Edit profile',
  deleteProfile: 'Delete profile',
  copyApiKey: 'Copy API key ID',
  awManualLink: 'Instruction_SAIA_Augmented_Writing.pdf',
  customer_intelligence: 'Communication-Analysis for Customer',
  customer_segmentation: 'Segmentation-Analysis for Customer',
  augmented_writing_customer: 'Augmented Writing for Customer',
  augmented_writing_talent_intelligence: 'Augmented Writing for Talent',
  competence_monitor: 'Team-Match for Talent',
  augmented_writing_brand: 'Augmented Writing for Brand',
  augmented_writing_brand_sync: 'Augmented Writing Brand Sync',
  brand_awareness_radar: 'Brand Awareness Radar',
  seo: 'SEO',
  api: 'API',
  support: 'Support',
  administration: 'Administration',
  adminSectionOverview: 'Overview',
  adminNavMonitoring: 'Monitoring',
  adminNavUserOverview: 'User overview',
  adminNavQueue: 'Queue management',
  adminNavLinkedinSession24h: 'LinkedIn session (24h)',
  adminNavCampaignTimeline: 'Campaign contact timeline',
  adminNavFeedbackTickets: 'User feedback',
  adminBackToOverview: 'Back to administration overview',
  startPageSEO: '',
  startPageAPI: '',
  removeHeader: 'Please remove the header from the csv file and upload again',
  surveyDelete: 'Delete analysis',
  surveyDeleteWarning: 'Are your sure you want to delete {{surveyName}}? You will lose the analysis calculated for this.',
  surveyDeleteWarning_plural: 'Are your sure you want to delete {{surveyName}}? You will lose all {{count}} analyses calculated for this.',
  jobOffersPerPage: 'Job offers per page',
  teams: 'Teams',
  team: 'Team',
  cmManualProfile: 'Manually created profile',
  successAddJobOffer: 'The job offer "{{tagName}}" has successfully been added',
  deleteJobOffer: 'Delete job offer',
  successDeleteJobOffer: 'Job offer deleted',
  deleteJobOfferText: 'You are about to delete the job offer "{{tagName}}"',
  pdfReport: 'PDF Report',
  applicants: 'Applicants',
  addApplicant: 'Add applicant',
  selectVariant: 'Select variant',
  selectVariantText: 'Select the variant with which you want to add the applicant(s) to the list',
  survey: 'Motive\nanalysis',
  lead: 'LEaD\nEvaluation',
  text: 'Free text',
  pdf: 'PDF file',
  audio: 'Audio file',
  successAddApplicant: 'Applicant {{firstname}} {{lastname}} has successfully been added',
  successAddApplicantSurvey: 'The applicant has successfully been added',
  successAddApplicantSurvey_plural: '{{count}} applicants have successfully been added',
  motiveForm: 'Motive form',
  variant: 'Variant',
  selectedProfile: 'Selected profile: {{profile}}',
  writeJobOffer: 'Write job offer',
  amountIndifferent: 'One team member cannot be assigned to any of the above characteristics',
  amountIndifferent_plural: '{{count}} team members cannot be assigned to any of the above characteristics',
  newTeam: 'New team',
  teamName: 'Team name',
  editTeam: 'Edit team {{teamName}}',
  teamMember: 'Team member',
  changeTeamName: 'Change team name',
  viewTeam: 'View team',
  newTeamMember: 'Add team members',
  deleteTeam: 'Delete team',
  confirmDeleteTeamMember: 'You are about to remove {{firstname}} {{lastname}} from the team, proceed?',
  successDeleteTeamMember: 'Successfully deleted team member',
  confirmDeleteTeam: 'Your are about to delete the team {{teamName}}, proceed?',
  successDeleteTeam: 'Team {{team}} has successfully been deleted',
  successEditTeam: 'Team {{team}} has successfully been edited',
  teamManagement: 'Team management',
  addMembersToTeam: 'Add members to team {{teamName}}',
  searchJobOffer: 'Search job offer',
  searchTeam: 'Search for team',
  viewJobOffer: 'View job offer',
  instructions: 'Instructions',
  newJobOffer: 'New job offer',
  resendSurvey: 'Resend mail',
  noTeamMembersAvailable: 'No team members available',
  removeEmployeesFromTeam: 'Remove employees from team',
  jobProfile: 'Job profile',
  chooseProfileType: 'Select the desired profile type',
  confirmDeleteApplicant: 'Are you sure you want to remove the applicant?',
  applicantSurveysDisabled: 'Applicants have already been added via free text or PDF, so it is no longer possible to add them via surveys.',
  applicantTextAndPdfDisabled: 'Applicants have already been added via surveys, so it is no longer possible to add via free text or PDF.',
  noTeamAdded: 'No team added yet.',
  successApplicantRemoved: 'Removed applicant successfully',
  recommendations: 'Recommendations',
  teamProfileSwitch: 'Team Profiles',
  noApplicantsAvailable: 'No applicants are available',
  share: 'Share',
  authGmail: 'Please login to save your Gmail credentials',
  successResendSurvey: 'The survey was resent to {{firstname}} {{lastname}}',
  amountTeamMembers: 'Amount of team members',
  surveysPending: 'Surveys pending',
  showOnlyWonContacts: 'Show only own contacts',
  notOwnGlobalContactTooltip: 'The contact was shared with you and can only be edited or deleted by the creator.',
  globalContactTooltip: 'You made this contact visible for your company',
  shareWithCompany: 'Share with your company',
  saveJobOfferToCm: 'Save job offer',
  searchSpace: 'Search space',
  moreInfoSEOResultsTitle: 'Legend',
  seoInfoDialogSearchVolumeContent: 'Search Volume is the amount of searches per month that occur for a particular keyword or term.',
  seoInfoDialogCompetitionContent:
    'Indicates how hard it would be to use SEO on a new webpage to hypothetically outrank the web pages that are currently ranking high on search engine result pages. A value of 100% means, for example, that 100% at least one competitor is ranked higher.',
  seoInfoDialogCpcContent:
    'Cost per click (CPC) is a paid advertising term where an advertiser pays a cost to a publisher for every click on an ad. CPC is used to determine costs of showing users ads on search engines, Google Display Network for AdWords, social media platforms and other publishers.',
  timeToWrite: 'Time to write',
  existingMembers: 'Copy/move member from existing team',
  selectVariantTextTeamDialog: 'Select the variant with which you want to add the team member(s)',
  intoTeam: 'into team "{{team}}"',
  fromTeam: 'From team',
  move: 'move',
  copy: 'copy',
  addWithSurvey: 'Add new member via survey to the team',
  addMailThreadTexts: 'Add new mails from current thread to profile',
  noContactOutlook: 'Please specify a recipient for the email and reload',
  noProfileOutlook1: 'No profile found for this contact.',
  noProfileOutlook2: 'First analyze received emails from this address or select an already existing profile.',
  loadTextFromOutlook: 'Import text from Outlook Editor',
  sendTextToOutlook: 'Send text back to Outlook Editor',
  ciApikey: 'CI API-Key',
  awApikey: 'AW API-Key',
  enterApiKeys: 'Please enter API-Keys',
  ciKeyNotValid: 'CI API-Key invalid',
  awKeyNotValid: 'AW API-Key invalid',
  noTextFoundToAnalyze: 'No text content from the selected sender found for analysis in current mail thread.',
  allTextsAnalyzed: 'Already analyzed all mails in this thread',
  hashError: 'Error while processing the sender',
  mailHandlerError: 'Error while processing the mail thread',
  customerTagCreationError: 'Error while creating the profile',
  mailTextAddError: 'Error while adding the text',
  warningNoEmailSent: 'No automatic email was sent',
  notSendEmail: 'Don\'t send email',
  achieveResults: 'Achieve\nresults',
  manageChanges: 'Manage\nchanges',
  shaping: 'Shaping\nvision & strategy',
  competencies: 'Competencies',
  creativePersonality: 'Act as a\ncreative personality',
  develop: 'Develop employees\n& teams',
  loadingSentences: 'Loading sentences...',
  improvesScore: 'Improves the score',
  scoreIndependent: 'Score independent',
  triggerAutocompleteOneLanguage: 'Autocomplete for texts of the language: {{language}}',
  triggerAutocompleteMultipleLanguages: 'Autocomplete for texts of the languages: {{language1}} and {{language2}}',
  sentenceGenerationKeys: 'with SHIFT + SPACE',
  cancelSuggestion: 'cancel with ESC',
  successAddApiKey: 'API-Key has successfully been added',
  generationLanguageNotSupported: 'We are working on enabling auto-completion for other text languages as well. Currently only English is supported',
  emptyInputText: 'Please enter text to use this function',
  noSentencesGenerated: 'No matching sentences found',
  notRecognizedContent: 'The analyzed text contains text passages which cannot be assigned to any of the supported languages!',
  analysisSelected: 'One analysis selected',
  analysisSelected_plural: '{{count}} analyses selected',
  confirmDeleteSurveys: 'Are you sure you want to delete the selected analysis?',
  confirmDeleteSurveys_plural: 'Are you sure you want to delete all {{count}} selected analyses?',
  enterPlaceholder: 'Enter placeholder',
  amount: 'Amount',
  username: 'Username',
  roleInCompany: 'Role in company',
  branch: 'Branch',
  branches: 'Branches',
  roles: 'Roles',
  branchOfCompany: 'Branch of the company',
  addRole: 'Add role',
  addBranch: 'Add branch',
  successAddNewTag: 'New role {{tag}} has successfully been added!',
  errorAddNewTag: 'An error occurred while adding a tag!',
  successDeleteTag: 'The tag {{tag}} has successfully been deleted!',
  confirmDeleteTag: 'Are you sure you really want to delete the tag {{tag}}?',
  errorDeleteTag: 'An error occurred while deleting the tag!',
  successAddNewBranch: 'New branch {{branch}} has successfully been added!',
  errorAddNewBranch: 'An error occurred while adding a branch!',
  successEditNewRole: 'The role has successfully been edited!',
  errorEditNewRole: 'An error occurred while editing the role!',
  editTag: 'Edit tag',
  editName: 'Edit name',
  saveName: 'Save name',
  searchFor: 'Search for {{item}}',
  successDeleteBranch: 'The branch {{branch}} has successfully been deleted!',
  errorDeleteBranch: 'An error occurred while deleting the branch!',
  successEditNewBranch: 'The branch has successfully been edited!',
  errorEditNewBranch: 'An error occurred while editing the branch!',
  editBranch: 'Edit branch',
  confirmDeleteBranch: 'Are you sure you really want to delete the branch {{branch}}?',
  whatHappenToEmails: 'What would you like to happen to the email(s) already available on the profile?',
  keepThem: 'Keep them',
  replaceThem: 'Replace them',
  companyAdministration: 'Company administration',
  customerIntelligenceStatistics: 'Customer Intelligence Statistics',
  editRolesAndBranches: 'Edit roles & branches',
  emailAlreadyExists: 'The email is already used in another account',
  triggerAnalysis: 'Trigger the analysis',
  analysisKeys: 'with ALT + ENTER',
  tooMuchContent: 'In order to obtain a reliable result, the individual text samples should contain a maximum of {{number}} words!',
  reduceWords: 'Reduce the number of words in the text to start the analysis',
  wordCount: '{{words}} Words',
  licenses: 'Licenses',
  passChanged: 'Password Changed',
  makeSurePasswordCorrect: 'Make sure the password entered is correct',
  infoUpdated: 'Your info has been updated',
  'user(s)': 'User(s)',
  expiresOn: 'Expires On',
  trial: 'Trial',
  licenseRemoveConfirmation: 'Delete license',
  licenseWillNoLongerBeAvailable: 'Do you really want to delete the license für <strong>{{license}}</strong> with <strong>{{count}}</strong> users?\n\nThe process is not reversible and it will no longer be available afterwards.',
  changeActiveLicenseConfirmationText: 'This will change the license status. Only active licenses can be used in the application.',
  newLicense: 'New License',
  expDate: 'Expiration Date',
  isTrial: 'Trial License',
  apiKeyCopied: 'API Key Copied',
  noCompany: 'No Company',
  editLicense: 'Edit License',
  addExistingUser: 'Add Existing User',
  addNewUser: 'Add additional user',
  noAnalysisPossible: 'Select a profile and write text in the editor',
  noData: 'There are no data for your selection yet',
  noProfile: 'Select a profile',
  noText: 'Write text in the editor',
  fontText: 'Font Picker',
  boldText: 'Bold',
  italicText: 'Italic',
  underlineText: 'Underlined',
  numberedList: 'Numbered List',
  bulletList: 'Bullet List',
  indentForward: 'Forward Indentation',
  indentBackward: 'Backward Indentation',
  diversity: 'Gender diversity',
  yourCustomer: 'Your customer',
  performanceProfitOriented: 'achievement oriented and profit oriented',
  are: 'are',
  you: 'You',
  relationshipQuality: 'Your relationship quality is',
  relationshipTendency: 'The tendency of your relationship quality is',
  relationshipQualityStrong: 'Very good, relationships above 80% imitation have up to 25.7% higher closing probability.',
  relationshipQualityOK: 'Be more responsive to the other person. With a score above 80%, you would be up to 25.7% more likely to close the deal.',
  relationshipQualityBad:
    '	Less than 60% imitation dramatically reduces your closing probability. Respond better to your counterpart and thus significantly increase your closing probability.',
  relationshipTendencyIncrease: 'Very nice, your counterpart builds up closeness to you. This increases your probability of closing the deal.',
  relationshipTendencyDecrease: 'Your counterpart is distancing himself from you. Counteract this with the right choice of words.',
  averageImitationScore: 'Average - Content-Engagement-Score',
  averageWorkTime: 'Average Time of Work',
  averageImitationImprovements: 'Average - Content-Engagement-Score - Improvements',
  genderScoreImprovement: 'Average - Gender-Diversity-Score - Improvement',
  averageGenderScore: 'Average - Gender-Diversity-Score',
  category: 'Category',
  relationshipTendencyNeutral: 'There is no change in your relationship with the other person.',
  noRelationshipQuality: 'We do not yet have a conversation history for the analysis of relationship quality',
  clickHereToImport: 'Please click here to get text.',
  tooInformal: 'Too informal',
  tooFormal: 'Too formal',
  showAll: 'Show all',
  hintsForSpeech: 'Tips for addressing',
  emailTemplates: 'Email templates',
  pitchViaEmail: 'Pitch via mail',
  invitationCall: 'Invitation Call',
  mailAfterCall: 'Mail after call',
  offerMail: 'Offer mail',
  followUpAfterOffer: 'Follow up after offer',
  thankYouForAcceptance: 'Thank you email for acceptance',
  customizeTemplates: 'Customize templates',
  editTemplates: 'Manage\ntemplates',
  selectAssessment: 'Select assessment',
  emailTemplateName: 'Email template name',
  selectTemplateToCustomize: 'Select the phase where you want to change the template:',
  orCreatePhase: 'Or create a new phase',
  createNewPhase: 'Create new phase',
  editOrCreatePhase: 'Edit or create phase',
  phaseName: 'Phase name',
  selectTypeAndCustomizeText: 'Select type and customize text',
  selectTypeOfCustomer: 'Select the type of customer you want to customize the template for',
  yourTemplateIsAvailable: 'Your new template is available immediately',
  editAnotherTemplate: 'Edit another template',
  before: 'Before',
  after: 'After',
  firstPosition: 'First position',
  editText: 'Edit text',
  templates: 'Templates',
  loadTemplate: 'Load template',
  order: 'Order',
  hintForSpeechHeadline1: '„What kind of thinking and acting characterizes your counterpart?“',
  hintForSpeechHeadline2: '„Answer these questions for your counterpart and you\'ve already pretty much won:“',
  hintForSpeechHeadline3: '„Strong words for more success“',
  idealFormality: 'Formality ideally met',
  profileSelection: 'Select profile',
  profileChange: 'Change Profile',
  welcomeTo: 'Welcome to',
  selectExistingProfile: 'Select existing profile',
  newProfileCreation: 'Create new profile',
  newProfileGroupCreation: 'Create profile group',
  onlyOwn: 'Show only own contacts',
  welcomeTo100w: 'Welcome to 100W',
  textgenre: 'Text genre',
  websiteText: 'Website text',
  augmentedWriting: 'Augmented Writing',
  outlookPlugin: 'Outlook Plugin',
  days: 'Days',
  chooseProfile: 'Choose Profile',
  addData: 'Add Data',
  manageTexts: 'Manage Texts',
  date: 'Date',
  words: 'Words',
  score: 'Score',
  profileTextsAppear: 'Texts of the contact appear',
  targetGroupTextsAppear: 'Texts of the target group appear',
  outlookFooterDialogTitleAw: '100W Analysis',
  outlookFooterTextAw: '100W Analysis',
  outlookFooterText: 'Reply with 100W',
  outlookFooterDialogTitle: 'How to answer with 100W?',
  outlookFooterDialogContent:
    'To be able to use the 100W plugin also when replying to a mail, click Reply in the Outlook tool. Then click on the 100Words logo again.',
  changesTakeTime: 'Please note that changes in the licenses usually take few minutes to take effect.',
  changingToSmallerPlan: 'Changing to smaller plan might cause loss of data in case the current data exceeds the new license quota.',
  analyseTextFirst: 'First analyze a text in the text field',
  userOrEmail: 'User or email address',
  orSelectProfile: 'or select an already existing profile',
  useSelectedProfile: 'Use selected profile',
  inviteUser: 'Invite user',
  createBranch: 'Create Branch',
  updateBranch: 'Update Branch',
  createRole: 'Create Role',
  updateRole: 'Update Role',
  branchRemoveConfirmation: 'Are you sure you want to remove this branch?',
  branchWillNoLongerBeAvailable: 'This action is irreversible. The branch "{{branch}}" will no longer be available.',
  tagRemoveConfirmation: 'Are you sure you want to remove this tag?',
  tagWillNoLongerBeAvailable: 'This action is irreversible. The tag "{{tag}}" will no longer be available.',
  mergeProfiles: 'Merge profiles',
  reallyWantMerge: 'Do you really want to merge the following profiles?',
  processNotReversible: 'This process is not reversible, the original profiles are no longer available afterwards.',
  enterNameMergedProfile: 'Enter a name for the merged profile',
  mergeSuccess: 'The profiles were successfully merged.',
  mergeError: 'An error occurred while merging the profiles!',
  rolesAndBranches: 'Roles & Branches',
  improvesOverallScore: 'Removing this word improves the overall score.',
  addTag: 'Add Tag',
  targetGroupProfile: 'Target Group Profile',
  expression: 'Expression in %',
  loadingChart: 'Loading chart...',
  noTextAnalyzedYet: 'No text has been analyzed yet',
  selectTags: 'Select Tags',
  addEmails: 'Add Emails',
  firstAddTextToProfile: '* First add a text to the profile',
  createProfileManually: 'Set profile manually',
  understood: 'Understood, continue',
  manualProfileWarning: 'It is better to insert texts so that the AI can work. It is recommended that only experienced users set profiles manually.',
  tags: 'Tags',
  tag: 'Tag',
  successProfileEdit: 'The profile was successfully edited',
  successProfileAdd: 'The profile was successfully added',
  successTagAdd: 'The tag was added successfully',
  successAddEmails: 'The email(s) was added successfully.',
  errorAddEmails: 'An error occurred while adding the email(s)!',
  wordsAnalyzedForProfile: 'An average of <strong>{{amount}} words</strong> were analyzed for this profile.',
  pleaseSelect: 'Please select',
  addText: 'Insert text here',
  motivationAnalysis: 'Motivation analysis',
  deleteAnalysis: 'Delete analysis',
  confirmDeleteAnalysis:
    'Are you sure you really want to delete the analysis? This operation is not reversible, the analysis will no longer be available afterwards.',
  writeAText: 'Write a text…',
  selectOperatingVersion: 'Select operating version',
  outlookManualIntroduction:
    'The SAIA Outlook plugin can be installed in several ways. This depends on the number of users and their permissions. Users can, if the internal permissions allow it, install the plugin themselves on their own system. Alternatively, the plugin can be installed centrally by an administrator of the mail server for all or a group of users in the company.',
  pdfManual: 'PDF Manual',
  yourPersonalApiKey: 'Your personal API key: ',
  download: 'Download',
  downloadAddin: 'Download add-in',
  downloadRuntime: 'Download Runtime',
  authenticateAddin: 'Click here to authenticate the add-in',
  installationO365FirstPart: '2. Download the file. Save it.\nIf you are using the Safari browser:\n',
  installationO365ListItemOne:
    'Go to Safari\'s preferences, select "pop-up windows" under "websites" in the left bar, and select "allow" at outlook.office.com in the middle of the window.',
  installationO365ListItemTwo: 'Go to Outlook Web App and log out of Outlook. After that, close Safari completely as well.',
  installationO365SecondPart:
    '3. Please open your Outlook and click on "Get Add-Ins".\n' +
    '4. Multiple steps are combined here. Please select "My add-ins", then click on "+ Add custom add-in" at the bottom and "Add from file". - Please select the downloaded manifest XML file here.\n' +
    '5. Afterwards the add-in installs itself automatically.\n' +
    '6. Please close Outlook once and restart it afterwards.\n' +
    '7. You can now open the add-in in the tab under "SAIA".\n' +
    '8. Log in there with your 100W account.',
  installationVsto:
    '1. Download the file. Save it.\n' +
    '2. Make sure that Outlook is closed.\n' +
    '3. Please run the downloaded file 100W-Outlook-Add-In.exe.\n' +
    '4. Afterwards the add-in installs itself automatically.\n' +
    '5. Start Outlook.\n' +
    '6. You can now open the add-in in the tab under "SAIA".\n' +
    '7. Please enter your personal API key there.',
  manualProfile: 'Manual profile',
  outlookVersion: 'Outlook Version',
  loadingProfiles: 'loading profiles...',
  searchForProfile: 'Search for profile',
  optional: 'optional',
  newVersionAvailableTitle: 'New version available',
  newVersionAvailableText: 'Download the newest version of the add-in.',
  hide: 'hide',
  qualityAnalytics: 'Analytics - Relationship Quality',
  imitationAnalytics: 'Analytics - CES/GES',
  lastSevenDays: 'Last 7-Days',
  lastMonth: 'Last Month',
  lastYear: 'Last Year',
  selectDurationForAnalysis: 'Select a time period for your analysis',
  totalScore: 'Total Score',
  tendency: 'Tendency',
  mostCommon: 'Most Common',
  good: 'GOOD',
  okUpper: 'OK',
  bad: 'BELOW AVERAGE',
  upward: 'UPWARD',
  same: 'UNCHANGED',
  downward: 'DOWNWARD',
  all: 'All',
  sessionExpired1: 'Your session has expired',
  sessionExpired2: 'Please login again.',
  subscription: 'Subscription',
  services: 'Services',
  forSmallTeams: 'For small teams',
  forMediumTeams: 'For medium teams',
  forLargeTeams: 'For large teams',
  amountUsers: '{{amount}} Users',
  paymentOutlookDescription1: 'Analysis of the needs of customers / candidates',
  paymentOutlookDescription2: 'Analysis of the current relationship with the customer / candidate',
  paymentOutlookDescription3: 'Customization of own emails according to the needs of the client / candidate',
  profileManagement: 'Profile management',
  paymentProfileManagementDescription1: 'Create automatic target groups from the analyzed customers',
  paymentProfileManagementDescription2: 'Create automatic target groups from well-performed cover letter texts',
  paymentProfileManagementDescription3: 'Build target groups based on your own personas',
  paymentAugmentedWriterDescription1: 'Optimization of mailings and social media messages to the needs of the target group',
  paymentAugmentedWriterDescription2: 'Optimization of job ads / website texts to the needs of the target group',
  amountOfRequests: 'Amount of requests',
  paymentPeriod: 'Payment period',
  paymentUsers: 'Users',
  unlimited: 'unlimited',
  yearly: '1 Year',
  monthly: '1 Month',
  priceYearly: 'Price with annual billing',
  priceMonthly: 'Price with monthly billing',
  test: 'Test',
  buyNow: 'Buy now',
  preregisterNow: 'Pre-register now',
  specialPlanContactIntro: 'Need a special plan for you or your company? Reach out to us directly:',
  modificationDate: 'Modification Date',
  and: 'and',
  or: 'or',
  significanceTest: `
    Significance test.

    Your selection is not yet significant.

    Add between {{ from }} - {{ to }} more texts to reach significance.`,
  significanceExample1: 'Examples:',
  significanceExample2: '"TAG 1" AND "TAG 2": Only data that has both tags will be filtered.',
  significanceExample3: 'Example: Filtering for sales managers in a region. "Sales managers AND Germany" returns all sales managers from Germany.',
  significanceExample4: '"TAG 1" OR "TAG 2": Filter data that has either one or the other tag.',
  significanceExample5:
    'Example: Filtering for sales managers and marketing managers. "Sales managers OR marketing managers" returns all sales and marketing managers.',
  significanceExample6: '"TAG 1 AND TAG 2 OR TAG 3 AND TAG 4".',
  significanceExample7: 'Filter data that have either TAG 1 and TAG 2 or TAG 3 and TAG 4. \n',
  significanceExample8:
    'Example: Filtering for sales and marketing managers from Germany. "Sales managers AND Germany OR Marketing managers AND Germany" will output all sales and marketing managers. Germany.',
  marketingExample:
    'Hello dear user,\n' +
    'Thank you for your interest in precise emotional communication. This text is already saved in the editor to give you a better understanding of the individual functions.\n' +
    'Of course you can replace it directly with your own text from your landing page.\n' +
    'The Augmented Writer offers the following features:\n' +
    '- Based on the selection of your target group, SAIA analyzes in the background how well you hit the current tone of this target group. The higher the score on the right side, the more precisely you hit the tone. The goal is to achieve the highest possible score.\n' +
    '- To make your work easier, the Augmented Writer offers you "blue underlined" suggestions. The thickness of the underline indicates the strength of the suggestion. Focus on the thicker suggestions first and then click on the thinner ones.\n' +
    '- In addition to this, our Augmented Writing offers you spelling verbsserungen. You can find them with a "gray underlined line".\n' +
    '- If you don\'t achieve a high score with the suggestions alone, which should be the exception, we offer you additional lists with promising words. You can find them on the right side of the page. Include them in your text and achieve a better effect with your target group.\n' +
    'Currently the text genre {website} is selected. SAIA is calibrated for different communication channels. You can find them under the text genre selection. This way we provide an even better fit to the tonality of your target group. For example for newsletters, outreach or websites.\n' +
    'And now have fun optimizing.\n' +
    'Feel free to replace this text with another text of your choice from the specific genre.',
  hrExample:
    'Hello dear user\n' +
    'Thank you for your interest in precise emotional communication. This text is already saved in the editor to give you an understanding of the individual functions.\n' +
    'Of course you are welcome to replace it directly with your own job ad.\n' +
    'The Augmented Writer offers the following features:\n' +
    '- Based on the selection of your target group, SAIA analyzes in the background how well you match the current tone of this target group. The higher the score on the right side, the more precisely you hit the tone. The goal is to achieve the highest possible score.\n' +
    '- To make your work easier, the Augmented Writer offers you "blue underlined" suggestions. The thickness of the underline indicates the strength of the suggestion. Focus on the thicker suggestions first and then click on the thinner ones.\n' +
    '- In addition to this, our Augmented Writing offers you spelling verbsserungen. You can find them with a "gray underlined line".\n' +
    '- If you don\'t achieve a high score with the suggestions alone, which should be the exception, we offer you additional lists with promising words. You can find them on the right side of the page. Include them in your text and achieve a better effect with your target group.\n' +
    'Currently the text genre {job ads} is selected. SAIA is calibrated for different communication channels. You can find them under the text genre selection. This way we ensure an even better fit to the tonality of your target group. For example for active sourcing or job ads.\n' +
    'And now have fun optimizing.\n' +
    'Feel free to exchange this text with another text of your choice from the specific genre.',
  extendLicense: 'Extend license',
  exportToJson: 'Export to .json file',
  noProfileAW: 'There are not yet sufficient analyses for the selected profile. Please add data first or select another profile.',
  tagExplanation: 'Define your target audience by selecting tags or creating new ones.',
  dataExplanation:
    'Add texts (for example, emails, websites, blog posts, etc.) from representative people to train our AI the language of your target audience.',
  duration: 'Duration',
  createdAt: 'Created at',
  highlights: 'Highlights',
  sidebarNotes: 'Sidebar notes',
  tenant: 'Tenant',
  phoneNumber: 'Phone Number',
  phoneNumberRequired: 'Phone number is required',
  enterPhoneNumberHere: 'Please enter your phone number here...',
  phoneNumberLooksGood: 'Phone number looks good',
  reportProblem: 'Report Problem',
  abort: 'abort',
  giveFeedback: 'give feedback',
  feedbackTitle: 'It\'s great that you support us to get better.',
  optionalComment: 'Feel free to add an optional comment.',
  savingFeedbackData: 'In order to avoid this error in the future, we temporarily store the following data:',
  feedbackData: 'User ID, error message, selected suggestion(s), your text and your comment.',
  selectFeedbackSuggestion: 'Please select at least one suggestion.',
  usersFeedback: 'Users Feedback',
  feedbackSubmitted: 'Thank you, your feedback has successfully been submitted.',
  succeeded: 'Succeeded',
  true: 'True',
  false: 'False',
  timeToNextPicture: 'Time until next image',
  selectUserToTransferData: 'Select a user to whom the data will be transferred:',
  noOtherUsersInTenant: 'There is no other users in tenant to move the previous data.',
  transferUserData: 'Would you like to transfer user\'s data to another user?',
  domain: 'Domain',
  getUsersFeedback: 'Get users feedback',
  doYouWant: 'Do you want:',
  higherSales: 'Higher\nsales',
  moreEffectiveMarketing: 'More effective\nmarketing',
  hrCommunication: 'HR\ncommunication',
  wowEffectClicks: 'You are only 3 clicks away to get the "Wow"-Effect',
  theSalesTool: 'The Sales Tool',
  whatYouGet: 'What you get:',
  salesToolFirstParagraph: 'Understand the relationship quality with your customers via Email analysis by only 6 clicks.',
  salesToolSecondParagraph: 'Understand your writing styles impact on each customer by analyzing your own messages.',
  nextStep: 'Next step',
  installOutlookAddIn: 'Install Outlook Add-in',
  bookACall: 'Book a call',
  theMarketingTool: 'The Marketing Tool',
  marketingToolParagraph: 'Understand your impact on specific buyer personas by analyzing your own writing.',
  whoYouNeedInTeam: 'Who is of interest for you?',
  forIndividualConsultation: 'For an individual consultation:',
  talentTool: 'The Talent Tool',
  talentParagraph: 'Understand your job ads\' impact on specific buyer personas and gender neutrality by analyzing your own texts.',
  checkTextImpact: 'Check text impact',
  tabAnalyses: 'Analyses',
  tabManage: 'Manage',
  setup: 'Setup',
  dataAnalysisInstruction: 'Please select the contacts you want to learn more about. Additionally, add the tags for targeting.',
  selectAll: 'Select all',
  activateAllContactsDisabled: 'Nobody on this list can be activated — blacklisted, deleted, or suspended.',
  newSinceLastUpdate: '<strong>New</strong> since the last update',
  new: 'new',
  needs: 'Needs',
  processing: 'Processing',
  qualityFactor: 'Quality',
  trend: 'Trend',
  reallySelectAll: 'Really select all contacts?',
  reallyUnselectAll: 'Really unselect all contacts?',
  selectAllWarning: 'The current selection is lost in the process. This process is not reversible.',
  writing: 'Writing',
  newEmails: 'You have new messages',
  analyzeNewEmails: 'Do you want to analyze the new messages?',
  textAnalysisStarted: 'You will receive an email when the analysis is ready for the contacts.',
  analyzeAgain: 'Analyze again?',
  alreadyAnalyzedThisSession: 'You have already analyzed your selected contacts in this session.',
  removeContact: 'Remove contact from analysis',
  createReport: 'Create a report',
  installExtension: 'Analyze the text here or install the appropriate extension:',
  createYourFreeAccount: 'Create your free account.',
  accountFeaturesOne: 'No credit card information needed',
  accountFeaturesTwo: '14 days free trial',
  signInGladTitle: 'Glad to have you back.\nPlease log in now.',
  // Auth Marketing Panel
  authMarketingHeadline: 'Outreach that Converts — in Recruiting & Lead Gen',
  authMarketingSubheadline: 'Smart & Automated Outreach.',
  authMarketingBody:
    'SAIA’s AI-powered agents help recruiting and growth teams scale success without adding complexity. Whether you’re hiring top talent or winning new clients, SAIA does the grind so you can focus on winning.',
  authMarketingPillRecruiting: 'Recruiting SAIA',
  authMarketingPillLead: 'Lead SAIA',
  authMarketingStat1: '2x More replies',
  authMarketingStat2: '3x Faster time-to-hire',
  authMarketingStat3: '100% Tailored outreach based on personality insights',
  authSignupTeaser: 'A few clicks away from your outreach revolution',
  authSigninHeadline: 'Nice to have you back',
  authSignupHeadline: 'Sign up now and start your outreach revolution',
  communicateEffectively: 'Communicate more successfully.',
  resetPasswordStartAgain: 'Reset your password here and start again immediately.',
  videoManagement: 'Video Management',
  noContactsSelected: 'No contacts selected. Please select contacts from the Manage tab and start the analysis.',
  installExtensionShort: 'Install the appropriate extension:',
  'percentage share': 'percentage share',
  getStarted: 'Get started',
  outlookTutorialAnalysisTitle: 'Understand the relationship with your interlocutors',
  outlookTutorialAnalysisText1: 'Click on incoming message',
  outlookTutorialAnalysisText2: 'Obtain relationship quality and motive profile',
  outlookTutorialAnalysisAllTitle: 'Understand the relationship with all your interlocutors',
  outlookTutorialAnalysisAllText1: 'Select all contacts in Settings',
  outlookTutorialAnalysisAllText2: 'Get relationship analysis for all of your contacts',
  outlookTutorialAwTitle: 'Improve the relationship with your interlocutor',
  outlookTutorialAwText1: 'Before sending your email click on plugin',
  outlookTutorialAwText2: 'Get word suggestions and spelling improvement for better relationship',
  createNewTag: 'Create new tag',
  tagName: 'Tag name',
  updateOfficeVersion:
    'Our add-in is not supported in your installed Microsoft Office version. Please update your Microsoft Office to at least version 16.0.11629 to be able to use the add-in.',
  analyzingCommunication: 'Analyzing your communication...',
  longTextError: 'The large amount of text cannot be processed by our core. Please split the text and analyze the individual parts separately.',
  'Against Types': 'Quality customer types',
  actionGrammar: 'Correct the grammatical error.',
  actionParaphrase: 'Improve your language',
  saveDataTitle: 'Data storage information',
  savingDataReason: 'Ignored suggestions will be included in our review process, for which the following data will be saved:',
  savedData: 'User id, error message, suggestions and your text.',
  ignoreSuggestion: 'Ignore suggestion',
  chooseTextGenre: 'Choose the appropriate text genre',
  toAddinStore: 'To the add-in store',
  hideAssistant: 'Hide assistant',
  assignContacts: 'Assign contacts',
  contactsToAdd: '{{count}} contacts are added to the profile.',
  contactsToAddLimit: 'The number of contacts to be added should not exceed 500 per upload. Split the data into several tables and then add step by step.',
  withCSV: 'With csv file',
  manually: 'Manually',
  emailPlaceholder: 'Enter contact email here',
  analysisCurrentlyActive: 'The analysis started before is not finished yet.',
  deleteOutlookData: 'Delete Outlook Data',
  yourContact: 'Your contact',
  yourResults: 'Your result profile',
  noCopyPaste: 'Don\'t feel like copying and pasting?',
  installOurPlugins: 'Install our plugins for',
  freemiumTitle1: 'Paste emails from a person you want to analyze and click "Analyze" afterwards',
  freemiumTitle2: 'Paste your response letter, customize it to the person and click "Analyze" afterwards',
  freemiumTitle3: 'Raise the match by using similar words as your counterpart',
  freemiumPlaceholder: 'Insert here an email from the person you want to analyze...',
  backToWebsite: 'Back to\nthe website',
  ecommerce: 'Ecommerce',
  welcomeUser: 'Welcome to 100W, {{userName}}',
  guidanceInfo: 'Click on the LinkedIn icon and install our Chrome Extension for LinkedIn in less than 3 minutes.',
  guidanceLinkedin1: 'Use the prediction of 100W - SAIA on LinkedIn.',
  guidanceLinkedin2: 'This will help you understand your prospects better and support you in personalized targeting.',
  guidanceOutlook1: 'Use the prediction of 100W - SAIA in your Outlook.',
  guidanceOutlook2: 'It will help you understand your conversation partners better and support you in personalized email writing.',
  directTextOptimization: 'Direct text optimization',
  guidanceDirect1: 'Use the prediction of 100W - SAIA for better texts.',
  guidanceDirect2: 'We help you to address people\'s motives correctly.',
  linkedinTitle: 'Great that you want to better understand profiles on LinkedIn.',
  linkedinSubTitle: 'Look at the personality of people on LinkedIn.',
  linkedinInfo: 'Our Chrome Extension tells you exactly what type of person you\'ll meet and helps you write everything from contact requests to appointment requests. Look for the "100W Analysis" button on LinkedIn.',
  howItsDone: 'That\'s how it\'s done',
  linkedinWelcomeStep1: 'Reload already opened LinkedIn pages to enable 100W analysis there.',
  linkedinWelcomeStep2: 'The Chrome Extension can be pinned in the Browser Extensions if desired.',
  linkedinWelcomeOnlyFewSteps: 'Only a few steps to your first analysis with 100W.',
  linkedinUsageStep1: 'Install the Chrome extension.',
  linkedinUsageStep2: 'Search for a person.',
  linkedinUsageStep3: 'On the right side you will find the blue button in the middle. With it you identify the type.',
  linkedinUsageStep4: 'After writing your message in the text field on LinkedIn, the orange button appears. After clicking it, you match your language to the type.',
  installChromeExtension: 'Install the extension',
  tryItOut: 'Try it out now',
  outlookTitle: 'Great that you want to better understand your contacts by mail.',
  outlookSubTitle: 'Look at the personality of your contacts',
  outlookInfo: 'Our Outlook add-in will tell you exactly which profile to set for your contact and help you write your emails for the perfect "match". Look for the "100W Analysis" - button in your Outlook.',
  setupInfo: 'This is how the setup works',
  authenticate: 'Authenticate',
  outlookUsageStep1: 'Authenticate the add-in.',
  outlookUsageStep2: 'Install the add-in.',
  outlookUsageStep3: 'Click on the dark blue button and predict the motives.',
  outlookUsageStep4: 'After writing an email, click the dark blue button and match the language.',
  noO365: 'No Office365, then this way',
  vstoOutlookStep1: 'Download and run .exe.',
  vstoOutlookStep2: 'Click on "more information" and "run anyway".',
  directOptimizationTitle: 'Write texts with strong impact.',
  directOptimizationSubTitle: 'Adapt your texts to the motives of your customers',
  directOptimizationInfo: 'Our Augmented Writer supports you in "matching" the motives of your profiles. This way you create a lasting impression.',
  directOptimizationUsageStep1: 'Select a profile.',
  directOptimizationUsageStep2: 'Select your text genre and insert a text.',
  directOptimizationUsageStep3: 'Click on "Analyze" and match the language of your profile.',
  chooseYourProfile: 'Select your profile',
  firstSteps: 'First steps',
  does: 'Do\'s',
  donts: 'Don\'ts',
  vocabulary: 'Vocabulary',
  comparison: 'Comparison',
  degreeOfFormality: 'Degree of formality',
  userWordList: 'Words that go down well with {{contactName}}',
  theContact: 'the contact',
  theContact2: 'the contact',
  improveCommunication: 'Improve communication',
  match: 'Match',
  learnMore: 'Learn more',
  aScore: 'A - good',
  bScore: 'B - Ok',
  cScore: 'C - less good',
  importantToContact: 'This is important to {{contactName}}',
  answerContactQuestions: 'Answer {{contactName}} the following questions',
  lowComparison: 'low',
  dominantComparison: 'dominant',
  moreComparison: 'more',
  languageStyle: 'Language style',
  genderScoring: 'Genderscoring',
  typeInformation: 'Information to type',
  characters: 'Characters',
  own: 'Own',
  firstname: 'First name',
  lastname: 'Last name',
  targetGroup: 'Target group',
  noData1: 'Now add data to your target group to better understand them and customize texts.',
  noData2: 'You have four options',
  noData3: 'Once you have added data, your result will appear.',
  noDataOption1: 'Add people via email address.',
  noDataOption2: 'Set profile manually.',
  noDataOption3: 'Add people via the "tag" attribute.',
  noDataOption4: 'Add texts of the target group directly to the profile.',
  toTextImprovement: 'To text improvement',
  improveText: 'Align\ntext',
  profileManualCreation: 'You can set a profile manually and assign a value from 1 to 5 to each proficiency.',
  addAnotherTag: 'Add another tag',
  notOwnTextWarning: 'This profile belongs to another user, so you cannot edit it.',
  emailOrLinkedin: 'Email/LinkedIn',
  noCopyToClipboard: 'Clipboard not available. Please copy the text manually.',
  chooseYourType: 'Choose your type',
  productF1: '100W for LinkedIn',
  productF2: 'Augmented Writing',
  productF3: 'Matchfeatures',
  productF4: '100 W for Outlook',
  productF5: 'Individual performance analytics and reports',
  productF6: 'Erweiterte Team-Analytik und Reports',
  productFA1P: 'A total of 1000 person analyses',
  productFA1B: 'A total of 2000 person analyses',
  productFA1E: 'A total of 3500 person analyses',
  productFA2: 'Free choice from 14 motif profiles',
  productFA3: 'Analysis of emails, LinkedIn profiles, websites, blog articles & job advertisements',
  productFA4: 'Spell check',
  productFA5: 'Speech enhancement',
  productFA6: 'Stilanalyse',
  productFA7: 'Verification of comprehensibility',
  productFA8: 'Features für passgenaue Ansprache',
  productFA9: 'Analyse own contact qualities over a period of time',
  productFA10: 'Automatically analyse multiple contacts simultaneously',
  productFA11: 'Grouping several people into one ultimate profile',
  productFA12: 'Infinite number of group profiles',
  productFA13: 'Analyse contact qualities of the team over a period of time',
  productEF1: 'Implicit and explicit motives - result of your personal explicit and implicit motive profile',
  productEF2: 'Standardisation - comparison with other managers or experts',
  productEF3: 'Resources - What are my strengths, and what are the areas of development?',
  productEF4: 'Self-reflection and tips - Tips for making the most of your strengths',
  productEF5: 'Prognosis - deriving skills and competences from your motives',
  productLF1: '360 degree leadership feedback',
  productLF2: 'Management-Audit',
  productLF3: 'Personality test',
  productLF4: 'Customisable',
  headerP1: 'This is included:',
  userOneLicense: 'User can only be assigned to one license.',
  paymentRequests: 'Requests',
  inDetail: 'In detail',
  addOn: 'Add-on',
  paymentMonthlyInfo: 'Monthly billing',
  paymentYearlyInfo: 'Save 15% with annual prepayment',
  paymentMonthlyGeneralInfo: 'per user and month, monthly billing',
  paymentYearlyGeneralInfo: 'per user and month, annual billing',
  request: 'Request',
  yourCurrentPlan: 'Your current plan',
  paymentUsersInfo: 'Total number of users: {{usersCount}}, users assigned: {{usersAssignedCount}}',
  paymentAddonsInfo: 'Total number of add-ons: {{addonsCount}}, add-ons assigned: {{addonsAssignedCount}}',
  editAbo: 'Edit abo',
  cancelAbo: 'Cancel abo',
  renewAbo: 'Renew abo',
  paymentRequestsInfo: 'Total number of requests: {{requestsCount}}, calls used: {{requestsUsedCount}}',
  sum: 'Sum',
  notPaid: 'Not paid',
  paid: 'Paid',
  goToInvoice: 'to the invoice',
  pay: 'pay',
  renewLicense: 'Renew license',
  licenseRenewWarning: 'Your selected license will be renewed.',
  licenseDelete: 'End license',
  licenseDeleteWarning: 'Your selected license will be ended! You can renew it at any time.',
  dataWillRemovedNow: 'Delete data immediately',
  end: 'end',
  addUsersInfo: 'Add users to your account and add a license to these users.',
  manageUsersInfo: 'Delete users from the account or edit them.',
  manageLicensesInfo: 'Manage your licenses.',
  costsPerYear: 'equals {{price}} € per year',
  tenantDetails: 'Company and User information',
  manageTenantInfo: 'Before you can book a package, please provide your complete company information here for billing purposes.',
  usersBehavior: 'Users Behavior',
  freeRegistration: 'Registration for the\nfree freemium account',
  registerProceed: 'Register and proceed',
  yourDesiredPassword: 'Your desired password',
  inclVat: 'incl. VAT',
  plusVat: 'plus VAT',
  netPlusVat: 'net plus VAT.',
  startForFree: 'Start now for free',
  starterDescription: 'For specialists, single users and small sales teams.',
  freemiumDescription: 'The small version for testing, getting to know and trying out. A change to a paid package is possible at any time.',
  mediumDescription: 'For larger sales teams.',
  productRangeInfo: 'The offer is <1>permanently free</1> of charge in the freemium version.\nNo credit card is required for Freemium.',
  loginGreeting: 'Thank you, your email is now confirmed.\nPlease log in now.',
  yourPassword: 'Your password',
  yourEmailAddress: 'Your email address',
  extensionInstallation1: 'Please install the SAIA\nSAIA Sales Chrome plugin now',
  extensionsInstallation1: 'Please install the SAIA\nSAIA Sales Edge or Chrome plugin now',
  extensionInstallation2: 'Then you can start right away',
  installPlugin: 'Install plugin',
  installChromePlugin: 'Install Chrome plugin',
  installEdgePlugin: 'Install Edge plugin',
  dontHaveChrome: 'But I don\'t have Chrome',
  dontHaveEdge: 'But I don\'t have Edge',
  chromeInstallation1: 'Don\'t have the Chrome browser\ninstalled yet?',
  chromeInstallation2: 'No problem. Just click here.',
  edgeInstallation1: 'Don\'t have the Edge browser\ninstalled yet?',
  edgeInstallation2: 'No problem. Just click here.',
  installChrome: 'Install Chrome',
  installEdge: 'Install Edge',
  installBrowserBack: 'After that back to LinkedIn AI Booster plugin installation',
  managementAndContract: 'Management & Contract',
  manuals: 'Manuals',
  helpAndService: 'Help & Service',
  loyaltyPoints: '{{count}} Loyalty Points',
  congratulationsProfilesAnalyzed: 'Congratulations! You have analyzed {{countRemaining}} / {{countTotal}} profiles this month.',
  bookServicePackage: 'Book\nlicense package',
  upgradeServicePackage: 'Upgrade\nlicense package',
  journeyCongratulationsTitle: 'Congratulations!\nYou are now a master in using LinkedIn AI Sales Booster',
  journeyCongratulationsParagraph1: 'You are now free to decide - if and how you want to continue using the tool.\nFor this we have 3 questions.',
  journeyCongratulationsParagraph2: 'The process only takes about 1 minute.',
  nextPage: 'Next page',
  colleaguesCountTitle: 'What do you estimate',
  colleaguesCountParagraph: 'How many of your colleagues could also benefit from this tool?',
  howProceedTitle: 'Do you want to ask colleagues for the decision-making?',
  howProceedParagraph: 'You can now invite colleagues to join your team or simply continue on your own.',
  inviteColleaguesTitle: 'Name your colleagues you would like to invite',
  inviteColleaguesParagraph: 'You will get additional free analytics from us so you can show your colleagues\nhow the plugin would work for your team.',
  function: 'Function e.g. Head of Sales',
  invitationSuccessTitle: 'Great, you have successfully invited a colleague',
  invitationSuccessParagraph: 'Would you like to invite more colleagues to your team now or continue?',
  choosePackageTitle: 'Which package is right for you?',
  choosePackageParagraph1: 'You can choose one of the three paid packages here and increase your conversion & sales.',
  choosePackageParagraph2: 'You stay in the freemium package with a limited number of 5 analyses per month.',
  choosePackageParagraph3: '* Save now and effectively pay\nonly 10 out of 12 months with annual payment.',
  yearlyPayment: 'Annual payment',
  monthlyPayment: 'Monthly payment',
  stayFreemium: 'Stay in freemium',
  desiredLicenses: 'Number\nof desired\nlicenses',
  desiredLicensesUsageLimited: 'Number\nof desired\njob ads\nper month',
  sumTextYearly: 'Total amount net per month with annual prepayment and cancel option',
  sumTextYearlySplit: 'Total amount net per month\nwith annual prepayment\nand cancel option',
  sumTextMonthly: 'Total amount net per month with monthly payment and cancel option',
  sumTextMonthlySplit: 'Total amount net per month\nwith monthly payment\nand cancel option',
  starterDescr: 'For specialists, single users and small sales teams',
  mediumDescr: 'For sales teams, SaaS companies and social selling agencies',
  advancedDescr: 'For larger sales teams, SaaS companies and social selling agencies',
  starterMainFeatures: '1000 person analyses initial\nadditionally 150 analyses per month',
  mediumMainFeatures: '2000 person analyses initial\nadditionally 250 analyses per month',
  advancedMainFeatures: '3500 person analyses initial\nadditionally 500 analyses per month',
  freemiumMainFeatures: '10 person analyses initial\nadditionally 5 analyses per month',
  feature1: 'SAIA LinkedIn Booster',
  feature2: 'Augmented Writing',
  feature3: 'Matchfeatures',
  feature4: 'Customized performance analytics and reports',
  feature5: 'Analyze own contact qualities over a period of time',
  feature6: 'The free choice from 14 motive profiles',
  feature7: 'Spell check',
  feature8: 'Speech enhancement',
  feature9: 'Style analysis',
  feature10: 'Comprehensibility check',
  feature11: 'Features for precise targeting',
  addColleagueSuccess: 'Invitation successful',
  addColleagueError: 'An error occurred while creating the user!',
  analyticsDashboard: 'Analytics\nDashboard',
  enterUserInfoParagraph: 'In order to book a license package, we need your complete bill recipient information.',
  conformEntries: 'Confirm entries',
  commercial: 'Commercial usage',
  private: 'Private usage',
  nameOfInvoiceRec: 'Name of the invoice recipient',
  houseNumber: 'House number',
  vatId: 'VAT ID',
  germany: 'Germany',
  austria: 'Austria',
  switzerland: 'Switzerland',
  otherEu: 'Other EU',
  forExampleShort: 'e.g.',
  paymentSuccess1: 'Congratulations!',
  paymentSuccess2: 'You have successfully chosen the {{packageName}} package and the booking\nis now complete.',
  alreadyInstalledExtension: 'I have already installed the plugin',
  few: 'few',
  several: 'several',
  many: 'many',
  proceedAlone: 'proceed alone',
  inviteColleagues: 'invite colleagues',
  comesLater: 'comes later',
  licensePackage: 'License package',
  userManagementInfoTitle: 'Here you can manage all users in your account.',
  userManagementInfoBullet1: '1. Add users to your account and assign them a license.',
  userManagementInfoBullet2: '2. Edit user information or delete users.',
  allUsers: 'All users',
  basic: 'Basic',
  manager: 'Manager',
  owner: 'Owner',
  rowsPerPage: 'Rows per page',
  of: 'of',
  allLicenses: 'All licenses',
  licenseManagementInfoTitle: 'Here you can manage and assign your licenses.',
  addLicense: 'Add license',
  buyLicense: 'Buy license',
  userEmails: 'User emails',
  licensePackageInfo: 'Here you can view and upgrade your currently booked license package.',
  upgradeNow: 'Upgrade now',
  currentPackage: 'Current package',
  customersRecommendation: 'Customers recommendation',
  accountManagementInfoTitle: 'Here you can manage your account information.',
  userLicense: 'User license',
  initialSettings: 'Initial settings',
  analyses: 'Analyses',
  optimizations: 'Optimizations',
  analysesTitle: 'Analyses and evaluations',
  analysesParagraph: 'At this point we offer you the possibility to make the success of your work\nwith the tool measurable and to download reports.',
  settingValueForOpt: 'Setting conversion values before optimization',
  pleaseEnterValueForFunnel: 'Please enter here your experience conversion values that you have been able to collect\nso far with LinkedIn in the sales funnel.',
  acceptContactRequest: 'Acceptance Contact Request',
  responseOfFirstEmail: 'Reply to first mail to recipient',
  doNotKnowConversionValue: 'If you don\'t know the mentioned conversion values, just don\'t enter\na number and press "Show result" and we will show you\na cross-industry average value for your orientation.',
  showResult: 'Show result',
  dataSpace: 'Data space',
  resultsAfterTemplatesWithYear: 'Results by template on average | {{year}}',
  resultsAfterTemplates: 'Results by template on average',
  analysesDashboard: 'Analyses &\nOptimization',
  crPercent: 'Conversionrate in %',
  usageWeeks: 'Usage in weeks',
  usageMonths: 'Usage in months',
  userNotFound: 'No user found with this email adress',
  addStandardTemplate: 'Insert your default template for all types here',
  standardTemplate: 'Standard template',
  standardTemplatePlaceholder: 'Write here your default template for all types...',
  offerPlaceholders: 'We offer the following placeholders',
  linkedinForename: 'Recipient forename',
  linkedinSurname: 'Recipient surname',
  ownForename: 'Your forename',
  ownSurname: 'Your surname',
  analyticsEventTitle: 'Analytics Event',
  analyticsEventParagraph1: 'Did you receive a reply to a message from the template: #{{templateName}}?',
  analyticsEventParagraph2: 'If yes, was this response positive?',
  closeWindow: 'Close window',
  salesHeaderTitle: 'SAIA LinkedIn Booster',
  hrHeaderTitle: 'SAIA Recruiting',
  jobDescription: 'Job\nDescription',
  germanDescription: 'German descriptions',
  englishDescription: 'English descriptions',
  jobDescriptionParagraph: 'Please enter here the job title\nfor which you want to create a job description.',
  acceptJobTitle1: 'Select here if job title is present\nor sufficiently matched',
  acceptJobTitle2: 'When confirming, a job ad project is created and is valid for 1 month',
  acceptJobTitleButton: 'Create project',
  requestJobTitle: 'Select here if job title\nis not yet available or exact enough',
  requestJobTitleButton: 'Request position',
  occupationNoDataTitle: 'No data available',
  occupationNoDataBody: 'Unfortunately, the selected profile does not have any data yet. Please find another suitable job description or order the development of the desired profile.',
  requestOccupationMailSubject: 'Support for the profile {{profileName}}',
  requestOccupationMailBody: 'Dear SAIA team,%0d%0a %0d%0aI need the profile {{profileName}} for my successful work.%0d%0aIt would be great if you could put it into development.%0d%0aPlease let me know when I can expect a result.%0d%0a %0d%0aMany greetings%0d%0a{{userName}}',
  chooseDesign: 'Choose design',
  sales_design: 'Sales design',
  product_HR: 'SAIA Recruiting\nBusiness Packages',
  product_HR_LinkedIn: 'Sourcing\nBooster Packages',
  hr_design: 'HR design',
  optionallyBookable: 'optionally bookable',
  selectPackage: 'Select package',
  unselectPackage: 'Package selected',
  selectAtLeastOne: 'Please select at least one package.',
  customSolutionsIndividualOffers: 'Individual customized offers',
  customSolutionsContactUs: 'Contact our Customer Success department using\nthe button below and select a consulting appointment,\nor send us an email at:',
  getConsultingAppointment: 'Arrange a consulting appointment',
  customSolutionGenericTitle: 'SAIA Solutions',
  customSolutionGenericDescription: ' ',
  customSolutionGenericText: 'Do you need a service package that includes more uses than available in the business package selection because you want to use one of our products more often? We are happy to offer you a solution tailored exactly to your needs',
  customSolutionJobBoosterTitle: 'SAIA Recruiting\nEnterprise Solutions',
  customSolutionJobBoosterDescription: 'For effective and\ngender-neutral\njob ads',
  customSolutionJobBoosterText: 'Do you need a service package that includes more job ad analysis than\nis available in the business package selection because you place a higher number\nof jobs per year? We are happy to provide them\nwith a solution tailored to your exact needs.',
  businessPacket: 'Business Packet',
  with: 'with',
  runtimeTwelve: '12 months term',
  shoppingCartJobBooster: 'job ad optimizations',
  recruiterLicenses: 'recruiter licenses',
  activeSourcing: 'Active\nSourcing',
  linkedinSales: 'LinkedIn\nSales',
  jobOfferProjects: 'Job advertisements projects',
  acceptHrProject: 'Continue here with the selected project',
  acceptHrProjectButton: 'Take project',
  noPackage: 'No package booked',
  yourJobAdvProjects: 'Your\njob advertisements projects',
  hrProductMainFeatures: 'For effective and\ngender-neutral\njob ads',
  hrLinkedinMainFeatures: 'For Active Sourcing on\nLinkedIn per Recruiter',
  loginWithLinkedin: 'Log in with LinkedIn',
  registerWithLinkedin: 'Register with LinkedIn',
  loginWithGoogle: 'Log in with Google',
  registerWithGoogle: 'Register with Google',
  loginWithMicrosoft: 'Log in with Microsoft',
  activities: 'Activities',
  activitiesAccordingTemplate: 'Activities according to templates',
  positives: 'Positive ones',
  lastThreeMonths: 'Last 3 months',
  ownEmail: 'Your email',
  companyNameWarning: 'The name of the company can be max. 30 characters long',
  nameWarning: 'The name can be max. 30 characters long',
  registerWithMicrosoft: 'Register with Microsoft',
  piece: 'pc.',
  jobAdsBoosterFeature1: 'Target group selection from over 330 job profiles',
  jobAdsBoosterFeature2: 'Support for the alignment of the text:',
  jobAdsBoosterFeature3: 'Suggestion of more effective paraphrases',
  jobAdsBoosterFeature4: 'Suggestion of more effective words',
  jobAdsBoosterFeature5: 'Gender bias balancing',
  activeSourcingBoosterFeature1: 'Analysis of profiles in LinkedIn',
  activeSourcingBoosterFeature2: 'Analysis of profiles in LinkedIn Recruiter',
  activeSourcingBoosterFeature3: 'Automatic creation of text variants',
  activeSourcingBoosterFeature4: 'Automatic selection of the most effective text variants',
  activeSourcingBoosterFeature5: 'Improving the way you approach in LinkedIn:',
  activeSourcingBoosterFeature6: 'Suggestion of more effective paraphrases',
  activeSourcingBoosterFeature7: 'Suggestion of more effective words',
  createTemplates: 'Create\ntemplates',
  togglePasswordVisibility: 'toggle password visibility',
  for: 'for',
  highlightWordsWith: 'Highlight words associated with',
  closeSuggestion: 'Close Suggestion',
  sourceTemplate: 'Source Template',
  sourceTemplateText: 'Source Template Text',
  enterName: 'Enter the name of the template',
  selectDomain: 'Where will you use the message?',
  mainText: 'Main text',
  copyPastePlaceholder: 'Copy & Paste Placeholder',
  textAnalyzed: 'Text analyzed',
  notAllFieldsFilledWarning: 'Not all fields are filled',
  insertMessage: 'Insert message here',
  personaMatch: 'Persona Match',
  personaMatchText1: 'Your results will be shown here\nonce your message is analyzed',
  personaMatchText2: 'These are your actual results, they will\nchange during the process',
  optimizationInProgress: 'Optimization in\nprogress',
  optimizationDone: 'Optimization\ndone',
  textVariants: 'Text Variants',
  textVariantsInitial: 'Text suggestions for different personality types\nwill be shown here,\nonce you analyzed your message.',
  textVariantsAnalyzed: 'Please accept any variant that makes\nsense textually. Some Personality Types\nwill benefit from every decision.',
  textVariantsDone: '<strong>Congratulations!</strong>\n\nYour paraphrasing for all personality\ntypes was successful!\n\nYou created the following template set\ncontaining 14 individual single templates\n\n<strong>{{name}}</strong>\n\nNow save your template set,\n to complete the process',
  saveTemplates: 'Save template set',
  pageLeaveWarning: 'When you leave the page, your progress will be lost. Leave the page anyway?',
  profileTextVariant: 'Profile text variant',
  nameAlreadyTakenError: 'The name is already taken',
  optionalSentences: 'We have no more suggestions for your text.\n\nDo you want to add your own text variants?',
  addMoreSentences: 'Your sentence has successfully been added.\n\nDo you want to add more text variants?',
  addMoreSentencesSkip: 'Do you want to add your own text variants?',
  selectASentence: 'Select a sentence from the list\nfor which you want to add\nan additional variant.',
  addToSelection: 'Add to selection',
  optimizedTemplate: 'Type optimized Template',
  templateSelection: 'Template- and Typeselection',
  selectTemplateSet: 'Select a template set',
  templateSelectionText1: 'Please choose a template set',
  templateSelectionText2: 'Please select a communication type\nto edit the corresponding single template',
  nextSteps: 'Next Steps',
  createNewTemplateSet: 'Create new template set',
  nextStepsText1: 'Uplift our Sales Conversions!',
  nextStepsText2: 'You can continue with\nthe following options',
  goToLinkedin: 'Go to LinkedIn',
  renameTemplateSet: 'Rename template set',
  newTemplateSetName: 'New name of the template set',
  deleteTemplateSet: 'Delete template set',
  deleteTemplateSetWarning: 'Should the template set <strong>{{phaseName}}</strong> really be deleted?\n\nThe process is not reversible and the template set is no longer available afterwards.',
  cloneTemplateSet: 'Clone template set',
  clonedTemplateSetName: 'Cloned template set name',
  alignTextManually: 'Align text manually',
  noSourceAvailable: 'No source text saved',
  rename: 'rename',
  repositionTemplate: 'Change template set position',
  changePosition: 'Change position',
  changePositionText: 'To which position should the template set <strong>{{phaseName}}</strong> be moved?',
  alternatively: 'Alternatively - Go directly to',
  editManually: 'Manual editing',
  endProcess: 'End process',
  createNewTemplate: 'Create new template',
  templateCreationOnboardText: 'These can include <1>green</1> marked words for changes to the original text and red marked dots <3>[...]</3> for deleted words or parts of sentences from the original text.',
  showExample: '> Show example <',
  hideExample: '> Hide example <',
  yourConversionRating: 'Your Conversion Rating',
  amazing: 'Amazing',
  linkedinOnboarding1: 'Now you know for which prospect personalities you could improve your texting.',
  linkedinOnboarding2: 'Our augmented writer will support you in the next step.',
  linkedinOnboarding3: 'Now turn your {{conversionMinimum}}% Contact request Conversion Rate Into a Top conversion rate',
  linkedinOnboarding4: 'Optimize your current message templates of create one from scratch!',
  startOptimizingNow: 'Start Optimizing Now!',
  welcomeToDashboard: 'Welcome to your Dashboard!',
  welcomeToDashboardText: 'Here you will create your templates, analyze and optimize messages and track your success metrics.',
  continueSeeResults: 'Continue to see your results',
  onboardingStep1: 'Analyze your communication',
  onboardingStep2: 'Improve your text',
  onboardingStep3: 'Create templates',
  onboardingStep4: 'Send messages to contacts',
  onboardingSubStep1: 'Define Template Names',
  onboardingSubStep2: 'Define where you want to use this template',
  onboardingSubStep3: 'Copy and paste your current message template or write one from scratch',
  onboardingSubStep4: 'Insert place holders in your text to automize the template',
  onboardingSubStep5: 'Analyze text',
  onboardingSubStep6: 'Generate Template Variations',
  onboardingTitle: 'Four steps to becoming a social selling professional',
  dataExport: 'Data\nexport',
  analyzedContactRequests: 'Analyzed contact requests: <strong>{{count}}</strong>',
  estimatedProcessingTime: 'Total duration: <strong>approx. 2h</strong>',
  mailContactAnalysis: 'Email Contact Analysis',
  linkedinContactAnalysis: 'LinkedIn Contact Analysis',
  linkedinContactSearch: 'LinkedIn Contact Search',
  createNewProject: 'Create new project',
  crawlLinkedinProfiles: 'Crawl LinkedIn profiles',
  exportEmailContacts: 'Export email contacts',
  newProjectName: 'Name of the new project',
  searchForProjects: 'Search for projects',
  createExport: 'Create export',
  createNewExport: 'Create new export',
  uploadedEmailAddresses: 'Uploaded email addresses: {{count}}',
  uploadedLinkedinUrls: 'Uploaded LinkedIn URLs: {{count}}',
  connectToLinkedin: 'Connect to LinkedIn',
  crawlerStarted: 'Crawler runs',
  crawlerFinished: 'Crawler finished',
  crawlerSuspended: 'Crawler suspended',
  licenseExpired: 'The license has expired. Click here to renew.',
  uploadCsvEmail: 'Upload a CSV file with email addresses',
  uploadCsvLinkedin: 'Upload a CSV file with LinkedIn URLs\nor add the URLs directly using a LinkedIn search URL.',
  addWithSearchUrl: 'Add with search url',
  dataExportStepOne: '1. Upload CSV',
  uploadLinkedinUrls: 'Upload LinkedIn URLs',
  dataAnalysisExampleFile: 'The CSV file must look like this',
  downloadExample: 'Download example file',
  splitProfiles: 'Split into individual projects',
  splitProfilesInfo: 'LinkedIn currently only allows 150 profiles per account to be visited per day.\nTherefore, we split the amount between different projects, if necessary.',
  splitProject: 'Split & create project',
  saveCookies: 'Save Cookies',
  installExtensionText: 'Install extension',
  cookieInfoText1: 'For the analysis of LinkedIn contacts we need two cookies, the JSESSIONID and the li_at cookie.',
  cookieInfoText2: 'For the LinkedIn Sales Navigator, the li_a cookie is also required.',
  cookieInfoText3: 'These are created when logging in to LinkedIn and can be conveniently read by our extension with one click.',
  dontWantInstallExtension: 'Do you not want to install the extension?',
  seeHere: 'Then see here',
  cookieExpiredTitle: 'Session expired',
  cookieExpiredContent: 'Please log back into LinkedIn and try again.',
  cookieSignedOutTitle: 'Not logged in',
  cookieSignedOutContent: 'Please do log into LinkedIn and try again.',
  cookieDailyLimitReachedTitle: 'Analysis limit reached',
  cookieDailyLimitReachedContent: 'The daily limit of 150 analyses per LinkedIn account would be exceeded with this project.\n\nEither wait until tomorrow or change the cookies for the project.\n\nNumber of possible analyses today: <strong>{{count}}</strong>',
  cookieDailySearchLimitReachedTitle: 'Search request limit reached',
  cookieDailySearchLimitReachedContent: 'The daily limit of 1000 search requests per LinkedIn account would be exceeded with this project.\n\nEither wait until tomorrow or change the cookies for the project.\n\nNumber of possible search requests today: <strong>{{count}}</strong>',
  cookieInvalidTitle: 'Invalid cookies provided',
  cookieInvalidContent: 'One or more of the cookies provided are not valid LinkedIn cookies.\n\nPlease check them again and provide valid LinkedIn cookies if necessary.',
  getCookiesManually: 'Get cookies manually',
  changeLinkedinCookies: 'Change LinkedIn cookies',
  deleteProject: 'Delete project',
  deleteProjectWarning: 'Do you really want to delete the Project <strong>{{project}}</strong>?\n\nThe process is not reversible and it will not be available afterwards.',
  editProject: 'Edit project',
  downloadPersonaLists: 'Download persona lists',
  downloadOverallResults: 'Download overall results',
  manualCookiesTutorialTitle: 'How do I get my LinkedIn cookies manually?',
  manualCookiesTutorialParagraph1: 'You can\'t or don\'t want to use our Chrome extension to fetch LinkedIn cookies? No problem! There is also a manual way to get the cookies you need.',
  manualCookiesTutorialParagraph2: 'Open a new browser tab and go to <1>www.linkedin.com</1>. If you haven\'t already done so, log in there.',
  manualCookiesTutorialParagraph3: 'Right-click in the empty space there; this will open a menu. On this menu, click "Inspect" to open the browser\'s developer tools.',
  manualCookiesTutorialParagraph4: 'In the upper part of these developer tools there are several tabs. Go to the "Application" tab (Note: can also be hidden behind the double arrow ">>") and there under "Storage" > "Cookies" > "https://www.linkedin.com" you can then find the JSESSIONID and li_at cookies you are looking for.',
  manualCookiesTutorialParagraph5: 'Copy the values from the "Value" field and paste them into our data export tool at the correct position in the mask.',
  manualCookiesTutorialParagraph6: '<0>For info:</0> The quotes of the JSESSIONID cookie are also required, otherwise it will not be recognized as valid.',
  manualCookiesTutorialParagraph7: 'The tutorial was written specifically for Chrome and is also applicable for Edge and Opera.',
  manualCookiesTutorialParagraph8: 'Are you using Firefox or Safari browser, then have a look <1>here</1>.',
  restartCrawler: 'Restart crawler',
  enterUrl: 'Enter URL',
  enterUrlExample: 'Ex. https://www.linkedin.com/search/results/people/...',
  searchRunning: 'Search running',
  addUser: 'Add user',
  addUserToLicense: 'Add user to license',
  newUserEmail: 'Select one or more users from the list and add them to the license.',
  removeUserFromLicense: 'Remove user from the license',
  existingUsers: 'Select all users to be removed from the license',
  allUsersAdded: 'All users of the company have already been added to the license.',
  onlySalesNav: 'Only for LinkedIn Sales Navigator and Linkedin Recruiter',
  linkedProject: 'LinkedIn Project',
  linkedSalesNavProject: 'LinkedIn Sales Navigator Project',
  unknownError: 'Unknown error',
  reason: 'Reason',
  seatCookieMissing: 'li_a cookie is missing for Linkedin Sales Navigator requests',
  validationError: 'Error in request format',
  newProfileName: 'New profile name',
  projectInitiated: 'Project initiated',
  projectType: 'Project type',
  contacts: 'Contacts',
  progressCount: '{{current}} of {{total}}',
  createNewGlobalProfile: 'Create new global profile',
  addProjectsText: 'Select your projects that you want to combine into a group profile',
  checkProfile: 'Check profile',
  includedProjects: 'Included projects',
  numberOfContacts: 'Total number of contacts',
  significancePassedText: 'Your result is significant.',
  significanceFailedText: 'Your result is not significant.',
  significanceFailedTextMissingContacts: 'Add projects with a total of about {{difference}} more contacts.',
  significanceFailedTextAdditionalContacts: 'Remove projects with a total of about {{difference}} contacts.',
  saveAsGlobalProfile: 'Save as global profile',
  saveNotRecommended: 'Save (not recommended)',
  dataAnalysisFunctions: 'Data analysis functions',
  toTheFeature: 'To the product',
  toTheManagement: 'To the management',
  openFeature: 'Open Feature',
  linkedinProfileCrawler: 'LinkedIn Profile Crawler',
  linkedinProfileCrawlerDescription: 'Enables data enrichment through automatic analysis of LinkedIn profiles.',
  emailExport: 'Email Export',
  emailExportDescription: 'Enables enrichment of analyzed e-mail contacts.',
  linkedinUrlFinder: 'LinkedIn URL Finder',
  linkedinUrlFinderDescription: 'Finds for a list of people the associated LinkedIn URLs, if any.',
  manageCookies: 'Manage LinkedIn Cookies',
  manageCookiesDescription: 'Management of cookies required for LinkedIn features.',
  downloadEmailExportText: 'The created file\n<1>{{fileName}}</1> is now ready to download.',
  uploadSearchContacts: 'Upload contacts',
  splitSearchProjectsInfo: 'LinkedIn currently only allows about 1000 searches per account per day.\nTo keep the waiting time low, we split the amount between different projects with a maximum of 50 searches, if necessary.',
  uploadedSearchContacts: 'Uploaded contacts: {{count}}',
  uploadCsvSearchContacts: 'Upload a CSV file with contacts to search. The format should look like this:\n\nFirst name > Last name > Company\n\nPlease enter here only the contact details without table headings.',
  linkedinSearch: 'LinkedIn Search',
  transformToCrawlingProject: 'Transform into LinkedIn Crawler Project',
  transformProjectsText: 'Select your LinkedIn Search projects here that you want to combine into one LinkedIn Crawler project',
  transformToGroupProfile: 'Transform to group profile',
  info: 'Info',
  augmentedWritingError: 'An error occurred while aligning the text! ',
  linkedinCookiesMissing: 'LinkedIn cookies are missing',
  selectUrlsText: 'Select here the URLs that should be transferred to the new project',
  displayed: 'Displayed: {{count}}',
  selected: 'Selected: {{count}}',
  showMultipleRepresented: 'Show only multiple represented',
  noAssignment: 'No Assignment',
  filterBy: 'Filter by',
  later: 'Later',
  // new ui keys
  userDoneTitle: 'Congratulations!',
  userDoneText1: 'You have achieved an excellent result',
  userDoneText2: 'Your text is now optimized',
  hrBooster: 'SAIA Recruiting',
  salesBooster: 'Sales Booster',
  leadBooster: 'SAIA Sales',
  loadExistingProjects: 'Load existing projects',
  loadingProfile: 'Loading profile',
  firstStep: 'Step 1',
  secondStep: 'Step 2',
  thirdStep: 'Step 3',
  selectJob: 'Select profile',
  generateTextVariants: 'Generate text',
  finalizeText: 'Finalize text',
  textGenPlaceholder: 'Here, text can be generated using bullet points and then either the generated text or your own text can be optimized and finalized.',
  finalizeTextPlaceholder: 'The function takes you to the text optimization to finalize your texts.',
  finalizeTextPlaceholderWithOccupation: 'The function takes you to the text optimization to finalize your texts.\n\nIn this final step, we optimize the match to the persona {{occupation}}',
  nothingSuitable: 'Nothing suitable or nothing displayed?',
  requestGlobalProfile: 'Request global profile',
  timeUntilProfileCreated: 'We usually need a maximum of 48 hours until a profile has been created for you and is available.',
  option: 'Option {{number}}',
  enterProfession: 'Enter a profession here, e.g. Recruiter',
  enterProjectName: 'Enter the project name here',
  cancel: 'Cancel',
  accept: 'Accept',
  jobOfferCompanyDescriptionInstruction: 'Write something about your company here:',
  jobOfferCompanyDescriptionPlaceholder: 'e.g.\nSAIA, based in Heilbronn, Germany, offers solutions for the improvement of recruiting, marketing and sales. Since its start in 2018, the company has continuously evolved into a successful AI solution provider. The company relies on a mix of psychological targeting and generative AI solutions and creates unique content.',
  jobOfferResponsibilitiesInstruction: 'List here the responsibilities of the position:',
  jobOfferResponsibilitiesPlaceholder: 'e.g.\n- Analyze data from our CRM to derive sales opportunities\n- Translate statistical knowledge into easy to understand presentations\n- etc.',
  jobOfferRequirementsInstruction: 'List here the requirements of the position:',
  jobOfferRequirementsPlaceholder: 'e.g.\n- Successfully completed studies in Data Science, Mathematics or comparable fields of study\n- Curiosity for new insights based on a structured approach',
  jobOfferWhyYouInstruction: 'Write here why you would like to win the persona:',
  jobOfferWhyYouPlaceholder: 'You would be a great fit for us based on your experience in Data Science and your previous projects.Your life history so far shows that you have international experience and would therefore fit very well with our international project team. ',
  jobOfferJobTitleInstruction: 'Enter the job title here:',
  jobOfferJobTitlePlaceholder: 'e.g. Data Scientist (m/f/d)',
  jobOfferDivisionDescriptionInstruction: 'Write something about your department here:',
  jobOfferDivisionDescriptionPlaceholder: 'e.g.\nTogether with our team, we take care of analyses to capture market data and sales opportunities, thus providing a decisive contribution to the success of SAIA.',
  jobOfferBenefitsInstruction: 'Write here what you offer the candidates:',
  jobOfferBenefitsPlaceholder: 'e.g.\nWe offer flexible working from anywhere in the world, great events and most importantly an environment that focuses on learning from each other.',
  jobOfferCtaInstruction: 'Name a call-to-action here:',
  jobOfferCtaPlaceholder: 'e.g. Apply now at application@secret-ai-agent.de',
  textGenDoneInstruction: 'Click on "Copy to text field" or copy individual sections into the text field of the 3rd step.',
  recentProjects: 'Recent projects',
  delete: 'delete',
  toTheProject: 'To the project',
  ok: 'Ok',
  confirmDeleteProjectText: 'Do you really want to delete the project {{projectName}}?\n\nThis operation is not reversible and the project will not be available afterwards.',
  result: 'Result',
  profiling: 'Profiling',
  cacheText: 'Save temporarily',
  meanings: 'Meanings',
  targetValue: 'Personality type target value',
  currentValue: 'Current value of your text',
  paiMatch: 'Agent-Match',
  paiMatchDetails: 'Agent-Match Details',
  motiveMatch: 'Motive-Match',
  languageStyleMatch: 'Language-Style-Match',
  genderMatch: 'Gender-Match',
  grammarOptimization: 'Grammar Optimization',
  paiMatchOptimization: 'Agent-Match Optimization',
  ignoreOnce: 'ignore once',
  alwaysIgnore: 'always ignore',
  suggestions: 'Suggestions',
  plusMoreSuggestions: '+ approx. {{count}} more',
  congratulations: 'Congratulations',
  userDoneText: 'You are now successfully addressing {{profileName}}',
  personalityType: 'Personality type',
  analyzeTextButtonText: 'Analyze text & get suggestions',
  analyzeTextButtonTextShort: 'Analyze text',
  saveTextButtonText: 'Save text & exit',
  saveTextButtonTextShort: 'Save & exit',
  hrBoosterFinalTextTitle: 'Here you will find your ready job ad for {{occupation}}',
  leadBoosterFinalTextTitle: 'Here you will find your ready text for {{occupation}}',
  copyText: 'Copy text',
  textCopied: 'Text copied',
  leadBoosterProblemsInstruction: 'List the problems of the contact persons here:',
  leadBoosterProblemsPlaceholder: 'e.g.\n- Too little feedback in outbound\n- Too little time to prepare optimally for each prospect\n- Target achievement jeopardized',
  leadBoosterFeaturesInstruction: 'List the features of your service/product here:',
  leadBoosterFeaturesPlaceholder: 'e.g.\n- Automatically detect personality type\n- Generate texts for personality type\n- Align texts for personality type',
  leadBoosterBenefitsInstruction: 'List the benefits of your service/product here:',
  leadBoosterBenefitsPlaceholder: 'e.g.\n- Gain confidence in addressing people\n- Create texts faster and save time\n- Formulate better texts and gain more leads',
  leadBoosterImpactInstructions: 'List the business impact of your service/product here:',
  leadBoosterImpactPlaceholder: 'e.g.\n- 2x more leads\n- 90% more time\n- 100% more safety',
  leadBoosterSocialProofInstructions: 'Name the social proof of your product here:',
  leadBoosterSocialProofPlaceholder: 'e.g.\nPerson/company XYZ uses our product and achieves 30% higher conversions.',
  leadBoosterEventTitleInstructions: 'Name the title of your event here:',
  leadBoosterEventTitlePlaceholder: 'e.g.\nWebinar: Higher Conversions with SAIA',
  leadBoosterEventDescriptionInstructions: 'List the description of your event here:',
  leadBoosterEventDescriptionPlaceholder: 'e.g.\n- In the event you learn how SAIA automatically creates persona\n- Creates texts from the target group data\n- And supports the user to adapt them to the emotional needs of the target group.',
  leadBoosterDateInstructions: 'Name the date of your event here:',
  leadBoosterDatePlaceholder: 'e.g.\nDay and time of the event',
  leadBoosterProductNameInstructions: 'Enter the name of your product here:',
  leadBoosterProductNamePlaceholder: 'e.g.\nSAIA SAIA Sales',
  leadBoosterProductInfoInstructions: 'List the description of your product here:',
  leadBoosterProductInfoPlaceholder: 'e.g.\n- SAIA Sales creates persona\n based on real target group data- Supports in text creation with GPT\n- Helps to frame the texts to the persona',
  leadBoosterTitleInstructions: 'Name the title of your blogpost here:',
  leadBoosterTitlePlaceholder: 'e.g.\nKI in lead generation: 10 AI tools to improve lead generation.',
  leadBoosterCompanyNameInstructions: 'Enter the name of your company here:',
  leadBoosterCompanyNamePlaceholder: 'e.g.\nSAIA',
  selectGenreText: 'Select text genre',
  product: 'Product',
  back: 'back',
  loadExistingTemplates: 'Load existing templates',
  enterNewTemplateName: 'Enter the new template name here',
  persona: 'Persona',
  recentTemplates: 'Recent templates',
  contactRequest: 'Contact request',
  emailShort: 'Email',
  close: 'Close',
  home: 'Home',
  upgrade: 'Upgrade',
  help: 'Help',
  account: 'Account',
  login: 'Login',
  logout: 'Logout',
  linkedinExtension: 'LinkedIn extension',
  appsandintegrations: 'Apps & Integrations',
  personaGenerator: 'Tailored Profile Generator',
  personaGeneratorCardInstructionPrimary: 'Create a personality profile',
  personaGeneratorCardInstructionSecondary: 'that mirrors the target group based on LinkedIn searches.',
  collapse: 'collapse',
  expand: 'expand',
  collapseSidebar: 'Collapse Sidebar',
  urlFinder: 'LinkedIn Profile Finder',
  urlFinderCardInstructionPrimary: 'Find LinkedIn profiles',
  urlFinderCardInstructionSecondary: 'using contact information.',
  createOwnProfile: 'Create own profile',
  profileCreationRequirements: 'A LinkedIn Premium, Sales Navigator or Recruiter account is required to create own profiles by yourself.',
  addProfilesToPersona: 'Add profiles to the persona',
  classifyPersonalityTypes: 'Classify personality types',
  definePersonalityTypeManually: 'Manually define personality type',
  personaGeneratorStepTwoPlaceholder: 'Select here from the people we found on LinkedIn according to your definition.',
  evaluationResult: 'Evaluation result',
  personaGeneratorStepThreePlaceholder: 'Here you will see the persona and some information about the persona once you have finished the process.',
  personaSuccessfullyCreated: 'Persona successfully created',
  personaSuccessfullyCreatedText: 'The persona has been successfully created and you can now use it in HR and Leadbooster.',
  searchViaLinkedin: 'Search directly via LinkedIn',
  enterSearchUrl: 'Enter a LinkedIn, Sales-Navigator or Recruiter search url here',
  startSearch: 'Start search',
  createClassificationProjectCount: 'Create classification project ({{count}})',
  useUrlFinderProjects: 'Use your URL Finder projects',
  noUrlFinderProjectsYet: 'No LinkedIn Profile Finder projects yet?',
  selectUrlFinderProject: 'Select a URL Finder project',
  applyUrlFinderProject: 'Apply URL Finder project',
  create: 'Create',
  save: 'Save',
  peopleFoundOnLinkedin: 'List of the following people found on LinkedIn',
  personaGeneratorUrlFinderProjectsText: 'You can now decide which of the people are relevant to you for the target group. After that, the individual LinkedIn profiles are classified and you can combine them into a persona.',
  createClassificationProject: 'Create classification project',
  manageClassificationProject: 'Here you can manage your classification project "{{projectName}}".',
  personaGeneratorClassificationProjectsText: 'You need at least one completed project to evaluate a persona. If the result is not yet significant, you can classify more personality types here.',
  evaluatePersona: 'Evaluate persona',
  export: 'Export',
  restart: 'Restart',
  completed: 'completed',
  startNow: 'Start now',
  personaSignificantText: 'Congratulations, the persona is significant and you can save it now.',
  personaNotSignificantText: 'The persona is not yet significant. We recommend that you classify more data to make the persona meaningful.',
  savePersona: 'Save persona',
  savePersonaAnyway: 'Save persona anyway',
  globallySavePersona: 'Save persona globally',
  maxContactsDialogTitle: 'We have noticed that you have more than 150 people in your search.',
  maxContactsDialogText: 'LinkedIn allows users to analyze a maximum of 150 profiles per day. We will therefore split the search into individual projects.',
  maxContactsDialogAction: 'Split & start analysis',
  cookieDialogTitle: 'Hello {{firstName}}, we have detected that your LinkedIn cookies are not working.',
  connectViaExtension: 'Connect with LinkedIn via our extension',
  getCookies: 'Get Cookies',
  installOurExtension: 'Install SAIA Extension',
  manualInputCookies: 'Manual input of LinkedIn cookies',
  howDoIt: 'How to do it?',
  enterLiAtCookie: 'Enter the li_at cookie here',
  enterJsessionIdCookie: 'Enter the JSESSIONID cookie here',
  enterLiACookie: 'Enter the li_a cookie here (Sales Navigator & Recruiter)',
  enterPersonaName: 'Enter the person name here',
  confirmSaveGlobalProfile: 'The selected projects are saved as a global profile under the name <1>{{profileName}}</1>.\n\nThis is an admin function and is difficult to correct afterwards.',
  provideContactInformation: 'Provide the contact information',
  findLinkedinUrls: 'Find LinkedIn URLs',
  urlFinderPlaceholder: 'Your URL Finder projects will be displayed here later',
  searchLinkedinUrlsViaCsv: 'Search LinkedIn URLs via a CSV or Excel file',
  uploadCsv: 'Upload CSV',
  profileFinderCsvFormatContacts: 'CSV format:\nFirst name, Last name, Company name, Email address - without header.',
  profileFinderCsvFormatWebsite: 'CSV format:\nCompany name, Search terms, Country - without header.',
  rowsCount: 'Searches: {{count}}',
  manageUrlFinderProject: 'Here you can manage your URL Finder project "{{projectName}}"',
  urlFinderProjectsText: 'You need at least one completed project to generate a persona or classify the personality type from the LinkedIn URLs you find.',
  createPersonaProject: 'Create persona project',
  profiles: 'Profiles',
  profile: 'Profile',
  german: 'German',
  english: 'English',
  italian: 'Italian',
  french: 'French',
  spanish: 'Spanish',
  portuguese: 'Portuguese',
  dutch: 'Dutch',
  nameOfCompany: 'Company name',
  zip: 'Postal Code',
  zipShort: 'ZIP CODE',
  street: 'Street',
  city: 'City',
  savedIgnoredSuggestionSuccess: 'The suggestion was successfully added to the dictionary and will not occur in the future.',
  year: 'Year',
  month: 'Month',
  anotherLicenseRequired: 'You need another license for this feature',
  annualBilling: 'Annual billing',
  monthlyBilling: 'Monthly billing',
  discountAnnualBilling: 'Save with annual billing!',
  jobOffers: 'Job offers',
  jobOffer: 'Job offer',
  activeSpeech: 'Active speech',
  personaAndLeadGenerator: 'Persona & Lead\nGenerator',
  amountContacts: '{{count}} Contacts',
  cancelableAnytime: 'cancelable anytime',
  cancelableAnnually: 'annually cancelable',
  select: 'Select',
  enterNumberOfUsers: 'Enter the number of users here',
  enterNumberOfProfiles: 'Enter the number of profiles here',
  enterNumberOfPackages: 'Enter the number of packages here',
  unlimitedWriting: 'unlimited writing',
  amountProfiles: '{{count}} Profile',
  amountLanguages: '{{count}} Languages ({{languages}})',
  featureLinkedinExtension: 'LinkedIn extension',
  featureTemplateGeneration: 'Generate templates automatically',
  featureAlignTemplates: 'Align templates to different target groups',
  featureEvaluateCommunicationQuality: 'Evaluate communication quality',
  featureAlignTexts: 'Align texts with the target group',
  featureGenerateTexts: 'Generate texts automatically',
  featureAlignTextsWithNeeds: 'Align texts with needs',
  featurePersonaCreation: 'Persona creation',
  featureExportLeadLists: 'Export of the lead lists for enrichment for the CRM',
  warningCompanyInfoMissing: 'Complete company information',
  warningCompanyInfoMissingContent: 'For invoicing we need the complete company information. Please complete this first.',
  warningOnlyIntegers: 'Only integers allowed',
  warningOnlyIntegersContent: 'The quantity entered is not an integer.',
  motiveTests: 'Motive Tests',
  personalityTests: 'Personality Tests',
  leadSection: 'LEAD',
  yourInformation: 'Your information',
  accountManagement: 'Account management',
  licenseManagement: 'License management',
  companyInformation: 'Company information',
  changePasswordSuccess: 'Congratulations, your password has been successfully changed.',
  changeUserInfoSuccess: 'Congratulations, your user information has been successfully changed.',
  data: 'Data',
  noValidEmailError: 'No valid email address',
  saveChanges: 'Save Changes',
  password: 'Password',
  oldPassword: 'Old Password',
  wrongOldPassword: 'Wrong old password',
  newPassword: 'New Password',
  currentPassword: 'Current Password',
  enterCurrentPasswordHere: 'Enter your current password',
  enterNewPasswordHere: 'Enter your new password',
  confirmNewPassword: 'Confirm new password',
  confirmNewPasswordHere: 'Confirm your new password',
  passwordTooShort: 'Password is too short (min. 6 characters)',
  passwordTooLong: 'Password is too long (max. 50 characters)',
  repeatNewPassword: 'Repeat new password',
  passwordsNoMatch: 'Passwords do not match',
  successfullyChanged: 'Successfully changed',
  usersInSystem: 'These users exist in the system',
  userName: 'User name',
  edit: 'edit',
  createUser: 'Create user',
  editUser: 'Edit user',
  deleteUser: 'Delete user',
  deleteUserWarning1: 'Should the user <1>{{userName}}</1> really be deleted?',
  deleteUserWarning2: 'This process is not reversible and the user is not available afterwards.',
  dataProceedQuestion: 'What should happen to the data of <1>{{userName}}</1>?',
  dataProceedInfo: 'The data will be irrevocably deleted.',
  dataTransferQuestion: 'To which user should the data be transferred?',
  createAccount: 'Create Account',
  company: 'Company',
  role: 'Role',
  language: 'Language',
  license: 'License',
  editAccount: 'Edit account',
  licensesInSystem: 'These licenses are available in the system',
  licenseUserName: 'Name of the license user',
  remove: 'remove',
  user: 'User',
  limits: 'Limits',
  expiredOn: 'Expires on',
  add: 'add',
  createLicense: 'Create license',
  upgradeLicense: 'Upgrade license',
  bookedLicenses: 'Booked licenses',
  chatStatus: 'Status',
  activeUntil: 'Active until: {{expirationDate}}',
  toUpgrade: 'upgrade',
  cancelLicense: 'cancel',
  renew: 'renew',
  transactions: 'transactions',
  removeUser: 'Remove user',
  removeUserWarning: 'Do you really want to remove the user from the license? The user can be added back to this or another license later.',
  deleteLicense: 'Delete license',
  deleteLicenseWarning1: 'Do you really want to delete the license for <1>{{licenseName}}</1>?',
  deleteLicenseWarning2: 'This operation is not reversible and the license will not be available afterwards.',
  companyNameTooLong: 'Company name too long (max. 29 characters)',
  companyAddressMissing: 'Address of the company is partially or completely missing',
  companyName: 'Company name',
  companiesInSystem: 'These companies exist in the system',
  changeCompanyInformationSuccess: 'Congratulations, your company information has been successfully changed.',
  deleteCompany: 'Delete company',
  deleteCompanyWarning: 'Should the company "{{companyName}}" really be deleted?\n\nThis operation is not reversible and the company will not be available afterwards.',
  editCompany: 'Edit company "{{companyName}}"',
  motiveAnalysis: 'Motive analysis',
  motiveAnalysisSubText: 'Here you can perform the Original PSE (Picture Story Exercise) and, in addition to the implicit motives, also obtain a statement about the explicit motives of the persons. This supports you in executive coaching.t',
  leadLeadershipFeedback: 'LEAD-\nLeadership feedback',
  leadSubText: 'Get 360 ° feedback of your competencies through our completely flexible leadership platform.',
  contactPartnerTitle: 'Hello {{firstName}}, We offer the personality test together with our partner A47 Consulting.',
  contactPartnerText: 'If you are interested, please feel free to contact A47 Consulting.',
  contactPartner: 'Contact A47',
  placeholders: 'Placeholders',
  skip: 'skip',
  textImpact: 'Impact of your text',
  selectedGlobalProfile: 'You have selected the following global profile',
  selectedOwnProfile: 'You have selected the following own profile',
  globalProfiles: 'Global Profiles',
  globalProfile: 'Global Profile',
  tailoredProfiles: 'Tailored Profiles',
  addCompany: 'Add company',
  transfer: 'transfer',
  createacc: 'Don\'t have an account? Sign Up',
  email: 'Email',
  forgotpw: 'Forgot password?',
  remember: 'Remember me',
  signin: 'Sign in',
  signup: 'Sign up',
  backToLogin: 'Back to the sign in',
  signupsucces: 'Registration successful',
  signupsucces1: 'You have received an email',
  signupsuccesAction1: 'Confirm your email address using the link',
  signupsuccesAction2: 'Also check your spam folder in case the email is not in your inbox',
  signupsucces2: 'You can also sign in first and verify your email later.',
  agreeConditionsInfo: 'By continuing, you agree to the following conditions',
  resetPassword: 'Reset password',
  forgetPasswordTitle: 'Request email',
  forgetPasswordParagraph: 'To reset your password, we will send you an email to the email address you entered in your profile',
  forgetPasswordEnterNow: 'Please enter it here now',
  forgetPasswordEmailSent1: 'We have sent an email at \'{{email}}\'.',
  forgetPasswordEmailSent2: 'Please click on the link there to continue.',
  requestPwMail: 'Request email now',
  resetPasswordTitle: 'Enter new password',
  resetPasswordParagraph: 'Set your new password now',
  resetPasswordNow: 'Reset password now',
  backToRequestMail: 'Back to request email',
  passNoMatch: 'Passwords do not match',
  resetPasswordTokenExpired: 'The token has expired, please request an email again',
  extensionInstallationSuccessTitle: 'Extension\nsuccessfully installed',
  extensionInstallationSuccess1: 'Congratulations! You have successfully installed the extension!',
  extensionInstallationSuccess2: 'You can now open LinkedIn',
  extensionInstallationSuccess3: 'If you have already opened LinkedIn, please reload the page',
  extensionInstallationSuccess4: 'You need a SAIA account to use the extension',
  extensionInstallationSuccess5: 'If you don\'t have a SAIA account yet, you can create one for free on our website',
  openLinkedIn: 'Open LinkedIn',
  backToDashboard: 'To the SAIA website',
  paidModels: 'Also check out our paid models here',
  activityChartXAxis: 'CW {value}',
  activityChartYAxis: 'Number Total usage / CW',
  activityTooltip: '<strong>{c} x</strong><br/>used in CW {b}',
  clone: 'clone',
  show: 'Show',
  boosterWords: 'Booster\nWords',
  doesAndDonts: 'Does & Dont\'s',
  textOptimization: 'Text\nOptimization',
  emailOptimization: 'Email\nOptimization',
  textGeneration: 'Text\nGeneration',
  optimizedTemplates: 'Optimized\nTemplates',
  boosterWordsInstruction: 'These words are particularly well received by your counterpart. Use them and improve your speech with them.',
  doesInstruction: 'These do\'s are particularly important to your counterpart. Pay attention to them and use them to improve your speech.',
  dontsInstruction: 'You must pay particular attention to these don\'ts with your counterpart. Avoid them and improve your speech.',
  copyTemplateInstruction: 'Copy your template optimized for "{{personaName}}" and improve your address',
  noAssessmentTitle: 'Not enough data',
  noAssessment1: 'The selected contact does not have enough data to create a meaningful profile.',
  preview: 'preview',
  outlookAddIn: 'Outlook Add-in',
  apiKey: 'API-Key',
  vstoNotSupportedTitle: 'COM add-in is no longer supported',
  vstoNotSupportedMessage: 'Dear users,\n\nwe would like to inform you that we will stop support for COM Add-ins in Outlook with immediate effect. Please note that this only affects older versions of Outlook and that our Outlook Add-in for MS Office 365 will continue to be supported and further developed.\n\nWe recommend that you switch to our Outlook Add-in for MS Office 365 if possible in order to continue to benefit from our latest features and updates.\n\nWe thank you for your loyalty and hope that you will continue to benefit from our products.\n\nBest regards\n\nSAIA',
  settings: 'Settings',
  forbiddenDomains: 'Ignored domains',
  reallyDeleteOutlookData: 'Delete all Outlook data',
  deleteOutlookDataWarning: 'All Outlook data will be deleted.\n\nThis process is not reversible and the data will not be available afterwards.',
  error: 'Fehler',
  clickToAuthenticate: 'Authenticate add-in',
  notAuthenticated: 'The add-in may not be authenticated yet.',
  reloadAddin: 'Now restart the add-in. If the problem still occurs, please contact us.',
  outlookAuthTitle: 'Authentication\nsuccessful',
  outlookAuthText: 'The Outlook add-in from SAIA has been successfully authenticated.',
  connectedTo: 'Connected to:\n<strong>{{domain}}</strong>',
  selectSuitableProfile: 'Select a suitable profile to continue.',
  chooseContactOutlook: 'For which of the recipients should the text be optimized?',
  importText: 'Import text',
  textGenerationInstruction: 'Generate a text customized to the contact. Use an existing project or create a new one.',
  createNewTextProject: 'Create new text project',
  saveContentTitle: 'Save content for later',
  saveContent: 'Should the current content of the text fields be saved in a new project?',
  contactCharacteristics: 'Characteristics of {{contactName}}',
  definesContact: 'This defines {{contactName}}',
  checkingInbox: 'Search the inbox for new messages from {{contactEmail}}',
  job_offer: 'Job Ad',
  active_sourcing: 'Active Sourcing for LinkedIn Text Generation',
  active_sourcing_short: 'Active Sourcing',
  sales_email: 'Sales Email for LinkedIn Text Generation',
  sales_email_short: 'Sales Email',
  connection_request: 'Connection Request for LinkedIn Text Generation',
  connection_request_short: 'Connection Request',
  marketing_newsletter: 'Marketing Newsletter',
  social_post: 'Socialmedia Post',
  social_ad: 'Socialmedia Ad',
  invitation: 'Invitation',
  blogpost: 'Blogpost',
  landingpage: 'Landing Page',
  product_desc: 'Product Description',
  generateTableOfContents: 'Generate table of contents',
  createContent: 'Create content',
  tableOfContents: 'Table of Contents',
  createANewProject: 'Create a <1>New project</1>',
  yourProductLibrary: 'Your <1>{{product}}</1> Library',
  selectProject: 'Select project',
  selectTemplate: 'Select template',
  backToLandingPage: 'Back to the landing page',
  outlookWelcomeMessage: 'Welcome to\nSAIA',
  goToLogin: 'Go to login',
  outlookFirstRunExperienceText1: 'Our add-in shows you the personality of your contact person.',
  outlookFirstRunExperienceText2: 'This will enable you to generate customized e-mails in the future and convince with outstanding communication.',
  outlookFirstRunExperienceText3: 'Experience the power of SAIA and improve your email communication.',
  outlookFirstRunExperienceText4: 'Register now or sign in with an existing account and discover the benefits of personalized, efficient and impactful conversations!',
  errorDialogTitle: 'An error occurred',
  errorDialogText1: 'One or more errors have occurred on the path <1>{{source}}</1>',
  errorDialogText2: 'If the problem persists, please contact us.',
  errorsOccurred: 'What errors have occurred?',
  report: 'Report error',
  errorEmailSubject: 'Error in the dashboard',
  errorEmailBody: 'Dear SAIA Team,\n\nfollowing errors occurred for me on the path "{{source}}" in the dashboard:\nTimestamp: {{timestamp}}\nErrors: {{errors}}\n\nBest regards\n{{userName}}',
  timestamp: 'Timestamp',
  autoDetect: 'Auto detect',
  limitReachedSpecialPlan: 'If you need a special plan for you or your company, please contact us directly at <1>toni.kuenzl@secret-ai-agent.de</1> and together we will find a suitable solution.',
  linkedinRequired: 'LinkedIn required',
  leadBoosterGlobalProfilesProductDescriptionMain: 'Optimize your marketing campaigns',
  leadBoosterGlobalProfilesProductDescriptionSub: 'based on AI generated global profession profiles.',
  leadBoosterTailoredProfilesProductDescriptionMain: 'Create campaign texts',
  leadBoosterTailoredProfilesProductDescriptionSub: 'tailored to your search requirements.',
  personaGeneratorProductDescriptionMain: 'Create personas and optimize your ads',
  personaGeneratorProductDescriptionSub: 'tailored to your search requirements.',
  hrBoosterGlobalProfilesProductDescriptionMain: 'Optimize your job ads',
  hrBoosterGlobalProfilesProductDescriptionSub: 'based on AI generated global profession profiles.',
  hrBoosterTailoredProfilesProductDescriptionMain: 'Optimize your job ads',
  hrBoosterTailoredProfilesProductDescriptionSub: 'tailored to your search requirements.',
  linkedinSearchDurationInfoTitle: 'This could take a while',
  linkedinProfileSearchDurationInfo: 'We will now create a list of LinkedIn contacts based on your search URL.',
  linkedinProfileSearchDurationTime: 'This process takes an estimated 5-6 minutes.',
  linkedinSearchDurationWarning: 'Keep the browser window open and do not reload the page while the feature is running. Otherwise, the service will terminate.',
  personaGeneratorDurationInfo: 'We now analyze the LinkedIn profiles based on the previously provided LinkedIn URL\'s.',
  personaGeneratorDurationTime: 'This process can take up to 2 hours.',
  personaGeneratorDurationWarning: 'You can leave the page now and come back later when the analysis is finished.',
  politeSpeech: 'Polite speech',
  casualSpeech: 'Casual speech',
  includeEmoji: 'Include emoji',
  autoOptimize: 'Auto Optimize',
  extensionRequired: 'LinkedIn extension required',
  tool: 'Tool',
  projects: 'Projects',
  manualActiveSourcing: 'Manual Active Sourcing',
  jobAdsOptimization: 'Job Ads',
  manualSocialSelling: 'Manual Social Selling',
  marketingCampaignsOptimization: 'Marketing Campaigns',
  newProject: 'New Project',
  startJourneyTitle: 'Start boosting your conversions with the right words',
  startJourneySubTitle: 'For which area would you like to start optimizing your text?',
  startJourneyButton: 'Start your journey!',
  startJourneyActiveSourcingCopilot: 'HR | SAIA Recruiting Co-Pilot',
  startJourneyActiveSourcing: 'HR | Manual Active Sourcing',
  startJourneyJobAdCampaigns: 'HR | Job Ad Campaigns',
  startJourneySocialSellingCopilot: 'Sales | SAIA Sales Co-Pilot',
  startJourneySocialSelling: 'Sales | Manual Social Selling',
  startJourneyMarketingCampaigns: 'Marketing | Marketing Campaigns',
  startJourneyNone: 'none of them',
  similarJobTitles: 'Similar Job Titles',
  enterLocation: 'Enter location',
  enterLocationLabel: 'Where do you want to search?',
  enterLocationDescription: 'For which locations or regions would you like to search for contacts?',
  similarJobTitlesSearchText: 'Searching for similar job titles.',
  jobTitleTableName: 'Name',
  jobTitleTableLinkedinProfiles: '# LinkedIn Profiles',
  jobTitleTableJobwareAds: '# Job Ads @Jobware',
  skills: 'Skills',
  noSearchResults: 'No search results for the selected location',
  generalCookieError: 'Make sure you have installed our browser extension and are logged into LinkedIn. If the problem still occurs, please contact us.',
  cookieErrorTitle: 'Cookie Error',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  sendConnectionRequest: 'Send contact request',
  connectionRequestAccepted: 'Contact request accepted',
  sendConnectionRequestDescription: 'Creates a personalized contact request, psychologically optimizes it and sends it to your contact.',
  sendMail: 'Send message',
  sendMailDescription: 'Creates an initial personalized message, psychologically optimizes it and sends it to your contact on LinkedIn.',
  sendMailWithContext: 'Send message\n(with context)',
  sendMailWithContextDescription: 'Creates an initial personalized message, psychologically optimizes it and sends it to your contact on LinkedIn. Here, the last past messages with a contact person as context are taken into account during text creation.',
  sendFollowUp: 'Send follow up',
  sendFollowUpDescription: 'Creates personalized follow up messages based on the texts sent so far, optimizes them psychologically and sends them to your contact on LinkedIn.',
  sendInMail: 'Send inmail',
  sendInMailDescription: 'Creates a personalized Inmail, optimizes it and sends it to your contact on LinkedIn. (Sales Navigator / Recruiter license must be available)',
  sendInMailWithContext: 'Send inmail\n(with context)',
  sendInMailWithContextDescription: 'Creates a personalized Inmail, optimizes it and sends it to your contact on LinkedIn. Here, the last past messages with a contact person as context are taken into account during text creation. (Sales Navigator / Recruiter license must be available)',
  sendEmail: 'Send email',
  sendEmailDescription: 'Creates an initial personalized message, psychologically optimizes it and sends it to your contact per email.',
  sendEmailWithContext: 'Send email \n(with context)',
  sendEmailWithContextDescription: 'Creates an initial personalized message, psychologically optimizes it and sends it to your contact per email. Here, the last past messages with a contact person as context are taken into account during text creation.',
  sendFollowUpEmail: 'Send follow up email',
  sendFollowUpEmailDescription: 'Creates personalized follow up messages based on the texts sent so far, optimizes them psychologically and sends them to your contact per email.',
  sendCallTranscript: 'Send Call Transcript',
  sendcallTranscriptDescription: 'Creates a phone transcript and sends it to a person via email.',
  coldCallTranscript: 'Adapted SPIN Selling Prompt with Optimized Structure and Objections\n\nSPIN Selling Prompt for Personalized Customer Engagement\n\nYou are an SDR tasked with conducting a cold call. The goal is to lead a convincing conversation based on the SPIN Selling method. Prepare by creating a conversation transcript based on the person\'s information.\n\n1. Information about the Person\'s Profile\nPosition and Industry: Describe the professional role, industry, and relevant responsibilities. ({{profile}})\nSuspected Challenges: Identify pain points or problems likely based on their position and industry. ({{problems}})\nPossible Solutions: Highlight how your solution directly addresses these issues. ({{features}})\nExpected Benefits: Define the positive impact your solution could have for the person. ({{benefits}})\nEvidence: Provide examples or success stories that reinforce your solution and build trust. ({{impact}})\n\n2. Create a brief profile summary with the hard facts. Do not include psychological traits.\n\n3. Conversation Transcript\nCreate a continuous transcript based on SPIN Selling principles, leveraging the person\'s information to be more persuasive:\n\nGreet the person politely and demonstrate that you understand their situation.\nIntroduce the context of the conversation by explaining the purpose of your call. Reference relevant points from their profile.\n\nSituation Questions\nAsk open-ended questions to explore the current situation and challenges.\nBase these questions on the suspected challenges.\n\nProblem Questions\nDive deeper into the problem areas by asking specific questions that highlight the pain points.\n\nImplication Questions\nEmphasize the consequences of leaving these challenges unresolved.\n\nNeed-Payoff Questions\nSteer the conversation towards the benefits of your solution, tailoring them to the person\'s needs.\n\nHandling Objections\nAnticipate and address objections flexibly. Use psychological approaches to empathize with objections and build trust.\n\nClosing\nGuide the conversation towards a concrete next step, such as a product demo or a meeting.\n\n4. Create three possible objections and counterarguments\nObjection 1:\nCounterargument:\n\nObjection 2:\nCounterargument:\n\nObjection 3:\nCounterargument\n\nNote: Use the profile information to personalize the approach and apply psychological analysis and industry-specific details to make the conversation dynamic and convincing.',
  sendReply: 'Send reply',
  functionWaitingTime: 'Waiting time = {{waitingTime}} hour',
  functionWaitingTime_plural: 'Waiting time = {{waitingTime}} hours',
  functionPrompt: '<0>Prompt:</0> {{prompt}}',
  hrBoosterAutoCampaignProduct: 'SAIA Recruiting',
  leadBoosterAutoCampaignProduct: 'SAIA Sales',
  findContactsWithJobAd: 'Find contacts using a job ad',
  findContactsWithJobAdInstruction: 'Enter the job title and a job ad in the corresponding text field and we will suggest suitable candidates.',
  enterJobTitleHere: 'Enter the job title here',
  enterJobAdHere: 'Enter a job ad here:',
  findContactsWithSearchUrl: 'Find contacts using a LinkedIn search URL',
  findContactsWithSearchUrlInstruction: 'Define a search directly on LinkedIn and copy the resulting URL from the address bar.',
  campaignWorkTimeTitle: 'When should the campaign work?',
  campaignWorkTimeInstruction: 'Select the days and the full hours on which the campaign should work automatically. e.g.\n0 = first hour (0:00 to 0:59)\n8 = ninth hour (8:00 to 8:59)\n23 = 24th hour (23:00 to 23:59)\netc.\n\nWe particularly recommend times when you are less active on LinkedIn.',
  weekday: 'Weekday',
  time: 'Time',
  timeZone: 'Time zone',
  daily: 'Daily',
  weekdays: 'Weekdays',
  weekend: 'Weekend',
  unselectAll: 'Unselect all',
  fullDay: 'Full day',
  workHours: '8 - 17',
  morning: 'Morning',
  evening: 'Evening',
  instruction: 'Instruction',
  createCampaignInstruction: 'Select the prompts you want to use for your campaign.',
  salesMethod: 'Sales Method',
  linkedinProduct: 'Select where the messages should be sent in LinkedIn',
  whichLinkedinProduct: 'Which LinkedIn product do you use?',
  selectLinkedinProduct: 'Select LinkedIn Product',
  linkedinProductInstruction: 'The personalized messages are sent to this LinkedIn product.',
  testCampaign: 'Test campaign',
  testFailedShort: 'The test failed — please start it again.',
  testNoResult: 'No test result found — results are kept for 2 hours.',
  testGuidanceInsteadOfMessage: 'The AI could not write a message from this instruction. Instead of a message, here is advice on how to improve the instruction.',
  testSuggestedInstruction: 'Suggested instruction',
  testCharacters: 'characters',
  testNoteShortened: 'Shortened by the AI (was {{before}} characters)',
  testNoteRegenerated: 'Rewritten because shortening was not enough (was {{before}} characters)',
  testNoteTooLong: 'Too long: {{characters}} of {{limit}} characters, even after shortening and rewriting. Live, this connection request would not be sent. Shorten the instruction (e.g. "2–3 short sentences") and test again.',
  testSkippedSteps: 'Without a message',
  testSourceApp: 'from the app',
  testSourceMcp: 'via MCP',
  testShownFromSource: 'Latest test {{source}} · {{time}}',
  testRunningFromSource: 'A test {{source}} is running …',
  testLastFailed: 'The latest test ({{time}}) failed. Start it again.',
  startCampaign: 'Start campaign',
  start: 'Start',
  endNoun: 'End',
  addFunction: 'Add function',
  addWaitingTime: 'Add waiting time',
  waitingTime: 'Waiting time',
  waitingTimeInstruction: 'Enter here the time in hours how long to wait until the next action is executed.',
  prompt: 'Prompt',
  promptInstruction: 'You can change the prompt here if necessary. The placeholders displayed in the prompt are used to insert individual information. Remove them only if they are not needed in the final text.',
  emailAddress: 'Caller email',
  emailAddressLabel: 'Caller email address (must have a valid SAIA account). You will receive further instructions and call reminders via email.',
  howManyReminders: 'How many reminders should be sent if the call attempt is not successful?',
  numRemindersLabel: 'Number of reminders',
  createNewCampaign: 'Create campaign',
  enterCampaignNameHere: 'Enter campaign name here...',
  findJobTitlesTableInstruction: 'Select the most relevant skill or combination of skills for you. We will then search for suitable candidates with the job titles <1>{{jobTitles}}</1> according to your selection.',
  foundContacts: 'Found contacts',
  campaignStarted: 'Campaign started',
  campaignStartedSuccess: 'Congratulations, your campaign is now running.',
  findContactsWithProductInformation: 'Find contacts using product information',
  findContactsWithProductInformationInstruction: 'Add the problems your offering solves, as well as the features, benefits & business impact of your offering in the appropriate text box and we\'ll suggest people to match.',
  generateExampleText: 'Generate example text',
  hideExampleText: 'Hide example text',
  next: 'Next',
  prev: 'Back',
  functionStepCounter: 'Step {{current}} of {{total}}',
  testCampaignTitle: 'What texts does my campaign generate?',
  testCampaignInstruction: 'Here you can see sample messages from the respective steps in the campaign. You can change the steps with "Next" and "Back" and see whether the generated texts are suitable for you.',
  leadBoosterAutoCampaignProductDescriptionMain: 'Automate your sales outreach',
  leadBoosterAutoCampaignProductDescriptionSub: 'with special workers who write to people in a completely individualized way.',
  hrBoosterAutoCampaignProductDescriptionMain: 'Automate your recruiting outreach',
  hrBoosterAutoCampaignProductDescriptionSub: 'with special workers who write to people in a completely individualized way.',
  selectLinkedinContact: 'Select contact',
  selectLinkedinContactInstruction: 'Select the LinkedIn contact whose profile you want to test the campaign with.',
  sendFollowUpNotFirstError: 'Follow up message can not be in the first place',
  deleteCampaignDialogTitle: 'Delete campaign',
  confirmDeleteCampaignDialogContent1: 'Do you really want to delete the campaign <1>{{name}}</1>?',
  confirmDeleteCampaignDialogContent2: 'This operation is not reversible and the campaign will not be available afterwards.',
  campaignStatus: 'Campaign Status',
  campaignStatusInstruction: 'The progress of all steps in the campaign and their conversion rates are displayed here.',
  stepCompletion: '{{stepName}} ({{sent}} / {{total}})',
  editFunction: 'Edit function',
  testCampaignDurationInfo: 'We now execute the individual campaign functions in the specified order. Here, sample messages are created for each step in the campaign.',
  testCampaignDurationTime: 'This process may take a few minutes.',
  jobs: 'Jobs',
  keywords: 'Keywords',
  topics: 'Topics',
  industries: 'Industries',
  findLeadsTableInstruction: 'Select the most relevant result for you. We will then search for the appropriate people according to your selection.',
  spinSellingDe: 'Spin Selling (German prompts)',
  spinSellingEn: 'Spin Selling (English prompts)',
  eg: 'e.g.',
  messagesPerDay: 'Messages per day',
  messagesPerDayInstruction: 'Specify here how many messages per campaign step should be sent per day. We limit the number of messages per day because LinkedIn also has daily or weekly limits for certain types of messages and we want to protect your account.',
  addContactsWithProfileFinder: 'Add contacts with the LinkedIn Profile Finder',
  addContactsWithProfileFinderInstruction: 'Use previously created LinkedIn Profile Finder projects to add a defined list of contacts.',
  showContacts: 'Show contacts',
  profileList: 'Contacts',
  profileListInstruction: 'Select the contacts to be added to the campaign.',
  profileListDuplicatesInstruction: 'The selected contacts from this and the previous list are added.',
  blacklist: 'Blacklist',
  companyBlacklists: 'Company blacklists',
  manageCompanies: 'Manage companies',
  enterCompanyNameHere: 'Enter company name here',
  noCompaniesOnBlacklist: 'No companies on the blacklist',
  createBlacklist: 'Create blacklist',
  editBlacklist: 'Edit blacklist',
  enterBlacklistName: 'Enter the name of the blacklist here',
  setAsDefault: 'Set as default',
  defaultBlacklistWarning: '* The default blacklist is applied to all new campaigns. Existing campaigns remain unchanged.',
  manageBlacklistsInstruction1: 'After you create your blacklist, you can add and remove companies there.',
  manageBlacklistsInstruction2: 'Employees of blacklisted companies do not receive contact requests or messages from the campaign for which the blacklist is active.',
  manageBlacklistsInstruction3: 'The default blacklist is applied to all new campaigns.',
  defaultBlacklist: 'default',
  companies: 'Companies',
  deleteBlacklist: 'Delete blacklist',
  deleteBlacklistContent1: 'Do you really want to delete the blacklist <1>{{blacklistName}}</1>?',
  deleteBlacklistContent2: 'This process is not reversible and the blacklist is no longer available afterwards.',
  noBlacklist: 'no blacklist',
  stopCampaign: 'Stop',
  stopCampaignFull: 'Stop campaign',
  restartCampaign: 'Restart',
  restartCampaignFull: 'Restart campaign',
  connectionRequests: 'Connection requests',
  messages: 'Messages',
  inMails: 'InMails',
  editOfferInstruction: 'You can change the information used in text creation here.',
  campaignStatistics: 'Campaign statistics',
  selectCampaign: 'Select campaign',
  selectCampaignInstruction: 'For which campaign do you want to see the detailed statistics? No campaigns are displayed that have not been started at least once.',
  performance: 'Performance',
  performanceInstruction: 'Here you can see how many messages were generated and sent for which campaign step in the last week.',
  messagesChronicle: 'Messages Chronicle',
  messagesChronicleInstruction: 'All messages generated and sent by the campaign are listed here. You can see here which messages were sent when to which contact and how high the match of the SAIA optimization was when sending.',
  reply: 'Reply',
  message: 'Message',
  noMessagesSent: 'No messages sent yet',
  details: 'Details',
  created: 'Created',
  started: 'Working',
  suspended: 'Suspended',
  finished: 'Finished',
  refreshed: 'Refreshed',
  archived: 'Archived',
  messagesSent: 'Messages sent',
  cloneExistingCampaign: 'Clone campaign {{name}}',
  campaignStep: 'Campaign step',
  overallProgress: 'Overall progress',
  conversion: 'Conversion',
  totalContacts: 'Total contacts',
  filteredOutFromBlacklist: 'Filtered out from the blacklist',
  cancelledForTechnicalReasons: 'Cancelled for techn. reasons',
  contactsResponse: 'Contact has responded or gone through the entire campaign',
  removeContacts: 'Remove contacts',
  savedSuccessfully: 'Saved successfully',
  textGenSavesSuccessfullyContent: 'The generated text was successfully saved in the new project.',
  saveAndExit: 'Save & exit',
  saveAndTitleSearch: 'Save & search title',
  saveAndOptimize: 'Save & optimize manually',
  selectGlobalProfile: 'Select global profile',
  selectProfileInstructions: 'You can either have a text generated for the selected profile, or continue with your own text.',
  generateNewText: 'Generate new text',
  selectTailoredProfile: 'Select a tailored profile',
  textGenerationInputs: 'Text generatio inputs',
  resultText: 'Result text',
  generateAndFinalizeText: 'Generate & finalize text',
  useOwnText: 'Use own text',
  useGeneratedText: 'Use generated text',
  textGenerationEditorPlaceholder: 'You can also insert a text directly here and skip the text generation',
  characteristics: 'Characteristics',
  priorities: 'Priorities',
  generateGenreText: 'Generate {{genre}}',
  optimizeGenreMatch: 'Optimize Match for {{genre}}',
  formatGenreText: 'Format {{genre}}',
  generateAnalysisResults: 'Generate analysis results',
  useOwnToC: 'Use own table of contents',
  useGeneratedToC: 'Use generated table of contents',
  showAssistant: 'Show assistant',
  showSuggestions: 'Show Suggestions',
  linkedinAccountManagement: 'LinkedIn Accounts',
  manageLinkedinAccountsInstruction1: 'For each LinkedIn account from which the campaign is to send messages, we need the corresponding credentials.',
  manageLinkedinAccountsInstruction2: 'A Co-Pilot license is required for each LinkedIn account that is to be added.',
  manageLinkedinAccountsInstruction3: 'After an account is added, you need to sync it to use it in a campaign.',
  noAccountsAdded: 'No accounts added',
  addAccount: 'Add account',
  addAccountNoSeatsLeft: 'All licence seats are in use. To add another LinkedIn account you need an additional licence — or remove an existing account.',

  // Use case store. The page carried no translations at all — every label, dialog and
  // message was hardcoded English, even though the templates themselves ship in German
  // and English.
  assignLicenseFailed: 'The licence could not be assigned. Check whether the account already holds a licence of this type.',
  licenseAssignedTo: 'Assigned to',
  licenseAssignmentFree: 'Unassigned',
  licenseAssignmentDangling: 'Account deleted — seat still held',

  useCaseStoreTitle: 'Use case store',
  useCaseStoreSubtitle_one: '{{count}} campaign template · from PAI and your organisation',
  useCaseStoreSubtitle_other: '{{count}} campaign templates · from PAI and your organisation',
  useCaseStoreFilterLabel: 'Filter',
  useCaseStoreSortedByLikes: 'Sorted by ratings',
  useCaseStoreMetricConversion: 'Conversion',
  useCaseStoreMetricUses: 'Uses',
  useCaseStoreMetricSteps: 'Steps',
  useCaseStoreSearchLabel: 'Search',
  useCaseStoreSearchPlaceholder: 'Search by name or creator',
  useCaseStoreChannels: 'Channels',
  useCaseStoreLinkedinProduct: 'LinkedIn product',
  useCaseStoreLanguage: 'Template language',
  useCaseStoreLanguageAny: 'All languages',
  useCaseStoreLanguageDe: 'German',
  useCaseStoreLanguageEn: 'English',
  useCaseStoreAny: 'Any',
  useCaseStoreMinLikes: 'Min. likes',
  useCaseStoreMinUses: 'Min. uses',
  useCaseStoreEmpty: 'No templates found. Adjust the filters or clear the search.',
  useCaseStorePage: 'Page {{page}}',
  useCaseStorePrevious: 'Previous',
  useCaseStoreNext: 'Next',
  useCaseStorePopular: 'Popular',
  useCaseStoreTopConversion: 'Top conversion',
  useCaseStoreLike: 'Like',
  useCaseStoreUnlike: 'Remove like',
  useCaseStoreApply: 'Apply',
  useCaseStoreApplyTitle: 'Apply template',
  useCaseStoreCampaignName: 'Campaign name',
  useCaseStoreLinkedinAccount: 'LinkedIn account',
  useCaseStoreApplyValidation: 'Please enter a name and select a LinkedIn account.',
  useCaseStoreApplySuccess: 'Template applied.',
  useCaseStoreApplyFailed: 'The template could not be applied.',
  useCaseStoreLoadFailed: 'The templates could not be loaded.',
  useCaseStoreLikeFailed: 'Your rating could not be saved.',
  useCaseStoreEditTitle: 'Edit template',
  useCaseStoreDescription: 'Description',
  useCaseStoreConversionRate: 'Conversion rate',
  useCaseStoreNameRequired: 'Please enter a name.',
  useCaseStoreConversionMustBeNumber: 'The conversion rate has to be a number.',
  useCaseStoreUpdateSuccess: 'Template updated.',
  useCaseStoreUpdateFailed: 'The template could not be updated.',
  useCaseStoreDeleteTitle: 'Delete template',
  useCaseStoreDeleteConfirm: 'Delete the template "{{name}}"?',
  useCaseStoreDeleteSuccess: 'Template deleted.',
  useCaseStoreDeleteFailed: 'The template could not be deleted.',
  editLinkedinAccount: 'Edit LinkedIn account',
  removeLinkedinAccount: 'Remove LinkedIn Account',
  removeLinkedinAccountContent1: 'Should the account <1>{{userName}}</1> really be removed?',
  removeLinkedinAccountContent2: 'This process is not reversible and the account must be recreated afterwards if it is needed again.',
  removeLinkedinAccountContent3: 'All active campaigns associated with this account will be stopped upon removal.',
  resetLocalStorage: 'Reset Local Storage',
  accountConnections: 'Connections',
  accountConnectionsIntro: 'All 1st-degree connections of {{userName}} as read from the LinkedIn app. Names appear once a connection is linked to a contact.',
  accountConnectionsSearchPlaceholder: 'Name, company or LinkedIn handle…',
  accountConnectionsCount: '{{count}} connections',
  accountConnectionsLastRead: 'Last read: {{date}}',
  accountConnectionsNeverRead: 'Not read yet',
  accountConnectionsRefreshRunning: 'Full read in progress: page {{page}} of up to {{pages}} (during the account\'s work window).',
  accountConnectionsRefresh: 'Re-read completely',
  accountConnectionsRefreshError: 'The refresh could not be requested.',
  accountConnectionsLoadError: 'The connections could not be loaded.',
  accountConnectionsEmpty: 'No connections found.',
  accountConnectionsColumnName: 'Contact',
  accountConnectionsColumnCompany: 'Company',
  accountConnectionsColumnFirstSeen: 'First seen',
  accountConnectionsColumnInContacts: 'In contacts',
  resetLocalStorageContent1: 'Should the local storage for account <1>{{userName}}</1> really be reset?',
  resetLocalStorageContent2: 'This clears cached LinkedIn data for this account. You may need to re-login and re-verify.',
  synchronized: 'synchronized',
  wrongCredentials: 'wrong credentials',
  verificationRequired: 'verification required',
  verifyLinkedinAccount: 'Verify LinkedIn account',
  verifyLinkedinAccountInstruction1: 'You should have received a LinkedIn verification code via SMS or email (depending on your settings).',
  verifyLinkedinAccountInstruction2: 'Always use the latest code.',
  verifyLinkedinAccountInstruction3: 'You will probably receive an email from LinkedIn about a login attempt from a new device.',
  verifyLinkedinAccountInstruction4: 'If you use the Authenticator app, make sure that the code does not expire immediately, but has just been regenerated.',
  enterLinkedinVerificationCodeHere: 'Enter the LinkedIn verification code here...',
  verificationCode: 'Verification code',
  linkedinAccount: 'LinkedIn Account',
  linkedinEmail: 'LinkedIn E-Mail',
  linkedinAccountInstruction: 'The LinkedIn account from which the messages are sent.',
  synchronize: 'synchronize',
  paused: 'Paused',
  linkedinLicenseDisclaimer: 'Depending on the LinkedIn license, the actual number of people found on LinkedIn may be lower than the number displayed.',
  missingPlaceholdersWarning: 'The following placeholders are missing in the prompt: {{placeholders}}',
  duplicateProfilePlaceholderWarning: 'The profile placeholder {{profile}} should appear only once in the prompt',
  duplicateJobOfferPlaceholderWarning: 'The job offer placeholder {{jobOffer}} should appear only once in the prompt',
  hrBoosterActiveSourcing: 'SAIA Recruiting for Active Sourcing',
  hrBoosterJobAds: 'SAIA Recruiting for Job Ads',
  leadBoosterSocialSelling: 'SAIA Sales for Social Selling',
  leadBoosterMarketingCampaigns: 'SAIA Sales for Campaign texts',
  fullyAutomated: 'Fully-automated',
  semiAutomated: 'Semi-automated',
  existingTargetGroups: 'existing target groups',
  ownTargetGroups: 'Own target groups',
  aiTextGeneration: 'AI text generation',
  matchPersonalityProfile: 'Matching to psych. personality profile',
  serverSmtp: 'Server (SMTP)',
  portSmtp: 'Port (SMTP)',
  security: 'Security',
  invalidSmtpServer: 'Invalid SMTP server',
  serverImap: 'Server (IMAP)',
  portImap: 'Port (IMAP)',
  invalidImapServer: 'Invalid IMAP serverr',
  invalidCredentials: 'Invalid credentials',
  none: 'None',
  emailCredentials: 'Email credentials',
  emailAccountCredentials: 'Email account credentials',
  emailCredentialsRequired: 'Email credentials required',
  createDate: 'Creation date',
  active: 'Active',
  inactive: 'Inactive',
  expired: 'Expired',
  canceled: 'Subscription canceled',
  expiredAt: 'Expired at',
  expiresAt: 'Expires at',
  nextPayment: 'Next payment',
  bookedManually: 'Booked manually',
  recruiterContract: 'Recruiter Contract',
  selectLinkedinAccount: 'Select LinkedIn account',
  selectLinkedinProductInstruction: 'Select the LinkedIn product in which you want to search for contacts.',
  selectLinkedinAccountInstruction: 'Select the LinkedIn account from which you want to search for contacts.',
  continue: 'Continue',
  // lead i18n start
  participantLimitReachedError: 'License does not contain other surveys. Please notify the creator.',
  boss: 'Boss',
  colleague: 'Colleague',
  employee: 'Employee',
  other: 'Other',
  leadQuestionnaireGreeting: 'Welcome to the <1>LEaD Leadership Feedback</1>',
  leadQuestionnairePerspectiveText1: 'Dear Participant,',
  leadQuestionnairePerspectiveText2: 'Welcome to the leadership feedback <1>"LEaD - Leadership Effectiveness and Development"</1>. We are pleased that you are taking part in the survey.',
  leadQuestionnairePerspectiveText3: 'First, please select from which perspective you are responding to the feedback so that we can match you with the appropriate questions.',
  leadQuestionnaireGreetingSelfPerspectiveText1: 'Dear Executive,',
  leadQuestionnaireGreetingSelfPerspectiveText2: 'welcome to the leadership feedback <1>"LEaD - Leadership Effectiveness and Development"</1>. We are pleased that you are participating.',
  leadQuestionnaireGreetingSelfPerspectiveText3: 'The LEaD questionnaire serves the purpose of providing you with differentiated feedback on your control and leadership skills in everyday life.',
  leadQuestionnaireGreetingSelfPerspectiveText4: 'Filling out the questionnaire will take <1>about 15-20 minutes</1>. We would like to ask you to complete the questionnaire in one piece. Please make sure to keep your browser window open in any case, even if you take a break. In this way, short time interruptions are possible during the processing of the questionnaire.',
  leadQuestionnaireGreetingSelfPerspectiveText5: 'Your answers and information will be kept <1>absolutely confidential and anonymous</1> and will not be accessible to anyone outside the A47-Consulting & SAIA team.',
  leadQuestionnaireGreetingSelfPerspectiveText6: 'The results of this survey should make an important contribution to supporting you in your professional and personal development.',
  leadQuestionnaireGreetingOtherPerspectiveText1: 'Dear Sir or Madam,',
  leadQuestionnaireGreetingOtherPerspectiveText2: 'welcome to the leadership feedback <1>"LEaD - Leadership Effectiveness and Development"</1>. We are pleased that you are participating.',
  leadQuestionnaireGreetingOtherPerspectiveText3: 'The LEaD questionnaire serves the purpose of providing your manager, your employee or your colleague with differentiated feedback on his/her control and leadership competencies in everyday life.',
  leadQuestionnaireGreetingOtherPerspectiveText4: 'Filling out the questionnaire will take <1>about 15-20 minutes</1>. We would like to ask you to complete the questionnaire in one piece. Please make sure to keep your browser window open in any case, even if you take a break. In this way, short time interruptions are possible during the processing of the questionnaire.',
  leadQuestionnaireGreetingOtherPerspectiveText5: 'Your answers and information are <1>absolutely confidential and anonymous</1> and are not accessible to anyone outside the team of A47-Consulting & SAIA. It is also not possible in the results report for the feedback recipient to associate your statements with you personally - only aggregated and averaged results are reported.',
  leadQuestionnaireGreetingOtherPerspectiveText6: 'The results of this survey are intended to make an important contribution to supporting your manager, your employee or your colleague in his or her professional and personal development. We therefore thank you in advance for your participation.',
  leadQuestionnaireGreetingOpenQuestions: 'If you have questions about the survey process, please contact A47 Consulting (<1 href="mailto:lead@a47-consulting-team.de">lead@a47-consulting-team.de</1>)',
  leadQuestionnaireThankYouForParticipation: 'Thank you very much for your participation!',
  leadQuestionnaireIntroduction: 'Introduction',
  leadQuestionnaireIntroductionSelfPerspectiveText: 'The following questionnaire includes questions about your control and leadership behavior in various control and leadership areas relevant to success.',
  leadQuestionnaireIntroductionOtherPerspectiveText: 'The following questionnaire includes questions about the control and leadership behavior of your manager, your employee or your colleague in various control and leadership areas relevant to success. For the sake of simplicity, we will refer to Mr. / Mrs. X in the questionnaire.',
  leadQuestionnaireIntroductionText1: 'Should you ever have difficulty deciding, please nevertheless tick the <1>answer that most closely matches the question.</1> If you have ever made an incorrect assessment, simply click on another <3>answer alternative</3>: the mark you clicked on first will automatically disappear.',
  leadQuestionnaireIntroductionText2: 'On the last pages of the questionnaire, you have the opportunity to share <1>your personal impressions</1>. Experience has shown that it is precisely these personal comments that are important indicators for further personal development. We therefore ask you to indicate your assessments here as well. Thank you very much!',
  leadQuestionnaireIntroductionText3: 'Please select in which language the questionnaire should be displayed.',
  leadQuestionnaireStartSurvey: 'Start survey',
  leadQuestionnaireErrorAlreadyCompleted: 'The questionnaire has already been answered',
  leadQuestionnaireErrorAlreadyGeneric: 'Please contact info@secret-ai-agent.de if the error continues to occur.',
  leadQuestionnaireProgress: 'Progress',
  leadQuestionnaireSurveyFinished: 'Questionnaire finished',
  leadQuestionnaireSurveyFinishedText1: 'Done. Thank you very much for your participation!',
  leadQuestionnaireSurveyFinishedText2: 'You can now close the window.',
  leadQuestionnaireSendSurvey: 'Send survey',
  never: 'never',
  rarely: 'rarely',
  partPart: 'part/part',
  often: 'often',
  almostAlways: 'regularly, almost always',
  leadQuestionnaireEffectiveLead: 'Effective leadership',
  leadQuestionnaireEffectiveLeadSelfPerspectiveText: 'The last part of the questionnaire is about the <1>impact of your leadership and influencing behavior. </1>Please estimate how often the following statements apply.',
  leadQuestionnaireEffectiveLeadOtherPerspectiveText: 'The last part of the questionnaire is about the <1>impacts of the leadership and influencing behavior</1> of Mr./Mrs. X. Please estimate how often the following statements apply to Mr. /Mrs. X.',
  enterYourText: 'Enter your text here...',
  leadQuestionnaireOpenQuestions: 'Your personal impressions',
  leadQuestionnaireOpenQuestionsSelfPerspectiveText1: 'While answering the previous questions, you will certainly have had many thoughts running through your head about what you see as your clear personal strengths and where there is also potential for development.',
  leadQuestionnaireOpenQuestionsSelfPerspectiveText2: 'Finally, please enter your personal impressions in the respective text fields - also in key points if you like.',
  leadQuestionnaireOpenQuestionsSelfPerspectiveText3: 'We will reproduce your statements faithfully in the results report - therefore, please ensure that your descriptions are legible and comprehensible and refrain from using formatting elements (such as bullet points or additional blank lines).',
  leadQuestionnaireOpenQuestionsOtherPerspectiveText1: 'Surely, while answering the previous questions, many thoughts have gone through your mind as to what, in your eyes, are clear strengths of your feedback recipient and where there is also potential for development.',
  leadQuestionnaireOpenQuestionsOtherPerspectiveText2: 'Finally, please enter your personal impressions in the respective text fields - also in key points if you like.',
  leadQuestionnaireOpenQuestionsOtherPerspectiveText3: 'We will reproduce your statements faithfully in the results report - therefore, please ensure that your descriptions are legible and comprehensible and refrain from using formatting elements (such as bullet points or additional blank lines).',
  leadQuestionnaireOpenQuestionsThankYou: 'Thank you very much!',
  leadQuestionnaireDemographicQuestions: 'Demographic questions',
  leadQuestionnaireDemographicQuestionsBranch: 'Branch',
  leadQuestionnaireDemographicQuestionsCompanySize: 'Company size',
  leadQuestionnaireDemographicQuestionsTeamSize: 'Team size',
  leadQuestionnaireDemographicQuestionsManagementField: 'Own management function',
  leadQuestionnaireDemographicQuestionsTeamType: 'Team characteristics',
  leadQuestionnaireDemographicQuestionsCustomerResponsibility: 'End customer responsibility',
  leadQuestionnaireDemographicQuestionsResponsibilityField: 'Area of responsibility/organizational unit',
  agriculture: 'Agriculture',
  construction: 'Construction',
  chemistryRawMaterials: 'Chemistry & Raw Materials',
  industryCraftsmanship: 'Industry & Craftsmanship',
  consulting: 'Consulting',
  eCommerceMailOrder: 'E-Commerce & Mail Order',
  energyEnvironment: 'Energy & Environment',
  financeInsuranceRealEstate: 'Finance, Insurance & Real Estate',
  societyEducationSocialJustice: 'Society (Education, Social, Justice)',
  trade: 'Trade',
  consumption: 'Consumption',
  mediaMarketing: 'Media & Marketing',
  pharmaHealth: 'Pharma & Health',
  metalElectronics: 'Metal & Electronics',
  technologyTelecommunication: 'Technology & Telecommunication',
  tourismHospitality: 'Tourism & Hospitality',
  sportsWellness: 'Sports & Wellness',
  transportLogistics: 'Transport & Logistics',
  administrationPublicService: 'Administration & Public Service',
  scienceResearch: 'Science & Research',
  upTo100Employees: 'Up to 100 Employees',
  to499Employees: '101 to 499 Employees',
  to4999Employees: '500 to 4,999 Employees',
  to19999Employees: '5,000 to 19,999 Employees',
  to50000Employees: '20,000 to 50,000 Employees',
  moreThan50000Employees: 'More than 50,000 Employees',
  executive: 'Executive',
  departmentManagement: 'Department Management',
  divisionalManagement: 'Divisional Management',
  leadQuestionnaireTeamManagement: 'Team Management',
  noManagementFunction: 'No Management Function',
  specialistTeam: 'Specialist Team',
  scienceTeam: 'Science Team',
  interprofessionalTeam: 'Interprofessional Team',
  salesTeam: 'Sales Team',
  operationalTeam: 'Operational Team',
  financeAccounting: 'Finance/Accounting',
  controlling: 'Controlling',
  humanResources: 'Human Resources',
  backOffice: 'Back Office',
  business: 'Business',
  developmentStrategy: 'Development/Strategy',
  riskManagement: 'Risk Management',
  informatics: 'IT',
  communicationMarketing: 'Communication/Marketing',
  serviceCenter: 'Service Center',
  salesSupport: 'Sales Support',
  // lead i18n end
  addBlacklistedCompaniesInstruction: 'Search for companies to exclude from the campaigns and add them to the blacklist.',
  selectLinkedinAccountForCompanyURNInstruction: 'Select the LinkedIn account from which the companies should be searched.',
  languageOptions: 'Language Options',
  perMonth: 'per month',
  perYear: 'per year',
  paidAnnually: 'paid annually',
  paidMonthly: 'paid monthly',
  enterNumberOfAccounts: 'Enter the number of accounts here',
  featureAutoLinkedinCrawler: 'Automatically find the relevant contacts on Linkedin',
  featureAutoLinkedinMessages: 'Automatically contact people on LinkedIn',
  featureAutoEmailMessages: 'Automatic contacting via e-mail possible',
  featureLinkedinExtensionIncluded: 'Linkedin extension included',
  copilotLicense: 'Co-Pilot license',
  inbox: 'Inbox',
  campaignInbox: 'Campaign Inbox',
  replyInbox: 'reply',
  updateInbox: 'Update Inbox',
  inboxUpdateModalTitle: 'Update Inbox',
  inboxUpdateModalDescription: 'Fetch new LinkedIn messages now. Optionally re-sync from an earlier date to catch up on older conversations.',
  inboxUpdateSinceLast: 'From last update (default)',
  inboxUpdateSinceCustom: 'From a specific date',
  inboxUpdateSinceDate: 'Re-sync from',
  inboxUpdateModalConfirm: 'Update now',
  replyLinkedin: 'reply via LinkedIn',
  replyEmail: 'reply via email',
  campaignInboxNoUnansweredMessages: 'No unanswered messages available',
  campaignInboxWriteMessage: 'Write message...',
  campaignInboxSendMessage: 'Send',
  overwriteOfferContentTitle: 'Overwrite {{credential}}',
  overwriteOfferContentContent: 'We have noticed that the {{credential}} in the text field is different from the saved one. Would you like to overwrite it?',
  markAsRead: 'mark as read',
  markAsReadContent1: 'The conversation is ended and removed from the inbox.',
  markAsReadContent2: 'This process cannot be reversed and the conversation can then only be continued directly on LinkedIn.',
  ms_o365: 'MS Office 365',
  accountType: 'Account type',
  authMsAccount: 'Authorize Microsoft account',
  authMsAccountInstruction: 'With this authorization process, you grant our application permission to read and manage your Outlook emails.',
  authCode: 'Authorization code',
  enterCodeHere: 'Enter the code from the authorization process here...',
  authMsAccountTitle: 'Authorization\nsuccessful',
  authMsAccountContent1: 'Congratulations! The authorization process was successful.',
  authMsAccountContent2: 'now copy the code below',
  authMsAccountContent3: 'go back to the email credentials dialog',
  authMsAccountContent4: 'and paste it into the "Authorization code" field',
  refreshInvalidCookiesInfo: 'Cookies invalid',
  refreshInvalidCookiesInfoContent1: 'The cookies from the selected LinkedIn account are no longer valid.',
  refreshInvalidCookiesInfoContent2: 'We are now synchronizing the account again.',
  refreshInvalidCookiesInfoContent3: 'Please repeat the request again in approx. 1 min.',
  refreshCookies: 'Refresh cookies',
  authGmailAccount: 'Authorize Gmail account',
  authGmailAccountInstruction: 'With this authorization process, you grant our application permission to read and manage your Gmail emails.',
  gmail: 'Gmail',
  leadGenSearchOptions: 'How would you like to search?',
  leadGenSearchOptionsDescription: 'You can choose between a normal person search on LinkedIn or an advanced search for people based on LinkedIn postings.',
  viaLinkedinSearch: 'via general LinkedIn search',
  viaPostingSearch: 'via LinkedIn postings',
  exportToExcel: 'Export to Excel',
  filter: 'Filter',
  waitBeforeSyncTitle: 'Please wait a moment',
  waitBeforeSyncContent1: 'We recently tried to synchronize the account with LinkedIn.',
  waitBeforeSyncContent2: 'Please wait <1>{{minutes}} minute(s)</1> and then synchronize it again.',
  waitForAccountSyncTitle: 'LinkedIn connection lost',
  waitForAccountSyncContent1:
    'LinkedIn ended this session (logout, security check, or expired cookies). We are reconnecting your account automatically.',
  waitForAccountSyncContent2: 'While this runs, related buttons and fields stay disabled temporarily.',
  waitForAccountSyncContent3: 'When the account is connected again, we continue your action automatically.',
  libraries: 'Libraries',
  functions: 'Functions',
  prompts: 'Prompts',
  promptManagement: 'Prompt management',
  addLibrary: 'Add library',
  editLibrary: 'Edit library',
  libraryName: 'Name of the library',
  enterLibraryNameHere: 'Enter library name here...',
  functionName: 'Name of the function',
  enterFunctionNameHere: 'Enter function name here...',
  campaignType: 'Campaign product type',
  deleteLibraryTitle: 'Delete library',
  deleteLibraryContent1: 'Really delete library <1>{{libraryName}}</1> and all associated functions?',
  deleteLibraryContent2: 'This process cannot be reversed and the library will no longer be available.',
  enterPromptHere: 'Enter prompt here...',
  deleteFunctionTitle: 'Remove function',
  deleteFunctionContent1: 'Really remove function <1>{{functionName}}</1> from the library?',
  deleteFunctionContent2: 'This process cannot be reversed and the function will no longer be available.',
  promptLibrariesNoPromptsFound: 'No libraries were found',
  activeSourcingDe: 'Active Sourcing (German prompts)',
  activeSourcingEn: 'Active Sourcing (English prompts)',
  limitReachedDialogTitle: 'Limit of the license reached',
  limitReachedDialogContent1: 'You have exceeded the number of requests that are possible with your license.',
  limitReachedDialogContent2: 'Please <1>upgrade your license</1>, or <3>contacts us</3> if you need a special plan for yourself or your company.',
  numberContactAnalyses: 'Number of contact analyses',
  crawlerOptions: 'Options for people search',
  includedPersonTypes: 'Included person types',
  reactions: 'Reactions',
  comments: 'Comments',
  authors: 'Authors',
  includedProfileDegrees: 'Included profile degrees',
  profileListCheckForContacts: 'Would you like to check whether contacts from the list have already been added to other campaigns from your company?',
  noDuplicateContactsFound: 'No contact from the list was found in another campaign.',
  contactsAlreadyInCampaign: 'Contacts from other campaigns',
  profileListCheckForContactsInstruction: 'Decide whether you want to add the people who are already in other campaigns to this campaign.',
  addContacts: 'Add contacts',
  typeOfContactSearch: 'Type of contact search',
  linkedinSearchURL: 'LinkedIn search URL',
  linkedinProfileFinder: 'LinkedIn Profile Finder',
  jobTitle: 'Job title',
  linkedinProfileFinderProjects: 'LinkedIn Profile Finder Projects',
  createLinkedinProfileFinderProject: 'New LinkedIn Profile Finder project',
  selectLinkedinProfileFinderProject: 'Select your LinkedIn Profile Finder project',
  searchForContacts: 'Search for contacts',
  problems: 'Problems',
  features: 'Features',
  benefits: 'Benefits',
  impact: 'Business Impact',
  baseTextDescription: 'The texts are used to enrich the prompts of the campaigns functions with the required information.',
  timeZoneDescription: 'The time zone that applies to the campaign.',
  blacklistDescription: 'Contacts from companies on the blacklist are not contacted by the campaign. The blacklists can be created and edited in a separate menu.',
  communicationSettings: 'Communication settings',
  campaignLanguage: 'Campaign language',
  checkForDuplicates: 'Check for duplicates',
  coPilot: 'Co-Pilot',
  editPrompt: 'Edit prompt',
  deleteFunction: 'Delete function',
  editWaitingTime: 'Edit waiting time',
  deleteWaitingTime: 'Delete waiting time',
  waitingTimeInHours: 'Waiting time in hours',
  deleteAllFunctions: 'delete all functions',
  dragMessageDescription: 'You can drag these messages into the area on the right-hand side.',
  dragConditionsDescription: 'You can drag these conditions into the area on the right-hand side.',
  dragHelperFunctionsDescription: 'You can drag these helper functions into the area on the right-hand side.',
  conditions: 'Logical conditions (Y/N)',
  alreadyConnected: 'Connected on LinkedIn',
  hasReplied: 'Has replied',
  connected: 'connected',
  notConnected: 'not connected',
  connectionRequestWasAccepted: 'Connection request accepted',
  accepted: 'accepted',
  notAccepted: 'not accepted',
  replied: 'replied',
  notReplied: 'not replied',
  alreadyConnectedDescription: 'Check whether you are already connected to the contact on LinkedIn. Can only be used at the beginning of the campaign.',
  connectionRequestAcceptedDescription: 'Check whether the sent contact request has been accepted by the contact. Can only be used after a contact request.',
  hasRepliedDescription: 'Check whether the contact has replied to the sent message. Can be used after every function that sends a message (except \'Send connection request\').',
  helperFunctions: 'Helper functions',
  waitingTimeDescription: 'Define how long to wait after a message or condition.',
  emails: 'Emails',
  emailCredentialsMissing: 'Email credentials missing',
  generateEmailAddress: 'Find email address',
  emailFound: 'found',
  emailNotFound: 'not found',
  generateEmailAddressDescription: 'We try to find out the email addresses of your contacts for you. It is possible that this does not always work. Can only be used before a function that sends an e-mail.',
  newCampaign: 'Create new Campaign',
  editCampaign: 'Edit Campaign',
  campaigns: 'Campaigns',
  enterCampaignName: 'Enter campaign name here...',
  removeAll: 'Remove all',
  addContactsViaCSV: 'Add contacts via a CSV file',
  addContactsViaFileInstruction: 'Upload a CSV file (CSV UTF-8) or an Excel file (.xlsx, .xls).',
  contacts_search: 'Add contacts',
  manual_contacts: 'Add contacts manually',
  manage_contacts_search: 'Manage your added LinkedIn lists',
  manage_contacts: 'Manage your Contacts',
  dragFileOrClickHere: 'Drag and drop some files here, or click to select files',
  dropFileHere: 'Drop files here',
  noContactsAdded: 'No contacts added',
  noSearchesAdded: 'No LinkedIn contact searches added',
  onlyJobs: 'only jobtitles',
  various: 'various',
  unselectAllDuplicates: 'Do not add any duplicates to the campaign',
  linkedinAccountInformation: 'LinkedIn-Account-Information',
  proxyServerInformation: 'Proxy-Server-Information',
  proxyServerInformationDescription: 'The country and city must be the same from which you are currently accessing your LinkedIn account (usually the city closest to where you live). We give you this free proxy to better protect your LinkedIn account.',
  noCampaignsFound: 'No campaigns found',
  addJobAd: 'Add job ad',
  editJobAd: 'Edit job ad',
  addProductInformation: 'Add product information',
  editProductInformation: 'Edit product information',
  basicCampaignSettings: 'Basic campaign settings',
  addAndManageContacts: 'Add & manage contacts',
  enterProductInformationHere: 'Enter the product information here',
  generateUrlQuestionRecruitingBooster: 'Would you like us to search for relevant candidates for you?',
  generateUrlQuestionSalesBooster: 'Would you like us to search for relevant contacts for you?',
  generateUrlQuestion: 'Would you like us to search for relevant candidates for you?',
  addOwnUrlQuestion: 'Have you created a search on LinkedIn yourself?',
  addContactSearches: 'Add LinkedIn contact searches to the campaign',
  addContactSearchesDescription: 'We crawl LinkedIn for you in the background for contacts. To do this, we need a LinkedIn search URL. You have two options for adding the URLs. Either we create a new search for you based on your needs, or you add your own existing search URL to the campaign.',
  selectSuitableTalentSearchResults: 'Select one or more searches',
  selectSuitableTalentSearchResultsDescription: 'Here you can see a list of LinkedIn searches. Select one or more of them and add them to the campaign. We then process the LinkedIn search in the background and add the contacts from it to the campaign. Depending on the LinkedIn license, the actual number of people found on LinkedIn may be lower than the number displayed.',
  selectSuitableLeadSearchResults: 'Select the suitable search results',
  selectSuitableLeadSearchResultsDescriptions: 'Here you can see a list of LinkedIn URLs with different search terms. Select one or more of them and add them to the campaign. We then process the LinkedIn search in the background and add the contacts from the search to the campaign. Depending on the LinkedIn license, the actual number of people found on LinkedIn may be lower than the number displayed.',
  addOwnUrl: 'Paste your Linkedin search URL here',
  addOwnUrlDescription: 'Copy the URL of your LinkedIn search from the LinkedIn URL bar and paste it into the text field below.',
  enterLinkedinSearchUrlHere: 'Enter your LinkedIn search URL here...',
  linkedinSearchesInCampaign: 'LinkedIn contact searches in the campaign',
  linkedinSearchesInCampaignDescription: 'Here you can see all the LinkedIn contact searches of the campaign. We use LinkedIn URLs to search for contacts in the background and add more and more contacts to the campaign over time. The searches are processed in sequence and only one search runs at a time.',
  searchTerms: 'Search terms',
  locations: 'Locations',
  moveToTop: 'Move to the top of the list',
  moveOneUp: 'Move one up',
  moveOneDown: 'Move one down',
  moveToBottom: 'Move to the end of the list',
  deleteUrl: 'Delete search',
  contactsInTheCampaign: 'Contacts in the current campaign',
  contactsInTheCampaignDescription: 'Here you can see a list of all contacts in the campaign. You can remove contacts from the campaign at any time if you no longer want them to receive messages.',
  contactsFromOtherCampaigns: 'Contacts already processed in other campaigns',
  contactsFromOtherCampaignsDescription: 'Contacts in this list must be checked manually and are otherwise not automatically processed in the current campaign. You can decide whether you want to add the duplicates to the campaign or remove them from the list.',
  removeAllContactsFromCampaign: 'remove all contacts from the campaign',
  removeAllContactsFromCampaignContent1: 'Do you really want to remove all contacts from the campaign?',
  removeAllContactsFromCampaignContent2: 'This process cannot be reversed. The contacts are then no longer available.',
  campaign: 'Campaign',
  deleteContactSearchDialogTitle: 'Delete LinkedIn search',
  deleteContactSearchDialogContent1: 'Should the LinkedIn contact search <1>{{name}}</1> really be deleted?',
  deleteContactSearchDialogContent2: 'This cancels the search and removes it from the system. This process cannot be reversed.',
  deleteContactSearchDialogContent3: 'However, contacts already added from this search remain in the campaign.',
  deleteContactFileDialogTitle: 'Delete contact file',
  deleteContactFileDialogContent: 'Should the file <1>{{name}}</1> and all contacts associated with it really be deleted?',
  recruiterUrlWarningDialogTitle: 'Recruiter URL expired',
  recruiterUrlWarningDialogContent1: 'The Recruiter URL you entered has expired and can no longer be used.',
  recruiterUrlWarningDialogContent2: 'The LinkedIn Recruiter only allows one search at a time.',
  recruiterUrlWarningDialogContent3: 'Please repeat the search, copy the URL directly and add it to the campaign.',
  noContactsFromOtherCampaignsFound: 'No contacts found from other campaigns',
  removeAllContactsFromDuplicateList: 'remove all contacts from the list',
  moveAllContactsFromDuplicatesListIntoCampaign: 'add all contacts to the campaign',
  removeAllContactsFromDuplicateListContent1: 'Do you really want to remove all contacts from the list?',
  removeAllContactsFromDuplicateListContent2: 'This process cannot be reversed. The contacts are then no longer available.',
  addToCampaign: 'add selection to the campaign',
  csvExport: 'CSV Export',
  salesNavOrRecruiterAccountRequired: 'Sales Navigator oder Recruiter account required',
  salesNavOrRecruiterContactsRequired: 'InMails can only be sent to Sales Navigator or Recruiter contacts',
  addContactsManually: 'Add contacts manually to the campaign',
  linkedinProfileFinderQuestion: 'Would you like to add contacts to your LinkedIn Profile Finder projects?',
  fileUploadQuestion: 'Would you like to upload contacts via a CSV or Excel file?',
  keepBoth: 'No filter',
  keepFemale: 'Only women',
  keepMale: 'Only men',
  waitingForChanges: 'saving changes....',
  saved: 'saved',
  profileFinderSearchTypes: 'What is the basis of your search?',
  profileFinderSearchTypesDescription: 'With the selection you determine which CSV format we expect.',
  websiteVisitors: 'Website visitors',
  linkedinUrl: 'LinkedIn URL',
  nameAndCompany: 'Name & Company',
  companyAndRole: 'Company & Role',
  noProjectsFound: 'No projects found',
  campaignOverview: 'Campaign Overview',
  campaignSummary: 'Campaign Summary',
  reactFlowDragInfo: 'Drag and drop messages, helper functions and logical conditions into the area and connect them to create your campaign.',
  backgroundCrawlerInfoDialogTitle: 'LinkedIn contact search',
  backgroundCrawlerInfoDialogContent1: '<0>Status:</0> The LinkedIn contact search has been successfully added to the campaign. We are now working step by step to add the contacts one by one.',
  backgroundCrawlerInfoDialogContent2: '<0>Why is it done this way?</0> We protect the LinkedIn account by retrieving the first two pages of the search results step by step. In this way, we prevent LinkedIn from taking measures against data being retrieved too quickly.',
  backgroundCrawlerInfoDialogContent3: '<0>How to use it:</0> If the search does not work as desired, click on the three dots on the right and select "Continue search" to load another page.',
  backgroundCrawlerInfoDialogAction: 'Click here to view the contacts you have already added',
  backToCampaign: 'back to the campaign',
  pageNotFoundTitle: '404 - Page Not Found',
  pageNotFoundText: 'The page you are looking for does not exist',
  routeToHomepage: 'to the homepage',
  emailAccount: 'Email account',
  addSingleContact: 'Add a single contact to the campaign',
  addSingleContactDialogTitle: 'Add contact',
  enterLinkedinUrlHere: 'Enter LinkedIn-URL here...',
  enterFirstNameHere: 'Enter first name here...',
  enterLastNameHere: 'Enter last name here...',
  enterCompanyHere: 'Enter company here...',
  enterEmailHere: 'Enter email here...',
  accountAlreadySyncedDialogTitle: 'Cookies still valid',
  accountAlreadySyncedDialogContent1: 'The cookies are still valid or the account is already in the login queue.',
  accountAlreadySyncedDialogContent2: 'It is therefore not necessary to synchronize the account again.',
  parallelLogin: 'Parallel login',
  pleaseResyncAccount: 'Please synchronize your account again',
  resyncAccount: 'synchronize account',
  recruiterParallelLoginDialogTitle: 'Recruiter account already in use',
  recruiterParallelLoginDialogContent1: 'The LinkedIn Recruiter only allows one session at a time.',
  recruiterParallelLoginDialogContent2: 'Please log out of LinkedIn Recruiter and then log in your account here.',
  recruiterParallelLoginDialogContent3: 'As soon as the account is logged in, you can use it again in your campaigns.',
  synchronizeNow: 'Synchronize now',
  approveMessagesBeforeSending: 'Approve messages before sending',
  messagesToApprove: 'Messages to approve',
  approve: 'approve',
  deny: 'deny',
  saveAndApprove: 'save & approve',
  leadBoosterCopilotName: 'SAIA Sales Co-Pilot',
  recruitingBoosterCopilotName: 'SAIA Recruiting Co-Pilot',
  copilotFeature1: 'Co-Pilot License for one year - cancellable at any time',
  copilotFeature2: 'License works in conjunction with a LinkedIn account',
  copilotFeature3: 'AI-generated messages tailored to the motivations of the recipient',
  copilotFeatureLead4: 'Fully automated expansion of your business network',
  copilotFeatureRecruiting4: 'Fully automated expansion of your candidate network',
  copilotFeature5: 'Multi-channel reach out',
  copilotFeature6: 'SAIA LinkedIn extension included',
  copilotFeature7: 'Contacts addressed in six languages (DE, EN, IT, FR, ES, PT)',
  leadAdsAndPersonaGeneratorName: 'Marketing Ads & Personas Generator',
  recruitingAdsAndPersonaGeneratorName: 'Job Ads & Personas Generator',
  adsAndPersonaGeneratorFeature1: 'Use any of our predefined profiles or create your own profiles',
  adsAndPersonaGeneratorFeature2: 'A "credit" allows the use of a predefined or custom profile for 30 days',
  adsAndPersonaGeneratorFeature3: 'Credits must be used within one year',
  adsAndPersonaGeneratorFeatureLead4: 'Optimize all your marketing texts for the respective target group (target profile)',
  adsAndPersonaGeneratorFeatureRecruiting4: 'Optimize all your job advertisements for the respective target group (target profile)',
  adsAndPersonaGeneratorFeature5: 'Analysis of the motivation and needs of the target audience identified or developed by you',
  adsAndPersonaGeneratorFeature6: 'Solution works in conjunction with a LinkedIn account',
  adsAndPersonaGeneratorFeature7: 'SAIA LinkedIn extension included',
  adsAndPersonaGeneratorFeature8: 'Optimization and analysis works in six languages (DE, EN, IT, FR, ES, PT)',
  paymentCreditsCount: 'for {{count}} credits',
  paymentMinCredits: 'min. {{minCredits}} credits',
  bundle: 'Bundle',
  noNamesInPromptsWarning: 'Please do not enter any names in the prompt. We will insert these later in the finished message using placeholders.',
  serverErrorTitle: 'Server not available',
  serverTemporaryTitle: 'We’ll be right back',
  serverTemporaryBody1: 'Everything’s okay — this is temporary. The service should be back shortly.',
  serverTemporaryBody2: 'You can retry in a moment. If it persists, contact support.',
  serverTemporaryBody3: 'We are deploying a new version right now, which can pause the service briefly.',
  serverTemporaryBody4: 'Deployments usually take 3–5 minutes. Feel free to grab a coffee ☕.',
  serverTemporaryNextCheck: 'Next check in {{seconds}}s',
  serverBackOnlineTitle: 'We’re back',
  serverBackOnlineBody: 'The service is available again. You can continue where you left off.',
  serverErrorContent1: 'Our server is currently unavailable.',
  serverErrorContent2: 'Possible reasons for this are:',
  serverErrorReason1: 'We are currently installing an update on the server and the service will be available again shortly',
  serverErrorReason2: 'You currently have no internet or your network is blocking the connection to our server',
  serverErrorReason3: 'We are indeed having problems with our server and are trying to fix them as quickly as possible',
  serverErrorContent3: 'Please wait a moment and then try again.',
  tryAgain: 'Try again',
  captchaTimedOut: 'captcha timed out',
  captchaDetected: 'captcha detected',
  solveNow: 'solve now',
  solveCaptchaDialogTitle: 'Solve the captcha',
  solveCaptchaDialogContent1: 'Please solve the captcha below so that we can synchronize your account.',
  solveCaptchaDialogContent2: 'Note that this is a screenshot of the captcha. Click with the mouse in the captcha and set your marker. When you are happy with the position of the marker, click on \'Ok\'',
  solveCaptchaDialogContent3: 'Repeat this process until the account is synchronized.',
  reloadCaptcha: 'Reload captcha',
  sendConnectionRequestWithoutText: 'Send connection request without text',
  withdrawConnectionRequest: 'Withdraw connection request',
  withdrawConnectionRequestDescription: 'Withdraw contact requests that have already been sent.',
  empty: 'Empty',
  fullName: 'Name (first and last name)',
  fileColumnDialogTitle: 'Assign contact properties',
  fileColumnDialogContent: 'Assign the appropriate contact property to the values from your file.',
  fileColumnDialogCampaignContactContent: 'We need at least the name and LinkedIn URL to be able to create a contact for the campaign.',
  fileColumnDialogProfileFinderContactsContent: 'We need at least the first and last name as well as the company in order to be able to start a contact search.',
  fileColumnDialogProfileFinderWebsiteVisitorsContent: 'We need the company, the role of the contact and the country in which the search is to be conducted in order to be able to start a search.',
  fileHasTableHeading: 'File has table heading',
  columnPreview: 'Column (preview)',
  contactProperty: 'Contact property',
  contactsNotImportedWarning: '{{count}} Contact(s) were not imported because either the name and/or the LinkedIn URL is missing',
  doNotImport: 'Do not import field',
  customField: 'Custom field',
  customFields: 'Custom fields',
  workTimeRecommendation1: 'It is best to set the AI\'s working hours at times when you yourself are not so active on Linkedin, so that there are no overlaps in the sessions.',
  workTimeRecommendation2: 'Ideally also with breaks between working hours to approximate human usage behavior.',
  continueSearch: 'Continue search',
  wrongPin: 'Wrong verification code',
  userEmail: 'User email',
  adminEmail: 'Admin email',
  windowsUndoRedo: 'back: ctrl + z forward: ctrl + y',
  macUndoRedo: 'back: ⌘ + z forward: ⌘ + y',
  linuxUndoRedo: 'back: ctrl + z forward: ctrl + y',
  contactManagement: 'Contact management',
  contactOverview: 'Contact overview',
  postingCreation: 'Posting Creation',
  postingOverview: 'Overview',
  postingCreationTitle: 'Posting Creation',
  postingCreationDescription: 'Create and manage your social media posts',
  planningBase: 'Base Planning',
  planningStrategy: 'Strategy',
  planningGenerate: 'Generate Content',
  leadListResearch: 'Lead List Research',
  leadListResearchTitle: 'Lead List Research Agent',
  leadListResearchDescription: 'Generate and refine lead lists based on a free-form prompt, with a focus on regional targeting.',
  leadListOverview: 'Overview',
  leadListResults: 'Lead List Results',
  tagManagement: 'Tag management',
  campaignTags: 'Campaign tags',
  manualTags: 'Manual tags',
  contactDegree: 'Contact degree',
  to: 'to',
  removeContactFromCampaign: 'Remove contact from campaign',
  addLicenseToUserDialogTitle: 'Select license',
  addLicenseToUserDialogContent: 'Select one or more licenses for the newly created user.',
  addAccountFromExternal: 'Add account from external',
  editExternally: 'Edit externally (generate link)',
  editEmailCredentials: 'Edit email credentials',
  copiedLinkToClipboard: 'Link copied to the clipboard. The link is now valid for 12 hours and should be used during this period.',
  cloneCampaign: 'Clone campaign',
  tokenExpiredDialogTitle: 'Token expired',
  tokenExpiredDialogContent1: 'The authentication token of your link has expired.',
  tokenExpiredDialogContent2: 'For security reasons, generated links are only valid for up to 12 hours and can then no longer be used.',
  tokenExpiredDialogContent3: 'Please contact the creator of the link and ask for a new link.',
  checkConnectionDisabledWarning: 'Its use is not recommended. Please use the "Connection request accepted until condition instead.',
  connectionRequestWasAcceptedUntil: 'Connection request accepted until',
  connectionRequestWasAcceptedUntilDescription: 'Check periodically within a defined period of time whether the connection request sent has been accepted by the contact. Can only be used after a contact request.',
  functionPeriod: 'Max. time until the connection request is accepted = {{waitingTime}} hour',
  functionPeriod_plural: 'Max. time until the connection request is accepted = {{waitingTime}} hours',
  editPeriod: 'Edit period',
  period: 'Period',
  periodInstruction: 'Enter the time in hours for checking whether the connection request has been accepted.',
  periodInHours: 'Period in hours',
  linkedinUser: 'LinkedIn User',
  linkedinAccountNotFoundTitle: 'LinkedIn account not found',
  linkedinAccountNotFoundContent1: 'The selected LinkedIn account was not found.',
  linkedinAccountNotFoundContent2: 'Please select a valid LinkedIn account first.',
  amountSelectedContacts: '{{count}} contacts selected',
  refineRecruiterSearch: 'Refine recruiter search',
  applyFilters: 'Apply filters',
  saveAndAddContactsAutomatically: 'Save & add contacts automatically',
  titles: 'Job titles',
  enterTitleHere: 'Enter the job title here...',
  enterSkillHere: 'Enter the skill here...',
  enterIndustryHere: 'Enter the industry here...',
  location: 'Locations',
  enterLocationHere: 'Enter the location here...',
  enterZipHere: 'Enter the postal code here...',
  searchWithinArea: 'Search within area',
  locationSearch: 'Location Search (by name)',
  areaSearch: 'Area Search (postal code or name + radius)',
  enterKeywordsHere: 'Enter the keywords here and press Enter...',
  area: 'within area',
  within1Mi: 'within 1mi (1,6 km)',
  within5Mi: 'within 5 mi (8 km)',
  within10Mi: 'within 10mi (16 km)',
  within25Mi: 'within 25mi (40 km)',
  within50Mi: 'within 50mi (80 km)',
  within100Mi: 'within 100mi (160 km)',
  within200Mi: 'within 200mi (321 km)',
  include: 'includes',
  exclude: 'does not include',
  addSelectedContactsToCampaign: 'add selected contacts to the campaign',
  position: 'Position',
  contactsSuccessfullyAddedToCampaign: 'Contacts successfully added to the campaign!',
  loadingRecruiterContacts: 'Loading Recruiter contacts',
  feedback: 'Feedback',
  whatIsNew: 'What is new?',
  crawlWithSeparateAccount: 'Crawl with a separate LinkedIn account',
  noContactsFound: 'No contacts found',
  changeLinkedinAccountWarning: 'The LinkedIn account can no longer be changed for campaigns that have already been started.',
  linkedinAccountCapacity: '# LinkedIn Accounts - current: {{current}} - remaining: {{remaining}}',
  copilotCredits: '# Contact analyses - current: {{current}} / remaining: {{remaining}}',
  quantity: 'Quantity',
  creditsExhaustedDialogTitle: 'Analysis limit reached',
  creditsExhaustedDialogContent1: 'The contact analysis limit for your license has been reached.',
  creditsExhaustedDialogContent2: 'Please get in touch with your SAIA contact or write to us at info@secret-ai-agent.de so that we can solve this problem.',
  changeCampaignFlowWarning: 'Changing the structure of campaigns that have already been launched is not recommended.',
  notAllNodesConnectedWarning: 'Not all nodes are connected.',
  connectionCheckFirstNodeWarning: '\'Connection request accepted until\' cannot be a start node.',
  utilityFunctionFirstNodeWarning: 'Utility functions cannot be start nodes.',
  multipleConnectionRequestNodesWarning: 'Make sure that two connection requests are not built into the same path.\nIf this is not the case, ignore the warning.',
  linkedinAccountMissingWarning: 'Please select a LinkedIn account',
  leadCampaignProductProblems: 'Describe the problems of the people you want to reach with the campaign',
  leadCampaignProductFeatures: 'Describe the features/services/offers you are providing to the people you want to reach with the campaign',
  leadCampaignProductBenefits: 'Describe the personal benefits of the people you want to reach with the campaign',
  leadCampaignProductImpact: 'Describe the business benefit/impact (figures, data, facts) that you bring to the people you want to reach with the campaign',
  profilePlaceholderMissingWarning: 'The profile placeholder [[{{profile}}]] is missing, but is absolutely necessary. Please make sure that the sentence "The recipient describes himself as follows: [[{{profile}}]]." is included in the prompt.',
  editLinkedinAccountName: 'Change LinkedIn account name',
  editLinkedinSignature: 'Edit LinkedIn signature',
  linkedinSignature: 'LinkedIn Signature',
  linkedinSignatureClarification: 'You can set a signature that will be automatically appended to messages sent through campaigns',
  useSignatureInMessages: 'Use signature in messages',
  enterSignature: 'Enter your signature',
  signatureExample: 'Example',
  addSignatureToMessage: 'Add signature',
  invalidUrlForLinkedinAccountWarning: 'The URL does not match the selected LinkedIn account\n* URL required from: {{product}}',
  invalidUrlForLiProductTypeWarning: 'The URL does not match the other contacts in the campaign\n* URL required from: {{product}}',
  filterExplanation: 'Specify the filter logic ("all must apply", "at least one must apply") and select the filter rules for the desired table columns. Click on "Apply filters" when you are happy with the rule set.',
  allConditionsMustBeTrue: 'all conditions must apply (AND)',
  oneConditionMustBeTrue: 'at least one condition must apply (OR)',
  filterColumn: 'Column',
  filterOperator: 'Operator',
  filterValue: 'Filter value',
  enterFilterValueHere: 'Enter filter value here...',
  addFilter: 'Add filter',
  removeAllFilters: 'remove all filters ({{count}})',
  styleMatch: 'Style Match',
  motives: 'Motives',
  manualTag: 'Manual tag',
  createTag: 'Create tag',
  enterTagNamePlaceholder: 'Enter the name of the tag here...',
  renameTag: 'Rename tag',
  deleteTag: 'Delete tag',
  deleteTagContent1: 'Do you really want to delete the tag {{tagName}}?',
  deleteTagContent2: 'This process cannot be reversed. The tag is then no longer available and is also removed from all contacts.',
  selectedContacts: 'selected contacts: {{count}}',
  addTagsToSelection: 'add tags to selection',
  editTags: 'Edit tags',
  is: 'is',
  isNot: 'is not',
  isAfter: 'is after',
  isOnOrAfter: 'is on or after',
  isBefore: 'is before',
  isOnOrBefore: 'is on or before',
  equals: 'equals',
  contains: 'contains',
  startsWith: 'starts with',
  endsWith: 'ends with',
  isEmpty: 'is empty',
  isNotEmpty: 'is not empty',
  isAnyOf: 'is any of the following',
  contactGender: 'Gender',
  linkedinProfile: 'LinkedIn Profile',
  contactPersons: 'Contact persons',
  contactPerson: 'Contact person',
  firstContactOn: 'First contact on',
  addContactsToCampaign: 'Add contacts to campaign',
  addTags: 'Add tags',
  noTagsFound: 'No tags found',
  loadingContact: 'Loading contact information...',
  loadingHistory: 'Loading campaign history...',
  loadingAnalysis: 'Loading contact analysis...',
  enterContactNameHere: 'Enter contact name here...',
  femaleGender: 'female',
  maleGender: 'male',
  editGender: 'Edit gender',
  pressEnterToAdd: 'Press Enter to add...',
  profileInfo: '* Unfortunately, we don\'t have enough information about {{contactName}} to create a personalized profile. Instead, the AI infers the most likely profile based on similar career profiles.',
  receivedMessage: 'Received message',
  tagsSuccessfullyAdded: 'Tags successfully added',
  editContactEmail: 'Edit email address',
  enterContactEmailHere: 'Enter here the email address of the contact...',
  yearsOfExperience: 'Years of experience',
  progressContacts: 'Progress (Contacts)',
  progressPages: 'Progress (Pages)',
  searchType: 'Type of search',
  peopleSearch: 'People',
  postingSearch: 'Postings',
  jobSearch: 'Jobs',
  project: 'Projekt',
  courseSearch: 'Courses',
  activitySearch: 'Activities',
  groupMemberSearch: 'Group members',
  eventAttendeesSearch: 'Event attendees',
  savedSearch: 'saved search',
  nameSearch: 'Name search',
  renameSearch: 'Rename search',
  enterSearchNamePlaceholder: 'Enter here the name of the search...',
  duplicates: 'Already contacted',
  contactSearchProgress: 'Contact search progress',
  addContactToCampaign: 'add to campaign',
  manageDuplicateContacts: 'Manage already contacted contacts',
  viewResultsAndFineTune: 'View results and fine tune',
  campaignNameFilter: 'Campaign name',
  linkedinProductFilter: 'LinkedIn product',
  linkedinAccountFilter: 'LinkedIn account',
  campaignStatusFilter: 'Campaign status',
  enterLinkedinAccountNameHere: 'Enter the LinkedIn account here...',
  selectTheLinkedinProduct: 'Select the LinkedIn product...',
  selectTheCampaignStatus: 'Select the campaign status...',
  allLinkedinProducts: 'all LinkedIn products',
  allCampaignStatuses: 'all campaign statuses',
  proxyCountryExample: '(e.g. Germany)',
  proxyCityExample: '(e.g. Munich)',
  from: 'from',
  upTo: 'to',
  years: 'years',
  reset: 'reset',
  lessThanOne: 'Less than 1',
  yourFirstSteps: 'Your first steps',
  doThisNow: 'Complete these points to guarantee a successful start with our tool.',
  addLinkedinAccount: 'Add your personal LinkedIn account',
  upgradeYourLicense: 'Upgrade to a paid license',
  bookAnOnboarding: 'Book an onboarding',
  addLinkedinAccountNow: 'Add LinkedIn account now',
  addLinkedinAccountLater: 'Add LinkedIn account later',
  supportedSearchTypes: 'supported search types',
  searchForPeople: 'Search for people',
  searchInPostings: 'Search in postings',
  searchForJobApplicants: 'Search for job applicants',
  searchInCourses: 'Search in courses',
  searchByActivities: 'Search by activities',
  searchInGroups: 'Search in groups',
  searchInEvents: 'Search in events',
  savedSearches: 'Saved searches',
  recruiterProjects: 'Recruiter projects',
  recruiterLocationSearchWarning: 'Use either location or postal code search. You cannot use both at the same time.',
  archiveCampaign: 'Archive campaign',
  unarchiveCampaign: 'Unarchive campaign',
  titlesOnlyActiveSourcing: 'Results based on job titles',
  titlesKeywordsActiveSourcing: 'Results based on job titles and keywords',
  titlesKeywordsEnglishActiveSourcing: 'Results based on job titles and keywords (English)',
  titlesKeywordsIndustriesActiveSourcing: 'Results based on job titles, keywords, and industries',
  titlesKeywordsIndustriesEnglishActiveSourcing: 'Results based on job titles, keywords, and industries (English)',
  keywordsIndustriesActiveSourcing: 'Results based on keywords and industries',
  titlesOnlySocialSelling: 'Results based on job titles',
  titlesKeywordsSocialSelling: 'Results based on job titles and keywords',
  titlesKeywordsEnglishSocialSelling: 'Results based on job titles and keywords (English)',
  titlesKeywordsIndustriesSocialSelling: 'Results based on job titles, keywords, and industries',
  keywordsIndustriesSocialSelling: 'Results based on keywords and industries',
  smartSearches: 'Smart searches',
  searchIntroduction: 'Based on your input, we create different Boolean search strings to find the best matching candidates on LinkedIn.',
  searchInstructionStep1: '1. Click on each search result to open it on LinkedIn.',
  searchInstructionStep2: '2. Review the results and fine-tune the search.',
  searchInstructionStep3: '3. Save the search to add it to your campaign.',
  selectAndFineTuneTalentSearch: 'Select and fine-tune your talent searches',
  selectAndFineTuneLeadSearch: 'Select and fine-tune your lead searches',
  selectAndFineTuneDescription: 'Click on each search result, review the LinkedIn results, and fine-tune the search.',
  actions: 'Actions',
  viewAndFineTune: 'View and Fine-Tune',
  redirectLinkedinSearchDialogInstruction: 'Review and optimize your AI-generated candidate list',
  redirectLinkedinSearchDialogContent1: 'Click on the following button, to review your AI-generated candidate list directly on LinkedIn.',
  viewCandidatesText: 'View Candidate List on LinkedIn',
  redirectLinkedinSearchDialogContent2: 'Adjust the candidate list according to your needs and optimize it for your preferences.',
  redirectLinkedinSearchDialogContent3: 'Copy the URL of the refined candidate list from your browser\'s address bar.',
  redirectLinkedinSearchDialogContent4: 'Return to this page and paste the copied URL in the text field below.',
  redirectLinkedinSearchDialogContent5: 'Click \'Save\' to include the refined list in your campaign.',
  enterAlteredLinkedinSearchUrlHere: 'Enter the optimized LinkedIn search URL here...',
  startYourJourney: 'Start Your Journey',
  startJourneyStep1: 'Signup',
  startJourneyStep2: 'Synchronize SAIA\nand LinkedIn accounts',
  startJourneyStep3: 'Create your first\nsmart campaign',
  startJourneyWelcome: 'Welcome! First things first...',
  startJourneyIntroduceLinkedinAccount: 'Introduce your LinkedIn account information',
  selectLinkedinProductClarification: 'Select the LinkedIn product that corresponds to the account you want to synchronize.',
  proxyServerClarification: 'Note: All locations in the drop-down menu are displayed in English.',
  linkedinAccountClarification: 'Enter the e-mail address and password of your personal LinkedIn account.',
  syncProcessingText: 'Wait for the LinkedIn account to be <1>synchronized with our tool</1>.',
  onboardingTooltipWaitTimeInfo: 'It is important to wait for this process as it allows our tool to recognize your information.\nThis will take some time, but it ensures a successful connection!',
  syncSuccessfulCongratulations: 'Congratulations, {{name}}!',
  syncSuccessfulText1: 'You have successfully synchronized your LinkedIn account - {{email}} - with the SAIA Tool!',
  syncSuccessfulText2Recruiting: 'Take advantage of AI-driven recruiting. Click on "Next" to create your first smart campaign with our <1>SAIA Recruiting</1>.',
  syncSuccessfulText2Lead: 'Take advantage of AI-driven lead-gen. Click on "Next" to create your first smart campaign with our <1>SAIA Sales</1>.',
  syncSuccessfulText2Regular: 'You can now close the pop-up.',
  syncErrorTitle: 'Error during synchronization',
  syncErrorText: 'We\'ve detected a problem synchronizing the LinkedIn account with the SAIA tool. Don\'t worry, we can help you!',
  syncErrorIssue: 'Issue:',
  syncErrorWrongCredentials: 'The LinkedIn account credentials provided are incorrect. <1>Please check that you have not inadvertently used the SAIA credentials instead of the LinkedIn credentials</1>.',
  syncErrorWrongPin: 'The verification code provided is incorrect.',
  syncErrorWrongPinText: 'Please <1>synchronize your account again</1> to obtain a new verification code.',
  syncErrorWrongPinInfo: 'If you entered the correct code and this message reappears, <1>please contact us</1> for further assistance.',
  syncErrorTimedOutCaptcha: 'The time to solve the captcha has expired.',
  syncErrorTimedOutCaptchaText: 'Please <1>synchronize your account again</1> to obtain a new captcha.',
  syncErrorTimedOutCaptchaInfo: 'If this error is still displayed despite a correctly solved captcha, <1>please contact us</1>.',
  syncErrorLinkedinOnboardingIncomplete: 'The LinkedIn Sales Navigator onboarding ist not completed.',
  syncErrorLinkedinOnboardingIncompleteText1: 'The LinkedIn Sales Navigator onboarding must be completed before we can synchronize your account with SAIA.',
  syncErrorLinkedinOnboardingIncompleteText2: 'Please go through the <1>welcome pages of the LinkedIn Sales Navigator</1> completely.',
  syncErrorLinkedinOnboardingIncompleteText3: 'When you have completed the setup process, come back here and click on "Retry Synchronization" to continue.',
  syncErrorUnknown: 'The synchronization has failed for a reason unknown to us.',
  syncErrorUnknownText: 'Please <1>synchronize your account again</1>.',
  syncErrorUnknownInfo: 'If this error is still displayed after the retry, <1>please contact us</1>.',
  syncErrorNeedHelp: '<0>Need help?</0> Click <2>support</2> for additional troubleshooting steps or to contact our team.',
  // Subject lines for the feedback form these links now open (176ce751).
  syncErrorSupportTitle: 'LinkedIn synchronization failed',
  syncErrorSupportDescription: 'Synchronization error: {{reason}}',
  syncErrorSupportTitleCaptcha: 'Captcha is rejected despite being solved correctly',
  syncErrorSupportTitleUnknown: 'Synchronization fails with an unknown error',
  syncErrorSupportTitleWrongPin: 'Verification code is rejected despite correct entry',
  inQueue: 'In queue',
  loadingPage: 'Loading page',
  signingIn: 'Signing in',
  extractingCookies: 'Extracting cookies',
  extractingQueryIDs: 'Extracting query IDs',
  inQueueExplanation: 'Getting ready! You\'re in line to sync your LinkedIn data',
  loadingPageExplanation: 'Connecting to LinkedIn... Just a moment while we establish a secure connection',
  signingInExplanation: 'Signing you in securely... This may take a few seconds',
  extractingCookiesExplanation: 'Gathering your information... We\'re securely retrieving the data you need',
  extractingQueryIDsExplanation: 'Almost there! Just a few final touches before you can use your account',
  restartOf: 'Restart',
  appSynchronization: 'App Synchronization',
  complete: 'Complete',
  theLinkedinOnboarding: 'The LinkedIn Onboarding',
  retrySynchronization: 'Retry Synchronization',
  addAccountInformation: 'Add LinkedIn account\'s login information',
  startLoginProcess: 'Start the login process',
  finishAccountSynchronization: 'Finish account synchronization',
  justAFewSteps: 'Just a few steps to synchronize a new account',
  addNewAccountWelcome: 'Hi {{userName}}, lets get your new account into the <3>{{product}}</3> revolution!',
  addNewAccountIntroduceLoginInformation: 'Introduce the new LinkedIn account\'s login information',
  aiRecruiting: 'AI recruiting',
  aiLeadGen: 'AI lead-gen',
  addNewAccountSelectLinkedinProduct: 'Select the LinkedIn product used by the new account',
  addNewAccountProxyServerInformation: 'Proxy server informationen of the new account',
  addNewAccountLinkedinAccountInformation: 'Login details of the new LinkedIn account',
  addNewAccountLinkedinAccountClarification: 'Enter the email address and the passwort of the LinkedIn account to be added.',
  addNewAccountLinkedinAccountBetterClarification: 'Enter the email and password for your LinkedIn account. <1>Make sure</1> the password is correct to login successfully.',
  addNewAccountSyncSuccessfulText1: 'You have successfully synchronized the new LinkedIn account - {{email}} - with the SAIA Tool!',
  addNewAccountSyncSuccessfulText2Recruiting: 'Now, {{firstName}} can unlock the power of AI-driven recruiting.',
  addNewAccountSyncSuccessfulText2Lead: 'Now, {{firstName}} can unlock the power of AI-driven lead-gen.',
  appSyncVerifyLinkedinAccount: 'Enter the LinkedIn account verification code you received',
  appSyncVerifyLinkedinAccountHeadsUp: 'Heads up! <1>You might have just received a verification code from LinkedIn via SMS, authenticator app or email</1> (depending on your preferences). Here are a few things to keep in mind:',
  appSyncVerifyLinkedinAccountInstruction1: 'Always use the latest code. Do not use any earlier codes that you may have received.',
  appSyncVerifyLinkedinAccountInstruction2: 'You may receive a notification from LinkedIn about a login attempt from a new device.',
  appSyncVerifyLinkedinAccountInstruction3: 'Using an authentication app? Make sure you enter the code before it expires (preferably when it has just been created)',
  appSyncSolveCaptcha: 'Lets do a quick security check! Solve the captcha underneath:',
  appSyncSolveCaptchaHeadsUp: 'To synchronize the account, complete the CAPTCHA on the right side.',
  appSyncSolveCaptchaInstruction1: 'Click inside the CAPTCHA image to select an element.',
  appSyncSolveCaptchaInstruction2: 'Make your selection carefully. You can zoom in for a better view.',
  appSyncSolveCaptchaInstruction3: 'Once you are sure, click on "Next".',
  appSyncSolveCaptchaInstruction4: 'You may need to repeat steps 1-3 until the CAPTCHA is solved and the synchronization process continues.',
  addNewLinkedinAccount: 'Add new LinkedIn account',
  appSyncChooseContract: 'Choose the contract that is associated with your LinkedIn account',
  missingContract: 'Contract is missing',
  onboardingIncomplete: 'Onboarding incomplete',
  fairUsePause: 'Fair use pause',
  fairUsePauseNotification1: 'Temporary Login Pause',
  fairUsePauseNotification2: 'To protect your account, we have paused the login for 24 hours due to LinkedIn\'s fair use policy.',
  fairUsePauseCampaignNotification: 'Note: Temporary login pause\nTo protect your LinkedIn account, we have paused the login for 24 hours due to LinkedIn\'s fair use policy.',
  notRecommended: 'not recommended',
  nameYourCampaign: 'Name your Campaign',
  campaignNameInstruction: 'Provide a unique name for your campaign',
  feedAI: 'Feed the AI with Information',
  briefDescription: 'We create tailored prompts and LinkedIn searches based on your data. To do this, our AI needs some information from you.',
  autoGenerate: 'Automatically generate using AI & product URL',
  manualEntry: 'Enter data manually later',
  provideURLInstruction: 'Please provide the URL for the product or job offer by copying the URL (Landing Page of the Product or Landing Page of the Job Ads).',
  enterJobOfferURL: 'Enter the URL of the job offer here...',
  blockedPlatformError: 'This URL does not allow us to access your data. Click Continue without URL and add the content in a later step',
  processingURL: 'Processing the URL, please wait...',
  scrapingData: 'Scraping Data...',
  summarizingResults: 'Summarizing Results...',
  urlSuccess: 'The URL was successfully processed, and the AI has generated the briefing.',
  urlError: 'There was an error processing the URL. Please check the URL and try again.',
  chooseTemplate: 'Select a Campaign Template',
  templateExplanation: 'Choose a template that best fits your needs.',
  internalRecruiting: 'You are working as an Internal Recruiting',
  externalRecruiting: 'You are working as an External Recruiting',
  whatToDoAfterCreation: 'Next Steps',
  feedAIWithData: 'Feed AI with Data',
  selectLinkedInAccount: 'Select LinkedIn Account',
  selectLinkedInAccountInstruction: 'Select the LinkedIn account from which the campaign messages are to be sent.',
  setCampaignDuration: 'Set Campaign Duration',
  addContactsOrSearches: 'Add Contacts or Searches',
  createCampaignFlow: 'Create Campaign Flow',
  testAndStartCampaign: 'Test and Start Campaign',
  continueWithoutUrl: 'Continue without URL',
  continueWithoutTemplate: 'Continue without template',
  createCampaignNow: 'Create Campaign Now',
  forWhom: 'For Whom',
  leadGenerationFormalName: 'Lead Generation (Formal)',
  leadGenerationFormalDescription: 'A professional approach to generating leads, ideal for B2B and corporate clients.',
  leadGenerationFormalAudience: 'SDRs targeting businesses and corporate clients.',
  leadGenerationCasualName: 'Lead Generation (Casual)',
  leadGenerationCasualDescription: 'A casual approach to generating leads, suitable for startups and small businesses.',
  leadGenerationCasualAudience: 'SDRs targeting startups and small businesses.',
  activeSourcingCasualFewInmailsName: 'Active Sourcing (Casual, Few Inmails)',
  activeSourcingCasualFewInmailsDescription: 'A casual approach to sourcing with limited Inmails, ideal for engaging young professionals.',
  activeSourcingCasualFewInmailsAudience: 'Internal recruiters targeting young professionals.',
  activeSourcingFormalFewInmailsName: 'Active Sourcing (Formal, Few Inmails)',
  activeSourcingFormalFewInmailsDescription: 'A formal approach to sourcing with limited Inmails, suitable for experienced professionals.',
  activeSourcingFormalFewInmailsAudience: 'Internal recruiters targeting experienced professionals.',
  activeSourcingFormalWithInmailsName: 'Active Sourcing (Formal, With Inmails)',
  activeSourcingFormalWithInmailsDescription: 'A formal approach to sourcing that includes Inmails, perfect for targeting executives.',
  activeSourcingFormalWithInmailsAudience: 'Internal recruiters targeting executives.',
  activeSourcingCasualWithInmailsName: 'Active Sourcing (Casual, With Inmails)',
  activeSourcingCasualWithInmailsDescription: 'A casual approach to sourcing with Inmails, great for startups and tech companies.',
  activeSourcingCasualWithInmailsAudience: 'Internal recruiters targeting startups and tech companies.',
  activeSourcingFormalWithInmailsExternalName: 'Active Sourcing (Formal, With Inmails, External)',
  activeSourcingFormalWithInmailsExternalDescription: 'A formal approach to sourcing with Inmails, aimed at external candidates.',
  activeSourcingFormalWithInmailsExternalAudience: 'External recruiters targeting candidates outside the company.',
  activeSourcingCasualWithInmailsExternalName: 'Active Sourcing (Casual, With Inmails, External)',
  activeSourcingCasualWithInmailsExternalDescription: 'A casual approach to sourcing with Inmails, focused on external candidates in tech startups.',
  activeSourcingCasualWithInmailsExternalAudience: 'External recruiters targeting tech startup candidates.',
  activeSourcingCasualFewInmailsExternalName: 'Active Sourcing (Casual, Few Inmails, External)',
  activeSourcingCasualFewInmailsExternalDescription: 'A casual approach to sourcing with limited Inmails, for various industries.',
  activeSourcingCasualFewInmailsExternalAudience: 'External recruiters targeting diverse industries.',
  activeSourcingFormalFewInmailsExternalName: 'Active Sourcing (Formal, Few Inmails, External)',
  activeSourcingFormalFewInmailsExternalDescription: 'A formal approach to sourcing with limited Inmails, suitable for external candidates.',
  activeSourcingFormalFewInmailsExternalAudience: 'External recruiters targeting experienced professionals outside the company.',
  unknownTemplateName: 'Unknown Template',
  unknownTemplateDescription: 'Description not available.',
  unknownTemplateAudience: 'Audience not available.',
  feedAIWithDataDescription: 'Provide detailed data about your product or job offer to help the AI generate tailored content.',
  selectLinkedInAccountTitle: 'Select LinkedIn Account',
  selectLinkedInAccountDescription: 'Choose the LinkedIn account you want to use for this campaign.',
  selectLinkedInAccountDescriptionHelper: 'Will be used for sending messages and connecting with prospects.',
  setCampaignDurationTitle: 'Set Campaign Duration',
  setCampaignDurationDescription: 'Specify the duration for which the campaign will run. Consider the length of time needed to achieve your goals.',
  addContactsOrSearchesTitle: 'Add Contacts or Searches',
  addContactsOrSearchesDescription: 'Add the contacts or searches that you want to target in your campaign. You can upload a list of contacts or use search parameters to find new ones.',
  createCampaignFlowTitle: 'Create Campaign Flow',
  createCampaignFlowDescription: 'Define the flow of your campaign, including the sequence of messages and actions to be taken at each step.',
  testAndStartCampaignTitle: 'Test and Start Campaign',
  testAndStartCampaignDescription: 'Test your campaign to ensure everything is set up correctly. Once tested, start the campaign and monitor its progress.',
  invalidUrlError: 'Please enter a valid URL or click on "Continue without URL". In this case, you must feed the AI with information after the campaign creation.',
  subject: 'Subject',
  accountAlreadyExistsDialogTitle: 'Account already exists',
  accountAlreadyExistsDialogContent1: 'The LinkedIn account <1>{{accountName}}</1> already exists.',
  accountAlreadyExistsDialogContent2: 'It therefore does not need to be created again.',
  contactPossibilityAvailable: 'Contact possibility available',
  notSynchronized: 'not synchronized',
  signIn: 'sign-in',
  signOut: 'sign-out',
  signInAction: 'Log in',
  signOutAction: 'Log out',
  accountLoggedIn: 'Logged in',
  salesNavSeatNotAnswering: 'Sales Navigator not connected',
  salesNavSeatNotAnsweringHint:
    'LinkedIn is logged in, but the Sales Navigator seat does not answer. Messages and invitations keep running, Sales Navigator searches and InMails do not. Please log in again and enter the PIN for the Sales Navigator app.',
  salesNavSeatReLogin: 'Log in to Sales Navigator again',
  recruiterSeatNotAnswering: 'Recruiter not connected',
  recruiterSeatNotAnsweringHint:
    'LinkedIn is logged in, but the Recruiter seat does not answer. Messages and invitations keep running, Recruiter searches, projects and InMails do not. Please log in again and enter the PIN for the Recruiter app.',
  recruiterSeatReLogin: 'Log in to Recruiter again',
  accountLoggedOut: 'Logged out',
  accountNeedsManualLogin: '🔐 Manual login required',
  enter2fa: 'Enter 2FA code',
  requestNewCode: 'Request new 2FA code',
  solveCaptcha: 'Solve captcha',
  correctAccessData: 'Correct access data',
  requestNewCaptcha: 'Request new captcha',
  chooseContract: 'Choose LinkedIn contract',
  incompleteOnboarding: 'Finish LinkedIn onboarding',
  loggingIn: 'Connecting to LinkedIn...',
  reopenLoginWindow: 'Reopen the login window',
  cancelConnecting: 'Cancel',
  cancelAndResetAccount: 'Cancel & reset',
  reLoginAction: 'Re-login',
  twoFaTimedOut: '2FA expired',
  convertSharpS: 'Convert all ß to ss',
  linkedinAccountSuccessfullySignedIn: 'The LinkedIn account has been successfully signed in.',
  autoSyncWarningDialogTitle: 'Status with need for action',
  autoSyncWarningDialogContent1: 'We could not successfully sign in your LinkedIn account <1>{{accountName}}</1>.',
  autoSyncWarningDialogContent2: 'Please check the LinkedIn account overview page and solve the problem displayed there.',
  autoSyncWarningDialogContent3: 'The following problem has occurred:',
  notSynchronizedWarning: 'The login process took too long and was therefore aborted. Please log in again.',
  wrongCredentialsWarning: 'The LinkedIn account credentials are incorrect.',
  twoFaWarning: 'Two-factor authentication (2FA) required.',
  appSyncApproveLinkedinPush: 'Approve the LinkedIn sign-in',
  appSyncApprovePushInstruction:
    'LinkedIn has sent a push notification to your mobile app. Approve it there first. If LinkedIn asks for a code instead, switch to the code flow below.',
  appSyncApprovePushInstruction1: 'Open the LinkedIn mobile app and approve the sign-in request.',
  appSyncApprovePushInstruction2: 'Once you approved it, come back here and click "I approved it in the LinkedIn app".',
  appSyncApprovePushInstruction3: 'If LinkedIn shows a verification code instead, click "I need a code" and enter it here.',
  appSyncApprovedInLinkedinApp: 'I approved it in the LinkedIn app',
  appSyncNeedVerificationCode: 'I need a code',
  appSyncBackToPushApproval: 'Back to app approval',
  wrongPinWarning: 'The entered verification code is incorrect.',
  captchaWarning: 'Please solve the Captcha.',
  timedOutCaptchaWarning: 'The time to solve the Captcha has expired.',
  chooseContractWarning: 'The LinkedIn contract could not be found.',
  onboardingIncompleteWarning: 'The LinkedIn onboarding is incomplete.',
  recruiterParallelLoginWarning: 'Another LinkedIn Recruiter session was detected.',
  fairUsePauseWarning: 'Due to LinkedIn\'s fair-use policies, we have paused the login for 24 hours.',
  thirdPartyWarning: 'A login mask of a third-party provider or a page unknown to us was recognized.',
  unknownErrorWarning: 'An unknown error has occurred. Please log in again.',
  autoSyncIndicatorText: 'LinkedIn account is being signed in',
  renameCampaign: 'Rename campaign',
  renameCampaignInstruction1: 'A campaign name is unique and cannot be used a second time.',
  renameCampaignInstruction2: 'Enter a different name than before and click on "Ok" to create your campaign.',
  campaignName: 'Campaign name',
  nameClonedCampaign: 'Enter the new name of the cloned campaign',
  selectLinkedinAccountForCampaign: 'Select the LinkedIn account to be used in the campaign',
  selectLinkedinAccountForSearch: 'Select the LinkedIn account to be used in the search',
  thirdPartyLogin: 'Third party login',
  enterText: 'Enter text...',
  appSyncThirdParty: 'Third-party website or unknown LinkedIn page detected',
  appSyncThirdPartyHeadsUp: 'Follow the instructions on the website from the screenshot',
  appSyncThirdPartyClickInstruction1: 'Click on the image to select an element (e.g. button, textfield, etc.).',
  appSyncThirdPartyClickInstruction2: 'Click on "Next" to continue the process.',
  appSyncThirdPartyClickInstruction3: 'Even if you select a button or a text field in the image, you must confirm the selection with "Next".',
  appSyncThirdPartyClickInstruction4: 'You may need to repeat steps 1 - 3 until the page is fully processed and the synchronization process continues.',
  appSyncSetThirdPartyText: 'Enter the information that matches the screenshot in the text field',
  fileUpload: 'File upload',
  blacklistFileUploadInstruction: 'Upload a company list as a CSV or Excel file',
  selectCompanyColumnTitle: 'Select company column',
  selectCompanyColumnContent: 'Assign the appropriate company column to the values from your file.',
  property: 'Property',
  replace: 'Replace',
  companiesToAdd: 'Companies to be added: {{count}}',
  addOrReplaceCompanies: 'Would you like to add the companies to the current list, or would you like to replace the existing list with the new companies?',
  campaignStatusCreated: 'Campaign Created',
  campaignStatusStarted: 'Campaign Running',
  campaignStatusFinished: 'Campaign Completed',
  campaignStatusSuspended: 'Campaign Suspended (Action Required)',
  campaignStatusPaused: 'Campaign Paused (Outside Working Hours)',
  campaignStatusFairUsePause: 'Campaign Paused (LinkedIn Limit Reached)',
  campaignStatusRecruiterParallelLogin: 'Campaign Paused (Account Logged in Elsewhere)',
  campaignStatusArchived: 'Campaign Archived',
  linkedinAccountLoggedIn: 'Logged in (Work mode enabled)',
  linkedinAccountLoggedOut: 'Logged out (Work mode disabled)',
  forThreeMonths: 'for 3 months',
  twoUsers: '2 users',
  automaticRenewal: 'Automatic renewal',
  inclOnboardingWorkshop: 'incl. onboarding workshop',
  highPrioritySupport: '3 months high priority support',
  oneUser: '1 user',
  noOnboarding: 'No onboarding',
  onboardingWorkshop: 'Onboarding workshop',
  bookableOnce: 'bookable once',
  threeMonthsMinimumTerm: '3 months minimum term',
  thereafterPricePerMonth: 'thereafter <1>{{price}}</1> per month',
  paidAndCancelableYearly: 'paid & cancelable yearly',
  paidAndCancelableMonthly: 'paid & cancelable monthly',
  paidAndCancelableMonthlyAfterMinimumTerm: 'after minimum term paid & cancelable monthly',
  onboardingForOneOffPrice: 'Onboarding for a one-off {{price}}',
  credits: 'Credits',
  billingType: 'Billing Type',
  onboardingAndSupport: 'Onboarding & Support',
  toTheAccountSettings: 'To the account settings',
  accountSettings: 'Account Settings',
  adminMode: 'Agency Accounts',
  managerMode: 'Own Account',
  viewTransactions: 'Show Invoices',
  hideTransactions: 'Close',
  showPasswordChange: 'Change Password',
  showApiKey: 'Show Api-Key',
  processed: 'Already processed',
  removeUnprocessedContacts: 'remove unprocessed contacts',
  removeUnprocessedContactsContent1: 'Do you really want to remove all unprocessed contacts from your campaign?',
  removeUnprocessedContactsContent2: 'This process cannot be reversed and the contacts are then no longer available.',
  normalLinkedInSearchWhyLead: 'Find potential leads on LinkedIn.',
  normalLinkedInSearchWhyRecruiting: 'Find potential candidates on LinkedIn.',
  normalLinkedInSearchWhenLead: 'Use when you need to identify new leads.',
  normalLinkedInSearchWhenRecruiting: 'Use when you need to identify new candidates.',
  normalLinkedInSearchHowLead: 'Perform a basic LinkedIn search using relevant keywords to discover new leads. Copy and paste the URL of the search results to integrate it into your outreach campaign.',
  normalLinkedInSearchHowRecruiting: 'Perform a basic LinkedIn search using relevant keywords to discover new candidates. Copy and paste the URL of the search results to integrate it into your outreach campaign.',
  normalSalesNavSearchWhy: 'Get detailed insights into your target audience.',
  normalSalesNavSearchWhenLead: 'Use for a more targeted approach in lead generation.',
  normalSalesNavSearchWhenRecruiting: 'Use for a more targeted approach in candidate generation.',
  normalSalesNavSearchHowLead: 'Use LinkedIn Sales Navigator to create advanced searches with detailed filters, such as job title, company size, and industry. Save these searches and set up alerts to stay updated on new potential leads. Copy and paste the URL to use it in your campaign.',
  normalSalesNavSearchHowRecruiting: 'Use LinkedIn Sales Navigator to create advanced searches with detailed filters, such as job title, company size, and industry. Save these searches and set up alerts to stay updated on new potential candidates. Copy and paste the URL to use it in your campaign.',
  savedSalesNavSearchWhyLead: 'Quickly access your pre-defined lead searches.',
  savedSalesNavSearchWhyRecruiting: 'Quickly access your pre-defined candidate searches.',
  savedSalesNavSearchWhen: 'Use when you need to revisit and utilize your saved searches.',
  savedSalesNavSearchHowLead: 'Access your saved searches in LinkedIn Sales Navigator by navigating to the "Saved Searches" section. This allows you to quickly revisit and act on pre-defined lead lists without having to recreate search parameters. Copy and paste the URL for easy access.',
  savedSalesNavSearchHowRecruiting: 'Access your saved searches in LinkedIn Sales Navigator by navigating to the "Saved Searches" section. This allows you to quickly revisit and act on pre-defined candidate lists without having to recreate search parameters. Copy and paste the URL for easy access.',
  normalRecruiterSearchWhy: 'Utilize LinkedIn Recruiter for comprehensive talent searches.',
  normalRecruiterSearchWhen: 'Use when looking for specific talent profiles.',
  normalRecruiterSearchHow: 'Perform a recruiter search using LinkedIn Recruiter to find specific talent profiles. Use advanced filters like skills, experience, and location to identify the best candidates for your needs. Copy and paste the URL to streamline your recruitment efforts.',
  recruiterProjectSearchWhy: 'Manage and search for candidates within specific projects.',
  recruiterProjectSearchWhen: 'Use when you have defined recruiting projects.',
  recruiterProjectSearchHow: 'Search within recruiter projects for relevant candidates. Navigate to your project and use the search bar to find candidates that match your specific criteria. Copy and paste the URL to integrate it into your recruitment process.',
  inMarketOutreachSearchesTitle: 'In-Market Outreach Searches',
  inMarketOutreachSearchesDescription: 'These searches help you find and engage with potential leads who have already shown interest in your industry or services.',
  eventParticipants: 'Event Participants',
  eventParticipantsWhy: 'Why you should use this:',
  eventParticipantsWhyDescription: 'Target participants of LinkedIn events.',
  eventParticipantsWhen: 'When you should use this:',
  eventParticipantsWhenDescription: 'Use when you want to engage with event attendees.',
  eventParticipantsHow: 'How you can use this:',
  eventParticipantsHowDescription: 'Search for participants of LinkedIn events related to your industry by entering the event name in the search bar. You must be a member of the event to access the participants. Copy and paste the URL to engage with event attendees.',
  linkedinPostingSearch: 'LinkedIn Posting Search',
  linkedinPostingSearchWhy: 'Why you should use this:',
  linkedinPostingSearchWhyDescription: 'Engage with users interested in specific content.',
  linkedinPostingSearchWhen: 'When you should use this:',
  linkedinPostingSearchWhenDescription: 'Use when you want to reach users who have interacted with posts.',
  linkedinPostingSearchHow: 'How you can use this:',
  linkedinPostingSearchHowDescription: 'Find and engage with users who have liked or commented on LinkedIn posts related to your business. Use the LinkedIn search feature to look up relevant posts and interact with engaged users. Copy and paste the URL of the post to include it in your outreach strategy.',
  groupParticipants: 'Group Participants',
  groupParticipantsWhy: 'Why you should use this:',
  groupParticipantsWhyDescription: 'Target active members of LinkedIn groups.',
  groupParticipantsWhen: 'When you should use this:',
  groupParticipantsWhenDescription: 'Use when you want to engage with group members.',
  groupParticipantsHow: 'How you can use this:',
  groupParticipantsHowDescription: 'Identify and engage with members of LinkedIn groups related to your industry. Use the group search feature to find active groups, and then navigate to the members\' section. You must be a member of the group to access its participants. Copy and paste the URL to engage with group members.',
  jobPostings: 'Job Postings',
  jobPostingsWhy: 'Why you should use this:',
  jobPostingsWhyDescription: 'Target users interested in job postings.',
  jobPostingsWhen: 'When you should use this:',
  jobPostingsWhenDescription: 'Use when you want to reach users actively looking for job opportunities.',
  jobPostingsHow: 'How you can use this:',
  jobPostingsHowDescription: 'Search for users who have interacted with job postings on LinkedIn by using the job search feature. We generate a lead list based on job ad searches. Copy and paste the URL of the job ad to include potential leads in your campaign.',
  useSeparateAccountTitle: 'Use a Separate LinkedIn Account',
  useSeparateAccountWhyDescription: 'You can leverage the power of Sales Navigator or Recruiter searches with more filters and contact people with different accounts.',
  useSeparateAccountWhenDescription: 'Use when you need to pick the account with the higher license and use it directly.',
  useSeparateAccountHowDescription: 'Select the account from the dropdown, and it will be used for the search. Copy and paste the URL from the selected account to use it.',
  supportedSearchTypesTitle: 'Supported Search Types',
  youHaveLinkedinList: 'You have a list of LinkedIn accounts or contact persons',
  whyUseAddContactsManually: 'You can enrich and manage your existing contacts by selecting a profile finder project or uploading a CSV file. This helps you efficiently enhance your contact list and integrate it into your campaign for outreach.',
  selectProfileFinder: 'Select a profile finder project',
  uploadFileSheet: 'Upload your file sheet',
  whyUseThis: 'Why you should use this:',
  whenUseThis: 'When you should use this:',
  howUseThis: 'How you can use this:',
  profileFinderWhyDescription: 'Using a profile finder project helps you organize and streamline your contact searches.',
  profileFinderWhenDescription: 'Use this when you have a specific project or campaign in mind.',
  profileFinderHowDescription: 'Select the appropriate project from the dropdown menu. Copy and paste the URL to ensure you are targeting the right audience for your campaign.',
  uploadFileWhyDescription: 'Uploading a file allows you to quickly add multiple contacts at once.',
  uploadFileWhenDescription: 'Use this when you have a list of contacts ready to be uploaded.',
  uploadFileHowDescription: 'Simply drag and drop your file into the dropzone or click to select a file. Ensure your CSV file is properly formatted to include all necessary contact information for seamless integration. Copy and paste the URL of the file to upload it.',
  coldOutreachTitle: 'Own Cold Outreach Searches',
  selectSeparateLinkedInAccount: 'Select a separate LinkedIn account',
  coldOutreachSearchesTitle: 'Cold Outreach Searches',
  coldOutreachSearchesDescriptionLead: 'These searches help you find potential leads that you can target specifically.',
  coldOutreachSearchesDescriptionRecruiting: 'These searches help you find potential candidates that you can target specifically.',
  weCanSearchForYou: 'Let us do the heavy lifting for you!',
  selectYourLinkedinProduct: 'Choose your LinkedIn product',
  specifyLocation: 'Set your target location',
  generatedSearchesDescription: 'We create customized LinkedIn searches to help you find the best matches for your needs.',
  useSeparateAccountWhy: 'Why you should use this:',
  useSeparateAccountWhen: 'When you should use this:',
  useSeparateAccountHow: 'How you can use this:',
  weSearchForYou: 'We can search for you',
  normalLinkedInSearch: 'Normal LinkedIn Search',
  normalSalesNavSearch: 'Normal Sales Navigator Search',
  savedSalesNavSearch: 'Saved Sales Navigator Search',
  normalRecruiterSearch: 'Normal Recruiter Search',
  recruiterProjectSearch: 'Recruiter Project Search',
  downloadAsExcel: 'Download as Excel file',
  searchTypesAdditionalInfo: 'Further information on the search types',
  editRunningCampaignDialogTitle: 'Campaign currently running',
  editRunningCampaignDialogContent1: 'Running campaigns are stopped in edit mode.',
  editRunningCampaignDialogContent2: 'Restart the campaign after you have edited it.',
  copilotLicenseExpiredDialogTitle: 'Co-pilot license expired',
  copilotLicenseExpiredDialogContent1: 'Your co-pilot license has expired. You cannot start, create or edit a campaign without a valid license.',
  copilotLicenseExpiredDialogContent2: 'Please <1>renew your license</1> under "Booked licenses" buy a new license <3>here</3> or <5>contact us</5> if you need a special plan for you or your company.',
  enrichmentSettings: 'Enrichment Settings',
  betterContactsApiKey: 'BetterContacts API Key',
  apiKeyRequired: 'API Key is required.',
  enrichmentScope: 'Enrichment Scope',
  enrichFullFunnel: 'Enrich Full Funnel',
  enrichLoadedContacts: 'Enrich Only Loaded Contacts',
  submit: 'Submit',
  assessing: 'Assessment',
  pleaseEnterAPrompt: 'Please enter a prompt.',
  pleaseSelectAtLeastOneOption: 'Please select at least one option.',
  assessmentFailed: 'Assessment failed.',
  anErrorOccurred: 'An error occurred.',
  assessmentProcessInitiated: 'The assessment process has been initiated.',
  submitting: 'Submitting...',
  assessmentWillContinueInBackground: 'The assessment will continue in the background.',
  assessmentExplanation: 'Provide specific criteria for the AI to develop suggestions on whether a contact might meet your expectations. Our system assists you by categorizing contacts into groups A, B, and C based on these criteria. You can decide which groups of contacts should be automatically added to the campaign. Additionally, the AI will provide an overall assessment to help you make informed decisions on contact selection.',
  whichContactsToAdd: 'Select contacts to add:',
  optionALabel: 'Group A – High Match',
  optionADescription: 'Contacts with a high match to your criteria.',
  optionBLabel: 'Group B – Medium Match',
  optionBDescription: 'Contacts with a medium match to your criteria.',
  optionCLabel: 'Group C – Low Match',
  optionCDescription: 'Contacts that have only a low match to the established criteria. This group may offer potential opportunities but might require additional review.',
  rejudgeExistingContacts: 'Reassess Existing Contacts',
  rejudgeExistingContactsDescription: 'Enable this option to reassess existing contacts and ensure they meet the current criteria. This can help improve the accuracy and relevance of your contact list.',
  nonMatchingContactsInfo: 'If you select this option, each contact will be reviewed again, and previous assessments will be removed. This might result in duplicate contacts in your campaign, but you can add them back if needed.',
  enrichmentExplanation: 'To use the enrichment feature, please visit https://app.bettercontact.rocks, create an account, and copy your API Key into this field to connect the service for this specific campaign.',
  newBetaFeatures: 'New Beta Features',
  newBetaFeaturesExplanation: 'We have deployed these new features in beta to test them with more data and users. This helps us understand their value and make improvements to their functionality.',
  aiJudgement: 'Rating',
  aiJudgementExplanation: 'Reason',
  accountNotFound: 'LinkedIn account not found',
  editAndRestart: 'Edit & Restart',
  editAndRestartFull: 'Edit & Restart Campaign',
  changeLinkedinAccount: 'Change LinkedIn Account',
  toTheSearches: 'to the searches',
  duration30Minutes: '30 Minutes',
  duration1Hour: '1 Hour',
  duration5Hours: '5 Hours',
  durationrestOfDay: 'Rest of the Day',
  logoutModaltitle: 'Logout LinkedIn Account',
  logoutModaldescription: 'Select the duration for which you want to stay logged out:',
  logoutModalcancel: 'Cancel',
  logoutModalconfirm: 'Confirm Logout',
  connectionsLimitWarning: 'We recommend sending no more than {{count}} connection requests per week.',
  messagesLimitWarning: 'We recommend sending no more than {{count}} messages per week.',
  inmailsLimitWarning: 'We recommend sending no more than {{count}} inmails per day.',
  contactsLoadingLimitWarning: 'We do not recommend loading more than {{count}} additional contacts at once.',
  coldCalls: 'Cold Calls',
  coldCallsLimitWarning: 'The daily limit for cold calls is exceeded. The recommended maximum is {{count}} per day.',
  // new ui translations
  selectPromptLibrary: '1. Select a prompt library',
  selectMessageOrCondition: '2. Select a message or a condition',
  waiting: 'Waiting',
  campaignStatusDraft: 'Draft',
  campaignStatusEditing: 'Editing',
  campaignStatusRunning: 'Working',
  startCampaignNow: 'Start Campaign Now',
  campaignBriefing: 'Campaign Briefing',
  campaignContactList: 'Campaign Contact List',
  campaignFlow: 'Campaign Flow',
  campaignSettings: 'Campaign Settings',
  campaignTesting: 'Campaign Testing',
  campaignBriefingDescription: 'To brief the AI on the outreach campaign, provide the AI with the complete job offer.',
  campaignContactListDescription: 'To add contacts to your campaign contact list, complete these three sections: Add, Manage, and generate Final Talent Short-list.',
  sourcePreQualifiedContacts: 'Source Pre-qualified Contacts',
  searchMethod: 'Search Method',
  productToBeUsed: 'Product to be used',
  searchObjective: 'Search Objective',
  pastedUrls: 'Pasted URLs',
  crawlingAccount: 'Crawling account',
  uploadedContacts: 'Uploaded contacts',
  searchLocation: 'Search Location',
  manageQualifyContacts: 'Manage & Qualify Contacts',
  manageSearches: 'Manage Searches',
  manageBlacklists: 'Manage Blacklists',
  manageQualifiedLeads: 'Manage qualified leads',
  finalTalentShortList: 'Final Talent Short-list',
  campaignSettingsDescription: 'Choose the LinkedIn account and whether messages need approval. Working hours and limits are set on the account.',
  approveMessages: 'Approve messages',
  leadSupplyMore: '{{count}} more contacts available in the search – they are loaded automatically as needed.',
  leadSupplyMoreUnknown: 'The search is still open – more contacts are loaded automatically as needed.',
  leadSupplyExhausted: 'No more contacts: the search is exhausted and every contact has been approached. Add a new search to keep the campaign running.',
  leadSupplyExhaustedWithReserve: 'The search is exhausted. {{count}} contacts are still waiting for their first message; after that no new ones will be added.',
  timezone: 'Timezone',
  timeSettings: 'Time settings',
  dailyMessageLimits: 'Daily message limits',
  selectedCount: '{{count}} selected',
  searchTypeCount: '{{count}} search type(s)',
  leadsCount: '{{count}} leads',
  campaignOverviewDescription: 'Review the campaign\'s details and start it if everything is fine.',
  paiSearch: 'We search for you',
  conductOwnSearch: 'You conduct your own search',
  existingContactList: 'Use your existing contact lists',
  addContactsFromCampaign: 'Add contacts from another campaign',
  campaignBriefingTitle: 'Campaign Briefing',
  campaignBriefingSubtitle: 'This is how it goes',
  campaignBriefingExplanation:
    'To empower the AI to effectively source, qualify, and engage top candidates, provide a thorough, high-quality job description. The more complete your listing—covering key aspects like company culture, required skills, and benefits—the better the AI can accurately target, qualify talent, and craft personalized outreach messages that maximize engagement and response rates.',
  equipAiTitle: 'Equip the AI with the right data',
  equipAiDescription:
    'We generate tailored prompts and optimized LinkedIn searches based on your input. To get started, simply provide the URL of the product or job offer by copying the landing page link (either for the product or the job ad). This essential information powers the AI to identify, qualify, and engage the right talent effectively.',
  jobOfferUrlPlaceholder: 'Paste here your job offer URL',
  productUrlPlaceholder: 'Paste here your product URL',
  invalidPerplexityUrlError: 'Please enter a valid URL',
  processingUrl: 'Processing URL...',
  jobTitlePlaceholder: 'Enter here your job title',
  jobOfferPlaceholder: 'Paste here your job offer',
  productProblemsPlaceholder: 'Paste here the problems your product solves',
  productFeaturesPlaceholder: 'Paste here the features of your product',
  productBenefitsPlaceholder: 'Paste here the benefits of your product',
  communicationStyleSettings: 'Communication style settings',
  aiGeneratedMessaging: 'AI generated messaging',
  aiBriefingPlaceholders: 'AI Briefing placeholders',
  selectCampaignFlowTemplate: 'Select campaign flow template (optional)',
  selectTemplateDescription: 'Select a pre-built template for a quick start. Pre set a full campaign flow, working hours and working days and the communication settings fitting best for your needs.',
  showTemplateOptions: 'Show template options',
  templateOverwriteWarning: 'Note: If you have already selected a template or built a flow on your own, selecting a new template will overwrite the flow completely.',
  languageDescription: 'Select the language you prefer for our AI to use in crafting your outreach message.',
  languageNote: 'Note: If you select "Auto detect" under Language, the message will be in the lead\'s LinkedIn profile language.',
  communicationStyle: 'Communication style',
  communicationStyleDescription: 'Your choice here will affect the tone and formality of your outreach messages. For example, by selecting "Polite Speech" your prompt will indicate the use of formal communication.',
  noMessageNodes: 'In this area you will see a list of all message nodes in your campaign, once you added at least one.',
  usePromptGenerator: 'Use the built-in prompt generator to create messages for each step.',
  noActionSelected: 'no action selected',
  timeUntilNextStep: 'time until next step: {{time}}',
  promptHelpText: 'A prompt is an input or instruction given to generative AI to guide its response. When writing a prompt, ensure it is clear, specific, and concise to achieve the desired outcome. Provide necessary context and avoid ambiguity to help the AI generate accurate and relevant results.',
  whatIsPrompt: 'What is a prompt and how to write one?',
  testPrompt: 'Test prompt',
  testContact: 'Test contact',
  testContactDescription: 'Select the contact to test the prompt.',
  startTest: 'Start test',
  defaultContact: 'Default contact',
  generatedText: 'Generated text',
  updateAiBriefingTitle: 'Update the AI Briefing placeholders',
  updateAiBriefingText:
    'The texts from the Campaign Briefing step will be used for some of the placeholders inside the prompt. Here you can adjust it, if e.g. the results from the prompt testing were not good enough.',
  productImpactPlaceholder: 'Describe the product impact here',
  updateFieldNote:
    'Note: If you update a field here, it will be updated in the "Campaign Briefing" tab as well.',
  condition: 'Condition',
  maxTimeUntilAccepted: 'Max. time until accepted',
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  connectedOnLinkedIn: 'Connected on LinkedIn?',
  contactRequestAccepted: 'Contact request accepted?',
  hasEmailAddress: 'Has email address?',
  utility: 'Helper node',
  withdrawContactRequest: 'Withdraw contact request',
  thisIsHowItGoes: 'This is how it goes',
  defineOperationalSettings: 'Set only what belongs to this campaign. Working hours and limits are configured on the LinkedIn account.',
  selectApproveMessages: 'Select approve messages',
  approveMessagesDescription: 'Do you want to approve the generated messages, before they are sent out to your contacts?',
  selectLinkedinAccountDescription: 'Specify which LinkedIn account should send the outreach messages.',
  campaignAccountLimitsHint: 'Working hours, timezone and daily limits live on the LinkedIn account — LinkedIn Accounts → Working hours.',
  recontactCooldownSidebar: 'Re-contacting',
  selectTimezone: 'Select timezone',
  selectTimezoneDescription: 'Select the time zone from which your outreach campaign will be operating from.',
  selectRecontactCooldown: 'Re-contacting people you have already approached',
  recontactCooldownDescription:
    'When someone has already been approached in another campaign: after how long may this campaign approach them again? This lets you decide how often a person hears from you.',
  recontactCooldownNever: 'Do not approach again',
  recontactCooldown2Weeks: 'After 2 weeks',
  recontactCooldown4Weeks: 'After 4 weeks',
  recontactCooldown2Months: 'After 2 months',
  recontactCooldown3Months: 'After 3 months',
  recontactCooldown6Months: 'After 6 months',
  recontactCooldownNote:
    'Note: this setting only applies to people approached in a different campaign. The number of messages within this campaign is still governed by its flow.',
  defineCampaignWorkTime: 'Define your outreach campaign\'s operational time settings',
  chooseWorkDaysHours: 'Choose the hours and days of the week you would like your AI co-pilot to be active in.',
  applyWorkTimeSettings: 'Apply these settings in a way to ensure the co-pilot sends messages outside your working hours, mimicking a natural schedule with morning and late-afternoon activity.',
  dailySentMessageLimits: 'Specify how many daily outreach messages should be sent',
  defineDailyMessages: 'Define the number of messages to send per campaign step each day. To safeguard your account, we cap daily messages since LinkedIn enforces daily and weekly limits for specific message types.',
  totalMessageLimit: 'If you have multiple campaigns running simultaneously, the total message limit will need to be shared across all campaigns.',
  eligibleDays: 'Eligible days',
  selectDaysActive: 'Select the days of the week your outreach campaign should be active.',
  eligibleHours: 'Eligible hours',
  selectHoursActive: 'Select the hours your outreach campaign should be active.',
  workHoursRuleHint: 'Up to {{maxBlocks}} time windows per day, each {{minLength}}–{{maxLength}} hours long, together at most {{maxHours}} hours. Click a free hour to add it, click a selected hour to cut the window back from there. Less is always allowed.',
  workHoursWindow: 'Window {{index}}: {{range}}',
  workHoursUsed: '{{used}} of {{max}} hours per day',
  workHoursNoneSelected: 'No hour selected yet — automation stays paused for this account.',
  workHoursBlockedMaxDaily: 'More than {{max}} hours of automation per day is not allowed. Remove an hour first.',
  workHoursBlockedMaxBlocks: 'At most {{max}} time windows per day. Extend an existing window or clear one.',
  workHoursBlockedMaxLength: 'A window may not run longer than {{max}} hours at a stretch — a long uninterrupted run stands out to LinkedIn.',
  workHoursTrimmedNotice: 'This account had {{previous}} hours per day configured. We trimmed the selection to {{max}} hours; saving applies the trim.',
  selectMaxThreeCandidates: 'Select candidates from your contact list to test the campaign.',
  selectContactsForTest_ActiveSourcing: 'Please select up to 5 contacts from your final candidate list.',
  selectContactsForTest_LeadBooster: 'Please select up to 5 contacts from your final lead list.',
  runTestCampaignAgain: 'Run Test Campaign again',
  preparingTestMessages: 'We are preparing a set of test messages for your selected candidates.',
  processMayTake: 'This process may take a few minutes. Thank you for your patience.',
  testYourCampaign: 'Test your campaign here to preview how messages across your entire campaign flow adapt to each lead"s motivations.',
  moreNodes: 'more node(s)',
  totalContactsInShortList: 'Total # of contacts in final short-list',
  totalContactsInShortList_ActiveSourcing: 'Total # of contacts in final candidate list',
  totalContactsInShortList_LeadBooster: 'Total # of contacts in final lead list',
  moreContacts: 'more contact(s)',
  campaignMessagesFromLinkedIn: 'LinkedIn account for sending out messages:',
  campaignOperatingDays: 'Campaign Operating days:',
  campaignOperatingHours: 'Campaign Operating hours:',
  campaignContactListTitle: 'Campaign Contact List',
  campaignContactListExplanation:
    'In this section, you\'ll supply a pull of target leads to fuel your campaign. You have two options: either let our AI source qualified leads based on your campaign brief, or specify your own search criteria to guide the process.',
  aiBriefingLanguage: 'Campaign briefing language',
  sourcingPotentialTalentOnLinkedIn: 'Sourcing talents on LinkedIn',
  identifyingQualifiedTalentSearches: 'We are identifying qualified talent searches that align with your job description. This may take a moment as we conduct a comprehensive search.',
  selectLinkedInAccountForSourcing: 'Select the LinkedIn account to use for sourcing',
  useDifferentLinkedInAccountsForSourcing: 'You can use different LinkedIn accounts for sourcing contacts and sending messages. This setup lets you gather leads from one account and reach out to them using another, optimizing both contact collection and engagement strategies.',
  useDifferentLinkedInAccountsForSourcingShort: 'You can use different LinkedIn accounts for sourcing contacts and sending messages.',
  chooseContactSourcingMethod: 'Choose your contact sourcing method',
  whichLinkedInProductForSourcing: 'Choose the LinkedIn product for sourcing',
  selectLanguagesForSearch: 'Select the languages for your search',
  chooseLanguagesForSearch: 'Choose the languages in which you\'d like us to conduct the search.',
  noteSelectMultipleLanguages: 'Note: You can select multiple languages. You have to select at least one language.',
  includeOwnContacts: 'Include your own contacts',
  includeOwnContactsLabel: 'Also 1st degree (all contacts)',
  includeOwnContactsDescription: 'By default we only search 2nd and 3rd degree. Turn this on to drop that filter and include 1st, 2nd and 3rd degree.',
  typeInYourSearchLocation: 'Type in your search location',
  selectLocationForContactSearch: 'Select the location where you want us to search for the contacts.',
  addLinkedinSearchesToLeadBank: 'Add LinkedIn searches to your lead bank',
  reviewSearchSamplesForLeads: 'Review the search samples to assess whether the generated leads meet your criteria and expectations. Once you are satisfied, add them to your lead bank. If the results are not ideal, use the search fine-tuning feature to optimize the output. Repeat this process until you achieve the desired lead quality.',
  weAreAlmostThere: 'We are almost there!',
  linkedinSearchReady: 'Your LinkedIn talent search is ready to go! Click \'Start talent search\' to generate a LinkedIn search that aligns with your criteria.',
  startTalentSearch: 'Start talent search',
  readyToQualifyYourLeads: 'Ready to qualify your leads!',
  clickButtonToAddSearch: 'Click on the button below to add the search to the campaign and start the lead qualification process.',
  addSearch: 'Add search',
  redoLeadSearch: 'redo lead search',
  finetune: 'Show and add',
  edited: '(edited)',
  dataNotAvailable: 'Data not available',
  notYetVisited: 'Not yet visited',
  notYetVisitedTitle: 'Why data is not shown yet',
  notYetVisitedIntro: 'This contact has not been visited by our crawler yet. Here are common reasons:',
  notYetVisitedReason_freemium: 'You are on Freemium: only 5 contacts can be analyzed per day.',
  notYetVisitedReason_limits: 'We already have enough contacts to start. LinkedIn has limits, so we minimize crawling to protect your account.',
  notYetVisitedReason_not_reached: 'The crawler has not reached the contact yet, but will visit it in due time.',
  notYetVisitedFreemiumNote: 'Upgrade to increase your daily analysis limit and unlock faster processing.',
  selectContactSearchObjective: 'Select the contact search objective',
  customizeSearchSelectOptions: 'To customize your search, select more options under this section',
  linkedinLeadSearchReady: 'Your LinkedIn lead search is ready to go! Click "Start lead Search" to generate a qualified contact list.',
  startLeadSearch: 'Start lead search',
  supportedSearches: 'Supported Searches',
  coldOutreach: 'Cold Outreach',
  inMarketOutreach: 'In-Market Outreach',
  yourSelectedSearches: 'Your Selected Searches',
  kickOffLinkedinSourcing: 'To kick off your LinkedIn sourcing, select the search types you want to use. Confirm your choices to start identifying candidates. Once your search is complete, copy and paste the resulting LinkedIn search URL here.',
  nameYourSearch: 'Name your search',
  insertLinkedinUrl: 'Insert your LinkedIn URL',
  pasteLinkedinUrl: 'Paste LinkedIn search URL here...',
  addNewUrlForSearch: '+ Add new URL for this search type',
  giveLinkedinSearchName: 'Give a name to your LinkedIn search...',
  linkedin_title: 'Normal LinkedIn search',
  linkedin_subTitle: 'Find potential leads on LinkedIn',
  linkedin_whenToUseText: 'When you need to identify new leads',
  linkedin_howToUseText: 'Perform a basic LinkedIn search using relevant keywords',
  salesNavigator_title: 'Normal Sales Navigator search',
  salesNavigator_subTitle: 'Get detailed insights into your target audience',
  salesNavigator_whenToUseText: 'When you need to identify new leads',
  salesNavigator_howToUseText: 'Perform a basic LinkedIn search using relevant keywords',
  savedSalesNav_title: 'Saved Sales Navigator search',
  savedSalesNav_subTitle: 'Quickly access your pre-defined LinkedIn searches',
  savedSalesNav_whenToUseText: 'Use this when you need to revisit and use your saved searches.',
  savedSalesNav_howToUseText:
    'Access your saved searches in LinkedIn Sales Navigator by navigating to the "Saved Searches" section. This allows you to quickly access and act on pre-defined lead lists without having to recreate the search parameters. Copy and paste the URL for easy access.',
  recruiter_title: 'LinkedIn Recruiter search',
  recruiter_subTitle: 'For comprehensive talent searches',
  recruiter_whenToUseText: 'Use this when searching for specific talent profiles.',
  recruiter_howToUseText:
    'Conduct a recruiter search using LinkedIn Recruiter to find specific talent profiles. Use advanced filters such as skills, experience, and location to identify the best candidates for your needs. Copy and paste the URL to optimize your recruiting efforts.',
  recruiterProjects_title: 'Recruiter Project Search',
  recruiterProjects_subTitle: 'Manage and search for candidates within specific projects',
  recruiterProjects_whenToUseText: 'Use this when you have defined recruitment projects.',
  recruiterProjects_howToUseText:
    'Search for relevant candidates within recruiter projects. Navigate to your project and use the search bar to find candidates that meet your specific criteria. Copy and paste the URL to integrate it into your recruitment process.',
  events_title: 'Find Event Participants',
  events_subTitle: 'Target attendees of LinkedIn events',
  events_whenToUseText: 'Use it when you want to connect with event attendees.',
  events_howToUseText:
    'Search for attendees of LinkedIn events related to your industry by typing the event name into the search bar. You must be a member of the event to access the attendees. Copy and paste the URL to connect with event attendees.',
  postings_title: 'Find LinkedIn Posts',
  postings_subTitle: 'Engage with users who are interested in specific content',
  postings_whenToUseText: 'Use it when you want to reach users who have interacted with posts.',
  postings_howToUseText:
    'Find and engage with users who have liked or commented on LinkedIn posts related to your company. Use LinkedIn"s search function to find relevant posts and interact with the engaged users. Copy and paste the post URL to include it in your outreach strategy.',
  groups_title: 'Find Group Participants',
  groups_subTitle: 'Target active members of LinkedIn groups',
  groups_whenToUseText: 'Use it when you want to connect with group members.',
  groups_howToUseText:
    'Identify and engage with members of LinkedIn groups that relate to your industry. Use the group search function to find active groups, then navigate to the "Members" section. You must be a member of the group to access its participants. Copy and paste the URL to connect with group members.',
  jobPostings_title: 'Find Leads by Job Postings',
  jobPostings_subTitle: 'Target leads who have posted job advertisements',
  jobPostings_whenToUseText: 'Use this when you want to reach users who have posted open positions.',
  jobPostings_howToUseText:
    'Search for users who post job openings on LinkedIn by using the job search feature. We create a lead list based on the decision-makers (department heads or CEOs) behind the posting. Copy and paste the job posting URL to add potential leads to your campaign.',
  whenToUse: 'When should you use this',
  howToUse: 'How you can use this',
  useThisLink: 'Use this link to conduct the search',
  addExistingContacts: 'Add existing contacts to the campaign',
  uploadInstructions:
    'To upload your existing contact list, please provide a CSV or Excel sheet file. If you have a LinkedIn Profile Finder project, please download it in the same format and upload it here.',
  almostThere: 'We are almost there!',
  leadReadyMessage:
    'Your LinkedIn lead pool is ready to go! Click \'Add list to lead bank\' and start qualifying leads.',
  addToLeadBank: 'Add list to lead bank',
  uploadMoreFiles: 'Upload more files',
  deleteContacts: 'Delete contacts',
  open: 'Open',
  manageQualifyLeads: 'Manage & Qualify Leads',
  loadingContacts: 'Loading contacts',
  notStartedYet: 'Not started yet',
  searchNumber: 'Search {{position}}/{{total}}',
  contactsNotRelatedToSearch: 'Manually added contacts',
  source: 'Source',
  typeOfSearch: 'Type of search',
  linkedInSearchUrl: 'LinkedIn Search URL',
  openOnLinkedIn: 'Open on LinkedIn',
  progress: 'Progress',
  fileNumber: 'File {{position}}/{{total}}',
  leadListPreview: 'Lead List Preview',
  totalBlacklists: '# Total Blacklists',
  globalBlacklists: 'Global Blacklists ({{count}})',
  campaignSpecificBlacklists: 'Campaign Specific Blacklists ({{count}})',
  activateExistingBlacklists: 'Activate existing blacklists',
  leads: 'Leads',
  addedToBlacklist: 'added to blacklist',
  contactLinkedInUrl: 'Contact LinkedIn URL',
  addNewContacts: '+ Add new contacts',
  addNewCompanies: '+ Add new companies',
  noCampaignSpecificBlacklist: 'You have not created any campaign specific blacklists yet. To start blocking contacts, click:',
  addNewCampaignSpecificBlacklist: '+ Add new campaign specific blacklist',
  addNewGlobalBlacklist: '+ Add new global blacklist',
  createNewBlacklist: '+ Create new Blacklist',
  totalFoundCandidates: 'Total found candidates',
  topCandidates: 'A. Top Candidates',
  strongContenders: 'B. Strong Contenders',
  backupCandidatePool: 'C. Backup Candidate Pool',
  allContacts: 'All contacts',
  candidates: 'Candidates',
  topCandidatesAddedToCampaign: 'Top candidates added to the campaign list',
  strongContendersAddedToCampaign: 'Strong contenders added to the campaign list',
  backupCandidatesAddedToCampaign: 'Backup candidates added to the campaign list',
  talentsAddedToCampaign: 'Talents added to the final campaign list',
  qualificationInProgress: 'Qualification in progress',
  profileAnalysisInProgress: 'Profile analysis in progress',
  aiLeadAssessment: 'AI Lead Assessment',
  linkedInURL: 'LinkedIn URL',
  duplicateCandidate: '{{contact}} is a duplicate candidate. Appears in the pipeline of campaigns: {{campaigns}}',
  linkedInContact: 'LinkedIn Contact',
  qualificationNote: 'Once your campaign is running, talents will be auto-added, qualified and shortlisted using your samles. <2>Click here to load more talents if needed.</2>',
  qualificationNoteShort: 'Once your campaign is running, talents will be auto-added, qualified and shortlisted using your samles.',
  clickHereToLoadTalents: 'Click here to load more talents if needed.',
  loadMoreTalents: 'Load more talents',
  loadMoreTalentsSuccessMessage: 'The search for further talent has been successfully launched!',
  candidatesAddedToFinalShortList: 'Candidates added to final talent short-list',
  downloadData: 'Download Data',
  shortSummary: 'Short summary',
  addNewColumn: '+ Enrich contact information',
  provideUniqueCampaignName: 'Provide a unique name for your campaign',
  createCampaign: 'Create Campaign',
  setupNewCampaign: 'Setup New Campaign',
  nextStepsInCampaignCreation: 'Next steps in your campaign creation',
  briefTheAIOnOutreachRequirements: 'Brief the AI on your outreach campaign requirements',
  aiOutreachDescription: 'To empower the AI to effectively source, qualify, and engage top candidates, provide a thorough and high-quality job description or enter the job offer landing page URL.',
  sourcePreQualifiedCandidates: 'Source pre-qualified candidates from LinkedIn searches',
  addContactsToTalentPool: 'Add contacts to your talent pool list to target in your campaign. You can either upload a list of existing contacts or use our search filters to discover new ones.',
  qualifyTalentsAndCreateShortlist: 'Qualify talents and create campaign shortlist',
  selectTopTalents: 'Select the top talents you would like to engage with moving forward.',
  testAndStartYourCampaign: 'Test and start your campaign',
  testCampaignSetup: 'Test your campaign to ensure everything is setup correctly. Once tested, start the campaign and monitor its process.',
  labelTheFieldsOfYourContactList: 'Label the fields of your contact list',
  mapFileValuesToContactProperties: 'Map the values from your file to the corresponding contact properties. We need at least the name and LinkedIn URL or the name and the company to add a contact to the campaign.',
  columnContentPreview: 'Column Content Preview',
  columnLabel: 'Column Label',
  pleaseEnterValidLinkedinUrl: 'Please enter a valid LinkedIn URL',
  recruiterSearchFineTuning: 'Recruiter search fine-tuning',
  initializingFieldsMessage: 'We are initializing the fields. Please wait a few seconds...',
  closeAndSave: 'Close & save',
  searchResults: 'Search results',
  searchResultsDescription: 'A list of contacts based on the search criteria on the right. The qualification of the individual contacts happens later in the process.',
  linkedInSearchFineTuner: 'LinkedIn search fine-tuner',
  linkedInSearchDescription: 'Review and adjust the criteria under each section to enhance your AI-based LinkedIn search',
  searchUpdatedSuccessMessage: 'Your search has successfully been updated!',
  keepOrDeleteContacts: 'Keep or delete contacts',
  updateSearchMessage: 'You are about to update your search.',
  keepOrDeleteMessage: 'Do you want to keep or delete the contacts associated with this search?',
  qualifiedContactsInfo: 'Your already qualified contacts will not be affected by this.',
  keep: 'Keep',
  insertSearchNamePlaceholder: 'Insert name of search here...',
  qualificationProcessStartedMessage: 'The qualification process has successfully been started!',
  manageContactsTitle: 'Manage Contacts',
  qualifyCandidatesIntro: 'In this section, you can qualify candidates and add them to your final campaign list.',
  qualifyCandidatesStep1Title: '1. You"ll see two lists: ',
  qualifyCandidatesStep1Description:
    '- Final Campaign List: Includes all contacts to be reached when your campaign starts.\n- Pre-Qualified Candidate List: Includes potential candidates who fully or partially meet your criteria.',
  qualifyCandidatesStep2Title: '2. Qualification options:',
  qualifyCandidatesStep2Description: 'Use AI to analyze your job ad and/or add custom criteria.',
  qualifyCandidatesStep3Title: '3. Candidates are qualified as:',
  qualifyCandidatesStep3Description: 'A. Fit: The must-have criteria are met and the profile fits the position.\nB. Possible: Basically suitable for the position, but the must-haves are not (fully) shown.\nC. Not suitable: An exclusion criterion (no-go) applies or the profile clearly does not fit the position – not contacted.',
  qualifyContactsTitle: 'Qualify contacts',
  assessContactsTitle: 'Assess contacts with the help of AI',
  continueWithoutQualifying: 'Continue without qualifying leads',
  startQualifying: 'Start qualifying leads',
  refineSearchTitle: 'Refine Search and Lead Qualification Criteria',
  refineSearchDescription: 'To ensure our AI identifies high-quality leads, we\'ve extracted search and qualification criteria from the campaign briefing (job ad). Please review and refine the following keyword and prompt input sections. By optimizing these, we\'ll empower our AI to deliver more effective results.',
  provideKeyCharacteristicsTitle: 'Provide the AI with the key company characteristics of the company posting the job offer',
  provideKeyCharacteristicsDescription: 'Help us identify the best-fit candidates by refining the attributes that align with your company or department. Our AI will focus on talents with experience in similar environments.',
  contactsToAddTitle: 'Which contacts to add',
  contactsToAddDescription: 'Please tell us, which contacts should be directly added to your final contact list depending on the qualification results.',
  aiLeadAssessmentTitle: 'AI Lead Assessment',
  updateCriteriaInfo: 'When you update the lead qualification criteria, we\'ll reassess all current leads, generating new lists from scratch. To avoid losing previously qualified leads, please indicate below whether you\'d like to retain your existing selections or start fresh with a newly qualified list.',
  retainOrResetTitle: 'Indicate if you want to keep existing leads or start fresh?',
  retainOrResetDescription: 'Do you want to keep your current selection, or shall we reset all lists?',
  keepExistingSelections: 'Keep your existing selections',
  startFresh: 'Start with a fresh, qualified list',
  reviewContactsTitle: 'Indicate if you want to review each contact again.',
  reviewContactsDescription: 'All contacts will be qualified again based on your updated information, if you select this option.',
  redoQualification: 'Redo qualification for existing contacts',
  updateQualificationCriteria: 'Update qualification criteria',
  topCandidate: 'Top Candidate',
  strongContender: 'Strong Contender',
  backupCandidate: 'Backup Candidate',
  notQualifiedTalent: 'Not qualified talent',
  talentPreview: 'Talent Preview',
  excludeFromContactList: 'Exclude from contact list',
  addToContactList: 'Add to contact list',
  addedToPipeline: 'Added to contact list',
  noLinkedInUrl: 'no LinkedIn URL',
  noEmail: 'no email',
  aiBasedLinkedInSearch: 'AI-based LinkedIn search',
  manuallyAddedContact: 'Manually added contact',
  assessmentOverview: 'Assessment Overview',
  aboutContact: 'About Contact',
  aboutCompany: 'About Company',
  qualificationReason: 'Qualification reason',
  whyIsContactQualified: 'Why is {{fullName}} a {{qualification}}',
  noExplanationYet: 'No explanation yet',
  professionSummary: 'Profession summary of {{fullName}}',
  experience: 'Experience',
  education: 'Education',
  na: 'N/A',
  present: 'Present',
  keySkills: 'Key skills and expertise of {{fullName}}',
  technicalSkills: 'Technical skills',
  industrySkills: 'Industry skills',
  softSkills: 'Soft skills',
  companyChannels: 'Company channels',
  companyInfo: 'Company info',
  noOfEmployees: 'No. of employees',
  headquarter: 'Headquarter',
  companyDescription: 'Company description',
  removalConfirmationMessage: 'You are trying to remove a previously selected objective: <1>{{title}}</1>',
  removalLossWarning: 'As a result, text fields that have already been filled-in are lost.',
  removalConfirmation: 'Shall we continue?',
  createCampaignBlacklist: 'Create campaign specific blacklist',
  addMoreItems: 'Add more {{item}}',
  enterBlacklistTopicName: 'Enter Name of Blacklist Topic',
  selectBlacklistType: 'Select if you want to blacklist based on a list of companies or contacts',
  uploadOrTypeItems: 'Select if you want to upload a file or type individual {{item}}',
  uploadFileOption: 'Upload CSV or Excel file',
  typeInIndividualOption: 'Type-in individual {{item}}',
  blacklistBasedOnContacts: 'Blacklist based on contacts',
  blacklistBasedOnCompanies: 'Blacklist based on companies',
  uploadContactList: 'Upload your contact list',
  uploadCompanyList: 'Upload your company list',
  typeInOrPasteContactLinkedInURL: 'Paste the contact\'s LinkedIn-URL',
  typeInOrPasteCompanyNames: 'Type-in or paste the company name',
  resetList: 'Reset list',
  itemsToBeAdded: '{{count}} {{item}} will be added to the blacklist',
  closeFile: 'Close file',
  selectLinkedinUrlColumn: 'Select the column of the LinkedIn URL in your file',
  selectCompanyNameColumn: 'Select the column of the company name in your file',
  confirmSelection: 'Confirm selection',
  pressEnterOrClick: 'Press enter or click the plus button if you type-in a value',
  invalidLinkedInUrl: 'Please enter a valid LinkedIn URL',
  deleteBlacklistTitle: 'Delete campaign blacklist',
  deleteBlacklistConfirmation: 'Should we really delete the blacklist {{name}}?',
  deleteBlacklistIrreversibleProcess: 'This process cannot be reversed and the blacklist is no longer available afterwards.',
  changeBlacklistNameTitle: 'Change blacklist name',
  changeBlacklistNamePlaceholder: 'Enter the new blacklist name here',
  aiPoweredEnrichmentTitle: 'AI-Powered Contact Data Enrichment',
  enhanceDatabaseTitle: 'Enhance Your Database Instantly',
  howItWorksTitle: 'This is how it goes',
  enrichmentDescription: 'Unlock AI-Powered Contact Data Enrichment! Our AI scans LinkedIn profiles to automatically fill in missing contact details, such as phone numbers, adding this information instantly as new columns in your database—saving you valuable time.',
  getBetterContactsStarted: 'Get started at <1>https://app.bettercontact.rocks</1>. Create an account, copy your API key, and link it to your campaign!',
  betterContactsApiKeyLabel: 'BetterContacts API key',
  prospeosEnrichmentTab: 'Prospeos Enrichment',
  customFieldEnrichmentTab: 'Custom Field Enrichment',
  prospeosEnrichmentTitle: 'Prospeos Enrichment',
  prospeosEnrichmentDescription: 'Enrich your contacts with additional data from Prospeos.',
  enrichEmail: 'Enrich Email',
  enrichPhoneNumber: 'Enrich Phone Number',
  customFieldEnrichmentTitle: 'Custom Field Enrichment',
  customFieldEnrichmentDescription: 'Use OpenAI web search to fill campaign-specific person and company information into the custom field.',
  customFieldPersonPromptLabel: 'Person information prompt',
  customFieldPersonPromptPlaceholder: 'e.g. What is this person likely responsible for and why are they relevant?',
  customFieldCompanyPromptLabel: 'Company information prompt',
  customFieldCompanyPromptPlaceholder: 'e.g. What recent company signals make this account relevant?',
  overrideExistingResults: 'Override Existing Results',
  addProspeosInformation: 'Add Prospeos Information',
  addCustomFieldInformation: 'Add Custom Field Information',
  pasteApiKeyPlaceholder: 'Paste the API key here...',
  enrichmentScopeLabel: 'Enrichment scope',
  enrichShortList: 'Enrich your candidate shortlist only',
  enrichFullPool: 'Enrich full candidate pool',
  addInformation: 'Add information',
  sourcingPhoneNumbers: 'Sourcing phone numbers for your leads',
  analyzingProfilesMessage: 'We are currently analyzing LinkedIn profiles from your contact list. Contacts with sufficient data will have their information displayed in the results column. Profiles lacking the necessary data will be automatically excluded from the final results.',
  startHereTitle: 'Start Here!',
  startHereSubtitle: 'Select the way you want to set up your Campaign',
  useTemplate: 'Use a template',
  setupFromScratch: 'Set up campaign from scratch',
  duplicateExisting: 'Duplicate one of your existing campaigns',
  createFromScratchInfo: 'If you choose this option, you will have to create your campaign flow from scratch. Would you like to continue?',
  selectTemplateLater: 'You can also select a template later if you wish.',
  addedTemplateTitle: 'Active Sourcing Template successfully added',
  addedTemplateSubtitle: 'Your new template already contains a complete structure for personal outreach.',
  addedTemplateStep1: 'Review the structure',
  addedTemplateStep1Description: 'Have a look at all messages in the template. You can adapt the prompts to make them more personal.',
  addedTemplateStep2: 'Customize wait times and flow',
  addedTemplateStep2Description: 'You can edit the wait times between messages, add or remove messages, and include new functions to optimize the flow.',
  withdraw: 'Withdraw',
  noNodesMessage: 'No nodes can be added here...',
  congratulationsFirstName: 'Congratulations, {{userFirstName}}!',
  campaignCreated_LeadBooster: 'You have successfully created your lead outreach campaign <1>{{campaignName}}</1>.',
  campaignCreated_ActiveSourcing: 'You have successfully created your recruiting campaign <1>{{campaignName}}</1>.',
  boostConversionsInfo_LeadBooster: 'Now you can start boosting your conversions with highly matching leads, customized messaging and automated workflows.',
  boostConversionsInfo_ActiveSourcing: 'Now you can start boosting your conversions with highly matching candidates, customized messaging and automated workflows.',
  keepTrackOf: 'Keep track of...',
  campaignStatusInfo: 'Your campaign status and performance',
  requiredActionsInfo: 'Required actions (see campaign overview)',
  editCampaignInfo: 'Remember, you can edit your campaign whenever needed',
  continueToStatus: 'Continue to status',
  addContact: '+ Contact',
  languages: 'Languages',
  default: 'automatic',
  noGlobalBlacklist: 'You have not yet created any global blacklists. Create your first blacklist now by clicking on :',
  noBlacklistsItemsAdded: 'There are no companies or contacts currently in your global blacklist. To take advantage of the blacklist feature and optimize your outreach campaign targeting, click the <1>Add Contacts</1> or <3>Add Companies</3> button to start adding contacts to the desired blacklist category.',
  addCompanies: 'Unternehmen hinzufügen',
  editBlacklistName: 'Edit blacklist name',
  manageGlobalBlacklists: 'Manage Global Blacklists',
  blacklistOverview: 'Blacklist Overview',
  blacklistedContacts: 'Blacklisted Contacts',
  blacklistedBy: 'Blacklisted by',
  activeAccounts: 'Active accounts',
  remainingAccounts: 'Remaining accounts',
  linkedinAccountTodayUsage: 'Today: {{profiles}} profiles crawled',
  riskReductionLabel: 'Profile visits throttled until {{date}} ({{percent}}%)',
  riskReductionHint: 'LinkedIn temporarily throttled profile views for this account. To protect it, profile visits run at {{percent}}% of the limit until {{date}}. Connection requests and messages are not affected. The normal limit returns automatically afterwards.',
  noLicense: 'No license',
  popular: 'Popular',
  featureOverviewLicenseSummary: '{{active}} of {{total}} licenses active',
  featureOverviewLicenseLocked: '{{products}} not unlocked',
  assignLicense: 'Assign license',
  unassignLicense: 'Unassign license',
  assignLicenseTitle: 'Assign License to LinkedIn Account',
  assignLicenseDescription: 'Select a SAIA license to link to this LinkedIn account.',
  noUnlinkedLicenses: 'No unlinked SAIA licenses available.',
  assignLicenseStepSubtitle: 'License',
  assignLicenseStepTitle: 'Assign a License',
  assignLicenseStepDescription: 'Each LinkedIn account requires an active SAIA license. Please select an available license to assign to this account before starting the login process.',
  loadingLicenses: 'Loading available licenses...',
  availableLicenses: 'Available Licenses',
  noLicensesAvailable: 'No licenses available',
  noLicensesAvailableDescription: 'There are no unassigned SAIA licenses available. Please contact your administrator to add a new license, or unlink an existing license from another account.',
  licenseActive: 'Active',
  licenseInactive: 'Inactive',
  saiaRecruiting: 'SAIA Recruiting',
  saiaSales: 'SAIA Sales',
  billingType_yearly: 'Yearly',
  billingType_monthly: 'Monthly',
  billingType_trial: 'Trial',
  signInAnyway: 'Sign in anyway',
  accountStatus: 'Account\'s status',
  accountActive: 'Connected',
  accountActiveAndRunning: 'Connected & automation active',
  accountMaintenanceRequired: 'Login issue - action required',
  accountConnected: 'Connected',
  accountDisconnected: 'Disconnected',
  accountConnecting: 'Connecting...',
  linkedinNotConnectedBanner: 'LinkedIn not properly connected',
  linkedinBannerMore: '(+{{count}} more)',
  accountAttentionRequired: 'Action required',
  accountTemporarilyRestricted: 'Temporarily restricted',
  campaignLead: 'Campaigns lead',
  campaignSteps: 'Campaign steps',
  noStepsConfigured: 'No steps are configured for this campaign.',
  noContactsOnStep: 'No contacts are on this step right now.',
  noRepliesYet: 'No replies recorded yet.',
  lastModified: 'Last modified',
  sourced: 'Sourced',
  inContactBank_LeadBooster: 'in the Lead Bank',
  inContactBank_ActiveSourcing: 'in the Talent Pool',
  assessed: 'Assessed',
  qualified: 'Qualified',
  inShortList: 'in Shortlist',
  jobsDoneInCampaignPipeline: 'Jobs done in campaign pipeline',
  replies: 'Replies',
  excluded: 'Excluded',
  fromShortlist: 'from the Shortlist',
  contacted: 'Contacted',
  contacts_LeadBooster: 'Leads',
  contacts_ActiveSourcing: 'Candidates',
  toMessages: 'to messages',
  toApprove: 'Approve',
  campaignAlt: 'Campaign',
  campaignOperationalStatus: 'Campaign\'s Operational Status',
  approveMessages2: 'Approve\nmessages',
  allCampaigns: 'All Campaigns',
  campaignIsWorking: 'Agent is working',
  campaignTakesBreak: 'Agent takes a break',
  campaignPausedByAccountLock: '🔐 Paused – LinkedIn login required',
  campaignStatusPausedByAccountLockDescription: 'This campaign was automatically paused because the linked LinkedIn account requires manual re-authentication. It will resume automatically once the account is logged in again.',
  campaignNeedsHelp: 'Agent needs help',
  campaignDone: 'Agent is done',
  campaignArchived: 'Archived',
  campaignDraft: 'Draft',
  campaignTurnedOff: 'Agent turned off',
  campaignStatusRunningDescription: 'Your campaign is active and currently sending messages. This status also confirms that your campaign is operating within its specified working hours as defined in the campaign settings. Messages are being delivered based on the set schedule.',
  campaignStatusPausedDescription: 'Your campaign is temporarily not sending messages because it is either outside the set working hours or the LinkedIn account is currently logging in.',
  campaignStatusNeedsHelpDescription: 'Your campaign is not active and needs help. Possible reasons for this are:\n- An account-related issue, such as a parallel account login, reached LinkedIn limits, or a LinkedIn account not found.',
  campaignStatusFinishedDescription: 'Your campaign has been completed because it reached its defined goal or completion criteria — such as exhausting the target audience, finishing the message sequence, or achieving the campaign objectives.',
  campaignStatusArchivedDescription: 'Your campaign has been archived and no longer appears in the regular campaign overview.',
  campaignStatusStartedDescription: 'Your campaign has been started and is now active. It is currently sending messages during the working hours defined in the campaign settings.',
  campaignStatusActuallyPausedDescription: 'Your campaign is currently not sending messages because it is either outside of the defined working hours or your LinkedIn account is in the process of logging in.',
  campaignStatusSuspendedDescription: 'Your campaign has been manually paused. You can restart it at any time.',
  campaignStatusCreatedDescription: 'Your campaign has been created but has not yet been started or fully set up. You can start it at any time once the setup is complete.',
  campaignStatusAccountNotFoundDescription: 'Your LinkedIn account could not be found. Please select an existing account for this campaign. Deleted or unavailable accounts are automatically removed from the campaign.',
  campaignStatusLinkedinAccountProblemDescription: 'There is a problem with your LinkedIn account. Please check the details in the account management and resolve the issue before restarting the campaign.',
  campaignStatusCoPilotLicenseExpiredDescription: 'Your Co-Pilot license has expired. Please renew it to continue your campaign.',
  campaignStatusContactsAlmostExhaustedDescription: 'Your campaign is almost finished. Please check if you want to add more contacts.',
  explanation: 'Explanation',
  declineMessage: 'Decline message',
  approveMessage: 'Approve message',
  in: 'in',
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  overallStats: 'Overall',
  timeFrame: 'Time Frame',
  campaignsPerformanceOverview: 'Campaigns Performance Overview',
  campaignOperationalOverview: 'Campaign Operational Overview',
  campaignPerformance: 'Campaign Performance',
  connectionRequestsSent: 'Connection Requests Sent',
  newContacts: 'New Contacts',
  positiveReplies: 'Positive Replies',
  negativeReplies: 'Negative Replies',
  conversionRate: 'Conversion Rate',
  avgLeadToConversionTime: 'Average Lead to Conversion Time',
  todaysSuccessMetrics: '<0>Today\'s</0> Success metrics',
  thisWeeksSuccessMetrics: '<0>This week\'s</0> Success metrics',
  thisMonthsSuccessMetrics: '<0>This month\'s</0> Success metrics',
  noCampaignsForLinkedinAccount: 'No campaigns for this LinkedIn account',
  noCampaignStartedYet: 'Please select one or more running campaigns above and then click on the "Load statistics" button to load the campaign statistics.',
  loadStatistics: 'Load statistics',
  marketConversionAverage: 'Market conversion average: {{conversion}}%',
  marketBenchmark: 'Market benchmark: {{avgConversion}} weeks',
  timeFormatWeek: '{{count}} week',
  timeFormatWeeks: '{{count}} weeks',
  timeFormatDay: '{{count}} day',
  timeFormatDays: '{{count}} days',
  timeFormatHour: '{{count}} hour',
  timeFormatHours: '{{count}} hours',
  timeFormatMinute: '{{count}} minute',
  timeFormatMinutes: '{{count}} minutes',
  timeFormatNoTime: '0 hours',
  campaignsPerformanceDistribution: 'Campaigns Performance Distribution',
  personalityTypesDistribution: '<0>Personality types</0> Distribution',
  reasonsForPositiveReplies: 'Reasons for positive replies',
  reasonsForNegativeReplies: 'Reasons for negative replies',
  positiveReplyReasonsDistribution: '<0>Positive reply reasons</0> Distribution',
  negativeReplyReasonsDistribution: '<0>Negative reply reasons</0> Distribution',
  profileViews: 'Profile Views',
  campaignLeadsProfileViewed: 'campaign lead"s profile was viewed prior to respond',
  viewedProfile: 'Viewed profile',
  didNotViewProfile: 'Did not view profile',
  professionalProfileDistribution: '<0>Professional profile</0> Distribution',
  companySizes: 'Company sizes',
  jobTitleErrorText: 'Job title was not automatically generated. Please enter a job title here to continue.',
  jobAdErrorText: 'Job ad was not automatically generated. Please enter a job ad here to continue.',
  productProblemsErrorText: 'Problems were not automatically generated. Please enter problems here to continue.',
  productFeaturesErrorText: 'Features were not automatically generated. Please enter features here to continue.',
  productBenefitsErrorText: 'Benefits were not automatically generated. Please enter benefits here to continue.',
  productImpactErrorText: 'Impact was not automatically generated. Please enter an impact here to continue.',
  talentsFoundMatchingCriteria: '{{count}} talents found',
  qualifyLeadsQuestion: 'How would you like to qualify talents?',
  qualifyLeadsDescription: 'Rely on direct AI-based qualification using job posting information, or enhance the process with additional talent criteria you provide?',
  aiBasedQualification: 'AI-based qualification based on job posting details',
  additionalCriteriaQualification: 'Provide additional talent criteria to the AI',
  recommendedDailyMax: 'Recommended max. per day: {{max}}',
  approveMessageSuccessMessage: 'The message has been approved and will be sent shortly.',
  comparePerformanceAcrossCampaigns: 'Compare Performance Across Campaigns',
  campaignComparison: 'Campaign comparison',
  statisticsSelectedCampaign: '{{count}} campaign',
  statisticsSelectedCampaigns: '{{count}} campaigns',
  statisticsNoCampaignSelected: 'No campaign selected',
  statisticsEntireRuntime: 'Entire campaign runtime',
  yourPerformance: 'Your Performance',
  selectMetricToCompare: 'Select a metric to compare performance across time periods',
  messageHistory: 'Message History',
  compareConversionRates: 'Compare conversion rates & lead-to-conversion times across campaigns.',
  leadToConversionTime: 'Lead to conversion time',
  averageMarketsBenchmark: 'Average market\'s benchmark',
  weeks: 'weeks',
  performanceForAvgSuccessMetrics: '<0>Your Performance</0> for <2>Average Success Metrics</2>',
  leadBoosterIcpTitle: 'Ideal Customer Profile (ICP)',
  leadBoosterIcpDescription: 'Please provide key information about your Ideal Customer Profile.',
  leadBoosterIcpPlaceholder: 'e.g. SaaS company | 50–500 employees | DACH region | Scaling issues in sales',
  leadBoosterIcpExplanation: 'What is an ICP?\nAn Ideal Customer Profile (ICP) is a description of the type of customer who gets the most value from your product — and provides the most value in return.',
  deleteAssociatedContacts: 'Delete the associated contacts',
  activeCampaigns: 'Active Campaigns',
  notActiveCampaigns: 'Not Active Campaigns',
  archivedCampaigns: 'Archived Campaigns',
  messageSentSuccess: 'Your message has successfully been sent.',
  searchCampaign: 'Search campaign',
  campaignFilters: 'Campaign Filters',
  handleMultipleChats: 'Handle multiple chats:',
  manageMultipleChatsTooltip: 'Manage multiple campaign chats across all your LinkedIn accounts simultaneously from a single platform. Choose the LinkedIn accounts for which you want to handle messages.',
  selectAllAccounts: 'Select all accounts',
  unselectAllAccounts: 'Unselect all accounts',
  unreadMessages: 'unread messages',
  campaignMessagesPlaceholder: 'Campaign messages will appear when you select a chat within the corresponding campaign.',
  fromLinkedinAccountInCampaign: 'From <1>{{senderName}}</1> in <3>{{campaignName}}</3>',
  reviewProfile: 'Review\nProfile',
  sendMessagePlaceholder: 'Send your message here from {{name}}\'s LinkedIn profile...',
  markAsUnread: 'Mark as unread',
  showDetailedContactView: 'Show detailed view of contact',
  inboxCampaignsColumn: 'Campaigns',
  inboxContactsColumn: 'Contacts',
  inboxUnreadCount: '{{count}} unread',
  inboxSelectCampaignHint: 'Select a campaign on the left to see its contacts.',
  inboxContactDetailView: 'Detail view',
  addMoreCandidates: 'Add more candidates',
  addCandidatesToPreQualificationList: 'Add more candidates to your pre-qualification list.',
  linkedinLimitsExplanation: 'Due to LinkedIn"s limitations and security policies, we can analyze approximately 400 LinkedIn profiles per day across all campaigns, with a maximum of 150 profiles per hour. < 1 > While you can load more profiles, exceeding these limits increases the risk of your LinkedIn account being flagged or blocked.</1>',
  leadLoadingAdvice: 'If you plan to load more leads into your qualification list, make sure to stay within the hourly limits and total number of processed profiles across all campaigns to remain within safe usage limits.',
  setTotalContactsTitle: 'Set the total number of contacts for pre-selection.',
  setTotalContactsDescription: 'Set the total number of contacts for pre-selection. Profiles will be analyzed gradually to protect your LinkedIn account and avoid blocks.',
  setTotalContactsDescriptionShort: 'Profiles will be analyzed gradually to protect your LinkedIn account and avoid blocks.',
  startLoadingContacts: 'Start loading contacts',
  loadMore: '+ Load more',
  urlValid: 'URL valid',
  searchStatusOutOfHours: 'Out of hours',
  searchStatusQuotaExceeded: 'Daily limit reached',
  searchQuotaExceededTooltip:
    'The daily contact limit for this LinkedIn account has been reached. Please increase the limit in account management or wait until tomorrow.',
  searchQuotaExceededTooltipWithDate:
    'The daily contact limit for this LinkedIn account has been reached. Please increase the limit in account management or wait until {{retryAt}}.',
  searchQuotaExceededHint:
    'This search was stopped because the daily limit was reached. Please increase the limit or restart tomorrow.',
  searchWithheldProfiles: '{{count}} of them came from LinkedIn without a name and could not be added.',
  searchWithheldProfilesTooltip:
    'LinkedIn withholds the name of some profiles — typically because they are outside your network and your Recruiter licence only shows them anonymised. Without a name no contact can be created. These profiles are part of the total search results but are missing from the pre-selection list.',
  searchQuotaExceededModalTitle: 'Daily limit reached',
  searchQuotaExceededModalContent:
    'The search "{{searchName}}" was paused because the linked LinkedIn account reached its daily contact limit.',
  searchQuotaExceededModalContentWithDate:
    'The search "{{searchName}}" was paused because the linked LinkedIn account reached its daily contact limit. Next retry is possible after {{retryAt}}.',
  searchQuotaExceededModalContentActionHint:
    'You can increase the limit in LinkedIn account management or wait until tomorrow.',
  searchQuotaExceededOpenAccountManagement: 'Open account management',
  nextBatchTooltip: 'The next candidates will be loaded automatically as soon as your campaign is active and the daily limit for loading candidates has not yet been reached.',
  candidatesAdded: 'Candidates added to the pre-qualification list',
  manageContacts: 'Manage contacts',
  contactList: 'Contact list',
  finalCampaignList: 'Final campaign list',
  preQualifiedContactList: 'Prequalified talent list',
  assessedCandidatesNumber_LeadBooster: '<0>{{current}} / {{total}}</0> assessed leads',
  assessedCandidatesNumber_ActiveSourcing: '<0>{{current}} / {{total}}</0> assessed talents',
  loadedCandidatesNumber_LeadBooster: '<0>{{current}} / {{total}}</0> loaded leads',
  loadedCandidatesNumber_ActiveSourcing: '<0>{{current}} / {{total}}</0> loaded talents',
  campaignNoSearchesPlaceholder: 'No searches were added to the campaign yet.',
  qualifiedAs: 'Assessment',
  qualifiedAsTooltip: 'Talents are categorized as:\nA. Fit: The must-have criteria are met and the profile fits the position.\nB. Possible: Basically suitable for the position, but the must-haves are not (fully) shown.\nC. Not suitable: An exclusion criterion (no-go) applies or the profile clearly does not fit the position – not contacted.',
  aContactDescription: 'Fit: Must-haves met, fits the position.',
  bContactDescription: 'Possible: Basically suitable, must-haves not (fully) shown.',
  cContactDescription: 'Not suitable: a no-go applies or clearly does not fit the position.',
  notJudged: 'Not yet assessed',
  presentIn: 'Present in campaign(s)',
  aContactsCount: 'A: <1>{{count}}</1>',
  bContactsCount: 'B: <1>{{count}}</1>',
  cContactsCount: 'C: <1>{{count}}</1>',
  notJudgedContactsCount: 'Not assessed: <1>{{count}}</1>',
  contactedOn: 'contacted on',
  toContactList: 'Continue to Contact List',
  toCampaignFlow: 'Continue to Flow',
  toCampaignSettings: 'Continue to Settings',
  toCampaignTesting: 'Continue to Testing',
  toCampaignOverview: 'Continue to Overview',
  autoReplySettings: 'Settings for automatic responses',
  missingCampaignFlowNoNodes: 'Your campaign flow does not have any nodes.',
  messageNodeMissingType: 'One or more of your message nodes does not have a specific message type selected.',
  connectMessageTo: 'What should your message be connected to?',
  negativeExit: 'Condition\n<1>negative</1> exit',
  positiveExit: 'Condition\n<1>positive</1> exit',
  warningMissingMessageType: 'One or more messages do not have a selected type.',
  warningMissingConditionType: 'One or more conditions do not have a selected type.',
  emailAccessRevoked: 'The access to your email account has been revoked. Please go through the authorization process again to restore access.',
  twoFaNotEnabled: '2FA not enabled',
  syncErrorTwoFaNotEnabled: '2FA not activated',
  syncErrorTwoFaNotEnabledText1: 'You need to enable two-factor authentication (2FA) in your {{liProductType}} account to log in successfully.',
  syncErrorTwoFaNotEnabledText2: 'Please <1>enable 2FA in your {{liProductType}} account</1>.',
  syncErrorTwoFaNotEnabledText3: 'Once you have enabled 2FA, return here and click "Retry Synchronization" to continue.',
  activate: 'Activate',
  theRecruiterTwoFa: 'the Recruiter 2FA',
  theLinkedinTwoFa: 'the {{liProductType}} 2FA',
  twoFaNotEnabledWarning: 'Two-factor authentication (2FA) is not activated in your LinkedIn account.',
  contactsAlreadyInCampaignExplanation: 'These contacts are already listed in another campaign"s contact list, meaning they have been or will be engaged as part of that campaign"s outreach funnel.',
  searchLoading: 'When and how are contacts loaded from searches?',
  noteAiDoesWork: 'Sit back and let the AI do the work',
  contactsLoadAutomatically: 'Contacts will load automatically over time. The "+ Load more" button is optional.',
  searchAutomaticLoadingExplanation: '<0>Automatic loading:</0> Contacts will add up as needed for the campaign. This process happens in the background once a campaign is active and the daily limit for loading contacts has not yet been reached.',
  searchSpecifiedLoadingExplanation: '<0>Specific number set:</0> We will load contacts from the search until the specified number is reached or the search is finished. (Numbers can differ depending on contacts available from the crawling LinkedIn account)',
  optimizeAndAddSearch: 'Optimize & add search',
  listPreview: 'List preview',
  reviewAndOptimizeSearch: 'Review and optimize your candidate LinkedIn search',
  refineSearchStepsTitle: 'Start refining your candidate search with ease by following these simple steps:',
  refineSearchStep1: '1. Click on the link of the current search result URL to open LinkedIn and review your candidate list.',
  refineSearchStep2: '2. Adjust the search on LinkedIn until it meets your specific criteria.',
  refineSearchStep3: '3. Once satisfied, copy the LinkedIn search result URL and paste it in the bottom section.',
  refineSearchStep4: '4. Finally, click "Save" to complete your refined search.',
  currentSearchUrl: 'Current search result URL',
  reviewCurrentSearch: 'Review your current search results and adjust via LinkedIn if necessary.',
  optimizedSearchUrl: 'Optimized search result URL',
  addMoreSearchesInstruction: 'You have successfully added the search <1>{{searchName}}</1>.\nTo add more searches, click the "Add more searches" button. Once you"re ready, click "Review leads" to proceed.',
  addMoreSearches: 'Add more searches',
  reviewContacts: 'Review contacts',
  added: 'added',
  contactLoadingInProgress: 'Loading contacts from your search',
  contactLoadingMayTakeAMoment: 'The contacts found in your search are being added to your candidate list. This may take a moment.',
  restructure: 'Restructure',
  howItWorks: 'This is how it works...',
  invalidLinkedinUrl: 'Please enter a valid LinkedIn URL',
  copyLinkToPasswordManager: 'Copy link to password manager',
  noPhone: 'No phone number',
  personalityProfile: 'Personality Profile',
  callTranscript: 'Call Transcript',
  callTranscriptAndPersonalityProfile: 'Call Transcript & Personality Profile',
  meetingBooked: 'Meeting Booked',
  noMeetingBooked: 'No Meeting Booked',
  unsuccessful: 'Unsuccessful',
  missingParameters: 'Missing required parameters. Cannot submit outcome.',
  processingChoice: 'Processing your choice...',
  failedToRecord: 'Failed to record your response. Please try again.',
  thankYouResponse: 'Thank you! Your response ({{chosenOutcome}}) has been recorded.',
  missingParametersUrl: 'Missing required parameters in URL.',
  failedToLoadTranscript: 'Failed to load transcript. Please try again later.',
  noTranscriptFound: 'No transcript found.',
  failedToLoadContactDetails: 'Failed to load contact details. Please try again later.',
  noAssessmentAvailable: 'No assessment available.',
  contactBlacklistFileStructureDescription: 'For our blacklist to function properly, please include the <1>LinkedIn URL</1> of each individual contact"s profile in your file.This allows us to accurately identify them.All other fields are optional.',
  companyBlacklistFileStructureDescription: 'For our blacklist to work effectively, please make sure your file includes the <1>name of each company</1> you want to blacklist. All other fields are optional.',
  updating: 'updating',
  paymentDate: 'Payment date',
  loadingTransactions: 'loading transactions',
  viewInvoice: 'View invoice',
  usage: 'Usage',
  activateSetting: 'Activate the setting',
  autoReplyQuestion: 'Shall we automatically reply to your received messages?',
  goalOfCommunication: 'Goal of Communication',
  goalOfCommunicationDescription: 'Define the goal of communication the reply messages should aim for.',
  goalPlaceholder: 'e.g. Book a call, Provide info, etc.',
  cases: 'Cases',
  casesDescription: 'Define the cases for which the auto reply function should apply.',
  caseNumber: 'Case #{{number}}',
  caseDescription: 'Case Description',
  caseDescriptionPlaceholder: 'What do we detect? e.g. Price objections',
  casePrompt: 'Case Prompt',
  casePromptPlaceholder: 'How to respond? e.g. Offer discount or clarify pricing',
  addCase: 'Add Case',
  saveAutoReplySettings: 'Save settings',
  seeAll: 'See all',
  seeLess: 'See less',
  insertPlaceholders: 'Insert placeholders',
  messageContext: 'Message context',
  approveMessagesNote: 'Note: When this setting is activated, messages will not be sent immediately by your campaign. Check the campaign tab regularly to ensure that all created messages are sent. Also, keep in mind that messages are only generated during the set campaign duration – plan this carefully.',
  campaignStartCountdown: 'Your campaign will start working in:',
  campaignEstimatedStart: 'Estimated time for your campaign to start generating messages:',
  startCampaignSkipWorkTimeCheck: 'Click here to immediately generate messages',
  campaignWorking: 'The campaign is currently working.',
  campaignLinkedInWarning: '<0>Remember!</0> To immediately generate messages, avoid using LinkedIn Recruiter. A double login may trigger LinkedIn"s security measures and block your account.',
  campaignStartingSoon: '<1>Stay alert!</1> In the next few minutes, we"ll start generating messages.',
  tooltipApproveMessages: 'You will find all your to be approved messages here.',
  startGeneratingMessagesNow: 'Generate messages now',
  enterEmailForTranscripts: 'Enter the email where transcripts should be sent',
  taskManager: 'Manage tasks',
  fixAccounts: 'Fix account problems',
  replyMessages: 'Reply to messages',
  handleMultipleAccounts: 'Handle multiple accounts:',
  manageMultipleAccountsTooltip: 'Manage campaign tasks for all your LinkedIn accounts from a single platform. Select the LinkedIn accounts you want to manage tasks for.',
  accountsToFix: 'Accounts to fix',
  tasksTitle: 'Tasks',
  tasksSubtitle: '{{openTasks}} open tasks across {{accountCount}} LinkedIn accounts',
  accountStatusLabel: 'Account status',
  accountsToFixHint: 'Blocking running campaigns',
  messagesToApproveHint: '{{messageCount}} messages waiting for approval',
  replyMessagesHint: 'Replies from the inbox',
  connectAccountTask: 'Connect account',
  reviewTask: 'Review',
  replyTask: 'Reply',
  task: 'Task',
  userAccount: 'User Account',
  messagesToApproveCount: '# Messages to approve',
  messagesToReplyCount: '# Messages to reply to',
  deleteContactPermanently: 'Delete contact permanently',
  confirmDeleteContact: 'Should the contact <1>{{contactName}}</1> really be permanently removed from the campaign?',
  deletedContactsInfo: 'Permanently deleted contacts will also not be re-added to the campaign through new searches.',
  deleteMultipleContactsPermanently: 'Delete multiple contacts permanently',
  confirmDeleteMultipleContacts: 'Should the <1>{{contactCount}}</1> contacts really be permanently removed from the campaign?',
  pwmLinkCopiedMessage: 'Link copied to clipboard. Open a new tab and paste the link into your browser"s URL bar.',
  updateAvailable: 'A new version is available. Please reload the page.',
  reload: 'Reload page',
  deleteFunnelContact: 'Delete contact',
  changeAiJudgement: 'Change AI judgement',
  changeAiJudgementFor: 'Change AI judgement for <1>{{contactName}}</1>',
  isReviewed: 'Reviewed',
  flowIncompleteDialogTitle: 'Flow incomplete',
  flowIncompleteDialogContent: 'The flow is incomplete. Please make sure that the flow is complete before testing or starting the campaign.',
  exportContact: 'Export Contact Profile',
  generateCV: 'Generate CV',
  selectLanguage: 'Select Language',
  additionalInformation: 'Additional Information',
  additionalInfoPlaceholder: 'Add any specific information you would like to include in the CV (e.g., project details, specific achievements, etc.)',
  noProfileIdError: 'No profile ID found for this contact.',
  cvGenerationError: 'An error occurred while generating the CV. Please try again.',
  positiveRepliesCount: 'Positive replies ({{count}})',
  negativeRepliesCount: 'Negative replies ({{count}})',
  mustHaveCriteria: 'Must haves (Required criteria)',
  niceToHaveCriteria: 'Nice to haves (Preferred, but not required)',
  excludeCriteria: 'Exclude if (Disqualifiers)',
  mustHaveCriteriaPlaceholder: 'Must meet all of these criteria to be qualified',
  niceToHaveCriteriaPlaceholder: 'These traits are desired, but not required',
  excludeCriteriaPlaceholder: 'Exclude if meet any of these criteria',
  aiBriefingCompanyChallengesLabel: 'Company Challenges',
  aiBriefingCompanyCharacteristicsLabel: 'Company Characteristics',
  aiBriefingCultureValuesLabel: 'Organizational and working culture values',
  aiBriefingAdditionalInfoLabel: 'Additional candidate requirements',
  aiBriefingCompanyChallengesDescription: 'Describe specific organizational challenges or contexts, e.g., high-volume data environments or managing large-scale automation projects in growth-driven companies.',
  aiBriefingCompanyCharacteristicsDescription: 'Describe company size/type, e.g., large companies with over 500 employees or fast-paced startups scaling operations.',
  aiBriefingCultureValuesDescription: 'Describe cultural fit/values, e.g., working in agile, collaborative teams that emphasize adaptability and data-driven decision-making.',
  aiBriefingAdditionalInfoDescription: 'Describe any additional requirements or characteristics your ideal candidates should possess if they have not been covered in the previous fields or search criteria.',
  includeSignatureInPreview: 'Include signature',
  // Create Campaign Success Dialog translations
  setupNewCampaign_ActiveSourcing: 'Setup New Active Sourcing Campaign',
  nextStepsInCampaignCreation_ActiveSourcing: 'Next steps in your active sourcing campaign',
  briefTheAIOnOutreachRequirements_ActiveSourcing: 'Brief the AI on your active sourcing campaign requirements',
  aiOutreachDescription_ActiveSourcing: 'To empower the AI to effectively source, qualify, and engage top candidates, provide a thorough and high-quality job description or enter the job offer landing page URL.',
  sourcePreQualifiedCandidates_ActiveSourcing: 'Source pre-qualified candidates from LinkedIn searches',
  addContactsToTalentPool_ActiveSourcing: 'Add potential candidates to your talent pool list to target in your campaign. You can either upload a list of existing contacts or use our search filters to discover new ones.',
  qualifyTalentsAndCreateShortlist_ActiveSourcing: 'Qualify candidates and create a recruitment shortlist',
  selectTopTalents_ActiveSourcing: 'Select the top talent profiles you would like to engage with for this position.',
  testAndStartYourCampaign_ActiveSourcing: 'Test and start your active sourcing campaign',
  testCampaignSetup_ActiveSourcing: 'Test your campaign to ensure everything is set up correctly for candidate outreach. Once tested, start the campaign and monitor the recruitment process.',
  ok_ActiveSourcing: 'OK',

  // File Upload Dialog translations
  labelTheFieldsOfYourContactList_ActiveSourcing: 'Label the fields of your candidate list',
  thisIsHowItGoes_ActiveSourcing: 'Mapping Candidate Information',
  mapFileValuesToContactProperties_ActiveSourcing: 'Map the values from your file to the corresponding candidate properties. We need at least the candidate name and LinkedIn URL or the name and the company to add a potential hire to the campaign.',
  fileHasTableHeading_ActiveSourcing: 'File has table heading',
  columnContentPreview_ActiveSourcing: 'Candidate Data Preview',
  columnLabel_ActiveSourcing: 'Field Label',
  continue_ActiveSourcing: 'Continue',
  doNotImport_ActiveSourcing: 'Do not import',
  firstName_ActiveSourcing: 'First Name',
  lastName_ActiveSourcing: 'Last Name',
  linkedinUrl_ActiveSourcing: 'LinkedIn URL',
  company_ActiveSourcing: 'Company',
  email_ActiveSourcing: 'Email',
  position_ActiveSourcing: 'Position',
  customField_ActiveSourcing: 'Custom Field',
  phoneNumber_ActiveSourcing: 'Phone Number',
  noNodesMessage_ActiveSourcing: 'No nodes available for this campaign.',
  // Brief AI translations for Active Sourcing
  campaignBriefingExplanation_ActiveSourcing: 'Brief the AI on your active sourcing campaign requirements by providing job details or a URL. This helps create targeted messaging for ideal candidates.',
  equipAiDescription_ActiveSourcing: 'Provide the AI with the job description and relevant details about the position you\'re recruiting for. This information will help the AI create personalized outreach messages for potential candidates.',
  // AI Search Briefing translations for Active Sourcing
  topCandidates_ActiveSourcing: 'A. Top Candidates',
  strongContenders_ActiveSourcing: 'B. Strong Contenders',
  backupCandidatePool_ActiveSourcing: 'C. Backup Candidates',
  qualifyLeadsQuestion_ActiveSourcing: 'How would you like to qualify your candidates?',
  qualifyLeadsDescription_ActiveSourcing: 'Select how you want to evaluate and qualify the candidates in your talent pool. You can use AI-based qualification or define additional criteria.',
  aiBasedQualification_ActiveSourcing: 'AI-based qualification',
  additionalCriteriaQualification_ActiveSourcing: 'Define additional qualification criteria',

  // Found LinkedIn Search translations for Active Sourcing
  talentsFoundMatchingCriteria_ActiveSourcing: 'We found {{count}} candidates matching your criteria',

  // PAI Contact Search translations for Active Sourcing
  sourcingPotentialTalentOnLinkedIn_ActiveSourcing: 'Sourcing potential candidates on LinkedIn...',
  identifyingQualifiedTalentSearches_ActiveSourcing: 'Identifying qualified candidate searches...',

  // Added Template Success Dialog translations for Active Sourcing
  addedTemplateStep1_ActiveSourcing: 'Review and customize the campaign messages',
  addedTemplateStep1Description_ActiveSourcing: 'The template has been added to your campaign flow. You can now review and customize the candidate outreach messages to best suit your needs.',
  addedTemplateStep2_ActiveSourcing: 'Test and launch your active sourcing campaign',
  addedTemplateStep2Description_ActiveSourcing: 'After customizing your messages, you can test your campaign to ensure it\'s set up correctly before launching it to start engaging with candidates.',
  // Create Campaign Success Dialog translations
  setupNewCampaign_LeadBooster: 'Setup New Lead Generation Campaign',
  nextStepsInCampaignCreation_LeadBooster: 'Next steps in your lead generation campaign',
  briefTheAIOnOutreachRequirements_LeadBooster: 'Brief the AI on the requirements of your lead generation campaign.',
  aiOutreachDescription_LeadBooster: 'To enable the AI to effectively identify, qualify, and engage with potential leads, please provide a detailed campaign description or a link to your landing page.',
  sourcePreQualifiedCandidates_LeadBooster: 'Conduct LinkedIn searches to generate pre-qualified leads.',
  addContactsToTalentPool_LeadBooster: 'Add contacts to your lead list that you want to approach in your campaign. You can either upload a list of existing contacts or use our search filters to discover new potential leads.',
  qualifyTalentsAndCreateShortlist_LeadBooster: 'Qualify leads and create a compelling shortlist for your campaign.',
  selectTopTalents_LeadBooster: 'Select the most promising leads you want to work with.',
  testAndStartYourCampaign_LeadBooster: 'Test and launch your lead generation campaign.',
  testCampaignSetup_LeadBooster: 'Test your campaign to ensure everything is setup correctly. Once tested, start the campaign and monitor its process.',
  ok_LeadBooster: 'OK',

  // File Upload Dialog translations
  labelTheFieldsOfYourContactList_LeadBooster: 'Label the fields of your lead list',
  thisIsHowItGoes_LeadBooster: 'Mapping Lead Information',
  mapFileValuesToContactProperties_LeadBooster: 'Map the values from your file to the corresponding lead properties. We need at least the lead name and LinkedIn URL or the name and the company to add a potential prospect to the campaign.',
  fileHasTableHeading_LeadBooster: 'File has table heading',
  columnContentPreview_LeadBooster: 'Lead Data Preview',
  columnLabel_LeadBooster: 'Field Label',
  continue_LeadBooster: 'Continue',
  doNotImport_LeadBooster: 'Do not import',
  firstName_LeadBooster: 'First Name',
  lastName_LeadBooster: 'Last Name',
  linkedinUrl_LeadBooster: 'LinkedIn URL',
  company_LeadBooster: 'Company',
  email_LeadBooster: 'Email',
  position_LeadBooster: 'Position',
  customField_LeadBooster: 'Custom Field',
  phoneNumber_LeadBooster: 'Phone Number',

  // Brief AI translations
  campaignBriefingExplanation_LeadBooster: 'Brief the AI on your lead generation campaign requirements by providing details about your target audience or a URL. This helps create targeted messaging for potential leads.',
  equipAiDescription_LeadBooster: 'Provide the AI with your product or service details and target customer information. This will help the AI create personalized outreach messages for potential leads.',

  // AI Search Briefing translations
  topCandidates_LeadBooster: 'A. Top Leads',
  strongContenders_LeadBooster: 'B. Strong Leads',
  backupCandidatePool_LeadBooster: 'C. Backup Leads',
  qualifyLeadsQuestion_LeadBooster: 'How would you like to qualify your leads?',
  qualifyLeadsDescription_LeadBooster: 'Select how you want to evaluate and qualify the leads in your prospect pool. You can use AI-based qualification or define additional criteria.',
  aiBasedQualification_LeadBooster: 'AI-based qualification',
  additionalCriteriaQualification_LeadBooster: 'Define additional qualification criteria',

  // Found LinkedIn Search translations
  talentsFoundMatchingCriteria_LeadBooster: 'We found {{count}} leads matching your criteria',

  // PAI Contact Search translations
  sourcingPotentialTalentOnLinkedIn_LeadBooster: 'Sourcing potential leads on LinkedIn...',
  identifyingQualifiedTalentSearches_LeadBooster: 'Identifying qualified lead searches...',

  // Added Template Success Dialog translations
  addedTemplateStep1_LeadBooster: 'Review and customize the campaign messages',
  addedTemplateStep1Description_LeadBooster: 'The template has been added to your campaign flow. You can now review and customize the lead outreach messages to best suit your needs.',
  addedTemplateStep2_LeadBooster: 'Test and launch your lead generation campaign',
  addedTemplateStep2Description_LeadBooster: 'After customizing your messages, you can test your campaign to ensure it\'s set up correctly before launching it to start engaging with potential leads.',
  // LeadBooster Translations
  // LeadBooster Translations
  manageContactsTitle_LeadBooster: 'Manage Your Leads',
  qualifyCandidatesIntro_LeadBooster: 'Our AI will help you qualify leads based on your ideal customer profile. This ensures you focus your outreach on the most promising leads.',
  qualifyCandidatesStep1Title_LeadBooster: 'Step 1: Describe Your Ideal Customer',
  qualifyCandidatesStep1Description_LeadBooster: 'Tell us who you\'re looking for. The more details you provide, the better our AI can match leads to your requirements.',
  qualifyCandidatesStep2Title_LeadBooster: 'Step 2: AI Analyzes Your Leads',
  qualifyCandidatesStep2Description_LeadBooster: 'Our AI will scan through your lead list and evaluate each lead based on your criteria.',
  qualifyCandidatesStep3Title_LeadBooster: 'Step 3: Get Qualified Leads',
  qualifyCandidatesStep3Description_LeadBooster: 'Receive a list of leads categorized by quality so you can prioritize your outreach efforts.',
  qualifyContactsTitle_LeadBooster: 'QUALIFY YOUR LEADS',
  assessContactsTitle_LeadBooster: 'LEAD ASSESSMENT CRITERIA',
  continueWithoutQualifying_LeadBooster: 'Continue without qualifying leads',
  next_LeadBooster: 'Next',
  back_LeadBooster: 'Back',
  startQualifying_LeadBooster: 'Start Qualifying Leads',

  // ActiveSourcing Translations
  manageContactsTitle_ActiveSourcing: 'Manage Your Candidates',
  qualifyCandidatesIntro_ActiveSourcing: 'Our AI will help you qualify candidates based on your job requirements. This ensures you focus your outreach on the most promising talent.',
  qualifyCandidatesStep1Title_ActiveSourcing: 'Step 1: Describe Your Ideal Candidate',
  qualifyCandidatesStep1Description_ActiveSourcing: 'Tell us who you\'re looking for. The more details you provide, the better our AI can match candidates to your requirements.',
  qualifyCandidatesStep2Title_ActiveSourcing: 'Step 2: AI Analyzes Your Candidates',
  qualifyCandidatesStep2Description_ActiveSourcing: 'Our AI will scan through your candidate list and evaluate each candidate based on your criteria.',
  qualifyCandidatesStep3Title_ActiveSourcing: 'Step 3: Get Qualified Candidates',
  qualifyCandidatesStep3Description_ActiveSourcing: 'Receive a list of candidates categorized by quality so you can prioritize your outreach efforts.',
  qualifyContactsTitle_ActiveSourcing: 'QUALIFY YOUR CANDIDATES',
  assessContactsTitle_ActiveSourcing: 'CANDIDATE ASSESSMENT CRITERIA',
  continueWithoutQualifying_ActiveSourcing: 'Continue without qualifying candidates',
  next_ActiveSourcing: 'Next',
  back_ActiveSourcing: 'Back',
  startQualifying_ActiveSourcing: 'Start Qualifying Candidates',

  // LeadBooster Translations
  aiLeadAssessmentTitle_LeadBooster: 'Lead Assessment',
  aiLeadAssessmentSubtitle_LeadBooster: 'Review how your leads have been qualified',
  topCandidatesDescription_LeadBooster: 'These leads closely match your ideal customer profile and show high potential for conversion.',
  strongContendersDescription_LeadBooster: 'These leads match several key criteria from your requirements and could be valuable prospects.',
  notIdealCandidates_LeadBooster: 'Less Qualified Leads',
  notIdealCandidatesDescription_LeadBooster: 'These leads match fewer of your criteria but might still be worth considering in your outreach.',

  // ActiveSourcing Translations
  aiLeadAssessmentTitle_ActiveSourcing: 'Candidate Assessment',
  aiLeadAssessmentSubtitle_ActiveSourcing: 'Review how your candidates have been qualified',
  topCandidatesDescription_ActiveSourcing: 'These candidates closely match your job requirements and show high potential as qualified applicants.',
  strongContendersDescription_ActiveSourcing: 'These candidates match several key criteria from your requirements and could be valuable additions to your talent pool.',
  notIdealCandidates_ActiveSourcing: 'Less Qualified Candidates',
  notIdealCandidatesDescription_ActiveSourcing: 'These candidates match fewer of your criteria but might still be worth considering for your position.',

  // LeadBooster Translations
  updateAiBriefingTitle_LeadBooster: 'Update Your Lead Generation Brief',
  updateAiBriefingText_LeadBooster: 'Refine the information about your product or service to help our AI generate more targeted outreach messages.',
  jobOfferPlaceholder_LeadBooster: 'Job description...',
  productProblemsPlaceholder_LeadBooster: 'What customer problems does your product solve?',
  productFeaturesPlaceholder_LeadBooster: 'What are the key features of your product?',
  productBenefitsPlaceholder_LeadBooster: 'What benefits does your product provide to customers?',
  productImpactPlaceholder_LeadBooster: 'What impact does your product have on customers\' business?',
  updateFieldNote_LeadBooster: 'Update any field to regenerate your messaging sequence.',

  // ActiveSourcing Translations
  updateAiBriefingTitle_ActiveSourcing: 'Update Your Recruitment Brief',
  updateAiBriefingText_ActiveSourcing: 'Refine the information about your job position to help our AI generate more effective outreach messages to candidates.',
  jobOfferPlaceholder_ActiveSourcing: 'Job description...',
  productProblemsPlaceholder_ActiveSourcing: 'What challenges is your company trying to address with this role?',
  productFeaturesPlaceholder_ActiveSourcing: 'What are the key responsibilities of this position?',
  productBenefitsPlaceholder_ActiveSourcing: 'What benefits does your company offer to employees?',
  productImpactPlaceholder_ActiveSourcing: 'What impact will this role have on your company\'s goals?',
  updateFieldNote_ActiveSourcing: 'Update any field to regenerate your messaging sequence.',

  // LeadBooster Translations
  noMessageNodes_LeadBooster: 'No message nodes available. Create a sequence or update your campaign brief to generate message nodes.',
  usePromptGenerator_LeadBooster: 'Your Lead Generation Messages',
  message_LeadBooster: 'Message',

  // ActiveSourcing Translations
  noMessageNodes_ActiveSourcing: 'No message nodes available. Create a sequence or update your recruitment brief to generate message nodes.',
  usePromptGenerator_ActiveSourcing: 'Your Candidate Outreach Messages',
  message_ActiveSourcing: 'Message',

  // LeadBooster Translations
  campaignContactListTitle_LeadBooster: 'Your Lead Source',
  campaignContactListExplanation_LeadBooster: 'Choose how you want to source leads for your campaign. You can use our AI search, paste LinkedIn URLs, or upload an existing contact list.',
  chooseContactSourcingMethod_LeadBooster: 'How would you like to source your leads?',
  paiSearch_LeadBooster: 'AI Search',
  ownLinkedinSearch_LeadBooster: 'LinkedIn URL',
  uploadContactList_LeadBooster: 'Upload Contact List',

  // ActiveSourcing Translations
  campaignContactListTitle_ActiveSourcing: 'Your Candidate Source',
  campaignContactListExplanation_ActiveSourcing: 'Choose how you want to source candidates for your campaign. You can use our AI search, paste LinkedIn URLs, or upload an existing candidate list.',
  chooseContactSourcingMethod_ActiveSourcing: 'How would you like to source your candidates?',
  paiSearch_ActiveSourcing: 'AI Search',
  ownLinkedinSearch_ActiveSourcing: 'LinkedIn URL',
  uploadContactList_ActiveSourcing: 'Upload Candidate List',

  // LeadBooster Translations
  provideKeyCharacteristicsTitle_LeadBooster: 'Provide Key Characteristics of Your Ideal Customer',
  provideKeyCharacteristicsDescription_LeadBooster: 'Help our AI understand what makes a high-quality lead for your business.',
  updateCriteriaInfo_LeadBooster: 'You can update your lead qualification criteria at any time. Our AI will re-evaluate your leads based on the new criteria.',
  contactsToAddTitle_LeadBooster: 'Which leads should be part of your outreach campaign?',
  contactsToAddDescription_LeadBooster: 'Select which lead qualification categories you want to include in your campaign.',
  reviewContactsTitle_LeadBooster: 'Review Existing Leads',
  reviewContactsDescription_LeadBooster: 'Choose whether to re-evaluate leads that have already been qualified.',
  redoQualification_LeadBooster: 'Re-evaluate existing leads with new criteria',
  updateQualificationCriteria_LeadBooster: 'Update Qualification Criteria',

  // ActiveSourcing Translations
  provideKeyCharacteristicsTitle_ActiveSourcing: 'Provide Key Characteristics of Your Ideal Candidate',
  provideKeyCharacteristicsDescription_ActiveSourcing: 'Help our AI understand what makes a high-quality candidate for your position.',
  updateCriteriaInfo_ActiveSourcing: 'You can update your candidate qualification criteria at any time. Our AI will re-evaluate your candidates based on the new criteria.',
  contactsToAddTitle_ActiveSourcing: 'Which candidates should be part of your outreach campaign?',
  contactsToAddDescription_ActiveSourcing: 'Select which candidate qualification categories you want to include in your campaign.',
  reviewContactsTitle_ActiveSourcing: 'Review Existing Candidates',
  reviewContactsDescription_ActiveSourcing: 'Choose whether to re-evaluate candidates that have already been qualified.',
  redoQualification_ActiveSourcing: 'Re-evaluate existing candidates with new criteria',
  updateQualificationCriteria_ActiveSourcing: 'Update Qualification Criteria',
  // LeadBooster Translations
  talentsAddedToCampaign_LeadBooster: 'Leads Added to Shortlist',
  qualificationInProgress_LeadBooster: 'Lead Qualification in Progress',
  aiLeadAssessment_LeadBooster: 'AI Lead Assessment',
  search_LeadBooster: 'Search leads...',
  contactLoadingInProgress_LeadBooster: 'Loading Leads...',
  contactLoadingMayTakeAMoment_LeadBooster: 'This may take a moment',
  name_LeadBooster: 'Lead Name',
  qualifiedAs_LeadBooster: 'Qualified As',
  qualifiedAsTooltip_LeadBooster: 'AI classification of leads based on your qualification criteria',
  reason_LeadBooster: 'Qualification Reason',
  jobTitle_LeadBooster: 'Job Title',
  location_LeadBooster: 'Location',
  linkedInURL_LeadBooster: 'LinkedIn URL',
  addContact_LeadBooster: 'Add Lead Manually',
  nextBatchTooltip_LeadBooster: 'Load more leads from your searches to add to your campaign',
  loadMore_LeadBooster: 'Load More',
  aiJudgementExplanation_LeadBooster: 'Qualification Explanation',
  personalityType_LeadBooster: 'Personality Type',
  shortSummary_LeadBooster: 'Summary',
  linkedInContact_LeadBooster: 'LinkedIn Lead',
  open_LeadBooster: 'Open',
  downloadData_LeadBooster: 'Download Leads',
  addNewColumn_LeadBooster: 'Add New Column',

  // ActiveSourcing Translations
  talentsAddedToCampaign_ActiveSourcing: 'Talents Added to Shortlist',
  qualificationInProgress_ActiveSourcing: 'Candidate Qualification in Progress',
  aiLeadAssessment_ActiveSourcing: 'AI Candidate Assessment',
  search_ActiveSourcing: 'Search candidates...',
  contactLoadingInProgress_ActiveSourcing: 'Loading Candidates...',
  contactLoadingMayTakeAMoment_ActiveSourcing: 'This may take a moment',
  name_ActiveSourcing: 'Candidate Name',
  qualifiedAs_ActiveSourcing: 'Qualified As',
  qualifiedAsTooltip_ActiveSourcing: 'AI classification of candidates based on your qualification criteria',
  reason_ActiveSourcing: 'Qualification Reason',
  jobTitle_ActiveSourcing: 'Current Job Title',
  location_ActiveSourcing: 'Location',
  linkedInURL_ActiveSourcing: 'LinkedIn URL',
  addContact_ActiveSourcing: 'Add Candidate Manually',
  nextBatchTooltip_ActiveSourcing: 'Load more candidates from your searches to add to your campaign',
  loadMore_ActiveSourcing: 'Load More',
  aiJudgementExplanation_ActiveSourcing: 'Qualification Explanation',
  personalityType_ActiveSourcing: 'Personality Type',
  shortSummary_ActiveSourcing: 'Summary',
  linkedInContact_ActiveSourcing: 'LinkedIn Candidate',
  open_ActiveSourcing: 'Open',
  downloadData_ActiveSourcing: 'Download Candidates',
  addNewColumn_ActiveSourcing: 'Add New Column',
  // Campaign Structure
  campaignBriefingDescription_LeadBooster: 'Here you can create and configure your sales campaign strategy.',
  campaignBriefingDescription_ActiveSourcing: 'Here you can create and configure your recruiting campaign strategy.',
  campaignContactListDescription_LeadBooster: 'Define the target audience for your sales campaign.',
  campaignContactListDescription_ActiveSourcing: 'Define the target candidates for your recruiting campaign.',
  campaignSettingsDescription_LeadBooster: 'Account, approval and re-contacting — working hours are set on the LinkedIn account.',
  campaignSettingsDescription_ActiveSourcing: 'Account, approval and re-contacting — working hours are set on the LinkedIn account.',
  campaignOverviewDescription_LeadBooster: 'Review and launch your sales campaign.',
  campaignOverviewDescription_ActiveSourcing: 'Review and launch your recruiting campaign.',

  // Main Steps
  sourcePreQualifiedContacts_LeadBooster: 'Source Pre-Qualified Leads',
  sourcePreQualifiedContacts_ActiveSourcing: 'Source Pre-Qualified Candidates',
  manageSearches_LeadBooster: 'Manage Lead Searches',
  manageSearches_ActiveSourcing: 'Manage Candidate Searches',
  manageContacts_LeadBooster: 'Manage Leads',
  manageContacts_ActiveSourcing: 'Manage Candidates',

  // Contact Management Tabs
  preQualifiedContactList_LeadBooster: 'Lead Bank',
  preQualifiedContactList_ActiveSourcing: 'Talent Pool',
  manageDuplicateContacts_LeadBooster: 'Sourced in prior campaigns',
  manageDuplicateContacts_ActiveSourcing: 'Sourced in prior campaigns',
  manageBlacklists_LeadBooster: 'Manage Blacklists',
  manageBlacklists_ActiveSourcing: 'Manage Blacklists',
  finalCampaignList_LeadBooster: 'Final campaign shortlist',
  finalCampaignList_ActiveSourcing: 'Final campaign shortlist',

  // Setting Fields
  searchObjective_LeadBooster: 'Sales Search Objective',
  searchObjective_ActiveSourcing: 'Recruiting Search Objective',
  approveMessages_LeadBooster: 'Approve Sales Messages',
  approveMessages_ActiveSourcing: 'Approve Recruiting Messages',
  linkedinAccount_LeadBooster: 'LinkedIn Account for Sales',
  linkedinAccount_ActiveSourcing: 'LinkedIn Account for Recruiting',
  timeSettings_LeadBooster: 'Sales Outreach Time Settings',
  timeSettings_ActiveSourcing: 'Recruiting Outreach Time Settings',
  dailyMessageLimits_LeadBooster: 'Daily Sales Message Limits',
  dailyMessageLimits_ActiveSourcing: 'Daily Recruiting Message Limits',
  // Candidate/Lead Status
  topCandidate_LeadBooster: 'Top Lead',
  topCandidate_ActiveSourcing: 'Top Candidate',
  strongContender_LeadBooster: 'Strong Lead',
  strongContender_ActiveSourcing: 'Strong Candidate',
  backupCandidate_LeadBooster: 'Backup Lead',
  backupCandidate_ActiveSourcing: 'Backup Candidate',

  // Drawer UI
  talentPreview_LeadBooster: 'Lead Preview',
  talentPreview_ActiveSourcing: 'Talent Preview',
  exportContact_LeadBooster: 'Export Lead',
  exportContact_ActiveSourcing: 'Export Candidate',
  pushContactDataToCrm_LeadBooster: 'Push Lead Data to CRM',
  pushContactDataToCrm_ActiveSourcing: 'Push Candidate Data to CRM',
  pushToCRM_LeadBooster: 'Push Lead to CRM',
  pushToCRM_ActiveSourcing: 'Push Candidate to CRM',

  // Tab Names
  assessmentOverview_LeadBooster: 'Lead Assessment Overview',
  assessmentOverview_ActiveSourcing: 'Candidate Assessment Overview',
  aboutContact_LeadBooster: 'About Lead',
  aboutContact_ActiveSourcing: 'About Candidate',
  aboutCompany_LeadBooster: 'About Company',
  aboutCompany_ActiveSourcing: 'About Company',
  // English (en.ts)

  duplicates_LeadBooster: 'Already Contacted Leads',
  duplicates_ActiveSourcing: 'Already Contacted Candidates',

  blacklist_LeadBooster: 'Blacklisted Companies',
  blacklist_ActiveSourcing: 'Blacklisted Organizations',
  enterLinkedinUrl: 'Enter your LinkedIn profile URL and get to know your personality type!',
  readyTo: 'Ready to',
  automateLinkedinOutreach_LeadBooster: 'Automate Your Entire LinkedIn Outreach',
  automateLinkedinOutreach_ActiveSourcing: 'Automate Your Entire LinkedIn Recruiting',
  aiPoweredOutreach_LeadBooster: 'with our AI-powered LinkedIn SAIA Sales?',
  aiPoweredOutreach_ActiveSourcing: 'with our AI-powered LinkedIn SAIA Recruiting?',
  whatToExpect: 'What to Expect When Setting Up Your Campaign?',
  youThePilot: 'You - The Pilot',
  defineWork: 'Define the work to be done by the AI.',
  aiTheCoPilot: 'The AI - The Co-Pilot',
  aiDoesHeavyLifting: 'Does the heavy lifting while you simply review and approve.',
  superchargeOutreach_LeadBooster: 'Ready to supercharge your LinkedIn outreach?',
  superchargeOutreach_ActiveSourcing: 'Ready to supercharge your LinkedIn recruiting?',
  aiHandlesDetails_LeadBooster: 'Let AI handle the details while you focus on building relationships!',
  aiHandlesDetails_ActiveSourcing: 'Let AI handle the details while you focus on building relationships!',
  createCampaignHere: 'Create Campaign here',
  automateOutreach_LeadBooster: 'Automate Your Entire LinkedIn Outreach',
  automateOutreach_ActiveSourcing: 'Automate Your Entire LinkedIn Recruiting',
  aiOutreachTool: 'With our AI-powered LinkedIn outreach automation tool, you can:',
  youThePilotStrong: '<0>You</0> - The Pilot',
  aiTheCoPilotStrong: '<0>The AI</0> - The Co-Pilot',
  stage1Title_LeadBooster: '1. Sourcing Leads',
  stage1Title_ActiveSourcing: '1. Sourcing Candidates',
  stage1Primary_LeadBooster: 'Brief the AI on your outreach campaign requirements. Who do you want to contact?',
  stage1Primary_ActiveSourcing: 'Brief the AI on your recruiting campaign requirements. Who do you want to contact?',
  stage1Secondary_LeadBooster: 'Finds relevant LinkedIn profiles based on your criteria.',
  stage1Secondary_ActiveSourcing: 'Finds relevant LinkedIn profiles based on your criteria.',
  stage2Title_LeadBooster: '2. Qualifying Leads',
  stage2Title_ActiveSourcing: '2. Qualifying Candidates',
  stage2Primary_LeadBooster: 'Define your ideal lead criteria (must-haves, exclusions, nice-to-haves)\nReview and make any final adjustments to the shortlist.',
  stage2Primary_ActiveSourcing: 'Define your ideal candidate criteria (must-haves, exclusions, nice-to-haves)\nReview and make any final adjustments to the shortlist.',
  stage2Secondary_LeadBooster: 'Pre-qualifies leads and provides reasoning for each decision.',
  stage2Secondary_ActiveSourcing: 'Pre-qualifies candidates and provides reasoning for each decision.',
  stage3Title_LeadBooster: '3. Crafting Outreach Messages',
  stage3Title_ActiveSourcing: '3. Crafting Recruiting Messages',
  stage3Primary_LeadBooster: 'Choose a campaign flow template and define messaging style.',
  stage3Primary_ActiveSourcing: 'Choose a campaign flow template and define messaging style.',
  stage3Secondary_LeadBooster: 'Generates tailored messages for each stage of the campaign.',
  stage3Secondary_ActiveSourcing: 'Generates tailored messages for each stage of the campaign.',
  stage4Title_LeadBooster: '4. Sending 100% Personalized Messages, 100% Automated',
  stage4Title_ActiveSourcing: '4. Sending 100% Personalized Messages, 100% Automated',
  stage4Primary_LeadBooster: 'You → Sit back, review, and let the AI do the work! 😉',
  stage4Primary_ActiveSourcing: 'You → Sit back, review, and let the AI do the work! 😉',
  stage4Secondary_LeadBooster: 'Analyzes each prospect’s LinkedIn profile and crafts hyper-personalized messages.',
  stage4Secondary_ActiveSourcing: 'Analyzes each prospect’s LinkedIn profile and crafts hyper-personalized messages.',
  tutorialCreateAccount: 'Create Account',
  tutorialSynchronizeAccount: 'Synchronize Account',
  tutorialCreateCampaign: 'Create Campaign',
  tutorialCampaignBriefing: 'Campaign Briefing',
  tutorialCampaignContactList: 'Campaign Contact List',
  tutorialSourceContacts: 'Source Contacts',
  tutorialSourceContacts_1_ActiveSourcing: 'Source Contacts - AI Search (Start Search)',
  tutorialSourceContacts_2_ActiveSourcing: 'Source Contacts - AI Search (Edit Results)',
  tutorialSourceContacts_1_LeadBooster: 'Source Contacts - AI Search',
  tutorialSourceContacts_2_LeadBooster: 'Source Contacts - LinkedIn URL',
  tutorialSourceContacts_3: 'Source Contacts - Upload contacts',
  tutorialQualifyContacts: 'Qualify Contacts',
  tutorialQualificationResults: 'Qualification Results',
  tutorialCampaignFlow: 'Campaign Flow',
  tutorialBuildFlow: 'Build Flow',
  tutorialMessageGenerationPrompt: 'Message Generation Prompt',
  tutorialCampaignTesting: 'Test Campaign',
  tutorialCampaignSettings: 'Campaign Settings',
  tutorialCampaignSummary: 'Start Campaign',
  tutorialCampaignOverview: 'Campaign Overview',
  tutorialCampaignStatistics: 'Campaign Statistics',
  tutorialCampaignInbox: 'Campaign Inbox',
  masterTheProductGroup: 'Master the {{productGroup}}',
  byGoingThroughOurOnboarding: 'by going through our onboarding',
  manageTrackCampaign: 'Manage and track your campaign\'s operation and performance',
  tutorialCampaignBriefingTitle: 'Campaign Briefing',
  tutorialCampaignBriefingDescription_LeadBooster: 'In this step, you\'ll provide the AI with the essential details needed to run your campaign effectively. You can use your product information as a reference.',
  tutorialCampaignBriefingDescription_ActiveSourcing: 'In this step, you\'ll provide the AI with the essential details needed to run your campaign effectively. You can use your job posting as a reference.',
  tutorialCampaignContactListTitle: 'Campaign Contact List - AI search',
  tutorialCampaignContactListDescription_LeadBooster: 'This step focuses on supplying the AI with a pool of leads, which will be qualified and added to your campaign shortlist in a later stage. Note: At this point, you are only sourcing leads for the AI, not qualifying them.',
  tutorialCampaignContactListDescription_ActiveSourcing: 'This step focuses on supplying the AI with a pool of candidates, which will be qualified and added to your campaign shortlist in a later stage. Note: At this point, you are only sourcing candidates for the AI, not qualifying them.',
  tutorialCampaignContactListSearchTitle_LeadBooster: 'Campaign Contact List - LinkedIn URL',
  tutorialCampaignContactListSearchTitle_ActiveSourcing: 'Campaign Contact List - AI search',
  tutorialCampaignContactListSearchDescription_LeadBooster: 'In this step, you can perform your own LinkedIn search and run it in our system.',
  tutorialCampaignContactListSearchDescription_ActiveSourcing: 'In this step, we\'ll conduct a LinkedIn search based on the briefing you provided earlier. This search serves as an initial pool of candidates for our AI co-pilot to review.',
  tutorialCampaignContactListSearchHighlight_LeadBooster: 'Don\'t worry if the list isn\'t a perfect match—this is just the first stage of the funnel. In the next steps, the AI will analyze the leads and generate a refined shortlist.',
  tutorialCampaignContactListSearchHighlight_ActiveSourcing: 'Don\'t worry if the list isn\'t a perfect match—this is just the first stage of the funnel. In the next steps, the AI will analyze the candidates and generate a refined shortlist.',
  tutorialQualifyingContactsVisualizingTitle_LeadBooster: 'Leads Qualifying - Visualizing Result',
  tutorialQualifyingContactsVisualizingTitle_ActiveSourcing: 'Candidates Qualifying - Visualizing Result',
  tutorialQualifyingContactsVisualizingDescription_LeadBooster: 'Review the qualification results by evaluating leads individually or with AI support. If the results aren\'t as expected, adjust the criteria and repeat the process until you get the desired outcome.',
  tutorialQualifyingContactsVisualizingDescription_ActiveSourcing: 'Review the qualification results by evaluating candidates individually or with AI support. If the results aren\'t as expected, adjust the criteria and repeat the process until you get the desired outcome.',
  tutorialCampaignFlowTitle: 'Campaign Flow - Build the Communication Funnel',
  tutorialCampaignFlowDescription_LeadBooster: 'This step is about designing your outreach campaign flow—the structured sequence of actions that will guide your engagement with leads. At this stage, the focus is solely on building the process flow, defining the steps and triggers, not yet crafting the specific messages for each step.',
  tutorialCampaignFlowDescription_ActiveSourcing: 'This step is about designing your recruiting campaign flow—the structured sequence of actions that will guide your engagement with candidates. At this stage, the focus is solely on building the process flow, defining the steps and triggers, not yet crafting the specific messages for each step.',
  tutorialMessageGenerationTitle: 'Campaign Flow - Brief the AI with guidance on message generation',
  tutorialMessageGenerationDescription: 'This step guides the AI in crafting messages by refining prompts that define tone, style, and key details for each stage of your campaign. A prompt is an instruction or guideline given to the AI to shape the content it generates. In this case, prompts define the tone, style, and key details for each message in your campaign.',
  tutorialTestCampaignTitle: 'Test Campaign',
  tutorialTestCampaignDescription: 'This section allows you to test how the AI generates and tailors messages by simulating their creation across different contacts. Review the results to ensure they meet your expectations and refine the message prompts if needed.',
  tutorialCampaignSettingsTitle: 'Campaign Settings',
  tutorialCampaignSettingsDescription: 'The campaign settings section is all about defining the operational settings of the campaign. This means time and number of messages and requests sent per day.',
  tutorialCampaignOverviewStartTitle: 'Campaign Overview & Start',
  tutorialCampaignOverviewStartDescription: 'This section provides an overview of your campaign setup – across all steps. Before launching, review all elements to ensure everything is in order. If needed, make any necessary adjustments.',
  tutorialCreateCampaignTitle: 'Create Campaign',
  tutorialCreateCampaignDescription: 'In this step, you will create a new campaign project. Be sure to give your campaign a clear, descriptive name and select the appropriate account to manage it from.',
  tutorialShowQualificationResultsTitle: 'Show Qualification Results',
  tutorialShowQualificationResultsDescription_LeadBooster: 'In this step, you’ll review and interpret contact qualification results. The tool progressively loads and assesses leads from your bank based on your criteria. The goal is to generate a shortlist, either automatically with AI or by adjusting the criteria yourself.',
  tutorialShowQualificationResultsDescription_ActiveSourcing: 'In this step, you’ll review and interpret contact qualification results. The tool progressively loads and assesses candidates from your bank based on your criteria. The goal is to generate a shortlist, either automatically with AI or by adjusting the criteria yourself.',
  tutorialCampaignOverviewTitle: 'Campaign Overview',
  tutorialCampaignOverviewDescription: 'This screen provides an overview of all campaigns you and your team are running. You can easily track each campaign’s operational status and progress through the entire funnel—from sourcing and qualifying contacts to monitoring tasks completed, messages sent, and positive replies received.',
  tutorialCampaignStatisticsTitle: 'Campaign Statistics',
  tutorialCampaignStatisticsDescription_LeadBooster: 'Speed matters, but so does effectiveness. On this screen, you can track key performance indicators across each stage of your campaign funnel. Compare data within and across campaigns, and gain insights into which lead profiles respond positively—and why.',
  tutorialCampaignStatisticsDescription_ActiveSourcing: 'Speed matters, but so does effectiveness. On this screen, you can track key performance indicators across each stage of your campaign funnel. Compare data within and across campaigns, and gain insights into which candidate profiles respond positively — and why.',
  tutorialCampaignInboxTitle: 'Campaign Inbox',
  tutorialCampaignInboxDescription: 'Track outgoing messages and schedule automated replies once your co-pilot is active. Keep in mind, this isn’t a live chat — messages are sent only during the campaign’s working hours. You can also manage inboxes for other team members or clients.',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
  synchronizingYourAccount: 'Synchronize LinkedIn account',
  sourcingContacts: 'Sourcing contacts',
  qualifyingContacts: 'Qualifying contacts',
  blacklistingContacts: 'Blacklisting contacts',
  campaignOverviewPerformance: 'Campaign Overview & Performance',
  whichAccountToSync: 'Which account should I synchronize?',
  syncAccountDescription: 'You need to synchronize the account that will be used with LinkedIn for your campaign. This means entering the email and password associated with your LinkedIn profile—the account from which you’ll be reaching out to people on LinkedIn.',
  forgotLinkedInPassword: 'What if I don’t remember my LinkedIn password?',
  forgotPasswordDescription: 'If you’ve forgotten your LinkedIn password, you can retrieve it by following these steps:',
  stepOpenBrowser: 'Open your browser and click on the three-dot menu in the top-right corner.',
  stepSelectSettings: 'Select Settings.',
  stepNavigateToPasswords: 'Navigate to Autofill and Passwords > Password Manager.',
  stepSearchLinkedIn: 'Search for "LinkedIn" in the password manager.',
  stepCopyPassword: 'Once found, click on it and copy the stored password.',
  stepPastePassword: 'Paste the password into our dashboard.',
  whyAccountNotSyncing: 'Why isn’t my account synchronizing?',
  accountNotSyncingReasons: 'If your account isn’t syncing, it could be due to one of the following reasons:',
  reasonTemporaryBlock: 'Temporary Block by LinkedIn (Fair Use Pause): LinkedIn may temporarily block your account if it detects automation-like behavior. This is a security measure to prevent misuse.',
  reasonSimultaneousLogins: 'Simultaneous Logins: If you access your LinkedIn account during the campaign’s active hours (as set in the campaign setup process), LinkedIn may detect multiple logins and de-synchronize your account.',
  whatIsBriefingFor: 'What is a briefing for?',
  briefingDescription: 'A briefing is a structured document that defines the key objectives, target audience, messaging strategy, and execution plan for a specific initiative. When briefing AI software for a LinkedIn outreach campaign in social selling or active sourcing, it should include details such as ideal prospect or candidate profiles, messaging frameworks, engagement tactics, follow-up sequences, and success metrics. The AI will then use this data to automate outreach, track responses, and refine engagement based on real-time insights.',
  missingBriefingInfo: 'What if I don’t have all the information for the briefing?',
  missingBriefingDescription: 'If you don’t have a structured briefing or all the required details, you can still proceed by leveraging existing resources.',
  forRecruiting: 'For recruiting:',
  recruitingInstructions: 'Copy and paste your job description or provide the URL of the job posting.',
  forSocialSelling: 'For social selling:',
  socialSellingInstructions: 'Provide the landing page URL where the product or service is featured.',
  aiExtractsInformation: 'This allows the AI to extract relevant information and generate effective outreach messaging automatically.',
  howAreContactsGenerated: 'How are the contacts generated?',
  contactsGeneratedDescription: 'They are sourced from LinkedIn, and we can also search for phone numbers and email addresses.',
  whatIsSourcingContacts: 'What is sourcing contacts, and how can I do it?',
  sourcingContactsDescription_LeadBooster: 'Sourcing contacts is about providing our AI agent with a pool of leads that it will later qualify and contact. You have three options:',
  sourcingContactsDescription_ActiveSourcing: 'Sourcing contacts is about providing our AI agent with a pool of candidates that it will later qualify and contact. You have three options:',
  uploadExistingFile_LeadBooster: 'Upload an existing file with leads.',
  uploadExistingFile_ActiveSourcing: 'Upload an existing file with candidates.',
  aiSearchForLeads_LeadBooster: 'Let the AI search for leads on your behalf.',
  aiSearchForLeads_ActiveSourcing: 'Let the AI search for candidates on your behalf.',
  manualLinkedInSearch: 'Manually search on LinkedIn and, once satisfied with the results, copy and paste the search URL into our dashboard.',
  supportedLinkedInSearches: 'What types of LinkedIn searches are supported by our AI?',
  aiSupportsTwoSearches: 'Our AI agent supports two types of searches:',
  coldOutreachAlt: 'Cold Outreach:',
  coldOutreachDescription: 'Finds people you haven’t contacted or connected with yet.',
  inMarketOutreachAlt: 'In-Market Outreach:',
  inMarketOutreachDescription_LeadBooster: 'Identifies leads based on LinkedIn activity (events, posts, groups, etc.), helping you engage with interacting with relevant content.',
  inMarketOutreachDescription_ActiveSourcing: 'Identifies candidates based on LinkedIn activity (events, posts, groups, etc.), helping you engage with interacting with relevant content.',
  requiredContactListInfo: 'What information is required if I upload a contact list?',
  contactListDescription_LeadBooster: 'The only required field is the LinkedIn profile URL of each lead you want to add to your campaign. However, you can include additional details if available, but the LinkedIn URL is essential for the AI to process and engage with the contacts.',
  contactListDescription_ActiveSourcing: 'The only required field is the LinkedIn profile URL of each candidate you want to add to your campaign. However, you can include additional details if available, but the LinkedIn URL is essential for the AI to process and engage with the contacts.',
  howToBestQualifyContacts: 'How to best qualify contacts?',
  qualifyContactsDescription: 'This section is about selecting which contacts you want to include in your campaign and which ones to exclude. You have two options:',
  aiDrivenQualificationTitle: 'AI-Driven Qualification:',
  aiDrivenQualificationDescription_LeadBooster: 'The AI agent uses the briefing information to assess and qualify contacts. To improve accuracy, click on "AI Lead Assessment" and specify which contacts should be included or excluded. The more detailed your briefing, the better the AI’s selection process.',
  aiDrivenQualificationDescription_ActiveSourcing: 'The AI agent uses the briefing information to assess and qualify candidates. To improve accuracy, click on "AI Candidate Assessment" and specify which candidates should be included or excluded. The more detailed your briefing, the better the AI’s selection process.',
  manualQualificationTitle: 'Manual Qualification:',
  manualQualificationDescription_LeadBooster: 'You can personally review and select leads for your campaign. Click on each lead to assess their details and review the AI’s evaluation before adding them to your list.',
  manualQualificationDescription_ActiveSourcing: 'You can personally review and select candidates for your campaign. Click on each candidate to assess their details and review the AI’s evaluation before adding them to your list.',
  fewerContactsPreQualificationTitle: 'Why do I have fewer contacts in my pre-qualification list than the total sourced?',
  fewerContactsPreQualificationDescription_LeadBooster: 'The AI agent progressively reviews leads over time rather than processing them all at once. Each lead is pre-qualified as A, B, C, or Not Qualified based on relevance. This staged approach allows you to verify the AI’s accuracy before launching the campaign.',
  fewerContactsPreQualificationDescription_ActiveSourcing: 'The AI agent progressively reviews candidates over time rather than processing them all at once. Each candidate is pre-qualified as A, B, C, or Not Qualified based on relevance. This staged approach allows you to verify the AI’s accuracy before launching the campaign.',
  dynamicLeadAssessment_LeadBooster: 'The system continues assessing leads dynamically—your campaign starts with already-qualified contacts, and the AI refines its selections based on your feedback, gradually expanding your final campaign list.',
  dynamicLeadAssessment_ActiveSourcing: 'The system continues assessing candidates dynamically—your campaign starts with already-qualified candidates, and the AI refines its selections based on your feedback, gradually expanding your final campaign list.',
  whoCanIBlacklist: 'Who can I blacklist?',
  whoCanIBlacklistDescription: 'You can blacklist both individual contacts and companies. This can be done by either uploading a file or manually entering LinkedIn URLs of the contacts or companies you want to exclude.',
  blacklistUploadInfoTitle: 'What information is required to upload a blacklist?',
  blacklistUploadInfoDescription: 'The only required field is the LinkedIn profile URL of each individual or the company name you want to blacklist. While you can include additional details, the LinkedIn URL is crucial for the AI to accurately process and exclude these contacts from your outreach.',
  startBuildingCampaignFlow: 'How do I start building my outreach campaign flow?',
  startBuildingCampaignFlowDescription: 'You can either start from scratch or use a pre-built template. If starting from scratch, you’ll need to add actions (e.g., LinkedIn connection requests, messages), set waiting times, and define conditions for different responses.',
  typesOfActionsInCampaign: 'What types of actions can I add to my campaign flow?',
  typesOfActionsInCampaignDescription: 'You can add:',
  actionLinkedInRequest: 'LinkedIn Connection Requests (with or without a message)',
  actionDirectMessages: 'Direct Messages (custom or AI-generated)',
  actionInMails: 'InMails (for premium users)',
  actionEmailFollowUps: 'Email follow-ups (if integrated)',
  actionEngagementActions: 'Engagement actions (e.g., liking or commenting on a post)',
  setupWaitingTimes: 'How do I set up waiting times between actions?',
  setupWaitingTimesDescription: 'You can specify delays between steps, such as waiting 2 days after a connection request before sending a follow-up message. This helps maintain a natural engagement flow.',
  whatAreConditionals: 'What are conditionals, and how do they work?',
  whatAreConditionalsDescription: 'Conditionals allow you to create different paths in your campaign flow based on user interactions. For example:',
  conditionalAcceptConnection: 'If the contact accepts a connection request → Send message A',
  conditionalNoResponse: 'If no response after 3 days → Send message B',
  conditionalPositiveReply: 'If they reply positively → Move to manual review or next step',
  customizeAIMessages: 'Can I customize the AI-generated messages?',
  customizeAIMessagesDescription: 'Yes! You should. Our AI agent will generate messages based on your prompt and its further settings. You can define the structure, tone (e.g., formal, casual), and key points you want to include.',
  handlingNoResponseRequests: 'How should I handle connection requests if there is no response?',
  handlingNoResponseRequestsDescription: 'You can set the waiting time before sending a follow-up message. This allows you to work in a structured way and ensure that no one is forgotten.',
  automaticResponsesNegativeReplies: 'Is it possible to set up automatic responses for negative replies in the campaign?',
  automaticResponsesNegativeRepliesDescription: 'Yes, we can integrate automatic responses into the flow.',
  setupCampaignCorrectly: 'How do I set up my campaign correctly?',
  setupCampaignCorrectlyDescription: 'The most important aspect of setting up your campaign is defining its operating time window. Your AI agent can only run the campaign while you are offline on LinkedIn. If you log into LinkedIn during the campaign’s active hours, the system will automatically pause the campaign to protect your account from being blocked.',
  campaignTimesNoMessages: 'We set campaign times, but the system didn’t send messages right away. Why?',
  campaignTimesNoMessagesReason: 'This usually happens if you have selected the "Approve Messages" option.',
  campaignTimesNoMessagesDescription: 'When your AI agent starts working (within the defined campaign hours), it first generates personalized messages based on each contact’s profile. However, these messages will not be sent automatically—you need to review and approve them. If you don’t actively approve the messages, your campaign will remain inactive.',
  dailyMessageLimit: 'How many contacts can I message per day?',
  dailyMessageLimitDescription: 'You can theoretically send messages to up to 100 contacts per day, but this depends on LinkedIn’s guidelines. Be mindful of LinkedIn’s limits to avoid restrictions. If you are running multiple campaigns simultaneously, the total daily message limit will be shared across all active campaigns.',
  exportCampaignResults: 'Can I export the results of my campaigns?',
  exportCampaignResultsDescription: 'Yes, you can export the final campaign list and enrich the contacts with additional information.',
  viewCampaignPerformance: 'How do I view the performance of my campaigns?',
  viewCampaignPerformanceDescription: 'You can view the performance of your campaigns by going to the "Campaigns" tab in the dashboard or for more details, go to the "Statistics" tab.',
  videoTutorials: 'Video Tutorials',
  // Translation keys for Source Contacts Upload option
  tutorialCampaignContactListUploadTitle: 'Campaign Contact List - Upload Your Contacts',
  tutorialCampaignContactListUploadDescription_LeadBooster: 'You can upload your own list of leads. This is useful if you already have a list of contacts you want to qualify and engage with through your campaign.',
  tutorialCampaignContactListUploadDescription_ActiveSourcing: 'You can upload your own list of candidates. This is useful if you already have a list of contacts you want to qualify and engage with through your campaign.',
  tutorialCampaignContactListUploadDescription_SalesBooster: 'You can upload your own list of contacts. This is useful if you already have a list of leads you want to qualify and engage with through your social selling campaign.',
  selectLinkedInAccountForSourcing_LeadBooster: 'Select LinkedIn Account for Lead Sourcing',
  useDifferentLinkedInAccountsForSourcing_LeadBooster: 'You can use different LinkedIn accounts for lead sourcing',
  none_LeadBooster: 'None',
  whichLinkedInProductForSourcing_LeadBooster: 'Which LinkedIn product would you like to use for lead sourcing?',
  selectLanguagesForSearch_LeadBooster: 'Select languages for your search',
  chooseLanguagesForSearch_LeadBooster: 'Choose which languages to use for your lead search',
  noteSelectMultipleLanguages_LeadBooster: 'Note: You can select multiple languages. You must select at least one language.',
  includeOwnContacts_LeadBooster: 'Include your own contacts',
  includeOwnContactsLabel_LeadBooster: 'Also 1st degree (all contacts)',
  includeOwnContactsDescription_LeadBooster: 'By default we only search 2nd and 3rd degree. Turn this on to drop that filter and include everyone.',
  aiBriefingLanguage_LeadBooster: 'AI Briefing Language',
  english_LeadBooster: 'English',
  typeInYourSearchLocation_LeadBooster: 'Type in your search location',
  selectLocationForContactSearch_LeadBooster: 'Select a location where you want to search for leads',
  addLinkedinSearchesToLeadBank_LeadBooster: 'Add LinkedIn searches to your Lead Bank',
  reviewSearchSamplesForLeads_LeadBooster: 'Review search samples to find qualified leads for your campaign',
  weAreAlmostThere_LeadBooster: 'We\'re almost there!',
  linkedinSearchReady_LeadBooster: 'Your LinkedIn search is ready to start finding qualified leads',
  startTalentSearch_LeadBooster: 'Start Lead Search',
  selectLinkedInAccountForSourcing_ActiveSourcing: 'Select LinkedIn Account for Candidate Sourcing',
  useDifferentLinkedInAccountsForSourcing_ActiveSourcing: 'You can use different LinkedIn accounts for candidate sourcing',
  none_ActiveSourcing: 'None',
  whichLinkedInProductForSourcing_ActiveSourcing: 'Which LinkedIn product would you like to use for candidate sourcing?',
  selectLanguagesForSearch_ActiveSourcing: 'Select languages for your search',
  chooseLanguagesForSearch_ActiveSourcing: 'Choose which languages to use for your candidate search',
  noteSelectMultipleLanguages_ActiveSourcing: 'Note: You can select multiple languages. You must select at least one language.',
  includeOwnContacts_ActiveSourcing: 'Include your own contacts',
  includeOwnContactsLabel_ActiveSourcing: 'Also 1st degree (all contacts)',
  includeOwnContactsDescription_ActiveSourcing: 'By default we only search 2nd and 3rd degree. Turn this on to drop that filter and include everyone.',
  aiBriefingLanguage_ActiveSourcing: 'AI Briefing Language',
  english_ActiveSourcing: 'English',
  typeInYourSearchLocation_ActiveSourcing: 'Type in your search location',
  selectLocationForContactSearch_ActiveSourcing: 'Select a location where you want to search for candidates',
  addLinkedinSearchesToLeadBank_ActiveSourcing: 'Add LinkedIn searches to your Talent Pool',
  reviewSearchSamplesForLeads_ActiveSourcing: 'Review search samples to find qualified candidates for your campaign',
  weAreAlmostThere_ActiveSourcing: 'We\'re almost there!',
  linkedinSearchReady_ActiveSourcing: 'Your LinkedIn search is ready to start finding qualified candidates',
  startTalentSearch_ActiveSourcing: 'Start Talent Search',
  inMailsNotAllowed: 'The LinkedIn account linked to the campaign does not support Inmails. (Remove the Inmail node or adjust the LinkedIn account)',
  emailsNotAllowed: 'The LinkedIn account linked to the campaign does not have an email account associated with it. (Remove the email node or adjust the LinkedIn account)',
  uncertainSexContacts: 'Contacts with uncertain gender',
  uncertainSexContactsDescription: 'We couldn’t determine the gender with certainty.',
  noUncertainSexContactsFound: 'No contacts with uncertain gender found',
  updateContactSex: 'Change gender',
  selectSex: 'Select gender',
  updateSexDescription: 'Please select the gender of the contact.',
  viewContactDetails: 'View contact details',
  updateSex: 'Change gender',
  agentRestart: 'Restart agent?',
  completeCampaign: 'Complete campaign',
  doNothing: 'You don\'t have to do anything',
  messagesWaitingForApproval_one: 'Approve {{count}} message',
  messagesWaitingForApproval_other: 'Approve {{count}} messages',
  messagesWaitingForApprovalHint: 'These messages are only sent once you approve them.',
  contactsWaitingForApproval_one: 'Approve {{count}} contact',
  contactsWaitingForApproval_other: 'Approve {{count}} contacts',
  contactsWaitingForApprovalHint: 'These contacts are only contacted once you approve them.',
  contactsToApprove: 'Contacts to approve',
  contactsToApproveHint_one: '{{count}} contact is waiting for approval',
  contactsToApproveHint_other: '{{count}} contacts are waiting for approval',
  contactsToApproveEmpty: 'No contact is waiting for approval right now.',
  contactsToApproveError: 'The contacts could not be loaded or saved. Please try again.',
  approveContacts: 'Approve contacts',
  approveContact: 'Approve',
  declineContact: 'Do not contact',
  approveAllContacts_one: 'Approve {{count}} contact',
  approveAllContacts_other: 'Approve all {{count}}',
  openLinkedInProfile: 'Open LinkedIn profile',
  removeContactFromCampaignDescription: 'If you select this option, this contact will be set to inactive in your campaign. This means that no further messages will be generated for this contact.',
  excludedContacts: 'excluded from this',
  generateMessageError: 'Error generating the message',
  generateMessageErrorDescription1: 'This can be due to several reasons.',
  generateMessageErrorDescription2: 'Please check your prompts to see if you have used any real names. For privacy reasons, we use placeholders in the background. Real names can confuse the AI and lead to errors in text generation.',
  generateMessageErrorDescription3: 'If you need further help, please contact our support.',
  promptGuidanceUsed: 'Prompt optimization suggestion available',
  promptSuggestionTitle: 'Suggested prompt improvement',
  promptSuggestionDescription: 'Use this adjusted prompt to get more reliable, concrete results. You can copy it or apply it directly.',
  copyPromptSuggestion: 'Copy suggestion',
  applyPromptSuggestion: 'Apply suggestion',
  suggestedPromptCopied: 'Suggested prompt copied',
  suggestedPromptApplied: 'Suggested prompt applied',
  declineMessageAndDeactivateContact: 'Decline message & deactivate contact',
  declineMessageAndGenerateAgain: 'Decline message & generate again',
  declineMessageQuestion: 'How do you want to decline the message?',
  deactivatedContactsNote: 'Note: For deactivated contacts, no new messages are generated.',
  declineMessageNote: 'Note: Messages will only be generated for running campaigns. If your campaign is not running, "{{buttonText}}" will only decline the message but not generate a new one.',
  confirmDeleteNode1: 'Are you sure you want to delete the node permanently?',
  confirmDeleteNode2: 'This action cannot be undone - the node and all of its content will be lost.',
  deleteEdge: 'Remove connection',
  deleteEdgeTitle: 'Remove connection',
  confirmDeleteEdge1: 'Without this connection, {{count}} steps are no longer part of any flow.',
  confirmDeleteEdge2: 'They will be deleted together with the connection. This cannot be undone.',
  deleteNodeTitle: 'Permanently Delete Node',
  declineMessageDescription: 'By selecting this option, a new message will eventually be generated for this contact. You will then have the opportunity to approve or decline the new message.',
  linkedinAccountProblem: 'Linkedin Account Problem',
  coPilotLicenseExpired: 'Co-Pilot license expired',
  coPilotLicenseExpiredDescription: 'Your license to use the Co-Pilot has expired. Please renew it to continue using the product.',
  contactsAlmostExhausted: 'Contacts almost processed',
  contactsAlmostExhaustedDescription: 'The agent has processed nearly all contacts in your campaign.\nAdd more now to keep the campaign running, or let it expire.',
  flowEmptyDialogTitle: 'No nodes found',
  flowEmptyDialogContent: 'Your campaign flow has no nodes. If nodes exist but could not be detected, save the flow manually and restart the campaign. If the issue persists, please contact our support team.',
  campaignNotFound: 'Campaign not found. The changes are not saved, please be careful!',
  flowNotFound: 'Flow not found. The changes are not saved, please be careful!',
  cloneContactsWithCampaign: 'Clone contacts with campaign',
  cloneContactsWithCampaignDescription: 'When enabled, all contacts from the original campaign will be cloned with their progress reset. When disabled, only the campaign settings will be cloned.',
  addContactsFromCampaignMethodTitle: 'Add contacts from other Campaigns',
  addContactsFromCampaignDescription: 'Copy contacts from another one of your campaigns into this one. You can filter which contacts to copy based on their connection degree and whether they replied.',
  addContactsFromCampaignSourceFunnelLabel: 'Source Campaign',
  addContactsFromCampaignSourceFunnelPlaceholder: 'Select campaign to copy contacts from',
  addContactsFromCampaignContactDegreeLabel: 'Contact Degree Filter',
  addContactsFromCampaignContactDegreeDescription: 'Choose the connection degree you want to filter by.',
  addContactsFromCampaignContactDegreeAll: 'All Contacts',
  addContactsFromCampaignContactDegreeFirst: '1st Degree Only',
  addContactsFromCampaignContactDegreeSecondPlus: '2nd Degree and Higher',
  addContactsFromCampaignAll: 'All Contacts',
  addContactsFromCampaignHasReacted: 'Has reacted or accepted',
  addContactsFromCampaignHasNotReacted: 'Has neither reacted nor accepted',
  addContactsFromCampaignHasReplied: 'Has replied',
  addContactsFromCampaignHasNotReplied: 'Has not replied',
  addContactsFromCampaignIsActiveLabel: 'Active Status Filter',
  addContactsFromCampaignIsActiveDescription: 'Choose the status you want to filter by.',
  addContactsFromCampaignIsActiveAll: 'All Contacts',
  addContactsFromCampaignIsActiveYes: 'Only contacts in the final list',
  addContactsFromCampaignIsActiveNo: 'Only contacts not in the final list',
  noFilter: 'No Filter',
  addContactsFromCampaignContactsThatRepliedLabel: 'Replied Status Filter (Select any)',
  addContactsFromCampaignContactsThatRepliedDescription: 'Choose the reply status you want to filter by.',
  addContactsFromCampaignRepliedPositive: 'Replied Positively',
  addContactsFromCampaignRepliedNegative: 'Replied Negatively',
  addContactsFromCampaignRepliedNote: 'If neither is selected, all contacts (regardless of reply status) matching the degree filter will be copied.',
  addContactsFromCampaignAddButton: 'Add Contacts',
  addContactsFromCampaignImportantNote: 'Note: Copied contacts will have their message history and step progress reset. Their \'isActive\' status will be preserved.',
  addContactsFromCampaignSuccessMessage: 'Successfully added {{count}} contacts from the selected campaign.',
  addContactsFromCampaignNoOtherFunnels: 'No other campaigns found to copy contacts from.',
  addContactsFromCampaignErrorsFetchFunnelsError: 'Could not load other campaigns. Please try again later.',
  addContactsFromCampaignErrorsNoSourceSelected: 'Please select a source campaign.',
  addContactsFromCampaignErrorsAlreadyAddedError: 'Contacts from this campaign may have already been added or are currently being processed. Please check the contacts list.',
  addContactsFromCampaignErrorsBadRequestError: 'Could not add contacts: {{message}}',
  addContactsFromCampaignErrorsGenericAddError: 'An error occurred while adding contacts. Please try again.',
  noLocationsFound: 'We could not find a suitable location for your query.',
  startingCampaignNotPossibleDialogTitle: 'Starting the campaign is not possible',
  startingCampaignNotPossibleDialogContent1: 'Your campaign cannot be started because some information is missing or incorrect. Please check your settings and try again.',
  startingCampaignNotPossibleDialogContent2: 'The following information is missing or incorrect:',
  workDaysNotSet: 'No workdays have been set yet. Set them under LinkedIn Accounts → Working hours.',
  workHoursNotSet: 'No working hours have been set yet. Set them under LinkedIn Accounts → Working hours.',
  notAllFunctionsSet: 'Your campaign flow has no message nodes.',
  allNodesNotConnected: 'Not all nodes in your campaign flow are connected.',
  offerNotSet: 'No campaign briefing has been set up yet.',
  linkedinAccountNotSelected: 'No LinkedIn account has been selected yet.',
  campaignNeedsRetest: 'Please test the campaign again before starting it.',
  offerNotSetError: 'Your campaign briefing contains empty fields.',
  flowHasIssues: 'Your campaign flow has issues.',
  notAllMessagesHaveType: 'Not all messages have a type.',
  notAllConditionsHaveType: 'Not all conditions have a type.',
  notAllNodesConnected: 'Not all nodes are connected.',
  somethingWentWrongTitle: 'An unexpected error occurred',
  somethingWentWrongDescriptionErrorSent: 'We\'re sorry, but an unexpected error occurred. Our technical team has been automatically notified and will address the issue as soon as possible.',
  somethingWentWrongDescriptionErrorNotSent: 'We\'re sorry, but an unexpected error occurred. Please reload the page and try again. If the problem persists, please contact our support so we can investigate the issue.',
  reloadPage: 'Reload Page',
  contactSupport: 'Contact Support',
  errorInFrontend: 'Error in Frontend',
  expertMode: 'Expert Mode',
  yourMessage: 'Your Message',
  noOutreachApproachSelected: 'You have not selected an outreach approach',
  noConnectionMethodSelected: 'You have not selected a connection method',
  noMessagingLanguageSelected: 'You have not selected a messaging language',
  noLinkedinAccountSelected: 'You have not selected a LinkedIn account',
  noLinkedinProductSelected: 'You have not selected a LinkedIn product',
  noSearchSearchLanguageSelected: 'You have not selected a search language',
  noSearchLocationSelected: 'You have not selected a search location',
  fillProductOffer: 'At least one field in the product briefing is not filled',
  fillJobOffer: 'At least one field in the job briefing is not filled',
  createCampaignTitle: '1. Let\'s Create Your Outreach Campaign in 10 Minutes!',
  reviewCampaignResultsTitle: '2. Review Campaign & view results',
  blacklistContactsAndStartCampaignTitle: '3. Blacklist contacts & start campaign',
  reviewResultsTitle: 'Review Results & Start Campaign',
  feedAiAgent: 'Feed the AI Agent',
  briefAiOnYour: 'Brief the AI on your',
  outreachCampaign: 'Outreach Campaign',
  provideAiWithCampaignCommunicationCriteria: 'Provide AI with your <1>Campaign communication criteria</1>',
  inMailsNote: '(only available for LinkedIn premium licenses)',
  provideAiWithCampaignOffer: 'Provide AI with your <1>{{offer}}</1>',
  productDescription: 'Product Description',
  qualificationCriteria: 'Qualification Criteria',
  specifyImportantQualificationCriteria: 'Specify <1>Important Qualification Criteria</1>',
  qualificationCriteriaLabel: 'Qualification Criteria',
  qualificationCriteriaDescription: 'Enter the essential qualifications and requirements that candidates must absolutely meet to be considered for this role.',
  qualificationCriteriaSpeechRecInfo: 'Tip: Use voice recognition for quick input - activate the switch and grant microphone access.',
  specifyContactsToBeExcludedFromCampaign: 'Specify the <1>Contacts to be excluded from the campaign</1>',
  blacklists: 'Blacklists',
  selectBlacklists: 'Select the blacklists you want to activate for this campaign.',
  noGlobalBlacklistsFound: 'You have not created any global blacklists yet. To start blocking contacts, click:',
  provideInformation: 'Provide information',
  toOperateYourCampaign: 'to operate your campaign',
  selectLinkedinAccountForTalentSourcing: 'Select LinkedIn Account for Talent Sourcing',
  talentSourcingDescription: 'You can use different LinkedIn accounts for your talent sourcing.',
  craftOutreachCampaign: 'Craft outreach campaign',
  reviewDetailsInExpertMode: 'Review details in expert mode',
  testMessageGeneration: 'Test Message Generation',
  notePromptsForMessageGenerationCanBeEditedUnderExpertMode: 'Note: Prompts for message generation can be edited under expert mode.',
  contactFunnel: 'Contact Funnel',
  approveMessagesAndContactsBeforeSending: 'Approve messages and contacts before sending',
  allowTheAgentToSendMessagesWithoutPriorReview: 'Allow to send messages without prior review',
  sourcedContactsInTalentPool: 'Contacts in talent pool',
  assessedContactsInTalentPool: 'Assessed contacts in talent pool',
  contactsInCampaignShortlist: 'Contacts in campaign shortlist',
  contactsAssessmentNote: 'Note: Contacts will be assessed and qualified progressively over time, but you can begin running your campaign right away.',
  candidatesHighestMatchFirstNote: 'Note: We address candidates with highest match first.',
  reviewAndFineTuneNote: 'Note: You can review & fine-tune the contact funnel settings in expert mode or start the campaign immediately.',
  startCampaignOrReviewMessage: 'Would you like to start the campaign immediately, or review and approve the message before launching?',
  craftingOutreachCampaign: 'Crafting outreach campaign...',
  campaignCraftingStepCampaignBriefing: 'Campaign Briefing',
  campaignCraftingStepReviewBriefing: 'Reviewing the briefing and extracting key requirements for the campaign:',
  campaignCraftingStepDefiningCriteria: 'Defining the criteria for conducting talent searches on LinkedIn.',
  campaignCraftingStepEstablishingRequirements: 'Establishing requirements for message generation.',
  campaignCraftingStepSourcingTalents: 'Sourcing Talents',
  campaignCraftingStepTalentSearch: 'Conducting a talent search on LinkedIn.',
  campaignCraftingStepQualifyingTalents: 'Qualifying Talents',
  campaignCraftingStepReviewQualificationCriteria: 'Reviewing and extracting key talent qualification criteria for talent assessment.',
  campaignCraftingStepEvaluatingContacts: 'Evaluating the first batch of contacts:',
  campaignCraftingStepIdentifyingProfiles: 'Identifying professional profiles and backgrounds.',
  campaignCraftingStepQualifyingProcessingTalents: 'Qualifying first Talents.',
  campaignCraftingStepCreatingShortlist: 'Creating a shortlist of qualified Talents.',
  campaignCraftingStepBuildingFlow: 'Building Campaign Flow',
  campaignCraftingStepReviewRequirements: 'Reviewing the briefing and extracting key requirements for message generation:',
  campaignCraftingStepDefiningCommunication: 'Defining communication requirements.',
  campaignCraftingStepConstructingFlow: 'Constructing the communication flow/process.',
  campaignCraftingStepCreatingPrompts: 'Creating text generation prompts for each message to be sent.',
  campaignCraftingStepCampaignTesting: 'Campaign Testing',
  campaignCraftingStepGeneratingExampleTexts: 'Generating example texts for each message node in the flow.',
  campaignCraftingStepCalculatingMatchScores: 'Calculating match scores and personas for each contact and message.',
  campaignCraftingStepEnsuringFunctionality: 'Ensuring the campaign is functioning as intended with the generated outputs.',
  campaignCraftingStepCampaignSettings: 'Defining Campaign Operational Settings',
  campaignCraftingStepLinkedinAccountManagement: 'LinkedIn account management',
  campaignCraftingStepTimeZone: 'Time zone',
  campaignCraftingStepWorkingDays: 'Working days and hours',
  campaignCraftingStepDailyOutreachQuota: 'Daily outreach message quota',
  campaignCraftingStepCompleted: 'Campaign building completed',
  campaignCraftingStepCampaignCompleted: 'The campaign has been built successfully.',
  finish: 'Finish',
  expressOnboardingStepBriefing: 'Great! First, let\'s make sure I have everything needed to build your campaign. Please complete all fields under \'Campaign Briefing\'—this defines how I source contacts and generate messages.',
  expressOnboardingStepQualifying: 'Awesome! Now let\'s define who you\'re looking for. Be specific with qualification criteria—imagine briefing an assistant. The clearer you are, the better I can shortlist high-quality contacts.',
  expressOnboardingStepOperationalSettings: 'Almost done! Tell me now which LinkedIn account you want to use for contact sourcing, and all the other information I need to build your campaign. Then you can simply click "Create Outreach Campaign". No need to worry – you can check and adjust everything before going live.',
  expressOnboardingStepReviewAndResults: 'Done! I\'ve processed your campaign setup. Now you can review the results, check the contact and message suggestions, and make final tweaks before going live.',
  expressOnboardingStepCampaignFlow: 'Campaign Flow – A visual overview of how the campaign runs, showing each step in order.',
  expressOnboardingStepMessageTesting: 'Message Generation Testing – Here you can preview AI-generated messages for each step. Messages are tailored based on the contact\'s profile and persona to increase engagement.',
  expressOnboardingStepContactFunnel: 'Contact Funnel – Track how many contacts have been sourced, assessed, and shortlisted. You can choose full automation or require approval before outreach.',
  startNewOrCloneCampaign: 'Create new or clone existing campaign',
  startNewOrCloneCampaignDescription: 'You can create a new campaign or clone an existing one to save time.',
  startNew: 'Start New Campaign',
  cloneExisting: 'Clone Existing Campaign',
  selectCampaignToClone: 'Select Campaign to Clone',
  selectCampaignToCloneDescription: 'Select a campaign to clone as a template for your new campaign.',
  expressBuilderFormDirtyWarning: 'You have unsaved changes in the campaign. If you leave the page, these changes will be discarded.',
  removeFromBlacklist: 'Remove from Blacklist',
  removeFromSuspended: 'Reset the suspended status',
  editGeneralSettings: 'Edit general settings',
  editLoginInformation: 'Edit login information',
  editUsername: 'Edit username',
  noTestContactsFound: 'We are still looking for suitable talents - sometimes it takes a little longer. Start the campaign anyway, our agent will take care of the rest for you.',
  microphoneBlockedTitle: 'Microphone Access Required',
  microphoneBlockedText1: 'To use this feature, you need to allow microphone access in your browser.',
  microphoneBlockedChromeInstructions: 'In Chrome: Click the icon left of the address bar, then click "Website settings" and allow microphone access.',
  microphoneBlockedEdgeInstructions: 'In Edge: Click the lock icon in the address bar, then click "Site permissions" and allow microphone access.',
  microphoneBlockedFirefoxInstructions: 'In Firefox: Click the microphone icon in the address bar, then click "Blocked" to reset the setting. When you use this feature next time, you will be prompted to allow access again.',
  microphoneBlockedSafariInstructions: 'In Safari: Click Safari in the menu bar, select "Settings for this Website" and allow microphone access.',
  microphoneBlockedGenericInstructions: 'Please allow microphone access in your browser settings to use this feature.',
  microphoneBlockedText2: 'After allowing access, refresh the page to continue.',
  microphoneBlockedText3: 'Alternatively, you can continue to enter texts manually if you do not want to use the microphone.',
  generateLeadList: 'Generate Lead List',
  enterYourPrompt: 'Enter your prompt',
  leadListPromptDescription: 'Describe the companies you’re looking for, including size, industry, location, etc.',
  overallPromptPlaceholder: 'e.g., Small to mid-size software companies in Berlin specializing in fintech',
  productOrIndustry: 'Product or Industry',
  productOrIndustryPlaceholder: 'e.g., CRM Software, Office Furniture',
  regionOrLocation: 'Region or Location',
  regionOrLocationPlaceholder: 'e.g., Berlin',
  regionSplitInstructions: 'Region Split Instructions',
  regionSplitInstructionsPlaceholder: 'How should the region be divided? e.g., by city or subregion (optional)',
  companyIdentificationInstructions: 'Company Identification Instructions',
  companyIdentificationInstructionsPlaceholder: 'e.g., Focus on industry verticals such as healthcare, finance (optional)',
  peopleSearchInstructions: 'People Search Instructions',
  peopleSearchInstructionsPlaceholder: 'e.g., Find the CTO, Head of Product, or Head of Engineering for each company. (optional)',
  generating: 'Generating...',
  myLeadLists: 'My Lead Lists',
  refresh: 'Refresh',
  generateNewLeadList: 'Generate New Lead List',
  newLeadList: 'New Lead List',
  leadListSummaryTotal: '{{lists}} lists · {{leads}} leads in total',
  leadListSummaryPage: '{{lists}} lists · {{leads}} leads on this page',
  searchLeadListPlaceholder: 'Search by product, region, or tag...',
  deleteLeadListTitle: 'Delete Lead List',
  deleteLeadListConfirmation: 'Are you sure you want to delete this lead list? This action cannot be undone.',
  tableHeaderName: 'Name',
  tableHeaderProduct: 'Product',
  tableHeaderRegion: 'Region',
  tableHeaderLeads: 'Leads',
  tableHeaderCreated: 'Created',
  tableHeaderActions: 'Actions',
  noLeadListsFound: 'No lead lists found.',
  generateFirstLeadList: 'Generate Your First Lead List',
  unnamedLeadList: 'Unnamed Lead List',
  fullResearch: 'Full Research',
  refineWithAi: 'Refine with AI',
  notSpecified: 'Not specified',
  region: 'Region',
  originalSearchPrompt: 'Original Search Prompt',
  leadDataCount: 'Lead Data ({{count}} leads)',
  exportAsCsv: 'Export as CSV',
  enrichWithLinkedinUrls: 'Enrich with LinkedIn URLs',
  debugData: 'Debug Data',
  phone: 'Phone',
  contactLinkedin: 'Contact LinkedIn',
  leadReason: 'Lead Reason',
  website: 'Website',
  companyLinkedin: 'Company LinkedIn',
  industry: 'Industry',
  size: 'Size',
  address: 'Address',
  viewProfile: 'View Profile',
  viewPage: 'View Page',
  enrichLeadList: 'Enrich Lead List',
  customFieldNameOptional: 'Custom Field Name (optional)',
  customFieldNamePlaceholder: 'e.g. seniority, focus, note',
  customFieldPromptOptional: 'Custom Field Prompt (optional)',
  customFieldPromptPlaceholder: 'e.g. What is this person\'s likely seniority?',
  customFieldInfo: 'If you provide a custom field and prompt, the backend will fill this field for each lead using your instructions.',
  enrichNow: 'Enrich Now',
  generateFullLeadList: 'Generate Full Lead List',
  fullLeadInfoAlert: 'This will generate a comprehensive lead list (50+ leads) based on your feedback. The process may take 3–9 minutes depending on complexity.',
  implementationNotes: 'Implementation Notes:',
  regionSplitting: 'The API performs intelligent region splitting to get more comprehensive results',
  structuredLeads: 'All leads follow a consistent structure with contact and company information',
  qualityAssessed: 'The research quality is automatically assessed and feedback is provided',
  durationNote: 'The process may take 180–540 seconds depending on complexity',
  usePreviousResults: 'You can use previousResults to provide initial data that will be extended',
  updateInsteadOfNew: 'If savedListId is provided, the existing list will be updated instead of creating a new one',
  researchParameters: 'Research Parameters',
  searchPrompt: 'Search Prompt',
  productPlaceholder: 'E.g., Employee Benefits Programs',
  regionPlaceholder: 'E.g., Bavaria, Germany',
  searchPromptPlaceholder: 'E.g., Find Employee Benefits Programs in Bavaria, Germany',
  leadTypePrompt: 'What kind of leads would you like to see?',
  researchFeedback: 'Research Feedback',
  researchFeedbackPlaceholder: 'E.g., Focus on HR departments and companies with more than 100 employees. Include direct phone numbers when available.',
  advancedSettings: 'Advanced Settings',
  regionSplitInstruction: 'Region Split Instructions',
  regionSplitPlaceholder: 'E.g., Split Bavaria into industrial regions with focus on major cities like Munich, Nuremberg and Ingolstadt',
  numSubregions: 'Number of Subregions: {{count}}',
  subregionInfo: 'Higher values provide more comprehensive coverage but take longer to process',
  companyInstructions: 'Company Identification Instructions',
  companySubSearchPlaceholder: 'E.g., For each region, create subsearches for company size.',
  companyInstructionsDescription: 'Instead of defining specific subsearches, provide instructions on how the system should generate subsearches. This helps the backend create more effective and diverse research strategies.',
  subsearchInstructions: 'Subsearch Instructions',
  subsearchPlaceholder: 'E.g., Create subsearches focusing on different roles like HR Directors, Department Heads, and C-level executives.',
  numSubsearches: 'Number of Subsearches: {{count}}',
  subsearchInfo: 'Higher values create more diverse research approaches but may increase processing time',
  peopleSearchInstruction: 'People Search Instructions',
  peopleSearchPlaceholder: 'e.g., Find the CTO, Head of Product, or Head of Engineering for each company. (optional)',
  peopleSearchCount: 'Number of People Searches per Company',
  updateExistingList: 'Update this lead list with new results',
  autoSaveResults: 'Automatically save results',
  uploadLeadList: 'Upload Lead List',
  listName: 'List Name',
  listNamePlaceholder: 'Enter a name for your list',
  startEnrichment: 'Start Enrichment',
  uploadSuccessPreview: 'Upload Success Preview',
  refineLeadInfoAlert: 'This will refine your existing lead list with AI based on your feedback. The process may take 30-60 seconds to complete.',
  refinementFeatures: 'Refinement Features:',
  intelligentRefinement: 'Intelligently refines your existing lead list',
  preserveOriginalData: 'Preserves original data while incorporating improvements',
  subregionalAnalysis: 'Performs subregional analysis for better coverage',
  consistentFormatting: 'Maintains consistent formatting with previous data',
  autoMergeLeads: 'Automatically merges new and existing leads',
  refineLeadList: 'Refine Lead List',
  refinementFeedback: 'Refinement Feedback',
  refinementFeedbackPlaceholder: 'E.g., Focus on HR departments and companies with more than 100 employees. Include direct phone numbers when available.',
  uploadOwnLeadList: 'Upload your own lead list',
  uploadOwnLeadListDescription: 'Upload a CSV or Excel file with your lead list and type in a name for it.',
  addToFunnel: 'Add to campaign',
  selectCampaignDescription: 'Select a LinkedIn Campaign to add contacts from the lead list (ID: {{leadListId}}).',
  loadingFunnels: 'Loading campaigns...',
  noActiveFunnelsFound: 'No active campaigns found.',
  funnel: 'Funnel',
  conversions: 'Conversions',
  campaignsOperationalOverview: 'Campaigns Operational Overview',
  campaignOverviewPlaceholder: 'Campaign operations overview will appear when you select a campaign.',
  qualifiedContacts_ActiveSourcing: 'Candidates in pipeline',
  contactsInShortlist_ActiveSourcing: 'Candidates in final candidate list',
  contactsInLeadBank_ActiveSourcing: 'Candidates in campaign',
  contactedContacts_ActiveSourcing: 'Contacted Candidates',
  notContactedContacts_ActiveSourcing: 'Not contacted candidates',
  connectedContacts_ActiveSourcing: 'Connected Candidates',
  contactsFinishedFunnel_ActiveSourcing: 'Candidates Finished Funnel',
  contactsCompletedFunnel_ActiveSourcing: 'Completed Candidates',
  qualifiedContacts_LeadBooster: 'Leads in pipeline',
  contactsInShortlist_LeadBooster: 'Leads in final lead list',
  contactsInLeadBank_LeadBooster: 'Leads in campaign',
  contactedContacts_LeadBooster: 'Contacted Leads',
  notContactedContacts_LeadBooster: 'Not contacted leads',
  connectedContacts_LeadBooster: 'Connected Leads',
  contactsFinishedFunnel_LeadBooster: 'Leads Finished Funnel',
  contactsCompletedFunnel_LeadBooster: 'Completed Leads',
  reactionsToMessages: 'Replies to Messages',
  contactedAndReacted: 'Contacted & Reacted',
  acceptedOrReplied: 'Accepted or Replied',
  backToAllCampaigns: 'Back to all campaigns',
  step: 'Step',
  noContactsInThisStep: 'No contacts in this step',
  noLinkedInURL: 'No LinkedIn URL',
  linkedInProfile: 'LinkedIn Profile',
  assessment: 'Assessment',
  contactInformation: 'Contact Information',
  sentMessages: 'Sent Messages',
  receivedMessages: 'Received Messages',
  stepsTaken: 'Steps Taken',
  at: 'at',
  lastCampaignUpdate: 'Last campaign update: {{date}}',
  lastCampaignUpdateBy: 'Last campaign update: {{date}} by {{user}}',
  conversionsAndStatistics: 'Conversions & Statistics',
  networkExpansion: 'How much have you broadened your network?',
  responseRate: 'Response Rate',
  responseRates: 'How many contacts have responded?',
  totalReplies: 'Total Replies',
  avgConnectionRequestAcceptanceTime: 'Avg. Time to Accept Connection Request',
  contactedContacts: 'Contacted Contacts',
  sent: 'Sent',
  responded: 'Responded',
  avgTimeToConversion: 'Avg. Time to Conversion',
  messageStepConversions: 'How well do my messages perform?',
  messageStepConversionsTooltip: 'Which messages lead to the fastest conversions and in what ratio?',
  messageNotReached: 'No messages sent from this step',
  conversionRates: 'Conversion Rates',
  avgConversionRate: 'Avg. Conversion Rate',
  viewCampaignDetails: 'View Campaign Details',
  connectionRequestsRate: 'Connection Request Acceptance Rate',
  acceptedConnectionRequests: 'Accepted Connection Requests',
  sentConnectionRequests: 'Sent Connection Requests',
  skipTutorial: 'Skip Tutorial',
  allMessagesProcessed: 'All messages have been processed',
  unsupportedPlaceholdersWarning: 'The following placeholders are not supported: {{placeholders}}',
  addContactsToCampaignDescription: 'Select a LinkedIn Campaign to add contacts from the lead list ({{leadListId}}).',
  selectCampaignToAddContacts: 'Search here for a campaign...',
  testAutoReplyTitle: 'Test Auto-Reply Function',
  testAutoReplyInstruction: 'Copy and paste a LinkedIn conversation here to test the auto-reply function.',
  pasteLinkedinConversation: 'Paste LinkedIn conversation here...',
  testAutoReplyResult: 'Test Result',
  autoReplyGeneratedMessage: 'Generated Reply (will be sent):',
  autoReplyDetectedCase: 'Detected Case:',
  voiceInputTooltip: 'Enable voice recognition',
  manualInputTooltip: 'Manual input',
  autoDetectLanguage: 'Auto-detect language',
  autoDetectLanguageDescription: 'The language is automatically taken from the job offer you have provided.',
  autoDetectLanguageAndEnglish: 'Auto-detected language and English',
  languageSelection: 'In which languages shall we search?',
  languageSelectionDescription: 'Define the languages for the search keywords that will be used to find relevant contacts.',
  cloneCampaignDescription: 'Use an existing campaign as a template. Clone its settings, update the details, and launch faster.',
  changeCommunicationStyleTitle: 'Note!',
  changeCommunicationStyleDescription1: 'Changing the communication style may cause inconsistencies in your messages—for example, if prompts are set to formal but the style is changed to informal.',
  changeCommunicationStyleDescription2: 'To avoid this, please update the prompts manually or select a new template.',
  briefAndCreateCampaign: 'Brief & create campaign',
  reviewCampaignResults: 'Review campaign results',
  blacklistContactsAndStartCampaign: 'Blacklist contacts & start campaign',
  blacklistsCaption: 'Note: Global blacklists can be edited anytime through the dashboard navigation bar. For campaign-specific blacklists, use Expert Mode within each campaign to make modifications.',
  addGlobalBlacklist: 'Add global blacklist',
  addCampaignSpecificBlacklist: 'Add campaign-specific blacklist',
  globalBlacklistsDescription: 'Global blacklists are blacklists, that are accessible to all of your campaigns. Activate at least one to start blocking contacts.',
  localBlacklistsDescription: 'Campaign-specific blacklists are blacklists, that are only accessible to the campaign you are currently building. Activate at least one to start blocking contacts.',
  blacklistName: 'Blacklist Name',
  enterBlacklistNameHere: 'Enter Blacklist Name here...',
  blacklistCreationBasis: 'On what basis will the blacklist be created?',
  uploadOrTypeItems2: 'How do you want to add {{item}} to the blacklist?',
  beforeStartingCampaignTitle: 'Before starting your campaign remember',
  infoTitle: 'Info',
  noActiveBlacklist: 'You don’t have an active blacklist yet.',
  proceedWithoutExclusions: 'Are you sure you want to proceed without excluding any contacts?',
  agentFailedWarning: 'The agent has failed to create the campaign. Please continue in Expert mode.',
  processingContacts: 'Contacts are being qualified for the shortlist...',
  countryEn: 'Country',
  cityEn: 'City',
  recommended: 'Recommended',
  flowTools: 'Flow Tools',
  zoomIn: 'Zoom-in',
  zoomOut: 'Zoom-out',
  centerFlow: 'Center',
  mouseWheelFunctionality: 'Mouse Wheel Functionality',
  scrollMode: 'Scroll',
  zoomMode: 'Zoom',
  enrichedViaBetterContact: 'Enriched via BetterContact',
  enrichedPhone: 'Enriched phone',
  enrichedEmail: 'Enriched email',
  failed: 'Failed',
  sparse: 'Profile not fully visible',
  enrichmentStatus: 'Enrichment Status',
  not_started: 'Not started',
  in_progress: 'In progress',
  sendAllContacts: 'Send all contacts',
  selectContactsToSend: 'Select contacts to send',
  addSelectedContacts: 'Add selected contacts',
  onlyContactsWithLinkedinUrlCanBeSelected: 'You can only select contacts with a valid LinkedIn URL.',
  webmeticsIntegrationsTitle: 'Webmetics Integrations',
  webmeticsIntegrationsDescription: 'Manage your Webmetics mappings and create searches to import contacts into your funnel.',
  addMappingSet: 'Add mapping set',
  deleteMappingTitle: 'Delete Mapping',
  deleteMappingConfirmation: 'Are you sure you want to delete this Webmetics mapping? This action cannot be undone.',
  createWebmeticsMappingTitle: 'Create Webmetics Mapping',
  updateWebmeticsMappingTitle: 'Update Webmetics Mapping',
  schemaName: 'Schema Name',
  enterSchemaName: 'Enter schema name here...',
  apiKeyWebmetics: 'API Key (Webmetics)',
  enterApiKey: 'Enter API Key here...',
  enterDomain: 'Enter domain here...',
  occupation: 'Occupation',
  enterOccupation: 'Enter occupation here and press enter or click the add button...',
  visitedWebsites: 'Visited Websites',
  visitedWebsitesCommaSeparated: 'Visited Websites (comma separated)',
  enterVisitedWebsites: 'Enter visited websites here...',
  saveMapping: 'Save Mapping',
  updateMapping: 'Update Mapping',
  testMappingResultsTitle: 'Test Mapping Results',
  visitedWebsitesReferrer: 'Visited Websites (Referrers)',
  noVisitedWebsites: 'No visited websites available.',
  funnelId: 'Funnel ID',
  occupations: 'Occupations',
  noMappingsAvailable: 'No Webmetics mappings available. Click Add Mapping Set to create your first mapping.',
  connectionSaved: 'Connection saved successfully!',
  invalidState: 'Invalid state parameter. Please try connecting again.',
  connectionFailed: 'Failed to connect. Please try again.',
  connectToDynamics: 'Connect to Microsoft Dynamics.',
  checkingAdminConsent: 'Checking admin consent status...',
  adminConsentGivenContinueAuth: 'Admin consent is given. Click the button below to complete user authentication.',
  alreadyConnectedToDynamics: 'You are already connected to Microsoft Dynamics.',
  adminConsentMissing: 'Admin consent is missing. Click to complete admin consent.',
  integrationsTitle: 'Integrations',
  integrationsDescription: 'Select a CRM platform to connect and manage your contacts, companies, and activities.',
  microsoftDynamics: 'Microsoft Dynamics',
  hubspot: 'HubSpot',
  connectToHubspot: 'Connect to HubSpot.',
  connectedToHubspot: 'You are already connected to HubSpot.',
  authenticateUser: 'Authenticate User',
  loadingMappings: 'Loading mappings...',
  disconnectCrmTitle: 'Disconnect CRM',
  disconnectCrmConfirmation: 'Are you sure you want to disconnect from {{crm}}? This action cannot be undone.',
  thisCrm: 'this CRM',
  disconnect: 'Disconnect',
  updateMappingSetTitle: 'Update Mapping Set',
  createMappingSetTitle: 'Create Mapping Set',
  loading: 'Loading...',
  mappingSetNameLabel: 'Mapping Set Name',
  triggerLabel: 'Trigger',
  allowAutomaticUpdates: 'Allow automatic updates from non-allowed campaigns',
  allowedCampaignsTitle: 'Allowed Campaigns',
  allowedCampaignsDescription:
    'Select campaigns that are allowed to push contacts to this CRM mapping. If no campaigns are selected and auto-update is disabled, no contacts can be pushed.',
  loadingCampaigns: 'Loading campaigns...',
  noCampaignsAvailable: 'No campaigns available',
  crmSelectionTitle: 'CRM Selection',
  crmSelectionDescription: 'Select the CRM system for all field mappings.',
  fieldMappingsTitle: 'Field Mappings',
  fieldMappingsDescription: 'Map local fields to CRM fields. The email field is required and must be mapped.',
  tableColumnName: 'Name',
  tableColumnLocalField: 'Local Field',
  tableColumnFieldType: 'Field Type',
  tableColumnCrmField: 'CRM Field',
  tableColumnActions: 'Actions',
  enterMappingName: 'Enter mapping name',
  required: 'Required',
  enterCustomField: 'Enter custom field',
  selectFieldTypeFirst: 'Select Field Type first',
  addMapping: 'Add Mapping',
  saveMappingSet: 'Save Mapping Set',
  deal: 'Deal',
  dynamicsOrganizationExample: 'Dynamics Organization (e.g. contoso)',
  regionExample: 'Region (e.g. 4 for crm4.dynamics.com)',
  regionHelperText: 'The region parameter changes the URL from .crm to .crm[region]. Leave empty for default region.',
  saveSettings: 'Save Settings',
  mappingSetName: 'Mapping Set Name',
  createdDate: 'Created Date',
  noCrmMappings: 'No CRM mappings available. Click "Add Mapping Set" to create your first mapping.',
  mappingDetails: 'Mapping Details',
  crmName: 'CRM Name',
  fieldType: 'Field Type',
  localField: 'Local Field',
  crmField: 'CRM Field',
  linkedinAccountLoginInProgress: 'LinkedIn account is logging in',
  licenseCreatedSuccess: 'License created successfully!',
  licenseUpdatedSuccess: 'License updated successfully!',
  globalFunnels: 'Global Funnels',
  globalFunnel: 'Global Funnel',
  globalFunnelDescription: 'Global funnels are funnels that are accessible to all of your campaigns. Activate at least one to start using global funnels.',
  globalFunnelName: 'Global Funnel Name',
  leadListResearchPlaceholder: 'Enter a list of companies here...',
  leadListResearchButton: 'Research Leads',
  leadListResearchResult: 'Lead List Research Result',
  leadListResearchResultDescription: 'The result of the lead list research.',
  leadListResearchResultPlaceholder: 'Enter a list of leads here...',
  leadListResearchResultButton: 'Research Leads',
  customPlaceholders: 'Custom placeholders',
  placeholderKey: 'Placeholder key',
  placeholderValue: 'Placeholder value',
  savePlaceholder: 'Save placeholder',
  customPlaceholdersDescription: 'Create your own placeholders here. You can insert them into any message in the message prompt by typing {{key}} where "key" is the placeholder key.',
  customPlaceholdersLockedTooltip: 'This section cannot be closed while placeholders are in use.',
  customPlaceholdersLockedDescription: 'This section cannot be closed while placeholders are in use.',
  missingCustomPlaceholders: 'You did not use these custom placeholders: {{placeholders}}',
  customPlaceholdersLocked: 'Custom placeholders locked',
  missingCustomPlaceholdersWarning: 'You didn’t use these custom placeholders in your prompt: {{placeholders}}',
  missingPlaceholdersWarningPrefix: 'The following placeholders are missing:',
  missingCustomPlaceholdersWarningPrefix: 'You didn’t use these custom placeholders:',
  placeholderCopied: 'Placeholder copied',
  saveToGlobalStore: 'Add to Store',
  saveToGlobalStoreDescription: 'Save the current prompt to the global store. This will allow you to use the same prompt in other campaigns.',
  saveToGlobalStoreConfirmation: 'Are you sure you want to save the current prompt to the global store? This will allow you to use the same prompt in other campaigns.',
  saveToGlobalStoreConfirmationDescription: 'This will allow you to use the same prompt in other campaigns.',
  saveToGlobalStoreConfirmationButton: 'Save',
  saveToGlobalStoreConfirmationCancel: 'Cancel',
  noValidLicense: 'You do not have a valid license for this product.',
  stopProcessing: 'Is being stopped...',
  contactSearch: 'Contact search',
  pipelineView: 'Pipeline view',
  contactSearchPlaceholder: 'Enter a list of contacts here...',
  contactSearchButton: 'Search Contacts',
  contactSearchResult: 'Contact Search Result',
  contactSearchResultDescription: 'The result of the contact search.',
  contactSearchResultPlaceholder: 'Enter a list of contacts here...',
  contactSearchResultButton: 'Search Contacts',
  answered: 'Answered',
  bookedMeeting: 'Booked meeting',
  qualifiedBant: 'Qualified (BANT)',
  customer: 'Customer',
  lost: 'Lost',
  interviewStage: 'Interview stage',
  interviewStageInt: 'Interview stage (internal)',
  cvToClient: 'CV sent to client',
  clientInterview: 'Client interview',
  hired: 'Hired',
  stageCounts: 'Stage counts',
  conversionPercent: 'Conversion %',
  avgDuration: 'Avg duration',
  avgStep: 'Avg step',
  velocity: 'Velocity',
  pipelineKpis: 'Pipeline KPIs',
  pipeline: 'Pipeline',
  searchContacts: 'Search contact',
  pipelineContactsCount_one: '{{count}} contact',
  pipelineContactsCount_other: '{{count}} contacts',
  pipelineContactsInPipeline: 'Contacts in pipeline',
  pipelineAcrossStages_one: 'across {{count}} stage',
  pipelineAcrossStages_other: 'across {{count}} stages',
  pipelineLostRate: 'Lost rate',
  pipelineLostOfTotal: '{{lost}} of {{total}}',
  pipelineAnswerToClose: 'Answer to close',
  pipelineAvgPerStage: 'Avg per stage',
  pipelineAcrossAllTransitions: 'across all transitions',
  pipelineConversionsAndDurations: 'Conversions & durations',
  pipelineShowDetails: 'Show details',
  pipelineHideDetails: 'Hide details',
  pipelineNoKpiData: 'No data for the selected filters.',
  pipelineInternal: 'Internal',
  pipelineExternal: 'External',
  deleteTenant: 'Delete Client',
  deleteTenantWarning1: 'Should the client <strong>tenantName</strong> really be deleted?',
  deleteTenantWarning2: 'This action cannot be undone. The client will be permanently deleted.',
  createTenant: 'Create Client',
  editTenant: 'Edit Client',
  enterTenantNameHere: 'Enter client name here...',
  enterStreetHere: 'Enter street here...',
  enterPostalCodeHere: 'Enter postal code here...',
  enterCityHere: 'Enter city here...',
  postalCode: 'Postal Code',
  adminLogin: 'Login as Admin',
  adminReloginTitle: 'Login with your own Admin account',
  unlockProduct: 'Unlock Product',
  adminLoginAs: 'Logged in as: {{userEmail}}',
  backToMyAccount: 'Back to my account',
  myProfile: 'My Profile',
  myCompany: 'My Company',
  companyApiKeys: 'API Keys',
  companyApiKeysDescription: 'Generate and manage tenant API keys for external integrations and log access.',
  createApiKey: 'Create API Key',
  editApiKey: 'Edit API Key',
  revokeApiKey: 'Revoke API Key',
  revokeApiKeyWarning: 'This API key will be disabled immediately and external clients using it will stop working.',
  noApiKeysCreatedYet: 'No API keys created yet. Create the first one here.',
  apiKeyNamePlaceholder: 'e.g. Log Database Access',
  apiKeyRateLimit: 'Rate limit',
  apiKeyCreatedSuccessfully: 'API key created successfully',
  apiKeyUpdatedSuccessfully: 'API key updated successfully',
  apiKeyRevokedSuccessfully: 'API key revoked successfully',
  newApiKeyCreated: 'New API key created',
  apiKeyShownOnce: 'Store this API key now. For security reasons it is shown only once.',
  copyApiKeyNow: 'Copy the key now and store it securely.',
  myClients: 'My Clients',
  myUsers: 'My Users',
  myLicenses: 'My Licenses',
  adminPanel: 'Admin Panel',
  invitationStatus_pending: 'Invitation pending',
  invitationStatus_expired: 'Invitation expired',
  invitationStatus_accepted: 'Invitation accepted',
  invitationStatus_none: 'No invitation',
  resendInvitation: 'Resend invitation',
  resendInvitationShort: 'Resend',
  invitationResentSuccessfully: 'Invitation resent successfully',
  userInformationUpdatedSuccessfully: 'User information updated successfully',
  passwordUpdatedSuccessfully: 'Password updated successfully',
  companyInformationUpdatedSuccessfully: 'Company information updated successfully',
  uiLanguage: 'UI Language',
  searchBy: 'Search by:',
  enterSearchTermHere: 'Enter search term here...',
  searchTermsAre: 'Search terms are:\n{{searchTerms}}',
  client: 'Client',
  linkedInAccount: 'LinkedIn Account',
  addClient: 'Add Client',
  noUsersFound: 'No users found',
  noTenantsFound: 'No tenants found',
  userManagement: 'User Management',
  tenantManagement: 'Tenant Management',
  enterUserNameOrEmailHere: 'Enter name or email of the user here...',
  cancelSubscription: 'Cancel Subscription',
  viewInvoices: 'View Invoices',
  manageUsers: 'Manage Users',
  scopes: 'Scopes',
  revoke: 'Revoke',
  lastUsed: 'Last used',
  minute: 'minute',
  copiedToClipboard: 'Copied to clipboard!',
  linkedinAccounts: 'LinkedIn Accounts',
  linkedinAccountOverview: 'LinkedIn Account Overview',
  linkedinAccountOverviewSubtitle: 'The following LinkedIn accounts are linked to your license:',
  researchAgent: 'Leadlist Research Agent',
  invoiceLoadingError: 'Error loading invoices',
  cancelSubscriptionWarning1: 'Are you sure you want to cancel your subscription?',
  cancelSubscriptionWarning2: 'If you continue, your subscription will be canceled at the end of the current billing period.',
  cancelSubscriptionWarning3: 'Canceled licenses cannot be reactivated. You must purchase a new license if you want to use the product again.',
  cancelSubscriptionSuccess: 'Subscription canceled successfully',
  selectCompanyCountryHere: 'Select the country of your company...',
  noLicensesFound: 'No licenses found',
  view: 'View',
  researchQuantity: 'Number of Research Licenses (per period)',
  researchCredits: 'Research Credits',
  confirm: 'Confirm',
  licensesAddedToUserSuccessfully: 'Licenses added to user successfully',
  licenseAddedToUsersSuccessfully: 'License added to users successfully',
  licenseDeletedSuccessfully: 'License deleted successfully',
  manageLicenseUsers: 'Manage License Users',
  manageLicenseUsersFromStripe: 'Thank you for purchasing a license!',
  manageLicenseUsersFromStripeDescription: 'Add the first users to your new license and start right away with the {{productName}}!',
  manageLicenseUsersSubtitle: 'Manage license user assignments for your company',
  manageLicenseUsersTooltip: 'All users of your company are displayed below. Check the boxes for users who should have access to this license. Uncheck boxes for users who should not have access. Users with unchanged checkboxes will keep their current access status.',
  searchForAUser: 'Search for a user...',
  userDeletedSuccessfully: 'User deleted successfully',
  userCreatedSuccessfully: 'User created successfully',
  userUpdatedSuccessfully: 'User information updated successfully',
  tenantDeletedSuccessfully: 'Client deleted successfully',
  tenantCreatedSuccessfully: 'Client created successfully',
  tenantUpdatedSuccessfully: 'Client information updated successfully',
  licensesUpdatedForUserSuccessfully: 'Licenses updated for user successfully',
  manageUserLicensesDialogTitle: 'Manage Licenses',
  manageUserLicensesDialogContent: 'Select the licenses that should be assigned to the user.',
  invoice: 'Invoice',
  amountOf: 'Amount',
  showInvoice: 'Show Invoice',
  sorting: 'Sorting',
  newestFirst: 'Newest first',
  oldestFirst: 'Oldest first',
  nameAscending: 'Name ascending',
  nameDescending: 'Name descending',
  noNumberWarningDialogTitle: 'Invalid input',
  noNumberWarningDialogContent: 'Please enter a valid number.',
  whatIsWrong: 'What is wrong?',
  targetJobTitles: 'Target Job Titles',
  targetJobTitlesHelper: 'Comma separated – e.g. CTO, VP Engineering',
  enterJobTitle: 'Enter a title and press Enter',
  rememberLinkedinAccount: 'Remember LinkedIn accounts',
  emailSenders: 'E-mail Senders',
  manageEmailSenders: 'Manage E-mail Senders',

  alias: 'Alias / Address',
  type: 'Type',
  quota: 'Daily quota',
  noEntries: 'No entries yet',
  /* Wizard */
  provider: 'Provider',
  credentials: 'Credentials',
  summary: 'Summary',
  chooseProvider: 'Choose provider',
  addSender: 'Add sender',
  editSender: 'Edit sender',
  providerGmail: 'Gmail (OAuth)',
  providerMicrosoft365: 'Microsoft 365 (OAuth)',
  providerSmtpImap: 'SMTP / IMAP',
  providerHint: 'Select which sending method you would like to connect.',
  gmailInstructions: 'To connect a Gmail inbox, enter the e-mail address, click “Authorize Gmail” and grant access. Finally paste the code displayed by Google.',
  microsoftInstructions: 'To connect a Microsoft 365 inbox, enter the e-mail address, click “Authorize Microsoft” and grant access. Then paste the authorisation code.',
  smtpInstructions: 'For a classic SMTP / IMAP mailbox, enter the server details and credentials below. We recommend SSL/TLS encryption.',
  smtpSection: 'SMTP (outgoing)',
  imapSection: 'IMAP (incoming)',
  fieldServer: 'Server',
  fieldPort: 'Port',
  fieldEncryption: 'Encryption',
  fieldUsername: 'Username',
  fieldPassword: 'Password',
  fieldEmail: 'E-mail address',
  fieldOauthCode: 'OAuth code',
  hintPasteOauth: 'Paste the code obtained from the authorisation popup',
  encryptionNone: 'None',
  encryptionSSL: 'SSL',
  encryptionTLS: 'TLS',
  encryptionSTARTTLS: 'STARTTLS',
  authorizeGmail: 'Authorize Gmail',
  authorizeMicrosoft: 'Authorize Microsoft',
  smtpServer: 'SMTP server',
  smtpUsername: 'SMTP username',
  imapServer: 'IMAP server',
  imapUsername: 'IMAP username',
  providerLabel_SMTP: 'SMTP / IMAP',
  providerLabel_GMAIL: 'Gmail',
  providerLabel_MS_O365: 'Microsoft 365',
  politeSpeechQuestion: 'Polite speech?',
  checkIsPolite: 'Polite speech',
  aiResearchAgentTitle: 'AI Research Agent',
  aiResearchAgentDescription: 'Enrich your contacts for free using AI-driven web research.',
  enrichViaAIResearchAgent: 'Enrich via AI Research Agent',
  aiResearchEnrichmentInitiatedSuccessfully: 'AI Research enrichment was started successfully.',
  aiResearchEnrichmentFailed: 'AI Research enrichment failed.',
  customFieldEnrichmentInitiatedSuccessfully: 'Custom field enrichment was started successfully.',
  customFieldEnrichmentFailed: 'Custom field enrichment failed.',
  addNewSearch: 'Add new search',
  stopRunningCampaignDialogTitle: 'Stop campaign',
  stopRunningCampaignDialogContent1: 'Running campaigns cannot be edited.',
  stopRunningCampaignDialogContent2: 'To edit the campaign, you must stop it first.',
  stopRunningCampaignDialogContent3: 'Remember to start the campaign again after editing.',
  stopAndEditCampaign: 'Stop campaign & edit',
  reloadSearch: 'Load missing',
  reloadSearchTooltip:
    'The first run completed in full — every result LinkedIn had for this search was fetched. Running it again does not start over: contacts already added are recognised and skipped, and only profiles that could not be added the first time are new.',
  retryStuckSearch: 'Retry',
  retryStuckSearchTooltip:
    'Contact loading was interrupted. Start the search again — contacts already in the campaign are recognised and not duplicated.',
  loadMoreTooltip: 'Note: Contacts are automatically loaded in the background as needed. Only load more manually when you need them immediately.',
  verification: 'Verification',
  orUploadCsv: 'or upload CSV',
  csvLoaded: '{{count}} rows loaded from CSV',
  clickNextToImport: 'Click “Next” to import the senders.',
  importResult: 'Import result: {{success}} success, {{failed}} failed',
  senderVerified: 'Sender verified successfully.',
  verificationFailed: 'Verification failed.',
  poorInboxHint: 'Inbox quality is poor; please review the issues.',
  senderVerifiedSuccessfully: 'Sender verified successfully.',
  csvLoadedSelected: '{{selected}} / {{count}} Zeilen ausgewählt',
  selectRowsHint: 'Wähle per Checkbox, welche Postfächer importiert werden sollen.',
  tablePreviewHint: 'Es werden die ersten {{shown}} von {{total}} Zeilen angezeigt',
  mapCsvColumns: 'CSV-Spalten zuordnen',
  completeMappingHint: 'Ordnen Sie alle benötigten Felder zu, um fortzufahren.',
  secondaryLanguage: 'Secondary language (optional)',
  secondaryLanguageDescription:
    'Leave blank to send all messages in the primary language. If a fallback is set, contacts whose profile language doesn’t match the primary will receive messages in this secondary language.',
  secondaryLanguageMustDiffer: 'Primary and secondary must differ',
  wrongAccountWarningDialogTitle: 'The selected account does not exist!',
  wrongAccountWarningDialogContent1: 'The account with the email address <1>{{email}}</1> does not exist.',
  wrongAccountWarningDialogContent2: 'Please make sure you select an account that is registered with us.',
  aiContactQualification: 'AI Contact Qualification',
  finalContactList: 'Final Contact List',
  contactsInOtherCampaigns: 'Contacts in other campaigns',
  startQualificationProcess_ActiveSourcing: 'Start candidate qualification now',
  startQualificationProcessDescription_ActiveSourcing: 'We evaluate the candidates and create a shortlist based on your criteria.',
  startQualificationProcess_LeadBooster: 'Start lead qualification now',
  startQualificationProcessDescription_LeadBooster: 'We evaluate the leads and create a shortlist based on your criteria.',
  aiContactQualification_ActiveSourcing: 'AI Candidate Qualification',
  aiContactQualificationDescription_ActiveSourcing: 'Set candidate criteria',
  aiContactQualificationExplanation_ActiveSourcing: 'Tell the AI which candidates are particularly relevant to you.',
  aiContactQualification_LeadBooster: 'AI Lead Qualification',
  aiContactQualificationDescription_LeadBooster: 'Set lead criteria',
  aiContactQualificationExplanation_LeadBooster: 'Tell the AI which leads are particularly relevant to you.',
  enrichContacts_ActiveSourcing: 'Enrich candidates',
  enrichContacts_LeadBooster: 'Enrich leads',
  blacklistSource: 'Blacklisted by',
  unknown: 'Unknown',
  uncertainSex: 'Uncertain sex',
  assessedContacts: 'Assessed contacts',
  unassessedContacts: 'Unassessed contacts',
  suspendedContacts: 'Suspended contacts',
  taskAccountDeleted: 'Account deleted',
  deletedContacts: 'Deleted contacts',
  alreadyContactedContacts: 'Already contacted contacts',
  isActiveContacts: 'Active contacts',
  isNotActiveContacts: 'Inactive contacts',
  isFinishedContacts: 'Finished contacts',
  stopAssessment: 'Stop qualification',
  deleteMultipleContacts: 'Delete multiple contacts',
  viewContactFunnel: 'View contact funnel',
  noContactSearchesFound_ActiveSourcing: 'No contacts could be found via LinkedIn search. Please adjust the search radius and/or the campaign briefing and try again.',
  noContactSearchesFound_LeadBooster: 'No leads could be found via LinkedIn search. Please adjust the search radius and/or the campaign briefing and try again.',
  talentSearchFeedbackTitle: 'Search Optimization Suggestions',
  talentSearchFeedbackAccept: 'Apply',
  talentSearchFeedbackAccepted: 'Applied',
  talentSearchFeedbackRetry: 'Retry Search',
  talentSearchFeedbackType_change_title: 'Job Title',
  talentSearchFeedbackType_broaden_location: 'Location',
  talentSearchFeedbackType_general: 'Tip',
  talentSearchViewSuggestions_ActiveSourcing: 'View AI suggestions',
  talentSearchViewSuggestions_LeadBooster: 'View AI suggestions',
  deleteSearchSuccessMessage: 'Search deleted successfully',
  searchReloadedSuccessMessage: 'Started loading the missing contacts',
  searchContinuedSuccessMessage: 'Loading more contacts successfully started',
  localBlacklistCreatedSuccessMessage: 'Campaign-specific blacklist created successfully',
  blacklistUpdatedSuccessMessage: 'Blacklist updated successfully',
  blacklistDeletedSuccessMessage: 'Blacklist deleted successfully',
  blacklistAddedSuccessMessage: 'Blacklist added to campaign successfully',
  blacklistRemovedSuccessMessage: 'Blacklist removed from campaign successfully',
  contactAddedSuccessMessage: 'Contact added successfully',
  contactDeletedSuccessMessage: 'Contact deleted successfully',
  contactsDeletedSuccessMessage: '{{count}} contact(s) deleted successfully',
  contactActivatedSuccessMessage: 'Contact added to final contact list successfully',
  contactDeactivatedSuccessMessage: 'Contact removed from final contact list successfully',
  contactsActivatedSuccessMessage: '{{count}} contact(s) added to final contact list successfully',
  contactsDeactivatedSuccessMessage: '{{count}} contact(s) removed from final contact list successfully',
  aiJudgementUpdatedSuccessMessage: 'AI assessment updated successfully',
  sexUpdatedSuccessMessage: 'Sex updated successfully',
  contactRemovedFromBlacklistSuccessMessage: 'Contact removed from blacklist successfully',
  contactRemovedFromSuspendedSuccessMessage: 'Contact suspension removed successfully',
  contactRecoveredFromDeletedSuccessMessage: 'Contact recovered successfully',
  recoverFromDeleted: 'Recover',
  addContacts_ActiveSourcing: 'Add candidates',
  addContacts_LeadBooster: 'Add leads',
  contactOverview_ActiveSourcing: 'Candidate overview',
  contactOverview_LeadBooster: 'Lead overview',
  allContacts_ActiveSourcing: 'All candidates',
  allContacts_LeadBooster: 'All leads',
  isActiveContacts_ActiveSourcing: 'Active candidates',
  isActiveContacts_LeadBooster: 'Active leads',
  isNotActiveContacts_ActiveSourcing: 'Inactive candidates',
  isNotActiveContacts_LeadBooster: 'Inactive leads',
  isFinishedContacts_ActiveSourcing: 'Finished candidates',
  isFinishedContacts_LeadBooster: 'Finished leads',
  alreadyContactedContacts_ActiveSourcing: 'Already contacted candidates',
  alreadyContactedContacts_LeadBooster: 'Already contacted leads',
  uncertainSexContacts_ActiveSourcing: 'Sex could not be determined',
  uncertainSexContacts_LeadBooster: 'Sex could not be determined',
  blacklistedContacts_ActiveSourcing: 'Blacklisted candidates',
  blacklistedContacts_LeadBooster: 'Blacklisted leads',
  suspendedContacts_ActiveSourcing: 'Suspended candidates',
  suspendedContacts_LeadBooster: 'Suspended leads',
  deletedContacts_ActiveSourcing: 'Deleted candidates',
  deletedContacts_LeadBooster: 'Deleted leads',
  contactsInOtherCampaigns_ActiveSourcing: 'Candidates in other campaigns',
  contactsInOtherCampaigns_LeadBooster: 'Leads in other campaigns',
  finalContactList_ActiveSourcing: 'Final candidate list',
  finalContactList_LeadBooster: 'Final lead list',
  deleteMultipleContacts_ActiveSourcing: 'Delete multiple candidates',
  deleteMultipleContacts_LeadBooster: 'Delete multiple leads',
  viewContactFunnel_ActiveSourcing: 'View candidate funnel',
  viewContactFunnel_LeadBooster: 'View lead funnel',
  singleContact: 'Single contact',
  multipleContacts: 'Multiple contacts',
  contactFunnelOverview: 'Contact funnel overview',
  generatingSankeyDiagram: 'Generating Sankey diagram...',
  manuallyAdded: 'Manually added',
  crawlable: 'Found in LinkedIn search',
  crawled: 'Added from search',
  outOfNetwork: 'Out of network',
  notCrawled: 'Not added',
  crawlingBuffer: 'Will be added later',
  crawledTwice: 'Duplicate (found in multiple searches)',
  otherNotCrawled: 'For other reasons not added\n(Found in multiple searches, Out-of-Network, etc.)',
  profileVisited: 'Profile visited & loaded',
  profileNotVisited: 'Profile not visited',
  needAction: 'Needs action',
  a: 'A',
  b: 'B',
  c: 'C',
  notJudgedYet: 'No AI judgement',
  judgedIn: 'Judged in',
  judgedOut: 'Judged out',
  final: 'Final',
  contactedElsewhere: 'Contacted elsewhere',
  contactedElsewhere_ActiveSourcing: 'Approached elsewhere',
  contactedElsewhere_LeadBooster: 'Approached elsewhere',
  contactedElsewhereInCampaign: 'Already approached in the campaign "{{campaign}}"',
  deleted: 'Deleted',
  blacklisted: 'Blocked (Blacklist)',
  aiJudgingError: 'AI judging error',
  useableContacts: 'Useable contacts',
  inCampaign: 'In campaign',
  inFinalList: 'In final list',
  contactPipeline_ActiveSourcing: 'Candidate pipeline',
  contactPipeline_LeadBooster: 'Lead pipeline',
  fromDate: 'From',
  toDate: 'To',
  overallCampaignRuntime: 'Overall campaign runtime',
  searchName: 'Search/source name',
  newestLicenseFirst: 'Newest license first',
  oldestLicenseFirst: 'Oldest license first',
  statusMessages: 'Status Messages',
  addNewMessage: 'Add new message',
  editMessage: 'Edit message',
  englishText: 'English Text',
  germanText: 'German Text',
  updatedAt: 'Updated at',
  noStatusMessagesFound: 'No status messages found',
  enterEnglishTextHere: 'Enter English text here...',
  enterGermanTextHere: 'Enter German text here...',
  englishTextRequired: 'The English text is required',
  germanTextRequired: 'The German text is required',
  deleteStatusMessageDialogTitle: 'Delete status message',
  deleteStatusMessageDialogContent1: 'Are you sure you want to delete this status message?',
  deleteStatusMessageDialogContent2: 'This action cannot be undone.',
  manageSubscriptionAndInvoices: 'Manage subscription & invoices',
  askForSyncDialogTitle: 'Log in to LinkedIn account',
  askForSyncDialogContent1: 'We have detected that your LinkedIn account <1>{{userEmail}}</1> is currently not logged in.',
  askForSyncDialogContent2: 'To edit the campaign, you should log in with your LinkedIn account. For viewing only, no login is required.',
  stayLoggedOut: 'View only',
  loginNow: 'Log in now',
  dontQualify: 'Continue without qualification',
  addContactSearch_ActiveSourcing: 'Add candidate search',
  addContactSearch_LeadBooster: 'Add lead search',
  editLinkedinAccountLimits: 'Edit LinkedIn account limits',
  editLinkedinAccountLimitsDescription: 'Edit the limits and schedule for your LinkedIn account.',
  editLinkedinAccountLimitsWorkDays: 'Work days',
  editLinkedinAccountLimitsWorkHours: 'Work hours',
  editLinkedinAccountLimitsTimeZone: 'Time zone',
  editLinkedinAccountLimitsMessageDailyLimit: 'Message daily limit',
  editLinkedinAccountLimitsVisitDailyLimit: 'Visit daily limit',
  editLinkedinAccountLimitsCooldownAfterMessages: 'Cooldown after messages',
  editLimitsAndSchedule: 'Edit limits & schedule',
  editAccountLimitsTitle: 'Account limits & working time',
  dailyActivityLimits: 'Daily activity limits',
  dailyVisitLimit: 'Daily profile-visit limit',
  cooldownAfterMessages: 'Pause after messages (sec)',
  cooldownAfterVisits: 'Pause after visits (sec)',
  profileVisits: 'Profile visits',
  editQuotaSplit: 'Edit quota split',
  quotaSplit: 'Quota split (optional)',
  weight: 'Weight',
  percentage: 'Percentage',
  visits: 'Visits',
  connections: 'Connections',
  linkedinAccountSettings: 'LinkedIn account settings',
  day: 'Day',
  defineQuotaSplitDescription: 'This feature is aimed at experienced users: Here you can distribute your daily quota specifically to different campaigns. Only adjust the weights if you are sure how this affects your campaigns.',
  currentSettings: 'Current settings',
  current: 'Current',
  changesAreSavedAutomatically: 'Changes are saved automatically',
  editLimitsAndAccountWorkingTime: 'Edit limits & account working time',
  selectLinkedinAccountToViewSettings: 'Select a LinkedIn account to view settings',
  campaignWorkUnitsStatus: 'Campaign work units status',
  globalWorkUnitsStatus: 'Global work units status',
  systemStatus: 'System status',
  currentlyProcessing: 'Currently being processed',
  upNext: 'Next to be processed',
  recentFailures: 'Recent failures',
  systemLoad: 'System load',
  noWorkUnitsInQueue: 'No work units in queue',
  runningFor: 'Running for',
  workUnitsStatus: 'Work units status',
  lastUpdated: 'Last updated',
  unknownCampaign: 'Unknown campaign',
  startsIn: 'Starts in',
  workingUnits: 'Working units',
  pendingUnits: 'Pending units',
  currentStep: 'Current step',
  selectedStep: 'Selected step',
  allChangesSaved: 'all changes saved',
  working: 'Working',
  noWorkUnitsProcessing: 'No work units are currently being processed',
  workUnitSend: 'Send',
  workUnitAnalyze: 'Analyze',
  workUnitSearch: 'Search',
  workUnitWrite: 'Write',
  workUnitWait: 'Wait',
  workUnitJudge: 'Judge',
  workUnitCheckIfConnected: 'Check if connected',
  workUnitCheckIfConnectedUntil: 'Check if connected until',
  workUnitWithdraw: 'Withdraw',
  workUnitCheckInbox: 'Check inbox',
  workUnitCheckConnection: 'Check connection',
  workUnitReply: 'Reply',
  workUnitAiSearch: 'AI search',
  adjustWeights: 'Adjust weights',
  hideWeights: 'Hide weights',
  loadingWorkUnitsStatus: 'Loading work units status...',
  stop: 'Stop',
  useInFreemium: 'Use in Freemium',
  freemiumCampaignLimitReached: 'In the Freemium you can only create one campaign.',
  setProductVisibilityAndLicenses: 'Set product visibility & licenses',
  runningCampaigns: 'Running campaigns',
  namesNotFoundWarning: 'Name not found. Please set the name manually under "Edit username".',
  resetTokenExpired: 'Reset token expired',
  resetTokenExpiredParagraph: 'The token to reset the password has expired. Please request a new email and reset the password within 12 hours of receiving the email.',
  requestNewEmail: 'Request new email',
  invalidRequestUserIdOrResetTokenMissing: 'User ID or reset token missing',
  tokenAlreadyUsedDialogTitle: 'Token already used',
  tokenAlreadyUsedDialogContent1: 'The token to reset the password has already been used.',
  tokenAlreadyUsedDialogContent2: 'Please request a new email and reset the password within 12 hours of receiving the email.',
  analysisInProgressDialogTitle: 'Analysis already started',
  analysisInProgressDialogContent1: 'The profile analysis for this campaign has already been started and is running in the background. The contacts will be analyzed or will start shortly.',
  analysisInProgressDialogContent2: 'No action required — you do not need to start it again.',
  jobSearchUrlRequired: 'Job-Search URL (required)',
  pasteLinkedinJobsPageUrl: 'Paste the full URL from the LinkedIn jobs page',
  targetJobTitlesRequired: 'Target Job Titles (required)',
  enterJobTitlePlaceholder: 'Enter job title here and press enter or click the add button...',
  noJobTitlesAddedYetAddATitleAboveToGetStarted: 'No job titles added yet. Add a title above to get started.',
  targetJobTitlesCount: 'Target Job Titles ({{count}})',
  enableJudgingForThisCampaign: 'Enable Judging for this campaign',
  enableJudgingForThisCampaignDescription: 'When enabled, profiles will be judged automatically. Fill out criteria below for custom qualification, or leave empty for AI-based qualification.',

  // ============================================
  // AI CHAT ASSISTANT
  // ============================================

  // General
  aiAssistant: 'AI Assistant',
  aiChatTitle: 'SAIA',
  aiChatSubtitle: 'Your intelligent campaign helper',

  // Welcome screen
  aiChatWelcome: 'Hello! How can I help you today?',
  aiChatWelcomeSubtitle: 'I can help you create campaigns, manage accounts, and analyze performance.',

  // Quick actions
  aiChatAddAccount: 'Add LinkedIn Account',
  aiChatCreateCampaign: 'Create Campaign',
  aiChatViewStats: 'View Statistics',
  aiChatGetHelp: 'Get Help',
  aiChatTutorial: 'Get Started Tutorial',
  aiChatMyCampaigns: 'My Campaigns',

  // Input
  aiChatInputPlaceholder: 'Type your message...',
  aiChatSend: 'Send',
  aiChatTyping: 'SAIA is typing...',

  // Chat panel
  aiChatMinimize: 'Minimize',
  aiChatMaximize: 'Maximize',
  aiChatClose: 'Close',
  aiChatClearHistory: 'Clear conversation',
  aiChatClearHistoryConfirm: 'Are you sure you want to clear the conversation history?',

  // Mode toggle
  chatMode: 'Chat',
  aiChatExpertMode: 'Expert',
  campaignMode: 'Campaign Mode',
  chatModeDescription: 'AI-guided campaign creation with step-by-step assistance',
  expertModeDescription: 'Full manual control over campaign settings',
  simplifiedMode: 'Simplified Mode',

  // Cards
  aiChatConfirm: 'Confirm',
  aiChatCancel: 'Cancel',
  aiChatEdit: 'Edit',
  aiChatSubmit: 'Submit',
  aiChatAutoFix: 'Auto-fix',

  // Wizard
  campaignWizard: 'Campaign Wizard',
  stepsCompleted: 'steps completed',
  wizardStep: 'Step',
  confirmAndContinue: 'Confirm & Continue',
  makeChanges: 'Make Changes',
  wizardBack: 'Back',

  // Wizard steps
  type_selection: 'Campaign Type',
  type_selection_desc: 'Choose between recruiting or sales campaign',
  name_account: 'Name & Account',
  name_account_desc: 'Set campaign name and select LinkedIn account',
  briefing: 'Briefing',
  briefing_desc: 'Describe your job/product and target audience',
  targeting: 'Target Audience',
  targeting_desc: 'Define who you want to reach',
  wizardContacts: 'Contact Source',
  contacts_desc: 'Choose how to add contacts to the campaign',
  wizardMessages: 'Messages',
  messages_desc: 'Create personalized message templates',
  flow: 'Campaign Flow',
  flow_desc: 'Design your outreach sequence',
  wizardSettings: 'Settings',
  settings_desc: 'Configure working hours and limits',
  review: 'Review',
  review_desc: 'Review all campaign settings',
  validation: 'Quality Check',
  validation_desc: 'AI validates your campaign before launch',
  wizardComplete: 'Complete',
  complete_desc: 'Campaign is ready to launch',

  // Validation
  qualityScore: 'Quality Score',
  readyToLaunch: 'Ready to Launch',
  issuesFound: 'Issues Found',
  mustFix: 'Must Fix',
  wizardRecommended: 'Recommended',
  wizardOptional: 'Optional Improvements',
  validationErrors: 'errors',
  validationWarnings: 'warnings',
  validationSuggestions: 'suggestions',
  revalidate: 'Re-validate',
  launchCampaign: 'Launch Campaign',
  checkedAt: 'Checked at',

  // Validation categories
  messageQuality: 'Message Quality',
  targetingQuality: 'Targeting Quality',
  sequenceLogic: 'Sequence Logic',
  accountReadiness: 'Account Readiness',
  validationCompliance: 'Compliance',
  bestPractices: 'Best Practices',

  // Account cards
  cardAccountStatus: 'Account Status',
  lastSynced: 'Last Synced',
  syncNow: 'Sync Now',
  updateCookie: 'Update Cookie',

  // Campaign cards
  cardCampaignSummary: 'Campaign Summary',
  cardCampaignStatus: 'Status',
  cardCampaignType: 'Type',
  contactsInCampaign: 'Contacts',
  viewDetails: 'View Details',
  cardEditCampaign: 'Edit Campaign',

  // Error states
  aiChatError: 'Something went wrong',
  aiChatRetry: 'Try again',
  aiChatNoConnection: 'Unable to connect to the AI assistant',

  // Loading states
  aiChatLoading: 'Loading...',
  aiChatProcessing: 'Processing your request...',
  aiChatAnalyzing: 'Analyzing...',
  chatCurrentAction: 'What chat is currently doing',
  chatUnderstood: 'What chat understood',
  chatMissingDetails: 'Missing details',
  qualityCheck: 'Quality check',
  qualityStatus: 'Success',
  chatErrors: 'Errors',
  chatInfo: 'Info',
  status: 'Status',
  chatLiveStatusNow: 'What chat is doing right now',
  chatLiveStatusPreparing: 'Preparing answer',
  chatLiveStatusPreparingDetail: 'I am collecting context and preparing the next step.',
  saiaWorking: 'SAIA is working on it...',
  saiaWorkedSteps: 'Steps performed',
  workStepUnderstanding: 'Understanding your message',
  workStepAnswering: 'Writing the answer',
  workStepSeconds: '{{count}} s',
  workStepsEarlier: '+ {{count}} earlier steps',
  workStepFailed: 'failed, correcting course',
  chatLiveStatusTooling: 'Running checks',
  chatLiveStatusToolingDetail: 'I am validating data and executing the right actions.',
  chatLiveStatusReasoning: 'Structuring response',
  chatLiveStatusReasoningDetail: 'I am mapping your request to the best possible answer.',
  chatLiveStatusResponding: 'Streaming answer',
  chatLiveStatusRespondingDetail: 'I am finalizing the response and quality-checking content.',

  // Empty states
  aiChatNoMessages: 'No messages yet',
  aiChatStartConversation: 'Start a conversation by typing a message below',

  // Public Chat Dashboard
  'publicChat.login': 'Login',
  'publicChat.signup': 'Sign Up Free',
  'publicChat.welcomeTitle': 'Welcome to SAIA',
  'publicChat.welcomeSubtitle': 'I\'m your confidential AI agent for LinkedIn automation. Ask me anything about how SAIA can help you reach more people, faster — with maximum discretion.',
  'publicChat.inputPlaceholder': 'Ask me anything about SAIA...',
  'publicChat.signupTitle': 'Create Your Account',
  'publicChat.signupSubtitle': 'Start your free 14-day trial',
  'publicChat.firstName': 'First Name',
  'publicChat.lastName': 'Last Name',
  'publicChat.email': 'Email',
  'publicChat.password': 'Password',
  'publicChat.passwordRepeat': 'Repeat password',
  'publicChat.passwordHint': 'At least {{count}} characters.',
  'publicChat.passwordRepeatHint': 'Enter it once more to be safe.',
  'publicChat.passwordsMatch': 'Passwords match',
  'publicChat.showPassword': 'Show password',
  'publicChat.hidePassword': 'Hide password',
  'publicChat.sectionPerson': 'About you',
  'publicChat.sectionPassword': 'Password',
  'publicChat.signupTrustLine': '14-day free trial · cancel anytime',
  'publicChat.errorFirstName': 'Please enter your first name.',
  'publicChat.errorLastName': 'Please enter your last name.',
  'publicChat.errorEmailRequired': 'Please enter your email address.',
  'publicChat.errorEmailInvalid': 'Please enter a valid email address.',
  'publicChat.errorPasswordRequired': 'Please choose a password.',
  'publicChat.errorPasswordShort': 'The password needs at least {{count}} characters.',
  'publicChat.errorPasswordLong': 'The password may have at most {{count}} characters.',
  'publicChat.errorPasswordRepeatRequired': 'Please enter the password again.',
  'publicChat.errorPasswordMismatch': 'The passwords do not match.',
  'publicChat.errorTerms': 'Please accept the terms and the privacy policy.',
  'publicChat.companyName': 'Company Name (optional)',
  'publicChat.createAccount': 'Create Account',
  'publicChat.alreadyHaveAccount': 'Already have an account?',
  'publicChat.loginInstead': 'Log in',
  'publicChat.termsNotice': 'By signing up, you agree to our Terms of Service and Privacy Policy',
  'publicChat.loginTitle': 'Welcome Back',
  'publicChat.loginSubtitle': 'Log in to continue',
  'publicChat.loginButton': 'Log In',
  'publicChat.noAccount': 'Don\'t have an account?',
  'publicChat.signupInstead': 'Sign up free',
  'publicChat.pricingTitle': 'Choose Your Plan',
  'publicChat.pricingSubtitle': '14-day free trial on all plans. Cancel anytime.',
  'publicChat.featuresTitle': 'What SAIA Can Do For You',
  'publicChat.safetyTitle': 'Your Account is Protected',
  'publicChat.safetySubtitle': 'Industry-leading safety measures',
  'publicChat.safetyNote': 'Most users never experience any issues. We prioritize your account safety above everything.',
  'publicChat.forgotPasswordLink': 'Forgot password?',
  'publicChat.forgotPasswordTitle': 'Reset your password',
  'publicChat.forgotPasswordLead':
    'Enter the email you use for SAIA. We will send you a link to set a new password.',
  'publicChat.forgotPasswordButton': 'Send reset link',
  'publicChat.forgotPasswordSuccessTitle': 'Check your email',
  'publicChat.forgotPasswordSuccessBody':
    'We sent a reset link to {{email}}. Open it from your inbox to continue — the link is valid for 12 hours.',
  'publicChat.forgotPasswordInvalidEmail': 'Please enter a valid email address.',
  'publicChat.forgotPasswordUserNotFound': 'No account found for this email.',
  'publicChat.backToLogin': 'Back to sign in',

  'pwaInstall.tooltip': 'Install App',
  'pwaInstall.iosTitle': 'Add App to Home Screen',
  'pwaInstall.iosSubtitle': 'Install SAIA as an app on your iPhone or iPad for faster access without the browser.',
  'pwaInstall.iosStep1': 'Tap the Share button (square with an arrow) in the Safari toolbar.',
  'pwaInstall.iosStep2': 'Scroll down and tap "Add to Home Screen".',
  'pwaInstall.iosStep3': 'Tap "Add" to confirm – done!',
  'pwaInstall.close': 'Got it',

  // Campaign overview (card layout)
  campaignCountLine: '{{shown}} of {{total}} campaigns · {{active}} active',
  campaignCardMeta: '{{lead}} · created {{date}}',
  campaignAcceptedReplied: 'Accepted / replied',
  searchCampaignPlaceholder: 'Search campaign …',
  rememberAccounts: 'Remember accounts',
  workUnits: 'Work Units',
  newCampaignShort: 'New campaign',

  // Administration (catalogue + monitoring dashboard)
  adminOverviewSubtitle: 'Owner role only',
  adminPurposePrompts: 'Maintain system prompts per product and funnel function',
  adminPurposeStatusMessages: 'Plan and publish banners for all tenants',
  adminPurposeMonitoring: 'Work units, daily limits and utilization per account',
  adminPurposeUserOverview: 'Search all users across all tenants',
  adminPurposeQueue: 'Inspect, restart or remove stuck work units',
  adminPurposeCampaignTimeline: 'Trace a contact\u2019s history within a campaign',
  adminPurposeLinkedinSession: 'Login errors and session drops of the last 24 hours',
  adminPurposeFeedbackTickets: 'Read and answer submitted tickets',
  adminMonitoringUpdated: 'Updated {{time}} · every {{seconds}} s',
  adminKpi_pending: 'Pending',
  adminKpi_processing: 'Processing',
  adminKpi_failed: 'Failed',
  adminKpi_finished: 'Finished',
  adminKpi_interrupted: 'Interrupted',
  adminChartPendingByType: 'Pending units by type',
  adminChartPendingByPriority: 'Pending units by priority',
  adminChartWorktime: 'Within working hours',
  adminWorktimeIn: 'In working hours',
  adminWorktimeOut: 'Outside',
  adminWorktimeUnknown: 'Unknown',
  adminProcessingTitle: 'Processing',
  adminProcessingCount: 'Live · {{units}} units',
  adminPendingTitle: 'Pending (sample)',
  adminPendingCount: '{{units}} units',
  adminColCampaign: 'Campaign',
  adminColTenant: 'Tenant',
  adminColType: 'Type',
  adminColPriority: 'Priority',
  adminColStarted: 'Started',
  adminColCreated: 'Created',
  adminColInWorktime: 'In working hours',
  adminActionRemove: 'Remove',
  adminConfirmRemovalTitle: 'Remove work unit',
  adminConfirmRemovalText: 'Are you sure you want to remove this work item?',
  adminDailyLimitsTitle: 'Daily limits',
  adminLimit_messages: 'Messages',
  adminLimit_connections: 'Connection requests',
  adminLimit_emails: 'Emails',
  adminLimit_inmails: 'InMails',
  adminLimit_visits: 'Profile visits',
  adminNoData: 'No data',

  // Public pages (sign up, reset password, 404)
  authSignupSubheadline: 'Just a few clicks away from your outreach revolution.',
  authSignupFormTitle: 'Create account',
  authSignupFormSubtitle: 'Start for free, no payment details required.',
  authMarketingStatBadge1: '2x',
  authMarketingStatText1: 'more replies',
  authMarketingStatBadge2: '3x',
  authMarketingStatText2: 'faster time-to-hire',
  authMarketingStatBadge3: '100%',
  authMarketingStatText3: 'tailored outreach based on personality insights',
  authFieldEmailLabel: 'Email address',
  authFieldEmailPlaceholder: 'name@company.com',
  authFieldCompanyPlaceholder: 'Example Ltd.',
  authFieldPasswordPlaceholder: 'At least 6 characters',
  authResetPasswordTitle: 'Reset password',
  authResetPasswordIntro: 'We will send a link to the email address stored in your profile. Please enter it here.',
  pageNotFoundEyebrow: 'ERROR 404',
  pageNotFoundHeadline: 'This page does not exist',
  pageNotFoundDescription: 'It may have been moved or the link is out of date.',
  pageNotFoundBack: 'Back',
  pageNotFoundHome: 'Go to home page',

  // Upgrade / pricing (design 2b)
  chooseLicense: 'Choose license',
  chooseBundle: 'Choose bundle',
  pricingVatNote: 'All prices incl. 19 % VAT. No hidden costs. Cancel anytime.',
  billingMonthly: 'Monthly',
  billingQuarterly: 'Quarterly −10%',
  billingYearly: 'Yearly −20%',
  billedMonthly: 'Billed monthly',
  billedQuarterly: 'Billed quarterly',
  billedYearly: 'Billed yearly',
  perMonthPerLicense: '/ month / license',
  savedComparedToMonthly: '{{percent}} % saved compared to monthly',

  // Account management (design 1b)
  myProfileSubtitle: 'Name, email address, language and password',
  myCompanySubtitle: 'Company details and billing address',
  myClientsSubtitle: 'Manage clients and look after their users',
  myUsersSubtitle: 'Invite users, assign roles and licenses',
  myLicensesSubtitle: 'Active licenses, assignments and billing',
  adminPanelSubtitle: 'All tenants, users and licenses of the platform',
  personalData: 'Personal data',
  personalDataHint: 'This information appears in campaigns and shares.',
  changePasswordHint: 'At least 8 characters. You stay signed in after saving.',

  // Text optimization (two-zone layout)
  lastSavedAt: 'Last saved {{time}}',
  analysisUpToDate: 'Analysis up to date',
  analysisNotRunYet: 'Not analyzed yet',
  analysisRunning: 'Analysis running …',
  applySuggestion: 'Apply',
  suggestionIgnoreOnce: 'Ignore once',
  suggestionIgnoreAlways: 'Always',

  // Account management – block titles of the content cards
  companyDataTitle: 'Company details',
  companyDataHint: 'This address appears on invoices and in outgoing documents.',
  userListTitle: 'User overview',
  licenseListTitle: 'License overview',
  tenantListTitle: 'Client overview',
  // App sync wizard (connect account)
  appSyncConnectLinkedinAccount: 'Connect LinkedIn account',
  appSyncLogoutHeader: 'Sign out LinkedIn account',
  appSyncStepCounter: 'Step {{current}} of {{total}}',
  appSyncConnectedElsewhere: 'This LinkedIn account is already connected in another workspace. If it is used in two places at the same time, LinkedIn signs the sessions out. Please disconnect it there or contact support.',
  appSyncProductLinkedin: 'LinkedIn Standard',
  appSyncProductLinkedinDescription: 'Connections, messages, inbox',
  appSyncProductRecruiter: 'Recruiter',
  appSyncProductRecruiterDescription: 'Talent search, InMail, projects',
  appSyncProductSalesNavigator: 'Sales Navigator',
  appSyncProductSalesNavigatorDescription: 'Lead search, lists, InMail',
  appSyncSelectProductTitle: 'Which account are we setting up?',
  appSyncSelectProductDescription:
    'We sign you in through the real LinkedIn app on a dedicated device. That is more stable and needs no parallel browser sessions.',
  appSyncLicenseSeat: 'License seat',
  appSyncSelectLicenseSeat: 'Select a seat',
  appSyncFreeSeats: '{{seats}} seats available',
  appSyncCredentialsTitle: 'Your LinkedIn credentials',
  appSyncCredentialsDescription: 'We store them encrypted and use them only to sign in to the app.',
  appSyncCredentialsPhoneHint: 'Keep your phone nearby: LinkedIn sends a confirmation you have to approve once.',
  appSyncCountry: 'Country',
  appSyncRegion: 'Region',
  appSyncRegionSelectCountryFirst: 'Pick a country first.',
  appSyncLocationTitle: 'Where should this account be online?',
  appSyncLocationDescription:
    'Your account gets its own fixed IP address in this region. Pick the place where the account owner usually works — that keeps the login trusted for good.',
  appSyncLocationHint:
    'A dedicated fixed IP is a prerequisite for the app login — it prevents the daily 2FA prompts that come with rotating addresses. It is used for this account only and we take care of it.',
  appSyncStartLogin: 'Start the login',
  appSyncConnectTitle: 'We are connecting your account',
  appSyncConnectDescription: 'This runs automatically. You do not have to do anything until we ask you for your code.',
  appSyncLogoutTitle: 'We are signing your account out',
  appSyncConnectStageIp: 'Fixed IP secured',
  appSyncConnectStageDevice: 'Device prepared',
  appSyncConnectStageDeviceHint: 'LinkedIn app ready to go',
  appSyncConnectStageSignIn: 'Signing in to LinkedIn',
  appSyncConnectStageSignInHint: 'We open the app and sign in…',
  appSyncConnectStageTwoFa: 'Two-step verification',
  appSyncConnectStageTwoFaHint: 'We will ask you for the code in a moment',
  appSyncConnectStageContract: 'Choose contract',
  appSyncConnectStageContractHint: 'Recruiter / Sales Navigator only',
  appSyncConnectStageDone: 'Done',
  appSyncTwoFaTitle: 'Quickly confirm it is you',
  appSyncTwoFaDescription:
    'Open your authenticator app and enter the 6-digit code. LinkedIn uses it to trust this device for good — after that you will not have to do this again.',
  appSyncTwoFaViaApp: 'Approve in the LinkedIn app',
  appSyncTwoFaViaCode: 'Code from your app',
  appSyncTwoFaSecondRoundHint: 'A second confirmation for the {{productApp}} app follows — then you are done with both.',
  appSyncConfirm: 'Confirm',
  appSyncChooseContractTitle: 'Which contract should we use?',
  appSyncChooseContractDescription: 'Your account has several contracts. Pick the one we should work with.',
  appSyncApplyContract: 'Apply',
  appSyncYourChoice: 'Your choice, quickly',
  appSyncDoneTitle: 'Account connected',
  appSyncDoneDescription: '{{name}} is ready to go. From here everything runs automatically — no signing in again.',
  appSyncDoneFactIp: 'Fixed IP & device assigned',
  appSyncDoneFactTrust: 'Device trusted — future logins without 2FA',
  appSyncDoneFactProduct: '{{product}} active',
  appSyncGoToAccounts: 'Go to my accounts',
  appSyncErrorWrongPasswordTitle: 'That password is not right',
  appSyncErrorWrongPasswordText:
    'LinkedIn rejected the login. Check the credentials and try again — your account is not blocked.',
  appSyncErrorWrongPasswordFieldHint: 'Please enter the current LinkedIn password.',
  appSyncErrorSignInAgain: 'Sign in again',
  appSyncErrorWrongPinTitle: 'The code was rejected',
  appSyncErrorCaptchaTitle: 'Time ran out',
  appSyncErrorLoginExpiredTitle: 'The login expired',
  appSyncErrorOnboardingTitle: 'The LinkedIn onboarding is not finished',
  appSyncErrorTwoFaTitle: 'Enable two-factor verification for {{liProductType}}',
  appSyncErrorUnknownTitle: 'We are on it',
  appSyncErrorUnknownText:
    'Something unexpected happened during the login. The error is logged with all details — reach out to support and we will look into it.',
  appSyncErrorUnknownRetryHint: 'We will retry automatically in a moment.',
  appSyncErrorReference: 'Reference',

  flowBuilderTitle: 'Create flow',
  flowBuilderDone: 'Done',
  flowBuilderLoading: 'Checking what the campaign already knows …',
  flowBuilderQuestionOf: 'Question {{n}} of {{total}}',
  flowBuilderGreeting: 'I will build the flow for this campaign. This is what I already know:',
  flowBuilderIntro: '{{count}} questions, then the flow with all messages appears in the canvas on the left.',
  flowBuilderKnownAccount_sales_navigator: 'Account: Sales Navigator, InMail credit',
  flowBuilderKnownAccount_recruiter: 'Account: Recruiter, InMail credit',
  flowBuilderKnownAccount_normal: 'Account: LinkedIn without visible Premium',
  flowBuilderKnownClients: 'You recruit as an agency',
  flowBuilderKnownOwn: 'You recruit for your own company',
  flowBuilderKnownOffer: 'Offer from the briefing',
  flowBuilderKnownLanguage: 'Language: {{lang}}',
  flowBuilderQAudience: 'Whom does this campaign address?',
  flowBuilderAudience_new: 'New contacts only',
  flowBuilderAudienceNewDesc: 'Connection request first, InMail as fallback',
  flowBuilderAudience_existing: 'Existing contacts only',
  flowBuilderAudienceExistingDesc: 'Straight to messages, no InMails',
  flowBuilderAudience_both: 'Both',
  flowBuilderAudienceBothDesc: 'Decided per contact at the start',
  flowBuilderQRecruitsFor: 'Do you recruit for your own company or as an agency?',
  flowBuilderRecruitsOwn: 'Own company',
  flowBuilderRecruitsClients: 'As an agency for clients',
  flowBuilderQInmailCredit: 'Does this LinkedIn account have InMail credit (Premium)?',
  flowBuilderInmailYes: 'Yes, InMail credit available',
  flowBuilderInmailYesDesc: 'One InMail as fallback if the request is not accepted',
  flowBuilderInmailNo: 'No',
  flowBuilderInmailNoDesc: 'The request is withdrawn after the waiting window',
  flowBuilderQFormality: 'Casual or formal?',
  flowBuilderCasual: 'Casual (first name)',
  flowBuilderCasualDesc: 'Like competent colleagues',
  flowBuilderFormal: 'Formal (last name)',
  flowBuilderFormalDesc: 'Professional and warm',
  flowBuilderQLanguage: 'Message language',
  flowBuilderLanguageHint: 'Pre-filled from the campaign. One click confirms.',
  flowBuilderLangKeep: 'As configured: {{primary}}{{secondary}}',
  flowBuilderLangWithSecondary: ', {{secondary}} as secondary language',
  flowBuilderLangPrimaryOnly: '{{primary}} only',
  flowBuilderLangAuto: 'Detect the profile language',
  flowBuilderLangDe: 'German',
  flowBuilderLangEn: 'English',
  flowBuilderLangAutoShort: 'Automatic',
  flowBuilderAnsweredKeep: 'Keep as is',
  flowBuilderQReferral: 'Ask for a referral at the end if there is no personal interest?',
  flowBuilderReferralYes: 'Yes, with a bonus',
  flowBuilderReferralYesDesc: 'Tell me the amount; it goes into the message.',
  flowBuilderReferralNo: 'No',
  flowBuilderReferralNoDesc: 'The flow ends with the breakup message.',
  flowBuilderReferralBonusLabel: 'Bonus, e.g. 500 €',
  flowBuilderReferralAnswered: 'Yes, bonus {{bonus}}',
  flowBuilderApply: 'Apply',
  flowBuilderGenerating: 'Building the flow …',
  flowBuilderGenerated: 'The flow is in the canvas on the left: {{steps}} steps, {{messages}} messages{{inmails}}.',
  flowBuilderGeneratedInmails: ', {{count}} of them InMails',
  flowBuilderLastQuestion: 'Last question, about what happens after a reply.',
  flowBuilderAutoReplyYes: 'Yes, with this proposal',
  flowBuilderAutoReplyNo: 'No, I reply myself',
  flowBuilderAutoReplyOff: 'Without automatic replies',
  flowBuilderCasesHint: 'Untick what does not fit. You can edit everything later in "Auto reply settings".',
  flowBuilderFreeTextHint: 'Answer by clicking. Everything can be changed afterwards.',
  flowBuilderDoneText: 'All set. Change whatever you like by clicking a message in the list or a node on the left.',
  flowBuilderAutoReplyRow: 'Automatic replies: {{state}} · {{count}} cases',
  flowBuilderOn: 'on',
  flowBuilderOff: 'off',
  flowBuilderEdit: 'edit',
  flowBuilderRegenerate: 'Generate again',
  flowBuilderWithoutBuilder: 'Without the builder: pick a template or start empty',
  flowBuilderChipInmails: '{{count}} InMail touchpoints',
  flowBuilderChipReferral: 'Referral {{bonus}}',
  flowBuilderChipClients: 'on behalf of a client',
  flowBuilderChipOwn: 'own company',
  flowBuilderWarning_referral_ignored_for_sales: 'The referral ask only exists for recruiting and was skipped.',
  flowBuilderBlockedNotDraft: 'The campaign is already running. The builder only changes drafts.',
  flowBuilderBlockedBriefing: 'The briefing is still missing: {{fields}}. Fill it in step 1, then continue here.',
  flowBuilderBlockedAccount: 'The campaign has no LinkedIn account. Pick one in the campaign settings.',
  flowBuilderContextError: 'The builder could not load the campaign.',
  flowBuilderRetry: 'Try again',
  flowBuilderErrorGeneric: 'That did not work: {{message}}',
  flowBuilderError_flow_builder_campaign_not_draft: 'The campaign is already running. The builder only changes drafts.',
  flowBuilderError_flow_builder_account_missing: 'The campaign has no LinkedIn account.',
  flowBuilderError_flow_builder_briefing_incomplete: 'The briefing is incomplete. Please complete step 1.',
  flowBuilderError_flow_builder_inmail_credit_unknown: 'Please answer whether the account has InMail credit.',
  flowBuilderError_flow_builder_recruits_for_unknown: 'Please answer whether you recruit for your own company or as an agency.',
  flowBuilderError_flow_builder_referral_bonus_missing: 'The referral ask needs a bonus.',
  flowBuilderError_flow_builder_auto_reply_incomplete: 'Automatic replies need a goal and at least one case.',
  flowBuilderError_flow_builder_generator_failed: 'The flow could not be generated. Please try again.',
  storeTemplateOwn: 'Own template',
  storeTemplateSteps: '{{count}} steps',
  storeTemplatesHint: 'Templates from the store. The flow builder in step 3 asks the right questions; here you pick a finished template by hand.',
  storeTemplatesEmpty: 'No templates in the store yet.',
  storeBlocksTitle: 'Flow builder text blocks',
  storeBlocksIntro: 'The builder assembles every prompt from these texts. Changes apply immediately to new flows of your tenant.',
  storeBlocksVariablesHint: '{{@name}} = builder variable (replaced while assembling), {{name}} = runtime placeholder (profile, offer).',
  storeBlocksSourceTenant: 'Own version',
  storeBlocksSourceSystem: 'Default',
  storeBlocksSystemVersion: 'Default text',
  storeBlocksSave: 'Save for my tenant',
  storeBlocksSaveSystem: 'Save as default for everyone',
  storeBlocksReset: 'Restore default',
  storeBlocksSaved: 'Block saved.',
  storeBlocksResetDone: 'Default restored.',
  storeBlocksSaveFailed: 'The block could not be saved.',
  storeBlocksResetFailed: 'The default could not be restored.',
  storeBlocksRejected: 'Not saved: {{message}}',
  storeBlocksPlaceholdersFound: 'Placeholders in this text:',
  storeBlocksLoadFailed: 'The blocks could not be loaded.',
  kiSearchEyebrow: 'AI search',
  kiSearchHeadline_ActiveSourcing: 'Where should we look for candidates?',
  kiSearchHeadline_LeadBooster: 'Where should we look for leads?',
  kiSearchIntro_ActiveSourcing: 'That is all we need. The AI already knows the position from your briefing and takes care of the rest.',
  kiSearchIntro_LeadBooster: 'That is all we need. From the offering in your briefing the AI works out who buys it and searches for those people.',
  kiSearchLocationLabel: 'Location',
  kiSearchStart_ActiveSourcing: 'Find candidates automatically',
  kiSearchStart_LeadBooster: 'Find leads automatically',
  kiSearchLocationMissing: 'Enter a location first.',
  kiSearchSearchesWith: 'Searches with',
  kiSearchChangeSettings: 'Change',
  kiSearchHideSettings: 'Done',
  kiSearchLanguages: 'Language',
  kiSearchAfterTitle: 'Everything after that runs on its own',
  kiSearchAfter1_ActiveSourcing: 'The AI reads the job title and job ad from your briefing',
  kiSearchAfter1_LeadBooster: 'The AI reads your offering and works out which positions and industries buy it',
  kiSearchAfter2_ActiveSourcing: 'It builds several LinkedIn searches and checks how many results each one brings',
  kiSearchAfter2_LeadBooster: 'It builds several LinkedIn searches and checks how many results each one brings',
  kiSearchAfter3_ActiveSourcing: 'The best searches are saved and the candidates land in your list',
  kiSearchAfter3_LeadBooster: 'The best searches are saved and the leads land in your list',
  kiSearchAfter4_ActiveSourcing: 'Every candidate is rated against your criteria',
  kiSearchAfter4_LeadBooster: 'Every lead is rated against your criteria',
  kiSearchBriefingMissing_ActiveSourcing: 'The AI search needs a job title or job ad in your briefing.',
  kiSearchBriefingMissing_LeadBooster: 'The AI search needs a description of your offering in the briefing (problems, features, benefits or impact).',
  expertMethodsToggle_ActiveSourcing: 'Add candidates yourself instead',
  expertMethodsToggle_LeadBooster: 'Add leads yourself instead',
  expertMethodsIntro: 'For when you already know your target group exactly. Whatever you add here lands in the same list.',
  expertOwnSearchDescription: 'Already built a search in LinkedIn, Recruiter or Sales Navigator? Paste the link and we take over the results.',
  expertUploadDescription: 'CSV or Excel with LinkedIn profile URLs, for example from your ATS or CRM.',
  expertFromCampaignDescription: 'Reuse contacts you already had in an earlier campaign.',
  expertMethodSelect: 'Select',
  expertMethodSelected: 'Selected',
  backToKiSearch: 'Back to AI search',
  titlesIndustriesSocialSelling: 'Results based on positions and industries',
  // Wizard „Neue Kampagne“ (Recruiting): Texte liegen unter features/co-pilot/campaign-wizard/locales
  ...wizardEN,
  // Engagement Center: Texte liegen unter features/engagement/locales
  ...engagementEN,
};

export default localeEN;
